/* eslint-disable */
import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never;
    };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  /** A string encoded in Base64URL */
  Base64Url: { input: any; output: any };
  /** A string that corresponds to one of the company brands like seek, jora etc */
  Brand: { input: any; output: any };
  /** A string that corresponds to company id */
  CompanyId: { input: any; output: any };
  /** A string that corresponds to a country code from the [alpha-2](https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2) set of country codes defined in the [ISO 3166 standard](https://en.wikipedia.org/wiki/ISO_3166). Example: `AU`. */
  CountryCodeIso2: { input: any; output: any };
  /** A string that corresponds to an alphabetic currency code defined in the [ISO 4217 standard](https://en.wikipedia.org/wiki/ISO_4217). Example: `AUD`. */
  CurrencyCodeIso: { input: any; output: any };
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: { input: any; output: any };
  /** A string representing an email address. Emails are validated against this [regex](https://github.com/SEEK-Jobs/validators-js/blob/master/src/validators/emailFormat/emailFormat.ts#L1). Example: `test@example.com`. */
  Email: { input: any; output: any };
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any };
  /** A string that corresponds to a job search query. */
  JobSearchQueryString: { input: any; output: any };
  /** A string that represents a job search V6 channel. Valid values are: "web", "mobileApp", "mobileWeb", "email", "push". */
  JobSearchV6Channel: { input: any; output: any };
  /** A string that represents a job search V6 duplicate handling mode. Valid values are: "off", "filter". */
  JobSearchV6DuplicateHandling: { input: any; output: any };
  /** A string that represents a job search V6 facet type. Valid values are: "advertiser", "category", "createdAt", "distinctTitle", "employer", "location", "salaryMax", "salaryMin", "title", "workArrangement", "workType". */
  JobSearchV6Facet: { input: any; output: any };
  /** A string that represents a job search V6 include feature. Valid values are: "canonical", "jobs", "relatedSearches", "jobHistory", "searchHistory", "employerSearch", "premiumads", "queryParamLabels", "seoQC", "locationSuggest", "locationHierarchy", "seoHierarchy", "historytags", "pills", "asyncpills", "noFeatured", "gptTargeting", "seoData", "facetCounts", "noExpanded", "joraCrossLink". */
  JobSearchV6Include: { input: any; output: any };
  /** A string that represents a job search V6 query hint. Valid values are: "all", "companySuggestion", "spellingCorrection". */
  JobSearchV6QueryHint: { input: any; output: any };
  /** A string that represents a job search V6 salary type. Valid values are: "annual", "hourly", "monthly". */
  JobSearchV6SalaryType: { input: any; output: any };
  /** A string that represents a job search V6 site key. Valid values are: "AU", "NZ", "ID", "MY", "PH", "SG", "HK", "TH". */
  JobSearchV6SiteKey: { input: any; output: any };
  /** A string that represents a job search V6 sort mode. Valid values are: "ListedDate", "KeywordRelevance", "Relevance", "Default", "Random". */
  JobSearchV6SortMode: { input: any; output: any };
  /** A string that represents a job search V6 source. Valid values are: "CAREER_ADVICE", "COMPANY", "COMPANY_ABOUT", "COMPANY_JOBS", "COMPANY_SALARIES", "DEEPLINK", "FE_HOME", "FE_JDV", "FE_REVERSAL", "FE_SERP", "FRONT_END", "MARKET_INSIGHTS", "OTHER", "QUICK", "RECENT", "RECS", "RELATED", "REVIEWS", "SAVED", "SAVED_ALERT", "SEARCH_ENG", "SEO", "SHALLOW_NO_RESULTS", "SUGGESTIONS". */
  JobSearchV6Source: { input: any; output: any };
  /** A string that represents a job search V6 tag. Valid values are: "new", "seen", "viewed", "applyStarted", "applied". */
  JobSearchV6Tag: { input: any; output: any };
  /** A string that represents a job search V6 work arrangement. Valid values are numeric IDs: "1" (ON_SITE - work must be performed at a physical location), "2" (HYBRID - work can be performed both on-site and remotely), "3" (REMOTE - work can be performed entirely remotely). */
  JobSearchV6WorkArrangement: { input: any; output: any };
  /** A string that represents a job search V6 work type. Valid values are numeric IDs: "242" (FULL_TIME - full-time employment), "243" (PART_TIME - part-time employment), "244" (CONTRACT - contract-based work), "245" (CASUAL - casual/vacation work). */
  JobSearchV6WorkType: { input: any; output: any };
  /** A string that corresponds to a language code defined in the [ISO 639-1 standard](https://en.wikipedia.org/wiki/ISO_639-1). Example: `en`. */
  LanguageCodeIso: { input: any; output: any };
  /** ISO-639-1 language codes and ISO-3166-1-alpha-2 country codes, separated by '-' */
  Locale: { input: any; output: any };
  /** The `PositiveInt` scalar type represents non-fractional unsigned whole numeric values with a value greater than 0. */
  PositiveInt: { input: any; output: any };
  /** A string that represents a profile visibility level. Valid values are: "Public", "Standard", "Limited", "Hidden". */
  ProfileVisibilityLevel: { input: any; output: any };
  RecommendedJobsWorkArrangementOption: { input: any; output: any };
  RecommendedJobsWorkTypeOption: { input: any; output: any };
  /** The `SafeInt` scalar type represents non-fractional signed whole numeric values that are considered safe as defined by the ECMAScript specification. */
  SafeInt: { input: any; output: any };
  /** Used to determine which smarter search cluster (URL) to use, valid values: default, ph-launch, end-state-launch */
  SmarterSearchCluster: { input: any; output: any };
  /** A string that corresponds to an IANA timezone ID defined in the [IANA Time Zone Database](https://www.iana.org/time-zones). Example: `Australia/Melbourne`. */
  Timezone: { input: any; output: any };
  /** A string representing a UUID. UUIDs are validated against this [regex](https://github.com/SEEK-Jobs/validators-js/blob/master/src/validators/uuid/isUuid.ts#L9). *Note:* The validation regex used does *not* conform to the UUID specification defined in [RFC 4122](https://tools.ietf.org/html/rfc4122), it is intentionally broader. Example: `f81d4fae-7dec-11d0-a765-00a0c91e6bf6`. */
  UUID: { input: any; output: any };
  /** A string that corresponds to a SEEK zone defined in [RFC034](https://github.com/SEEK-Jobs/rfc/blob/master/RFC034-Audience-Zone-Identifiers.md). */
  Zone: { input: any; output: any };
};

export type AccountBlockedError = I18nAccountError & {
  __typename?: 'AccountBlockedError';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  reason: Scalars['String']['output'];
};

export type AccountBlockedErrormessageArgs = {
  locale?: InputMaybe<Scalars['Locale']['input']>;
};

export type AccountStatus = {
  __typename?: 'AccountStatus';
  candidate: AccountStatusType;
  hirer: AccountStatusType;
  realmHint: Scalars['String']['output'];
};

export type AccountStatusType = 'found' | 'notFound';

export type AccountValidationError = I18nAccountError & {
  __typename?: 'AccountValidationError';
  code: Scalars['String']['output'];
  details: Array<I18nAccountFieldError>;
  message: Scalars['String']['output'];
  reason: Scalars['String']['output'];
};

export type AccountValidationErrormessageArgs = {
  locale?: InputMaybe<Scalars['Locale']['input']>;
};

export type Actor = {
  __typename?: 'Actor';
  /** Email address of the actor. */
  email: Scalars['String']['output'];
  /** The Auth0 user id of the actor, eg 'samlp|seek-okta-global|tkilvington@seek.com.au'. */
  id: Scalars['String']['output'];
};

export type AddSeekMaxCertificateToSeekPassError = {
  message: Scalars['String']['output'];
};

export type AddSeekMaxCertificateToSeekPassErrormessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type AddSeekMaxCertificateToSeekPassFailure = {
  __typename?: 'AddSeekMaxCertificateToSeekPassFailure';
  errors: Array<AddSeekMaxCertificateToSeekPassError>;
};

export type AddSeekMaxCertificateToSeekPassInput = {
  id: Scalars['ID']['input'];
};

export type AddSeekMaxCertificateToSeekPassPayload =
  | AddSeekMaxCertificateToSeekPassFailure
  | AddSeekMaxCertificateToSeekPassSuccess;

export type AddSeekMaxCertificateToSeekPassSuccess = {
  __typename?: 'AddSeekMaxCertificateToSeekPassSuccess';
  redirectUri: Scalars['String']['output'];
};

export type Advertiser = {
  __typename?: 'Advertiser';
  id: Scalars['ID']['output'];
  isVerified?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  registrationDate?: Maybe<SeekDateTime>;
};

export type AdvertisernameArgs = {
  locale?: Scalars['Locale']['input'];
};

export type AlertType = 'Info' | 'Promote';

export type AnswerForQuestionInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  text: Scalars['String']['input'];
  uri?: InputMaybe<Scalars['String']['input']>;
};

export type ApacSavedSearch = {
  __typename?: 'ApacSavedSearch';
  /** Display count for saved search (max 99+) */
  countLabel: Scalars['String']['output'];
  countryCode: Scalars['String']['output'];
  createdDate: SeekDateTime;
  id: Scalars['ID']['output'];
  lastExecutionDate?: Maybe<SeekDateTime>;
  modifiedDate?: Maybe<SeekDateTime>;
  name: Scalars['String']['output'];
  newToYouCountLabel?: Maybe<Scalars['String']['output']>;
  query: SavedSearchApacQuery;
  subscribeToNewJobs: Scalars['Boolean']['output'];
};

export type ApacSavedSearchcountLabelArgs = {
  cluster?: InputMaybe<Scalars['SmarterSearchCluster']['input']>;
};

export type ApacSavedSearchnameArgs = {
  languageCode?: InputMaybe<Scalars['LanguageCodeIso']['input']>;
};

export type ApacSavedSearchqueryArgs = {
  languageCode?: InputMaybe<Scalars['LanguageCodeIso']['input']>;
};

export type ApacSavedSearchConnection = {
  __typename?: 'ApacSavedSearchConnection';
  edges: Array<ApacSavedSearchEdge>;
  pageInfo: PageInfo;
};

export type ApacSavedSearchEdge = {
  __typename?: 'ApacSavedSearchEdge';
  cursor: Scalars['String']['output'];
  node: ApacSavedSearch;
};

export type ApplicantCount = JobInsight & {
  __typename?: 'ApplicantCount';
  count: Scalars['Int']['output'];
  countLabel?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  volumeLabel?: Maybe<Scalars['String']['output']>;
};

export type ApplicantCountcountLabelArgs = {
  locale: Scalars['Locale']['input'];
};

export type ApplicantCountmessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type ApplicantCountvolumeLabelArgs = {
  locale: Scalars['Locale']['input'];
};

export type ApplicantsWithCoverLetterPercentage = JobInsight & {
  __typename?: 'ApplicantsWithCoverLetterPercentage';
  message: Scalars['String']['output'];
  percentage: Scalars['Float']['output'];
};

export type ApplicantsWithCoverLetterPercentagemessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type ApplicantsWithResumePercentage = JobInsight & {
  __typename?: 'ApplicantsWithResumePercentage';
  message: Scalars['String']['output'];
  percentage: Scalars['Float']['output'];
};

export type ApplicantsWithResumePercentagemessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type ApplicationChannel = {
  label?: Maybe<Scalars['String']['output']>;
};

export type ApplicationChannellabelArgs = {
  locale: Scalars['Locale']['input'];
};

export type ApplicationContextInput = {
  build?: InputMaybe<Scalars['String']['input']>;
  channel?: InputMaybe<Platform>;
  /** client generated */
  key: Scalars['UUID']['input'];
  /** application bundleId */
  namespace?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

export type ApplicationDocuments = {
  __typename?: 'ApplicationDocuments';
  lastAppliedResumeIdPrefill?: Maybe<Scalars['String']['output']>;
  lastWrittenCoverLetter?: Maybe<LastWrittenCoverLetter>;
  selectionCriteriaRequired: Scalars['Boolean']['output'];
};

export type ApplicationInsightsStatistic = {
  message: Scalars['String']['output'];
};

export type ApplicationInsightsStatisticmessageArgs = {
  locale?: Scalars['Locale']['input'];
};

export type ApplicationProfile = {
  __typename?: 'ApplicationProfile';
  name?: Maybe<Scalars['String']['output']>;
};

export type ApplicationRestricted = ApplicationChannel & {
  __typename?: 'ApplicationRestricted';
  label: Scalars['String']['output'];
};

export type ApplicationRestrictedlabelArgs = {
  locale: Scalars['Locale']['input'];
};

export type AppliedForRoleCount = ApplicationInsightsStatistic & {
  __typename?: 'AppliedForRoleCount';
  count: Scalars['Int']['output'];
  message: Scalars['String']['output'];
};

export type AppliedForRoleCountmessageArgs = {
  locale?: Scalars['Locale']['input'];
};

export type AppliedJob = {
  __typename?: 'AppliedJob';
  applicationInsights: Array<ApplicationInsightsStatistic>;
  applicationRequestId: Scalars['String']['output'];
  appliedAt: SeekDateTime;
  createdAt: SeekDateTime;
  documents?: Maybe<AppliedJobDocuments>;
  downloadLinks?: Maybe<AppliedJobDownloadLinks>;
  events: Array<AppliedJobEvent>;
  hasAppliedWithCoverLetter: Scalars['Boolean']['output'];
  hasAppliedWithResume: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  isExternal: Scalars['Boolean']['output'];
  /** @deprecated Deprecated and to be removed by 31/10/2026. Use priorityApplyState instead. Migration guide: isPreferredApplication is equivalent to priorityApplyState.state === 'Prioritized' */
  isPreferredApplication: Scalars['Boolean']['output'];
  isPreferredApplicationEligible: Scalars['Boolean']['output'];
  job: Job;
  /**
   * UNSTABLE! description: proposed standard description for an AppliedJob.
   * e.g. 'Visited employer’s application site' (for link-out)
   */
  label?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  /** @deprecated Deprecated and to be removed by 31/10/2026. Use priorityApplyState.updatedAt instead. Migration guide: preferredApplicationMarkedAt is equivalent to priorityApplyState.updatedAt */
  preferredApplicationMarkedAt?: Maybe<SeekDateTime>;
  priorityApplyState?: Maybe<PriorityApplyState>;
};

export type AppliedJoblabelArgs = {
  length: AppliedJobLabelLength;
  locale: Scalars['Locale']['input'];
};

export type AppliedJobConnection = {
  __typename?: 'AppliedJobConnection';
  edges: Array<AppliedJobEdge>;
  pageInfo: PageInfo;
};

export type AppliedJobDocuments = {
  __typename?: 'AppliedJobDocuments';
  coverLetter?: Maybe<CoverLetterAppliedJobDocument>;
  resume?: Maybe<ResumeAppliedJobDocument>;
};

export type AppliedJobDownloadLinks = {
  __typename?: 'AppliedJobDownloadLinks';
  coverLetter?: Maybe<Scalars['String']['output']>;
  resume?: Maybe<Scalars['String']['output']>;
};

export type AppliedJobEdge = {
  __typename?: 'AppliedJobEdge';
  cursor: Scalars['String']['output'];
  node: AppliedJob;
};

export type AppliedJobEvent = {
  __typename?: 'AppliedJobEvent';
  status: AppliedJobStatus;
  timestamp: SeekDateTime;
};

export type AppliedJobLabelLength = 'LONG' | 'SHORT';

export type AppliedJobSortByInput = {
  applicationDate?: InputMaybe<Sort>;
  companyName?: InputMaybe<Sort>;
  jobTitle?: InputMaybe<Sort>;
};

export type AppliedJobStatus = 'Applied' | 'NotSuitable' | 'Viewed';

export type AppliedWithCoverLetterPercentage = ApplicationInsightsStatistic & {
  __typename?: 'AppliedWithCoverLetterPercentage';
  message: Scalars['String']['output'];
  percentage: Scalars['Float']['output'];
};

export type AppliedWithCoverLetterPercentagemessageArgs = {
  locale?: Scalars['Locale']['input'];
};

export type AppliedWithResumePercentage = ApplicationInsightsStatistic & {
  __typename?: 'AppliedWithResumePercentage';
  message: Scalars['String']['output'];
  percentage: Scalars['Float']['output'];
};

export type AppliedWithResumePercentagemessageArgs = {
  locale?: Scalars['Locale']['input'];
};

export type Approachability = {
  __typename?: 'Approachability';
  approachable: Scalars['Boolean']['output'];
};

export type ApproxModuleSocialData = {
  __typename?: 'ApproxModuleSocialData';
  /** UNSTABLE! */
  commentCount?: Maybe<SocialMetric>;
  /** UNSTABLE! */
  likeCount?: Maybe<SocialMetric>;
};

export type AttachmentMetadata = {
  __typename?: 'AttachmentMetadata';
  contentType?: Maybe<Scalars['String']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  virusScanStatus: VirusScanStatus;
};

export type AttachmentType = 'CoverLetter' | 'SelectionCriteria';

export type AttributionSource =
  | 'APPLIED_JOBS'
  | 'APPLY_LINKOUT_SUCCESS'
  | 'APPLY_SUCCESS'
  | 'COMPETITIVE_PLACEMENT'
  | 'HOME'
  | 'JOB_DETAILS'
  | 'LOGGED_OUT_COMPETITIVE_PLACEMENT'
  | 'LOGGED_OUT_HOME'
  | 'RECOMMENDATIONS';

export type Availability = {
  __typename?: 'Availability';
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
};

export type AvailabilityOption = {
  __typename?: 'AvailabilityOption';
  /** Human readable string used when the user is selecting an availability option. */
  description: Scalars['String']['output'];
  /** Unique ID used to identify a specific availability option */
  id: Scalars['Int']['output'];
};

export type Award = {
  __typename?: 'Award';
  description: Scalars['String']['output'];
  imageUrl: Scalars['String']['output'];
  name: Scalars['String']['output'];
  year: Scalars['Int']['output'];
};

export type BadgeDetails = {
  __typename?: 'BadgeDetails';
  /** The type of the badge. Used for styling and tracking i.e "NEW", "VIEWED", etc. */
  badge: Scalars['String']['output'];
  displayText: Scalars['String']['output'];
};

export type Banner = {
  __typename?: 'Banner';
  analytics?: Maybe<Scalars['JSON']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  template?: Maybe<BannerTemplate>;
};

export type BannerHeading = {
  __typename?: 'BannerHeading';
  style?: Maybe<BannerStyle>;
  text?: Maybe<Scalars['String']['output']>;
};

export type BannerImage = {
  __typename?: 'BannerImage';
  url?: Maybe<Scalars['String']['output']>;
  urlDark?: Maybe<Scalars['String']['output']>;
};

export type BannerItems = {
  __typename?: 'BannerItems';
  href?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type BannerLink = {
  __typename?: 'BannerLink';
  style?: Maybe<BannerStyle>;
  text?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type BannerPlacement = 'MOBILE_HOME' | 'SERP_FOOTER_LINKS';

export type BannerStyle = {
  __typename?: 'BannerStyle';
  backgroundColor?: Maybe<Scalars['String']['output']>;
  backgroundColorDark?: Maybe<Scalars['String']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  colorDark?: Maybe<Scalars['String']['output']>;
};

export type BannerTemplate = {
  __typename?: 'BannerTemplate';
  heading?: Maybe<BannerHeading>;
  id?: Maybe<Scalars['String']['output']>;
  image?: Maybe<BannerImage>;
  items: Array<BannerItems>;
  link?: Maybe<BannerLink>;
  style?: Maybe<BannerStyle>;
};

export type BaseCredential = {
  __typename?: 'BaseCredential';
  credentialInfo: Array<CredentialInfo>;
  deleteVerificationUrl: Scalars['String']['output'];
  expiryStatus?: Maybe<CredentialExpiryStatus>;
  manageVerificationUrl: Scalars['String']['output'];
  verification: CredentialVerification;
};

export type BaseVerifiableCredential = {
  label: Scalars['String']['output'];
};

export type BasicBranding = {
  __typename?: 'BasicBranding';
  brandId?: Maybe<Scalars['String']['output']>;
  cover?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
};

export type Branding = {
  __typename?: 'Branding';
  cover?: Maybe<Cover>;
  logo?: Maybe<Scalars['String']['output']>;
};

export type COMPANY_GROUP = 'INDUSTRY';

export type COMPANY_SORT_BY = 'REVIEWS_COUNT';

export type CacheControlScope = 'PRIVATE' | 'PUBLIC';

export type Candidate = {
  __typename?: 'Candidate';
  /**
   * Unique candidate ID.
   * Note: This is a temporary field. We cannot change `id` to string format
   * right now because of dependency on long tail apps.
   */
  _id: Scalars['ID']['output'];
  apacSavedSearches?: Maybe<Array<ApacSavedSearch>>;
  /** UNSTABLE! */
  apacSavedSearchesConnection: ApacSavedSearchConnection;
  appliedJob?: Maybe<AppliedJob>;
  appliedJobs: AppliedJobConnection;
  /** @deprecated Candidates have received sufficeint notice of migration since Unification completed */
  appliedJobsMigrationMessage?: Maybe<Scalars['String']['output']>;
  /** Candidate's approachability */
  approachability: Approachability;
  attachmentMetadata?: Maybe<AttachmentMetadata>;
  availability?: Maybe<Availability>;
  candidateJobMatchAllocation?: Maybe<CandidateJobMatchAllocation>;
  /** EXPERIMENTAL! */
  candidateJobPreferences?: Maybe<Array<Maybe<CandidateJobPreferencesGroup>>>;
  /** Career Objectives for candidate */
  careerObjectives?: Maybe<CareerObjectives>;
  /** Current location for this candidate */
  currentLocation2?: Maybe<Location2>;
  /** Temporary document download link for a given resource id (Type could be a Resume, Cover Letter, or Selection Criteria) */
  documentDownloadLink?: Maybe<DocumentDownloadLink>;
  /** Form data for clients to upload documents(documents type could be a Resume, Cover Letter, or Selection Criteria) */
  documentUploadFormData?: Maybe<DocumentUploadFormData>;
  emailAddress: Scalars['Email']['output'];
  /** @deprecated Use viewer.trackingId */
  emailCorrelationId: Scalars['String']['output'];
  /**
   * External Id (candidate)
   * Note: This is a temporary field used to identify the candidate within APAC (Asia) Domain
   */
  externalId?: Maybe<Scalars['ID']['output']>;
  /** Unique candidate ID in numeric format */
  id: Scalars['Int']['output'];
  /** Identity of the currently authenticated user. */
  identity: Identity;
  /** Determines whether an authenticated user is associated with a candidate record. */
  isAccountProvisioned?: Maybe<Scalars['Boolean']['output']>;
  /** Candidate's language proficiencies */
  languageProficiencies: Array<LanguageProficiency>;
  /** Licences */
  licences: Array<Licence>;
  /**
   * Candidate's work notice period length
   * @deprecated Use availability instead
   */
  noticePeriod?: Maybe<NoticePeriod>;
  notificationCTPPreferenceGroups?: Maybe<
    Array<NotificationCTPPreferenceGroup>
  >;
  onboardingComplete?: Maybe<Scalars['Boolean']['output']>;
  /**
   * *Note*: The default values for the parameters to this query are `"AU"`
   * and `"en"` respectively, *not* `false` as they in the playground.
   */
  personalDetails: PersonalDetails;
  /** Preferred classification for this candidate */
  preferredClassification?: Maybe<Classification>;
  /** All preferred locations for this candidate */
  preferredLocations2: Array<Location2>;
  /** EXPERIMENTAL! */
  preferredRoleTitles?: Maybe<Array<OntologyStructuredData>>;
  /** Candidate's Profile Avatar */
  profileAvatar?: Maybe<ProfileAvatar>;
  /** Get the current status of an avatar upload/processing */
  profileAvatarStatus?: Maybe<ProfileAvatarStatusResult>;
  /**
   * The insights of profile interactions for this candidate
   * @deprecated Use profileInsights2
   */
  profileInsights?: Maybe<ProfileInsights>;
  profileInsights2?: Maybe<ProfileInsights2>;
  profileSuggestions?: Maybe<Array<ProfileSuggestion>>;
  /** The verified and verifiable data for this candidate */
  profileVerifications?: Maybe<ProfileVerifications>;
  /**
   * Profile Visibility for candidate
   * @deprecated Use viewer.profileVisibility2
   */
  profileVisibility?: Maybe<ProfileVisibility>;
  /** Profile Visibility for candidate */
  profileVisibility2?: Maybe<ProfileVisibilityOption>;
  /** Public profile settings */
  publicProfile?: Maybe<PublicProfile>;
  /** A specific qualification for this candidate */
  qualification?: Maybe<Qualification>;
  /** All qualifications for this candidate */
  qualifications: Array<Qualification>;
  /** Group candidate recommendations under one type */
  recommendations?: Maybe<Recommendations>;
  /** All reference checks associated with this candidate. It expects audience zone as argument to enable references based on market. */
  referenceChecks?: Maybe<Array<ReferenceCheck>>;
  /** A specific resume for this candidate */
  resume?: Maybe<Resume>;
  /** All resumes for this candidate */
  resumes: Array<Resume>;
  /** Rights to work for candidate */
  rightsToWork: Array<RightToWork>;
  /**
   * Rights to work alert type for candidate
   * @deprecated No longer required
   */
  rightsToWorkAlert: RightsToWorkAlert;
  /** Specific role for candidate */
  role?: Maybe<Role>;
  /** All roles for this candidate */
  roles: Array<Role>;
  salaryNudge?: Maybe<CandidateSalaryNudge>;
  /**
   * Salary preferences for candidate. Description fields will be returned in the language
   * specified via the `languageCode` parameter.
   */
  salaryPreferences2: Array<SalaryPreference2>;
  savedJobs: SavedJobConnection;
  /**
   * Profile completeness score. The `zone` parameter restricts the tips returned so they are only relevant to the
   * brand associated with the zone provided.
   */
  score: ProfileScore;
  searchAppliedJobs: Array<SearchAppliedJobPartial>;
  searchSavedJobs: Array<SearchSavedJobPartial>;
  /**
   * Displays data that a candidate has chosen to share via a public url
   * @deprecated This functionality is retired
   */
  shareableProfile: ShareableProfile;
  /**
   * Shareable Profile Settings
   * @deprecated This functionality is retired
   */
  shareableProfileSettings: ShareableProfileSettings;
  /**
   * All skills for this candidate
   * @deprecated Use `viewer.skills2` instead
   */
  skills: Array<Skill>;
  /** All skills for this candidate */
  skills2?: Maybe<Array<Skill>>;
  /**
   * All suggested skills for this candidate
   * @deprecated Use `viewer.suggestedSkills2` instead
   */
  suggestedSkills: Array<Skill>;
  suggestedSkills2?: Maybe<Array<Skill>>;
  /** Unique tracking (candidate) ID in UUID format */
  trackingId: Scalars['ID']['output'];
  /** Unconfirmed data for given context */
  unconfirmedDataForContext: UnconfirmedData;
  /**
   * Candidate context that can be persisted in cookies
   * @deprecated This field will always return null
   */
  userCookie?: Maybe<UserCookie>;
  verificationNudges: Array<VerificationNudge>;
  /** @deprecated Please use viewer.profileVerifications instead */
  verifications?: Maybe<Verifications>;
  /** The verified identity data for this candidate */
  verifiedIdentity?: Maybe<VerifiedIdentity>;
  /** Candidate's work types */
  workTypes: Array<WorkType>;
  /**
   * Candidate's years of experience
   * @deprecated Its no longer being used in production after unification. Will be removed in future releases.
   */
  yearsOfExperience?: Maybe<YearsOfExperience>;
};

export type CandidateapacSavedSearchesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CandidateappliedJobArgs = {
  jobId: Scalars['ID']['input'];
};

export type CandidateappliedJobsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['Locale']['input']>;
  sortBy?: InputMaybe<AppliedJobSortByInput>;
};

export type CandidateappliedJobsMigrationMessageArgs = {
  locale: Scalars['Locale']['input'];
  zone: Scalars['Zone']['input'];
};

export type CandidateattachmentMetadataArgs = {
  blobUrl: Scalars['String']['input'];
};

export type CandidateavailabilityArgs = {
  languageCode: Scalars['LanguageCodeIso']['input'];
};

export type CandidatecurrentLocation2Args = {
  languageCode?: InputMaybe<Scalars['LanguageCodeIso']['input']>;
  zone: Scalars['Zone']['input'];
};

export type CandidatedocumentDownloadLinkArgs = {
  resourceId: Scalars['ID']['input'];
  resourceType: DocumentResourceType;
};

export type CandidatedocumentUploadFormDataArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};

export type CandidatelicencesArgs = {
  languageCode?: InputMaybe<Scalars['LanguageCodeIso']['input']>;
  platform?: InputMaybe<Platform>;
  source?: InputMaybe<SourceExperience>;
  zone?: InputMaybe<Scalars['Zone']['input']>;
};

export type CandidatenotificationCTPPreferenceGroupsArgs = {
  onlyProductionOption?: Scalars['Boolean']['input'];
  zone: Scalars['Zone']['input'];
};

export type CandidatepersonalDetailsArgs = {
  countryCode?: InputMaybe<Scalars['CountryCodeIso2']['input']>;
  languageCode?: InputMaybe<Scalars['LanguageCodeIso']['input']>;
};

export type CandidatepreferredClassificationArgs = {
  languageCode?: InputMaybe<Scalars['LanguageCodeIso']['input']>;
};

export type CandidatepreferredLocations2Args = {
  languageCode?: InputMaybe<Scalars['LanguageCodeIso']['input']>;
  zone: Scalars['Zone']['input'];
};

export type CandidateprofileAvatarStatusArgs = {
  avatarId: Scalars['ID']['input'];
};

export type CandidateprofileInsightsArgs = {
  zone: Scalars['Zone']['input'];
};

export type CandidateprofileInsights2Args = {
  zone: Scalars['Zone']['input'];
};

export type CandidateprofileSuggestionsArgs = {
  languageCode: Scalars['LanguageCodeIso']['input'];
  zone: Scalars['Zone']['input'];
};

export type CandidateprofileVerificationsArgs = {
  locale: Scalars['Locale']['input'];
  zone: Scalars['Zone']['input'];
};

export type CandidateprofileVisibilityArgs = {
  languageCode?: InputMaybe<Scalars['LanguageCodeIso']['input']>;
};

export type CandidateprofileVisibility2Args = {
  locale?: InputMaybe<Scalars['Locale']['input']>;
};

export type CandidatequalificationArgs = {
  id: Scalars['UUID']['input'];
  isUnifiedSite?: InputMaybe<Scalars['Boolean']['input']>;
  languageCode?: InputMaybe<Scalars['LanguageCodeIso']['input']>;
  platform?: InputMaybe<Platform>;
  source?: InputMaybe<SourceExperience>;
  zone?: Scalars['Zone']['input'];
};

export type CandidatequalificationsArgs = {
  includeVerified?: InputMaybe<Scalars['Boolean']['input']>;
  isUnifiedSite?: InputMaybe<Scalars['Boolean']['input']>;
  languageCode?: InputMaybe<Scalars['LanguageCodeIso']['input']>;
  platform?: InputMaybe<Platform>;
  source?: InputMaybe<SourceExperience>;
  status?: InputMaybe<ConfirmedStatus>;
  zone?: InputMaybe<Scalars['Zone']['input']>;
};

export type CandidateresumeArgs = {
  id: Scalars['UUID']['input'];
  languageCode?: InputMaybe<Scalars['LanguageCodeIso']['input']>;
};

export type CandidateresumesArgs = {
  languageCode?: InputMaybe<Scalars['LanguageCodeIso']['input']>;
};

export type CandidaterightsToWorkArgs = {
  countryCode?: InputMaybe<Scalars['CountryCodeIso2']['input']>;
  isUnifiedSite?: InputMaybe<Scalars['Boolean']['input']>;
  languageCode?: InputMaybe<Scalars['LanguageCodeIso']['input']>;
  platform?: InputMaybe<Platform>;
  source?: InputMaybe<SourceExperience>;
  zone?: InputMaybe<Scalars['Zone']['input']>;
};

export type CandidaterightsToWorkAlertArgs = {
  countryCode: Scalars['CountryCodeIso2']['input'];
};

export type CandidateroleArgs = {
  id: Scalars['UUID']['input'];
};

export type CandidaterolesArgs = {
  status?: InputMaybe<ConfirmedStatus>;
};

export type CandidatesalaryNudgeArgs = {
  zone: Scalars['String']['input'];
};

export type CandidatesalaryPreferences2Args = {
  countryCode?: InputMaybe<Scalars['CountryCodeIso2']['input']>;
  languageCode?: InputMaybe<Scalars['LanguageCodeIso']['input']>;
};

export type CandidatesavedJobsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CandidatescoreArgs = {
  isUnifiedSite?: InputMaybe<Scalars['Boolean']['input']>;
  languageCode?: InputMaybe<Scalars['LanguageCodeIso']['input']>;
  zone?: InputMaybe<Scalars['Zone']['input']>;
};

export type CandidatesearchAppliedJobsArgs = {
  jobIds: Array<Scalars['String']['input']>;
};

export type CandidatesearchSavedJobsArgs = {
  jobIds: Array<Scalars['String']['input']>;
};

export type CandidateshareableProfileArgs = {
  profileSlug: Scalars['String']['input'];
};

export type CandidateshareableProfileSettingsArgs = {
  languageCode?: InputMaybe<Scalars['LanguageCodeIso']['input']>;
  zone?: InputMaybe<Scalars['Zone']['input']>;
};

export type CandidatesuggestedSkillsArgs = {
  languageCode?: InputMaybe<Scalars['LanguageCodeIso']['input']>;
  zone?: InputMaybe<Scalars['Zone']['input']>;
};

export type CandidatesuggestedSkills2Args = {
  languageCode: Scalars['LanguageCodeIso']['input'];
  zone: Scalars['Zone']['input'];
};

export type CandidateunconfirmedDataForContextArgs = {
  contextId: Scalars['String']['input'];
  contextType?: InputMaybe<UnconfirmedContextType>;
  languageCode?: InputMaybe<Scalars['LanguageCodeIso']['input']>;
};

export type CandidateverificationNudgesArgs = {
  jobId: Scalars['ID']['input'];
  platform: Platform;
  selectedAnswerUris: Array<Scalars['String']['input']>;
  source: SourceExperience;
  zone?: InputMaybe<Scalars['Zone']['input']>;
};

export type CandidateverificationsArgs = {
  testGroup?: InputMaybe<VerificationsTestVariant>;
};

export type CandidateverifiedIdentityArgs = {
  languageCode: Scalars['LanguageCodeIso']['input'];
  platform: Platform;
  source: SourceExperience;
  zone: Scalars['Zone']['input'];
};

export type CandidateworkTypesArgs = {
  languageCode?: InputMaybe<Scalars['LanguageCodeIso']['input']>;
};

export type CandidateyearsOfExperienceArgs = {
  languageCode?: InputMaybe<Scalars['LanguageCodeIso']['input']>;
};

export type CandidateJobMatch = {
  jobId: Scalars['ID']['output'];
};

export type CandidateJobMatchAllocation = {
  __typename?: 'CandidateJobMatchAllocation';
  message: Scalars['String']['output'];
};

export type CandidateJobMatchExists = CandidateJobMatch &
  CreateCandidateJobMatchResponse & {
    __typename?: 'CandidateJobMatchExists';
    createdAt: Scalars['DateTime']['output'];
    jobId: Scalars['ID']['output'];
    recommendations: Scalars['String']['output'];
    recommendationsList: Array<Scalars['String']['output']>;
    shouldApply: Scalars['Boolean']['output'];
    shouldApplyMessage?: Maybe<Scalars['String']['output']>;
    summary: Scalars['String']['output'];
    summaryList: Array<Scalars['String']['output']>;
    trackingId: Scalars['UUID']['output'];
  };

export type CandidateJobMatchInProgress = CandidateJobMatch &
  CreateCandidateJobMatchResponse & {
    __typename?: 'CandidateJobMatchInProgress';
    jobId: Scalars['ID']['output'];
    trackingId: Scalars['UUID']['output'];
    waitForMs: Scalars['Int']['output'];
  };

export type CandidateJobMatchNotExists = CandidateJobMatch & {
  __typename?: 'CandidateJobMatchNotExists';
  jobId: Scalars['ID']['output'];
};

export type CandidateJobMatchResultInvalid = CandidateJobMatch &
  CreateCandidateJobMatchResponse & {
    __typename?: 'CandidateJobMatchResultInvalid';
    createdAt: Scalars['DateTime']['output'];
    jobId: Scalars['ID']['output'];
    message: Scalars['String']['output'];
    trackingId?: Maybe<Scalars['UUID']['output']>;
  };

export type CandidateJobMatchResultInvalidmessageArgs = {
  locale?: InputMaybe<Scalars['Locale']['input']>;
};

export type CandidateJobPreferencesGroup = {
  __typename?: 'CandidateJobPreferencesGroup';
  items?: Maybe<Array<Maybe<CandidateJobPreferencesItem>>>;
  label?: Maybe<Scalars['String']['output']>;
  reason: Scalars['String']['output'];
};

export type CandidateJobPreferencesGrouplabelArgs = {
  locale: Scalars['Locale']['input'];
};

export type CandidateJobPreferencesItem = {
  __typename?: 'CandidateJobPreferencesItem';
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  typeId: Scalars['String']['output'];
};

export type CandidateJobPreferencesItemlabelArgs = {
  locale: Scalars['Locale']['input'];
};

export type CandidateSalaryNudge = {
  __typename?: 'CandidateSalaryNudge';
  callToActions: Array<CandidateSalaryNudgeCallToAction>;
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  imageUrl: Scalars['String']['output'];
  prompt: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type CandidateSalaryNudgeCallToAction = {
  __typename?: 'CandidateSalaryNudgeCallToAction';
  displayText: Scalars['String']['output'];
  /** The call to action submission operation */
  operation: Scalars['String']['output'];
};

export type CandidateSalaryNudgeFeedbackPayload = {
  __typename?: 'CandidateSalaryNudgeFeedbackPayload';
  nudgeId: Scalars['ID']['output'];
};

export type CareerFeed = {
  __typename?: 'CareerFeed';
  /** @deprecated Use serviceToken instead. */
  correlationId?: Maybe<Scalars['UUID']['output']>;
  edges: Array<Maybe<CareerFeedEdge>>;
  emptyComponentReason?: Maybe<CareerFeedEmptyComponentReason>;
  pageInfo?: Maybe<CareerFeedPageInfo>;
  serviceToken: Scalars['UUID']['output'];
  solMetadata?: Maybe<Scalars['JSON']['output']>;
};

export type CareerFeedChannel = 'HOME';

export type CareerFeedCompanyEvp = CareerFeedNode & {
  __typename?: 'CareerFeedCompanyEvp';
  /** AI Summary: in list on basis that there will only be one CareerFeedCompanyEvp in the list */
  companyId: Scalars['CompanyId']['output'];
  companyProfile?: Maybe<CompanyProfileV2>;
  companyReviewsAISummary?: Maybe<CompanyReviewsAISummary>;
  id: Scalars['ID']['output'];
  serviceToken: Scalars['UUID']['output'];
  solMetadata?: Maybe<Scalars['JSON']['output']>;
};

export type CareerFeedCompanyEvpcompanyReviewsAISummaryArgs = {
  locale?: InputMaybe<Scalars['Locale']['input']>;
};

export type CareerFeedComponent = 'COMPANY_EVP' | 'JOB' | 'MARKET_INSIGHTS';

export type CareerFeedContextInput = {
  recsRefinementToken?: InputMaybe<Scalars['UUID']['input']>;
};

export type CareerFeedEdge = {
  __typename?: 'CareerFeedEdge';
  node?: Maybe<CareerFeedNode>;
};

export type CareerFeedEmptyComponentReason = {
  reason?: Maybe<Scalars['String']['output']>;
};

export type CareerFeedEmptyJobsEmptyComponentReason =
  CareerFeedEmptyComponentReason & {
    __typename?: 'CareerFeedEmptyJobsEmptyComponentReason';
    reason?: Maybe<Scalars['String']['output']>;
  };

export type CareerFeedEmptyJobsWithPreferencesEmptyComponentReason =
  CareerFeedEmptyComponentReason & {
    __typename?: 'CareerFeedEmptyJobsWithPreferencesEmptyComponentReason';
    reason?: Maybe<Scalars['String']['output']>;
  };

export type CareerFeedEnrichmentModel = 'BREVITY' | 'LOA';

export type CareerFeedExperimentInput = {
  key: Scalars['String']['input'];
  value: Scalars['JSON']['input'];
};

export type CareerFeedInsights = {
  __typename?: 'CareerFeedInsights';
  adVolumeData?: Maybe<CareerFeedInsightsAdVolumeData>;
  adVolumeShift?: Maybe<CareerFeedInsightsAdVolumeShift>;
  id: Scalars['String']['output'];
  serviceToken: Scalars['String']['output'];
};

export type CareerFeedInsightsAdVolumeData = {
  __typename?: 'CareerFeedInsightsAdVolumeData';
  chartLegend?: Maybe<Scalars['String']['output']>;
  dataPoints: Array<CareerFeedInsightsDataPoint>;
  xAxis: CareerFeedInsightsXAxis;
  yAxis: CareerFeedInsightsYAxis;
};

export type CareerFeedInsightsAdVolumeDatachartLegendArgs = {
  locale: Scalars['Locale']['input'];
};

export type CareerFeedInsightsAdVolumeShift = {
  __typename?: 'CareerFeedInsightsAdVolumeShift';
  count: Scalars['Int']['output'];
  dayRange: Scalars['Int']['output'];
};

export type CareerFeedInsightsDataPoint = {
  __typename?: 'CareerFeedInsightsDataPoint';
  adsPostedCount: Scalars['Int']['output'];
  adsPostedLabel: Scalars['String']['output'];
  endDate?: Maybe<Scalars['Float']['output']>;
  endDateLabel?: Maybe<SeekDateTime>;
  startDate: Scalars['Float']['output'];
  startDateLabel: SeekDateTime;
};

export type CareerFeedInsightsDataPointadsPostedLabelArgs = {
  locale: Scalars['Locale']['input'];
};

export type CareerFeedInsightsDateTick = {
  __typename?: 'CareerFeedInsightsDateTick';
  label: SeekDateTime;
  value: Scalars['Float']['output'];
};

export type CareerFeedInsightsLocationInput = {
  id: Scalars['String']['input'];
};

export type CareerFeedInsightsNumericTick = {
  __typename?: 'CareerFeedInsightsNumericTick';
  label: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type CareerFeedInsightsNumericTicklabelArgs = {
  locale: Scalars['Locale']['input'];
};

export type CareerFeedInsightsRoleInput = {
  uri: Scalars['String']['input'];
};

export type CareerFeedInsightsXAxis = {
  __typename?: 'CareerFeedInsightsXAxis';
  max: Scalars['Float']['output'];
  min: Scalars['Float']['output'];
  ticks: Array<CareerFeedInsightsDateTick>;
};

export type CareerFeedInsightsYAxis = {
  __typename?: 'CareerFeedInsightsYAxis';
  max: Scalars['Float']['output'];
  min: Scalars['Float']['output'];
  ticks: Array<CareerFeedInsightsNumericTick>;
};

export type CareerFeedJob = CareerFeedNode & {
  __typename?: 'CareerFeedJob';
  /** EXPERIMENTAL! */
  enrichment?: Maybe<Enrichment>;
  feedbackReasons?: Maybe<JobPreferencesFeedbackReasons>;
  id: Scalars['ID']['output'];
  job?: Maybe<Job>;
  jobBadges?: Maybe<JobBadges>;
  jobId: Scalars['ID']['output'];
  savedJob?: Maybe<SavedJob>;
  serviceToken: Scalars['UUID']['output'];
  solMetadata?: Maybe<Scalars['JSON']['output']>;
  workArrangements?: Maybe<CareerFeedJobWorkArrangements>;
};

export type CareerFeedJobenrichmentArgs = {
  model?: InputMaybe<CareerFeedEnrichmentModel>;
};

export type CareerFeedJobjobBadgesArgs = {
  channel: CareerFeedChannel;
  locale: Scalars['Locale']['input'];
  platform: Platform;
  visitorId: Scalars['UUID']['input'];
};

export type CareerFeedJobworkArrangementsArgs = {
  channel: CareerFeedChannel;
  platform: Platform;
  visitorId: Scalars['UUID']['input'];
};

export type CareerFeedJobWorkArrangement = {
  __typename?: 'CareerFeedJobWorkArrangement';
  label?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type CareerFeedJobWorkArrangementlabelArgs = {
  locale: Scalars['Locale']['input'];
};

export type CareerFeedJobWorkArrangements = {
  __typename?: 'CareerFeedJobWorkArrangements';
  arrangements?: Maybe<Array<Maybe<CareerFeedJobWorkArrangement>>>;
  label?: Maybe<Scalars['String']['output']>;
};

export type CareerFeedJobWorkArrangementslabelArgs = {
  locale: Scalars['Locale']['input'];
};

export type CareerFeedJobsRefinementItemInput = {
  answers: Array<Scalars['String']['input']>;
  question: Scalars['String']['input'];
};

export type CareerFeedJobsRefinementStatus = {
  refinementToken: Scalars['UUID']['output'];
};

export type CareerFeedJobsRefinementStatusAllocationExhausted =
  SubmitCareerFeedJobsRefinementError & {
    __typename?: 'CareerFeedJobsRefinementStatusAllocationExhausted';
    message: Scalars['String']['output'];
  };

export type CareerFeedJobsRefinementStatusInProgress =
  CareerFeedJobsRefinementStatus & {
    __typename?: 'CareerFeedJobsRefinementStatusInProgress';
    refinementToken: Scalars['UUID']['output'];
    waitForMs: Scalars['Int']['output'];
  };

export type CareerFeedJobsRefinementStatusReady =
  CareerFeedJobsRefinementStatus & {
    __typename?: 'CareerFeedJobsRefinementStatusReady';
    refinementToken: Scalars['UUID']['output'];
  };

export type CareerFeedJobsTimeoutEmptyComponentReason =
  CareerFeedEmptyComponentReason & {
    __typename?: 'CareerFeedJobsTimeoutEmptyComponentReason';
    reason?: Maybe<Scalars['String']['output']>;
  };

export type CareerFeedNode = {
  id: Scalars['ID']['output'];
};

export type CareerFeedPageInfo = {
  __typename?: 'CareerFeedPageInfo';
  cursor?: Maybe<Scalars['UUID']['output']>;
};

export type CareerFeedPersonalMarketInsights = CareerFeedNode & {
  __typename?: 'CareerFeedPersonalMarketInsights';
  id: Scalars['ID']['output'];
  location?: Maybe<SeekLocation>;
  role?: Maybe<OntologyRole>;
};

export type CareerObjectives = {
  __typename?: 'CareerObjectives';
  personalStatement: Scalars['String']['output'];
};

export type CategoryInfo = {
  __typename?: 'CategoryInfo';
  label: Scalars['String']['output'];
};

export type CategoryInfolabelArgs = {
  languageCode?: InputMaybe<Scalars['LanguageCodeIso']['input']>;
};

export type ChangeEmailAddressFailure = {
  __typename?: 'ChangeEmailAddressFailure';
  error: I18nAccountError;
};

export type ChangeEmailAddressInput = {
  isBGroup?: InputMaybe<Scalars['Boolean']['input']>;
  newEmailAddress: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
};

export type ChangeEmailAddressPayload =
  | ChangeEmailAddressFailure
  | ChangeEmailAddressSuccess;

export type ChangeEmailAddressSuccess = {
  __typename?: 'ChangeEmailAddressSuccess';
  ref: Scalars['UUID']['output'];
};

export type ChangeEmailStartFailure = {
  __typename?: 'ChangeEmailStartFailure';
  error: I18nAccountError;
};

export type ChangeEmailStartInput = {
  newEmailAddress: Scalars['Email']['input'];
};

export type ChangeEmailStartPayload =
  | ChangeEmailStartFailure
  | ChangeEmailStartSuccess;

export type ChangeEmailStartSuccess = {
  __typename?: 'ChangeEmailStartSuccess';
  ref: Scalars['UUID']['output'];
};

export type ChangeEmailVerifyFailure = {
  __typename?: 'ChangeEmailVerifyFailure';
  error: I18nAccountError;
};

export type ChangeEmailVerifyInput = {
  brand?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  newEmailAddress: Scalars['Email']['input'];
  verificationCode?: InputMaybe<Scalars['String']['input']>;
};

export type ChangeEmailVerifyPayload =
  | ChangeEmailVerifyFailure
  | ChangeEmailVerifySuccess;

export type ChangeEmailVerifySuccess = {
  __typename?: 'ChangeEmailVerifySuccess';
  ref: Scalars['UUID']['output'];
};

export type ChangePasswordFailure = {
  __typename?: 'ChangePasswordFailure';
  error?: Maybe<I18nAccountError>;
};

export type ChangePasswordInput = {
  newPassword: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type ChangePasswordPayload =
  | ChangePasswordFailure
  | ChangePasswordSuccess;

export type ChangePasswordSuccess = {
  __typename?: 'ChangePasswordSuccess';
  ref: Scalars['UUID']['output'];
};

export type ChildClassification = {
  __typename?: 'ChildClassification';
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
};

export type ChildClassificationdescriptionArgs = {
  languageCode?: InputMaybe<Scalars['LanguageCodeIso']['input']>;
};

export type Classification = {
  __typename?: 'Classification';
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  subClassification: SubClassification;
};

export type ClassificationInfo = {
  __typename?: 'ClassificationInfo';
  label: Scalars['String']['output'];
};

export type ClassificationInfolabelArgs = {
  languageCode: Scalars['LanguageCodeIso']['input'];
};

export type ClassificationInput = {
  id: Scalars['Int']['input'];
  subClassification: SubClassificationInput;
};

export type ClassificationOptions = {
  __typename?: 'ClassificationOptions';
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  subClassifications: Array<SubClassification>;
};

export type CommunityGuideline = {
  __typename?: 'CommunityGuideline';
  url: Scalars['String']['output'];
};

export type CommunityGuidelineurlArgs = {
  locale?: Scalars['Locale']['input'];
  zone?: Scalars['Zone']['input'];
};

export type CompanyDetails = {
  __typename?: 'CompanyDetails';
  companyProfile?: Maybe<CompanyProfileV2>;
  companyReviewLocations?: Maybe<Array<Maybe<CompanyReviewLocation>>>;
  companyReviews?: Maybe<CompanyReviewsV2>;
  companyReviewsAISummary?: Maybe<CompanyReviewsAISummary>;
  companySalaryRange?: Maybe<CompanyProfileSalaryRanges>;
  id: Scalars['CompanyId']['output'];
};

export type CompanyDetailscompanyProfileArgs = {
  draft?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CompanyDetailscompanyReviewLocationsArgs = {
  locale: Scalars['Locale']['input'];
  sort?: InputMaybe<Scalars['Boolean']['input']>;
  zone: Scalars['Zone']['input'];
};

export type CompanyDetailscompanyReviewsArgs = {
  locationId?: InputMaybe<Scalars['ID']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  zone: Scalars['Zone']['input'];
};

export type CompanyDetailscompanyReviewsAISummaryArgs = {
  locale?: InputMaybe<Scalars['Locale']['input']>;
};

export type CompanyGroupByInput = {
  group: COMPANY_GROUP;
  value: Array<InputMaybe<Scalars['String']['input']>>;
};

export type CompanyNameSlug = {
  __typename?: 'CompanyNameSlug';
  companySlug?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

export type CompanyProfile = {
  __typename?: 'CompanyProfile';
  /** @deprecated All company pages should display reviews */
  areReviewsEnabled: Scalars['Boolean']['output'];
  awards: Array<Award>;
  branding?: Maybe<Branding>;
  companyNameSlug: Scalars['String']['output'];
  countryCode?: Maybe<Scalars['String']['output']>;
  cultureAndValues?: Maybe<CultureAndValues>;
  customStatement?: Maybe<CustomStatement>;
  featured?: Maybe<Featured>;
  id: Scalars['ID']['output'];
  /** @deprecated Beta badge is not needed anymore */
  isBeta?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated All company pages are company profiles now */
  isCompanyProfile: Scalars['Boolean']['output'];
  missionStatement?: Maybe<MissionStatement>;
  name: Scalars['String']['output'];
  organisationId?: Maybe<Scalars['String']['output']>;
  overview?: Maybe<Overview>;
  perksAndBenefits: Array<PerkAndBenefit>;
  profileUrl?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use CompanyReviews query instead */
  reviews: Reviews;
  reviewsSummary?: Maybe<ReviewsSummary>;
  reviewsUrl?: Maybe<Scalars['String']['output']>;
  /** @deprecated All company pages should display reviews */
  shouldDisplayReviews: Scalars['Boolean']['output'];
  tracking: CompanyProfileTracking;
  zone: Scalars['Zone']['output'];
};

export type CompanyProfilereviewsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};

export type CompanyProfileAwards = {
  __typename?: 'CompanyProfileAwards';
  imageUrl: Scalars['String']['output'];
  name: Scalars['String']['output'];
  year: Scalars['Int']['output'];
};

export type CompanyProfileBranding = {
  __typename?: 'CompanyProfileBranding';
  brandId?: Maybe<Scalars['String']['output']>;
  cover?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
};

export type CompanyProfileCultureAndValues = {
  __typename?: 'CompanyProfileCultureAndValues';
  description: Scalars['String']['output'];
  imageUrl: Scalars['String']['output'];
  title: Scalars['String']['output'];
  values?: Maybe<Array<Maybe<CompanyProfileValues>>>;
};

export type CompanyProfileCustomStatement = {
  __typename?: 'CompanyProfileCustomStatement';
  description?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  title?: Maybe<Scalars['String']['output']>;
};

export type CompanyProfileData = {
  __typename?: 'CompanyProfileData';
  awards?: Maybe<Array<Maybe<CompanyProfileAwards>>>;
  branding?: Maybe<CompanyProfileBranding>;
  canonicalUrl?: Maybe<Scalars['String']['output']>;
  cultureAndValues?: Maybe<CompanyProfileCultureAndValues>;
  customStatement?: Maybe<CompanyProfileCustomStatement>;
  featured?: Maybe<CompanyProfileFeatured>;
  gallery?: Maybe<Array<Maybe<CompanyProfileGallery>>>;
  isClaimed: Scalars['Boolean']['output'];
  missionStatement?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  name?: Maybe<Scalars['String']['output']>;
  overview?: Maybe<CompanyProfileOverviewV2>;
  perksAndBenefits?: Maybe<Array<Maybe<CompanyProfilePerksAndBenefits>>>;
};

export type CompanyProfileFeatured = {
  __typename?: 'CompanyProfileFeatured';
  description?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  videoUrl?: Maybe<Scalars['String']['output']>;
};

export type CompanyProfileGallery = {
  __typename?: 'CompanyProfileGallery';
  date?: Maybe<Scalars['Int']['output']>;
  linkUrl: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type CompanyProfileOverallRating = {
  __typename?: 'CompanyProfileOverallRating';
  count?: Maybe<Scalars['Int']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
};

export type CompanyProfileOverview = {
  __typename?: 'CompanyProfileOverview';
  description?: Maybe<Array<Scalars['String']['output']>>;
  industry?: Maybe<Scalars['String']['output']>;
  primaryLocation?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['String']['output']>;
  specialities?: Maybe<Array<Scalars['String']['output']>>;
  website?: Maybe<CompanyProfileWebsite>;
};

export type CompanyProfileOverviewV2 = {
  __typename?: 'CompanyProfileOverviewV2';
  description?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  industry?: Maybe<Scalars['String']['output']>;
  primaryLocation?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['String']['output']>;
  specialities?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  traditionalLand?: Maybe<Scalars['String']['output']>;
  traditionalPlace?: Maybe<Scalars['String']['output']>;
  website?: Maybe<CompanyProfileWebsiteV2>;
};

export type CompanyProfilePerksAndBenefits = {
  __typename?: 'CompanyProfilePerksAndBenefits';
  description?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type CompanyProfileReviewsSummary = {
  __typename?: 'CompanyProfileReviewsSummary';
  count?: Maybe<Scalars['Int']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
};

export type CompanyProfileSalaryRanges = {
  __typename?: 'CompanyProfileSalaryRanges';
  lastUpdatedAt: SeekDateTime;
  salaryRangeByRoles: Array<Maybe<SalaryRangeByRoles>>;
};

export type CompanyProfileSortRating = {
  __typename?: 'CompanyProfileSortRating';
  rating?: Maybe<Scalars['Float']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type CompanyProfileTracking = {
  __typename?: 'CompanyProfileTracking';
  isCompanyProfile: Scalars['Boolean']['output'];
};

export type CompanyProfileV2 = {
  __typename?: 'CompanyProfileV2';
  companyReviewRating?: Maybe<CompanyReviewCompanyReviewRating>;
  data?: Maybe<CompanyProfileData>;
  organisationId?: Maybe<Scalars['String']['output']>;
  zone?: Maybe<Scalars['Zone']['output']>;
};

export type CompanyProfileValues = {
  __typename?: 'CompanyProfileValues';
  description: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type CompanyProfileWebsite = {
  __typename?: 'CompanyProfileWebsite';
  displayName?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type CompanyProfileWebsiteV2 = {
  __typename?: 'CompanyProfileWebsiteV2';
  displayName?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type CompanyReviewAISummaryContent = {
  __typename?: 'CompanyReviewAISummaryContent';
  challengesTheme?: Maybe<Array<Maybe<CompanyReviewAISummaryTheme>>>;
  positiveAndChallengesSummary?: Maybe<Scalars['String']['output']>;
  positiveTheme?: Maybe<Array<Maybe<CompanyReviewAISummaryTheme>>>;
};

export type CompanyReviewAISummaryTheme = {
  __typename?: 'CompanyReviewAISummaryTheme';
  description?: Maybe<Scalars['String']['output']>;
  theme?: Maybe<Scalars['String']['output']>;
};

export type CompanyReviewCompanyReviewRating = {
  __typename?: 'CompanyReviewCompanyReviewRating';
  careerOpportunity?: Maybe<CompanyReviewRating>;
  company?: Maybe<CompanyReviewRating>;
  companyRating1Star?: Maybe<CompanyReviewRating>;
  companyRating2Star?: Maybe<CompanyReviewRating>;
  companyRating3Star?: Maybe<CompanyReviewRating>;
  companyRating4Star?: Maybe<CompanyReviewRating>;
  companyRating5Star?: Maybe<CompanyReviewRating>;
  companyRecommended?: Maybe<CompanyReviewRating>;
  diversity?: Maybe<CompanyReviewRating>;
  executiveManagement?: Maybe<CompanyReviewRating>;
  perksAndBenefits?: Maybe<CompanyReviewRating>;
  salaryFair?: Maybe<CompanyReviewRating>;
  salaryGenerous?: Maybe<CompanyReviewRating>;
  salaryPoor?: Maybe<CompanyReviewRating>;
  workEnvironment?: Maybe<CompanyReviewRating>;
  workLifeBalance?: Maybe<CompanyReviewRating>;
};

export type CompanyReviewLocation = {
  __typename?: 'CompanyReviewLocation';
  contextualName: Scalars['String']['output'];
  relativeUrl: Scalars['String']['output'];
};

export type CompanyReviewRating = {
  __typename?: 'CompanyReviewRating';
  count?: Maybe<Scalars['Int']['output']>;
  percentage?: Maybe<Scalars['Float']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
};

export type CompanyReviewReply = {
  __typename?: 'CompanyReviewReply';
  createdAt: SeekDateTime;
  from: Scalars['String']['output'];
  text: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type CompanyReviewV2 = {
  __typename?: 'CompanyReviewV2';
  companyId: Scalars['String']['output'];
  cons?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<SeekDateTime>;
  employmentStatus?: Maybe<Scalars['String']['output']>;
  hasBeenFlagged?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  jobTitle?: Maybe<Scalars['String']['output']>;
  overallExperienceDetails?: Maybe<Scalars['String']['output']>;
  overallRating: Scalars['Float']['output'];
  pros?: Maybe<Scalars['String']['output']>;
  ratings: Array<CompanyReviewV2RatingItem>;
  recommended: CompanyReviewV2Recommended;
  reply?: Maybe<CompanyReviewV2Reply>;
  salarySummary: Scalars['String']['output'];
  schemaVersion: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
  upvotes?: Maybe<CompanyReviewV2UpVotes>;
  workLocation?: Maybe<Scalars['String']['output']>;
};

export type CompanyReviewV2employmentStatusArgs = {
  locale?: Scalars['Locale']['input'];
};

export type CompanyReviewV2salarySummaryArgs = {
  locale?: Scalars['Locale']['input'];
};

export type CompanyReviewV2RatingItem = {
  __typename?: 'CompanyReviewV2RatingItem';
  description: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type CompanyReviewV2RatingItemdescriptionArgs = {
  locale?: Scalars['Locale']['input'];
};

export type CompanyReviewV2Recommended = {
  __typename?: 'CompanyReviewV2Recommended';
  description: Scalars['String']['output'];
  value: Scalars['Boolean']['output'];
};

export type CompanyReviewV2RecommendeddescriptionArgs = {
  locale?: Scalars['Locale']['input'];
};

export type CompanyReviewV2Reply = {
  __typename?: 'CompanyReviewV2Reply';
  createdAt: SeekDateTime;
  from: Scalars['String']['output'];
  text: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type CompanyReviewV2UpVotes = {
  __typename?: 'CompanyReviewV2UpVotes';
  count: Scalars['Int']['output'];
  description: Scalars['String']['output'];
  userIds?: Maybe<Array<Scalars['String']['output']>>;
};

export type CompanyReviewV2UpVotesdescriptionArgs = {
  locale?: Scalars['Locale']['input'];
};

export type CompanyReviews = {
  __typename?: 'CompanyReviews';
  fullName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  rating: Scalars['Float']['output'];
  reviewCount: Scalars['Int']['output'];
  reviewsUrl: Scalars['String']['output'];
};

export type CompanyReviewsAISummary = {
  __typename?: 'CompanyReviewsAISummary';
  aISummaryContent?: Maybe<CompanyReviewAISummaryContent>;
  reviewsCount?: Maybe<Scalars['Int']['output']>;
  reviewsDateFrom?: Maybe<Scalars['String']['output']>;
  reviewsDateTo?: Maybe<Scalars['String']['output']>;
};

export type CompanyReviewsV2 = {
  __typename?: 'CompanyReviewsV2';
  data: Array<CompanyReviewV2>;
  paging: CompanyReviewsV2Paging;
};

export type CompanyReviewsV2Paging = {
  __typename?: 'CompanyReviewsV2Paging';
  page: Scalars['Int']['output'];
  perPage: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type CompanySize = {
  __typename?: 'CompanySize';
  description: Scalars['String']['output'];
};

export type CompanySizedescriptionArgs = {
  locale?: Scalars['Locale']['input'];
};

export type CompanyTag = {
  __typename?: 'CompanyTag';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type CompanyTagkeyArgs = {
  languageCode?: InputMaybe<Scalars['LanguageCodeIso']['input']>;
};

export type CompletionDate = MonthYear | Year;

export type ConfirmQualificationInput = {
  completed: Scalars['Boolean']['input'];
  completionYear?: InputMaybe<Scalars['Int']['input']>;
  expectedCompletionDate?: InputMaybe<MonthYearInput>;
  highlights?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  institute: OntologyStructuredDataInput;
  name: OntologyStructuredDataInput;
  tracking?: InputMaybe<TrackingInfoInput>;
};

export type ConfirmQualificationPayload = {
  __typename?: 'ConfirmQualificationPayload';
  /** @deprecated Use viewer.qualifications */
  ref?: Maybe<Scalars['UUID']['output']>;
  viewer?: Maybe<Candidate>;
};

export type ConfirmRoleInput = {
  achievements?: InputMaybe<Scalars['String']['input']>;
  company: OntologyStructuredDataInput;
  from: MonthYearInput;
  /** Required for JobsDB only */
  function?: InputMaybe<RoleFunctionInput>;
  id: Scalars['UUID']['input'];
  /** Required for JobsDB only */
  industry?: InputMaybe<RoleIndustryInput>;
  seniority?: InputMaybe<OntologyStructuredDataInput>;
  title: OntologyStructuredDataInput;
  to?: InputMaybe<MonthYearInput>;
  tracking?: InputMaybe<TrackingInfoInput>;
};

export type ConfirmRolePayload = {
  __typename?: 'ConfirmRolePayload';
  /** @deprecated Use viewer.roles */
  role: Role;
  viewer?: Maybe<Candidate>;
};

export type ConfirmedStatus = 'confirmed' | 'unconfirmed';

export type ConsentTransactionDetails = {
  __typename?: 'ConsentTransactionDetails';
  /** The name of the hirer requesting consent */
  hirerName: Scalars['String']['output'];
  /** The name of the partner requesting consent */
  partnerName: Scalars['String']['output'];
  /** The partner redirectUri in the event of a consent rejection or error */
  redirectUri: Scalars['String']['output'];
};

export type ConsentTransactionDetailsInput = {
  transactionId: Scalars['UUID']['input'];
};

export type ContactMatches = {
  __typename?: 'ContactMatches';
  type: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** Main Result Types */
export type CountV6Result = {
  __typename?: 'CountV6Result';
  resultCount: Scalars['Int']['output'];
};

export type CountryCallingCode = {
  __typename?: 'CountryCallingCode';
  /** Country calling code prefixed with a `+`, e.g. `+61` */
  countryCallingCode: Scalars['String']['output'];
  /**
   * Human-readable description of the country calling code; contains the country
   * associated with the code as well as the code itself, e.g. `Australia (+61)`.
   */
  description: Scalars['String']['output'];
  /** Unique ID used to identify a specific country calling code */
  id: Scalars['ID']['output'];
};

export type CountryCallingCodeInput = {
  /** Unique ID corresponding to a `CountryCallingCode` */
  id: Scalars['ID']['input'];
};

export type CountryCode = 'au' | 'nz' | 'sg';

export type CountryInformation = {
  __typename?: 'CountryInformation';
  /** The country's ISO 3166-1 alpha-2 country code */
  countryCode: Scalars['CountryCodeIso2']['output'];
  /** The country's name */
  name: Scalars['String']['output'];
};

export type CountsV6Result = {
  __typename?: 'CountsV6Result';
  classification: Array<Maybe<JobSearchV6FacetCount>>;
  location: Array<Maybe<JobSearchV6FacetCount>>;
  worktype: Array<Maybe<JobSearchV6FacetCount>>;
};

export type Cover = {
  __typename?: 'Cover';
  aspectRatio?: Maybe<Scalars['Float']['output']>;
  url: Scalars['String']['output'];
};

export type CoverLetterAppliedJobDocument = {
  __typename?: 'CoverLetterAppliedJobDocument';
  attachmentMetadata: AttachmentMetadata;
  blobUrl: Scalars['String']['output'];
  downloadLink?: Maybe<Scalars['String']['output']>;
};

export type CoverLetterInput = {
  uri: Scalars['String']['input'];
  writtenText?: InputMaybe<Scalars['String']['input']>;
};

export type CreateApacSavedSearchDuplicateError = CreateApacSavedSearchError & {
  __typename?: 'CreateApacSavedSearchDuplicateError';
  message: Scalars['String']['output'];
};

export type CreateApacSavedSearchDuplicateErrormessageArgs = {
  locale?: InputMaybe<Scalars['Locale']['input']>;
};

export type CreateApacSavedSearchError = {
  message: Scalars['String']['output'];
};

export type CreateApacSavedSearchErrormessageArgs = {
  locale?: InputMaybe<Scalars['Locale']['input']>;
};

export type CreateApacSavedSearchErrorMaxExceeded =
  CreateApacSavedSearchError & {
    __typename?: 'CreateApacSavedSearchErrorMaxExceeded';
    message: Scalars['String']['output'];
    savedSearchLimit: Scalars['Int']['output'];
  };

export type CreateApacSavedSearchErrorMaxExceededmessageArgs = {
  locale?: InputMaybe<Scalars['Locale']['input']>;
};

export type CreateApacSavedSearchFailure = {
  __typename?: 'CreateApacSavedSearchFailure';
  error: CreateApacSavedSearchError;
};

export type CreateApacSavedSearchInput = {
  isUnified?: InputMaybe<Scalars['Boolean']['input']>;
  searchQueryString: Scalars['JobSearchQueryString']['input'];
  zone: Scalars['Zone']['input'];
};

export type CreateApacSavedSearchInvalidLocationError =
  CreateApacSavedSearchError & {
    __typename?: 'CreateApacSavedSearchInvalidLocationError';
    message: Scalars['String']['output'];
  };

export type CreateApacSavedSearchInvalidLocationErrormessageArgs = {
  locale?: InputMaybe<Scalars['Locale']['input']>;
};

export type CreateApacSavedSearchPayload =
  | CreateApacSavedSearchFailure
  | CreateApacSavedSearchSuccess;

export type CreateApacSavedSearchSuccess = {
  __typename?: 'CreateApacSavedSearchSuccess';
  savedSearch: ApacSavedSearch;
};

export type CreateCandidateJobMatchAllocationExhausted =
  CreateCandidateJobMatchResponse & {
    __typename?: 'CreateCandidateJobMatchAllocationExhausted';
    jobId: Scalars['ID']['output'];
    message: Scalars['String']['output'];
    retryAfter: Scalars['Int']['output'];
  };

export type CreateCandidateJobMatchAllocationExhaustedmessageArgs = {
  locale?: InputMaybe<Scalars['Locale']['input']>;
};

export type CreateCandidateJobMatchJobExpired =
  CreateCandidateJobMatchResponse & {
    __typename?: 'CreateCandidateJobMatchJobExpired';
    jobId: Scalars['ID']['output'];
    message: Scalars['String']['output'];
  };

export type CreateCandidateJobMatchJobExpiredmessageArgs = {
  locale?: InputMaybe<Scalars['Locale']['input']>;
};

export type CreateCandidateJobMatchNotEligible =
  CreateCandidateJobMatchResponse & {
    __typename?: 'CreateCandidateJobMatchNotEligible';
    jobId: Scalars['ID']['output'];
    message: Scalars['String']['output'];
    qualifiers: Array<Scalars['String']['output']>;
  };

export type CreateCandidateJobMatchNotEligiblemessageArgs = {
  locale?: InputMaybe<Scalars['Locale']['input']>;
};

export type CreateCandidateJobMatchRequestInput = {
  channel: Scalars['String']['input'];
  jobId: Scalars['ID']['input'];
  language?: InputMaybe<Scalars['String']['input']>;
  platform: Platform;
  visitorId: Scalars['UUID']['input'];
};

export type CreateCandidateJobMatchResponse = {
  jobId: Scalars['ID']['output'];
};

export type CreateConsentError = {
  message: Scalars['String']['output'];
};

export type CreateConsentErrormessageArgs = {
  locale?: InputMaybe<Scalars['Locale']['input']>;
};

export type CreateConsentFailure = {
  __typename?: 'CreateConsentFailure';
  errors: Array<CreateConsentError>;
};

export type CreateConsentInput = {
  transactionId: Scalars['UUID']['input'];
};

export type CreateConsentPayload = CreateConsentFailure | CreateConsentSuccess;

export type CreateConsentSuccess = {
  __typename?: 'CreateConsentSuccess';
  redirectUri: Scalars['String']['output'];
};

export type CreateConsentTransactionInvalidError = CreateConsentError & {
  __typename?: 'CreateConsentTransactionInvalidError';
  message: Scalars['String']['output'];
};

export type CreateConsentTransactionInvalidErrormessageArgs = {
  locale?: InputMaybe<Scalars['Locale']['input']>;
};

export type CreateLinkoutApplicationInput = {
  jobId: Scalars['ID']['input'];
};

export type CreateLinkoutApplicationPayload = {
  __typename?: 'CreateLinkoutApplicationPayload';
  applicationUrl: Scalars['String']['output'];
};

export type CreateProfileAvatarError = {
  message: Scalars['String']['output'];
};

export type CreateProfileAvatarErrormessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type CreateProfileAvatarFailure = {
  __typename?: 'CreateProfileAvatarFailure';
  error: CreateProfileAvatarError;
};

export type CreateProfileAvatarPayload =
  | CreateProfileAvatarFailure
  | CreateProfileAvatarSuccess;

export type CreateProfileAvatarSuccess = {
  __typename?: 'CreateProfileAvatarSuccess';
  /** Avatar ID */
  avatarId: Scalars['ID']['output'];
  /** Upload URL */
  uploadUrl: Scalars['String']['output'];
};

export type CreateSavedJobError = {
  message: Scalars['String']['output'];
};

export type CreateSavedJobErrormessageArgs = {
  locale?: InputMaybe<Scalars['Locale']['input']>;
};

export type CreateSavedJobFailure = {
  __typename?: 'CreateSavedJobFailure';
  errors: Array<CreateSavedJobError>;
};

export type CreateSavedJobInput = {
  eventCaptureData?: InputMaybe<SavedJobEventCaptureDataInput>;
  id: Scalars['ID']['input'];
  zone?: InputMaybe<Scalars['Zone']['input']>;
};

export type CreateSavedJobPayload =
  | CreateSavedJobFailure
  | CreateSavedJobSuccess;

export type CreateSavedJobSuccess = {
  __typename?: 'CreateSavedJobSuccess';
  id: Scalars['ID']['output'];
  zone?: Maybe<Scalars['Zone']['output']>;
};

export type CreateSavedJobValidationError = CreateSavedJobError & {
  __typename?: 'CreateSavedJobValidationError';
  message: Scalars['String']['output'];
};

export type CreateSavedJobValidationErrormessageArgs = {
  locale?: InputMaybe<Scalars['Locale']['input']>;
};

export type CreateSeekMaxCommentBlockedWordsError =
  CreateSeekMaxCommentError & {
    __typename?: 'CreateSeekMaxCommentBlockedWordsError';
    message: Scalars['String']['output'];
    title: Scalars['String']['output'];
  };

export type CreateSeekMaxCommentBlockedWordsErrormessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type CreateSeekMaxCommentBlockedWordsErrortitleArgs = {
  locale: Scalars['Locale']['input'];
};

export type CreateSeekMaxCommentError = {
  message: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type CreateSeekMaxCommentErrormessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type CreateSeekMaxCommentErrortitleArgs = {
  locale: Scalars['Locale']['input'];
};

export type CreateSeekMaxCommentExceedRateLimitError =
  CreateSeekMaxCommentError & {
    __typename?: 'CreateSeekMaxCommentExceedRateLimitError';
    message: Scalars['String']['output'];
    title: Scalars['String']['output'];
  };

export type CreateSeekMaxCommentExceedRateLimitErrormessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type CreateSeekMaxCommentExceedRateLimitErrortitleArgs = {
  locale: Scalars['Locale']['input'];
};

export type CreateSeekMaxCommentFailure = {
  __typename?: 'CreateSeekMaxCommentFailure';
  errors: Array<CreateSeekMaxCommentError>;
};

/** @deprecated(reason: 'Use CreateSeekMaxCommentV2Input instead') */
export type CreateSeekMaxCommentInput = {
  content: Scalars['String']['input'];
  threadId: Scalars['ID']['input'];
  zone?: InputMaybe<Scalars['Zone']['input']>;
};

export type CreateSeekMaxCommentPayload =
  | CreateSeekMaxCommentFailure
  | CreateSeekMaxCommentSuccess;

export type CreateSeekMaxCommentSuccess = {
  __typename?: 'CreateSeekMaxCommentSuccess';
  comment: SeekMaxComment;
  /** @deprecated Use 'comment.id' instead */
  id: Scalars['ID']['output'];
};

export type CreateSeekMaxCommentUserIsBannedError =
  CreateSeekMaxCommentError & {
    __typename?: 'CreateSeekMaxCommentUserIsBannedError';
    message: Scalars['String']['output'];
    title: Scalars['String']['output'];
  };

export type CreateSeekMaxCommentUserIsBannedErrormessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type CreateSeekMaxCommentUserIsBannedErrortitleArgs = {
  locale: Scalars['Locale']['input'];
};

export type CreateSeekMaxCommentV2Input = {
  content: Scalars['String']['input'];
  threadId: Scalars['ID']['input'];
  zone: Scalars['Zone']['input'];
};

export type CreateSeekMaxModuleBookmarkError = {
  message: Scalars['String']['output'];
};

export type CreateSeekMaxModuleBookmarkErrormessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type CreateSeekMaxModuleBookmarkFailure = {
  __typename?: 'CreateSeekMaxModuleBookmarkFailure';
  errors: Array<CreateSeekMaxModuleBookmarkError>;
};

export type CreateSeekMaxModuleBookmarkPayload =
  | CreateSeekMaxModuleBookmarkFailure
  | CreateSeekMaxModuleBookmarkSuccess;

export type CreateSeekMaxModuleBookmarkSuccess = {
  __typename?: 'CreateSeekMaxModuleBookmarkSuccess';
  id: Scalars['ID']['output'];
};

export type CreateSeekMaxReplyBlockedWordsError = CreateSeekMaxReplyError & {
  __typename?: 'CreateSeekMaxReplyBlockedWordsError';
  message: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type CreateSeekMaxReplyBlockedWordsErrormessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type CreateSeekMaxReplyBlockedWordsErrortitleArgs = {
  locale: Scalars['Locale']['input'];
};

export type CreateSeekMaxReplyError = {
  message: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type CreateSeekMaxReplyErrormessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type CreateSeekMaxReplyErrortitleArgs = {
  locale: Scalars['Locale']['input'];
};

export type CreateSeekMaxReplyExceedRateLimitError = CreateSeekMaxReplyError & {
  __typename?: 'CreateSeekMaxReplyExceedRateLimitError';
  message: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type CreateSeekMaxReplyExceedRateLimitErrormessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type CreateSeekMaxReplyExceedRateLimitErrortitleArgs = {
  locale: Scalars['Locale']['input'];
};

export type CreateSeekMaxReplyFailure = {
  __typename?: 'CreateSeekMaxReplyFailure';
  errors: Array<CreateSeekMaxReplyError>;
};

/** @deprecated(reason: 'Use CreateSeekMaxReplyV2Input instead') */
export type CreateSeekMaxReplyInput = {
  commentId: Scalars['ID']['input'];
  content: Scalars['String']['input'];
  /** @deprecated Not in used */
  threadId?: InputMaybe<Scalars['ID']['input']>;
  zone?: InputMaybe<Scalars['Zone']['input']>;
};

export type CreateSeekMaxReplyPayload =
  | CreateSeekMaxReplyFailure
  | CreateSeekMaxReplySuccess;

export type CreateSeekMaxReplySuccess = {
  __typename?: 'CreateSeekMaxReplySuccess';
  /** @deprecated Use 'reply.id' instead */
  id: Scalars['ID']['output'];
  reply: SeekMaxReply;
};

export type CreateSeekMaxReplyUserIsBannedError = CreateSeekMaxReplyError & {
  __typename?: 'CreateSeekMaxReplyUserIsBannedError';
  message: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type CreateSeekMaxReplyUserIsBannedErrormessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type CreateSeekMaxReplyUserIsBannedErrortitleArgs = {
  locale: Scalars['Locale']['input'];
};

export type CreateSeekMaxReplyV2Input = {
  commentId: Scalars['ID']['input'];
  content: Scalars['String']['input'];
  zone: Scalars['Zone']['input'];
};

export type CreateSeekMaxThreadAttachmentInput = {
  filename: Scalars['String']['input'];
  type: SeekMaxAttachmentType;
};

export type CreateSeekMaxThreadBlockedWordsError = CreateSeekMaxThreadError & {
  __typename?: 'CreateSeekMaxThreadBlockedWordsError';
  message: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type CreateSeekMaxThreadBlockedWordsErrormessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type CreateSeekMaxThreadBlockedWordsErrortitleArgs = {
  locale: Scalars['Locale']['input'];
};

export type CreateSeekMaxThreadError = {
  message: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type CreateSeekMaxThreadErrormessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type CreateSeekMaxThreadErrortitleArgs = {
  locale: Scalars['Locale']['input'];
};

export type CreateSeekMaxThreadExceedRateLimitError =
  CreateSeekMaxThreadError & {
    __typename?: 'CreateSeekMaxThreadExceedRateLimitError';
    message: Scalars['String']['output'];
    title: Scalars['String']['output'];
  };

export type CreateSeekMaxThreadExceedRateLimitErrormessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type CreateSeekMaxThreadExceedRateLimitErrortitleArgs = {
  locale: Scalars['Locale']['input'];
};

export type CreateSeekMaxThreadFailure = {
  __typename?: 'CreateSeekMaxThreadFailure';
  errors: Array<CreateSeekMaxThreadError>;
};

export type CreateSeekMaxThreadInput = {
  attachments?: InputMaybe<Array<CreateSeekMaxThreadAttachmentInput>>;
  description: Scalars['String']['input'];
  groupNanoId: Scalars['ID']['input'];
  zone: Scalars['Zone']['input'];
};

export type CreateSeekMaxThreadPayload =
  | CreateSeekMaxThreadFailure
  | CreateSeekMaxThreadSuccess;

export type CreateSeekMaxThreadSuccess = {
  __typename?: 'CreateSeekMaxThreadSuccess';
  attachmentsToUpload?: Maybe<Array<SeekMaxAttachmentUploadReady>>;
  thread: SeekMaxThread;
};

export type CreateSeekMaxThreadUserIsBannedError = CreateSeekMaxThreadError & {
  __typename?: 'CreateSeekMaxThreadUserIsBannedError';
  message: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type CreateSeekMaxThreadUserIsBannedErrormessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type CreateSeekMaxThreadUserIsBannedErrortitleArgs = {
  locale: Scalars['Locale']['input'];
};

export type CreateSeekMaxThreadV2Input = {
  attachments?: InputMaybe<Array<CreateSeekMaxThreadAttachmentInput>>;
  categoryId: Scalars['ID']['input'];
  description: Scalars['String']['input'];
  zone: Scalars['Zone']['input'];
};

export type CreateShareableProfileSettingsError = {
  message: Scalars['String']['output'];
};

export type CreateShareableProfileSettingsErrormessageArgs = {
  locale?: InputMaybe<Scalars['Locale']['input']>;
};

export type CreateShareableProfileSettingsFailure = {
  __typename?: 'CreateShareableProfileSettingsFailure';
  error: CreateShareableProfileSettingsError;
};

export type CreateShareableProfileSettingsPayload =
  | CreateShareableProfileSettingsFailure
  | CreateShareableProfileSettingsSuccess;

export type CreateShareableProfileSettingsSuccess = {
  __typename?: 'CreateShareableProfileSettingsSuccess';
  viewer?: Maybe<Candidate>;
};

export type CreateUnregisteredApacSavedSearchDuplicateError =
  CreateUnregisteredApacSavedSearchError & {
    __typename?: 'CreateUnregisteredApacSavedSearchDuplicateError';
    message: Scalars['String']['output'];
  };

export type CreateUnregisteredApacSavedSearchDuplicateErrormessageArgs = {
  locale?: InputMaybe<Scalars['Locale']['input']>;
};

export type CreateUnregisteredApacSavedSearchError = {
  message: Scalars['String']['output'];
};

export type CreateUnregisteredApacSavedSearchErrormessageArgs = {
  locale?: InputMaybe<Scalars['Locale']['input']>;
};

export type CreateUnregisteredApacSavedSearchErrorMaxExceeded =
  CreateUnregisteredApacSavedSearchError & {
    __typename?: 'CreateUnregisteredApacSavedSearchErrorMaxExceeded';
    message: Scalars['String']['output'];
    savedSearchLimit: Scalars['Int']['output'];
  };

export type CreateUnregisteredApacSavedSearchErrorMaxExceededmessageArgs = {
  locale?: InputMaybe<Scalars['Locale']['input']>;
};

export type CreateUnregisteredApacSavedSearchInvalidChecksumError =
  CreateUnregisteredApacSavedSearchError & {
    __typename?: 'CreateUnregisteredApacSavedSearchInvalidChecksumError';
    message: Scalars['String']['output'];
  };

export type CreateUnregisteredApacSavedSearchInvalidChecksumErrormessageArgs = {
  locale?: InputMaybe<Scalars['Locale']['input']>;
};

export type CreateUnregisteredApacSavedSearchInvalidEmailError =
  CreateUnregisteredApacSavedSearchError & {
    __typename?: 'CreateUnregisteredApacSavedSearchInvalidEmailError';
    message: Scalars['String']['output'];
  };

export type CreateUnregisteredApacSavedSearchInvalidEmailErrormessageArgs = {
  locale?: InputMaybe<Scalars['Locale']['input']>;
};

export type CreateUnregisteredApacSavedSearchInvalidLocationError =
  CreateUnregisteredApacSavedSearchError & {
    __typename?: 'CreateUnregisteredApacSavedSearchInvalidLocationError';
    message: Scalars['String']['output'];
  };

export type CreateUnregisteredApacSavedSearchInvalidLocationErrormessageArgs = {
  locale?: InputMaybe<Scalars['Locale']['input']>;
};

export type CreateUnregisteredApacSavedSearchWithChecksumFailure = {
  __typename?: 'CreateUnregisteredApacSavedSearchWithChecksumFailure';
  error: CreateUnregisteredApacSavedSearchError;
};

export type CreateUnregisteredApacSavedSearchWithChecksumInput = {
  checksum: Scalars['String']['input'];
  emailAddress: Scalars['Email']['input'];
  isUnified?: InputMaybe<Scalars['Boolean']['input']>;
  searchQueryString: Scalars['JobSearchQueryString']['input'];
  zone: Scalars['Zone']['input'];
};

export type CreateUnregisteredApacSavedSearchWithChecksumPayload =
  | CreateUnregisteredApacSavedSearchWithChecksumFailure
  | CreateUnregisteredApacSavedSearchWithChecksumSuccess;

export type CreateUnregisteredApacSavedSearchWithChecksumSuccess = {
  __typename?: 'CreateUnregisteredApacSavedSearchWithChecksumSuccess';
  id: Scalars['ID']['output'];
};

export type CredentialExpiryStatus = 'EXPIRED' | 'EXPIRING_SOON';

export type CredentialInfo = {
  __typename?: 'CredentialInfo';
  name: Scalars['String']['output'];
  values: Array<Scalars['String']['output']>;
};

export type CredentialStatus = 'Expired' | 'ExpiresSoon' | 'New';

export type CredentialVerification = {
  __typename?: 'CredentialVerification';
  result: Scalars['String']['output'];
};

export type CultureAndValues = {
  __typename?: 'CultureAndValues';
  description: Scalars['String']['output'];
  imageUrl: Scalars['String']['output'];
  title: Scalars['String']['output'];
  values: Array<CultureValue>;
};

export type CultureValue = {
  __typename?: 'CultureValue';
  description: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type CurrentLocation2Input = {
  id: Scalars['Int']['input'];
};

export type CustomStatement = {
  __typename?: 'CustomStatement';
  description: Description;
  title: Scalars['String']['output'];
};

export type DateTimeContext = 'JOB_POSTED' | 'SEEKMAX_POLL_DURATION_LEFT';

export type DateTimeLength = 'LONG' | 'SHORT';

export type DefaultCurrency = {
  __typename?: 'DefaultCurrency';
  code: Scalars['String']['output'];
};

export type DefaultGenerateCoverLetterError = GenerateCoverLetterError & {
  __typename?: 'DefaultGenerateCoverLetterError';
  message: Scalars['String']['output'];
};

export type DefaultGenerateCoverLetterErrormessageArgs = {
  locale?: InputMaybe<Scalars['Locale']['input']>;
};

export type DefaultGenerateSelectionCriteriaError =
  GenerateSelectionCriteriaError & {
    __typename?: 'DefaultGenerateSelectionCriteriaError';
    message: Scalars['String']['output'];
  };

export type DefaultGenerateSelectionCriteriaErrormessageArgs = {
  locale?: InputMaybe<Scalars['Locale']['input']>;
};

export type DeleteAccountFailure = {
  __typename?: 'DeleteAccountFailure';
  error: I18nAccountError;
};

export type DeleteAccountInput = {
  isBGroup?: InputMaybe<Scalars['Boolean']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
};

export type DeleteAccountPayload = DeleteAccountFailure | DeleteAccountSuccess;

export type DeleteAccountSuccess = {
  __typename?: 'DeleteAccountSuccess';
  ref: Scalars['UUID']['output'];
};

export type DeleteApacSavedSearchAbsentError = DeleteApacSavedSearchError & {
  __typename?: 'DeleteApacSavedSearchAbsentError';
  message: Scalars['String']['output'];
};

export type DeleteApacSavedSearchAbsentErrormessageArgs = {
  locale?: InputMaybe<Scalars['Locale']['input']>;
};

export type DeleteApacSavedSearchError = {
  message: Scalars['String']['output'];
};

export type DeleteApacSavedSearchErrormessageArgs = {
  locale?: InputMaybe<Scalars['Locale']['input']>;
};

export type DeleteApacSavedSearchFailure = {
  __typename?: 'DeleteApacSavedSearchFailure';
  errors: Array<DeleteApacSavedSearchError>;
};

export type DeleteApacSavedSearchInput = {
  id: Scalars['ID']['input'];
};

export type DeleteApacSavedSearchPayload =
  | DeleteApacSavedSearchFailure
  | DeleteApacSavedSearchSuccess;

export type DeleteApacSavedSearchSuccess = {
  __typename?: 'DeleteApacSavedSearchSuccess';
  id: Scalars['ID']['output'];
};

export type DeleteAppliedJobError = {
  message: Scalars['String']['output'];
};

export type DeleteAppliedJobErrormessageArgs = {
  locale?: InputMaybe<Scalars['Locale']['input']>;
};

export type DeleteAppliedJobFailure = {
  __typename?: 'DeleteAppliedJobFailure';
  errors: Array<DeleteAppliedJobError>;
};

export type DeleteAppliedJobInput = {
  id: Scalars['String']['input'];
};

export type DeleteAppliedJobPayload =
  | DeleteAppliedJobFailure
  | DeleteAppliedJobSuccess;

export type DeleteAppliedJobSuccess = {
  __typename?: 'DeleteAppliedJobSuccess';
  id: Scalars['String']['output'];
};

export type DeleteAppliedJobValidationError = DeleteAppliedJobError & {
  __typename?: 'DeleteAppliedJobValidationError';
  message: Scalars['String']['output'];
};

export type DeleteAppliedJobValidationErrormessageArgs = {
  locale?: InputMaybe<Scalars['Locale']['input']>;
};

export type DeleteJobPreferencesError = {
  message: Scalars['String']['output'];
};

export type DeleteJobPreferencesErrormessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type DeleteJobPreferencesFailure = {
  __typename?: 'DeleteJobPreferencesFailure';
  error: DeleteJobPreferencesError;
};

export type DeleteJobPreferencesInput = {
  id: Scalars['ID']['input'];
};

export type DeleteJobPreferencesPayload =
  | DeleteJobPreferencesFailure
  | DeleteJobPreferencesSuccess;

export type DeleteJobPreferencesSuccess = {
  __typename?: 'DeleteJobPreferencesSuccess';
  preferences: Array<Maybe<CandidateJobPreferencesGroup>>;
};

export type DeleteLanguageProficiencyInput = {
  id: Scalars['UUID']['input'];
};

export type DeleteLanguageProficiencyPayload = {
  __typename?: 'DeleteLanguageProficiencyPayload';
  viewer?: Maybe<Candidate>;
};

export type DeleteLicenceInput = {
  id: Scalars['UUID']['input'];
};

export type DeleteLicencePayload = {
  __typename?: 'DeleteLicencePayload';
  /** @deprecated Use viewer.licences */
  ref?: Maybe<Scalars['String']['output']>;
  viewer?: Maybe<Candidate>;
};

export type DeleteProfileAvatarError = {
  message: Scalars['String']['output'];
};

export type DeleteProfileAvatarErrormessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type DeleteProfileAvatarFailure = {
  __typename?: 'DeleteProfileAvatarFailure';
  error: DeleteProfileAvatarError;
};

export type DeleteProfileAvatarPayload =
  | DeleteProfileAvatarFailure
  | DeleteProfileAvatarSuccess;

export type DeleteProfileAvatarSuccess = {
  __typename?: 'DeleteProfileAvatarSuccess';
  /**
   * Deleted Avatar ID.
   * Evict the `ProfileAvatar` with this id.
   */
  avatarId?: Maybe<Scalars['ID']['output']>;
  /** Candidate with updated Profile Avatar. Use this to refetch the `profileAvatar` field. */
  viewer?: Maybe<Candidate>;
};

export type DeleteQualificationInput = {
  id: Scalars['UUID']['input'];
};

export type DeleteQualificationPayload = {
  __typename?: 'DeleteQualificationPayload';
  /** @deprecated Use viewer.qualifications */
  id?: Maybe<Scalars['UUID']['output']>;
  viewer?: Maybe<Candidate>;
};

export type DeleteResumeInput = {
  id: Scalars['UUID']['input'];
};

export type DeleteResumePayload = {
  __typename?: 'DeleteResumePayload';
  ref?: Maybe<Scalars['UUID']['output']>;
  viewer?: Maybe<Candidate>;
};

export type DeleteRoleInput = {
  id: Scalars['UUID']['input'];
};

export type DeleteRolePayload = {
  __typename?: 'DeleteRolePayload';
  /** @deprecated Use viewer.roles */
  id: Scalars['UUID']['output'];
  viewer?: Maybe<Candidate>;
};

export type DeleteSavedJobError = {
  message: Scalars['String']['output'];
};

export type DeleteSavedJobErrormessageArgs = {
  locale?: InputMaybe<Scalars['Locale']['input']>;
};

export type DeleteSavedJobFailure = {
  __typename?: 'DeleteSavedJobFailure';
  errors: Array<DeleteSavedJobError>;
};

export type DeleteSavedJobInput = {
  eventCaptureData?: InputMaybe<SavedJobEventCaptureDataInput>;
  id: Scalars['ID']['input'];
};

export type DeleteSavedJobPayload =
  | DeleteSavedJobFailure
  | DeleteSavedJobSuccess;

export type DeleteSavedJobSuccess = {
  __typename?: 'DeleteSavedJobSuccess';
  id: Scalars['ID']['output'];
};

export type DeleteSavedJobValidationError = DeleteSavedJobError & {
  __typename?: 'DeleteSavedJobValidationError';
  message: Scalars['String']['output'];
};

export type DeleteSavedJobValidationErrormessageArgs = {
  locale?: InputMaybe<Scalars['Locale']['input']>;
};

export type DeleteSeekMaxCommentAlreadyDeletedError =
  DeleteSeekMaxCommentError & {
    __typename?: 'DeleteSeekMaxCommentAlreadyDeletedError';
    message: Scalars['String']['output'];
    title: Scalars['String']['output'];
  };

export type DeleteSeekMaxCommentAlreadyDeletedErrormessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type DeleteSeekMaxCommentAlreadyDeletedErrortitleArgs = {
  locale: Scalars['Locale']['input'];
};

export type DeleteSeekMaxCommentError = {
  message: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type DeleteSeekMaxCommentErrormessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type DeleteSeekMaxCommentErrortitleArgs = {
  locale: Scalars['Locale']['input'];
};

export type DeleteSeekMaxCommentFailure = {
  __typename?: 'DeleteSeekMaxCommentFailure';
  errors: Array<DeleteSeekMaxCommentError>;
};

export type DeleteSeekMaxCommentInput = {
  id: Scalars['ID']['input'];
  zone?: InputMaybe<Scalars['Zone']['input']>;
};

export type DeleteSeekMaxCommentNotExistError = DeleteSeekMaxCommentError & {
  __typename?: 'DeleteSeekMaxCommentNotExistError';
  message: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type DeleteSeekMaxCommentNotExistErrormessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type DeleteSeekMaxCommentNotExistErrortitleArgs = {
  locale: Scalars['Locale']['input'];
};

export type DeleteSeekMaxCommentPayload =
  | DeleteSeekMaxCommentFailure
  | DeleteSeekMaxCommentSuccess;

export type DeleteSeekMaxCommentSuccess = {
  __typename?: 'DeleteSeekMaxCommentSuccess';
  id: Scalars['ID']['output'];
};

export type DeleteSeekMaxCommentUserIsBannedError =
  DeleteSeekMaxCommentError & {
    __typename?: 'DeleteSeekMaxCommentUserIsBannedError';
    message: Scalars['String']['output'];
    title: Scalars['String']['output'];
  };

export type DeleteSeekMaxCommentUserIsBannedErrormessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type DeleteSeekMaxCommentUserIsBannedErrortitleArgs = {
  locale: Scalars['Locale']['input'];
};

export type DeleteSeekMaxModuleBookmarkError = {
  message: Scalars['String']['output'];
};

export type DeleteSeekMaxModuleBookmarkErrormessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type DeleteSeekMaxModuleBookmarkFailure = {
  __typename?: 'DeleteSeekMaxModuleBookmarkFailure';
  errors: Array<DeleteSeekMaxModuleBookmarkError>;
};

export type DeleteSeekMaxModuleBookmarkPayload =
  | DeleteSeekMaxModuleBookmarkFailure
  | DeleteSeekMaxModuleBookmarkSuccess;

export type DeleteSeekMaxModuleBookmarkSuccess = {
  __typename?: 'DeleteSeekMaxModuleBookmarkSuccess';
  id: Scalars['ID']['output'];
};

export type DeleteSeekMaxReplyAlreadyDeletedError = DeleteSeekMaxReplyError & {
  __typename?: 'DeleteSeekMaxReplyAlreadyDeletedError';
  message: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type DeleteSeekMaxReplyAlreadyDeletedErrormessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type DeleteSeekMaxReplyAlreadyDeletedErrortitleArgs = {
  locale: Scalars['Locale']['input'];
};

export type DeleteSeekMaxReplyError = {
  message: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type DeleteSeekMaxReplyErrormessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type DeleteSeekMaxReplyErrortitleArgs = {
  locale: Scalars['Locale']['input'];
};

export type DeleteSeekMaxReplyFailure = {
  __typename?: 'DeleteSeekMaxReplyFailure';
  errors: Array<DeleteSeekMaxReplyError>;
};

export type DeleteSeekMaxReplyInput = {
  id: Scalars['ID']['input'];
  zone?: InputMaybe<Scalars['Zone']['input']>;
};

export type DeleteSeekMaxReplyNotExistError = DeleteSeekMaxReplyError & {
  __typename?: 'DeleteSeekMaxReplyNotExistError';
  message: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type DeleteSeekMaxReplyNotExistErrormessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type DeleteSeekMaxReplyNotExistErrortitleArgs = {
  locale: Scalars['Locale']['input'];
};

export type DeleteSeekMaxReplyPayload =
  | DeleteSeekMaxReplyFailure
  | DeleteSeekMaxReplySuccess;

export type DeleteSeekMaxReplySuccess = {
  __typename?: 'DeleteSeekMaxReplySuccess';
  id: Scalars['ID']['output'];
};

export type DeleteSeekMaxReplyUserIsBannedError = DeleteSeekMaxReplyError & {
  __typename?: 'DeleteSeekMaxReplyUserIsBannedError';
  message: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type DeleteSeekMaxReplyUserIsBannedErrormessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type DeleteSeekMaxReplyUserIsBannedErrortitleArgs = {
  locale: Scalars['Locale']['input'];
};

export type DeleteSeekMaxThreadAlreadyDeletedError =
  DeleteSeekMaxThreadError & {
    __typename?: 'DeleteSeekMaxThreadAlreadyDeletedError';
    message: Scalars['String']['output'];
    title: Scalars['String']['output'];
  };

export type DeleteSeekMaxThreadAlreadyDeletedErrormessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type DeleteSeekMaxThreadAlreadyDeletedErrortitleArgs = {
  locale: Scalars['Locale']['input'];
};

export type DeleteSeekMaxThreadError = {
  message: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type DeleteSeekMaxThreadErrormessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type DeleteSeekMaxThreadErrortitleArgs = {
  locale: Scalars['Locale']['input'];
};

export type DeleteSeekMaxThreadFailure = {
  __typename?: 'DeleteSeekMaxThreadFailure';
  errors: Array<DeleteSeekMaxThreadError>;
};

export type DeleteSeekMaxThreadInput = {
  id: Scalars['ID']['input'];
  zone?: InputMaybe<Scalars['Zone']['input']>;
};

export type DeleteSeekMaxThreadNotExistError = DeleteSeekMaxThreadError & {
  __typename?: 'DeleteSeekMaxThreadNotExistError';
  message: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type DeleteSeekMaxThreadNotExistErrormessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type DeleteSeekMaxThreadNotExistErrortitleArgs = {
  locale: Scalars['Locale']['input'];
};

export type DeleteSeekMaxThreadPayload =
  | DeleteSeekMaxThreadFailure
  | DeleteSeekMaxThreadSuccess;

export type DeleteSeekMaxThreadSuccess = {
  __typename?: 'DeleteSeekMaxThreadSuccess';
  id: Scalars['ID']['output'];
};

export type DeleteSeekMaxThreadUserIsBannedError = DeleteSeekMaxThreadError & {
  __typename?: 'DeleteSeekMaxThreadUserIsBannedError';
  message: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type DeleteSeekMaxThreadUserIsBannedErrormessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type DeleteSeekMaxThreadUserIsBannedErrortitleArgs = {
  locale: Scalars['Locale']['input'];
};

export type DeletedSeekMaxComment = ISeekMaxComment & {
  __typename?: 'DeletedSeekMaxComment';
  exactSocialData: ExactCommentSocialData;
  id: Scalars['ID']['output'];
};

export type DeletedSeekMaxThread = ISeekMaxThread & {
  __typename?: 'DeletedSeekMaxThread';
  id: Scalars['ID']['output'];
};

export type Description = {
  __typename?: 'Description';
  full: Scalars['String']['output'];
  paragraphs: Array<Scalars['String']['output']>;
};

export type DeviceContextInput = {
  /** device country is different from brand country */
  country?: InputMaybe<Scalars['CountryCodeIso2']['input']>;
  /** client generated */
  key: Scalars['UUID']['input'];
  /** IETF BCP 47 Language Tag */
  locale?: InputMaybe<Scalars['String']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  os?: InputMaybe<ExperimentDeviceOSInput>;
  type?: InputMaybe<ExperimentDeviceType>;
};

export type DocumentDownloadLink = {
  __typename?: 'DocumentDownloadLink';
  link: Scalars['String']['output'];
};

export type DocumentResourceType = 'Resume';

export type DocumentUploadFormData = {
  __typename?: 'DocumentUploadFormData';
  formFields: Array<FormField>;
  key: Scalars['String']['output'];
  link: Scalars['String']['output'];
};

export type Duration = {
  __typename?: 'Duration';
  /** @deprecated Use labelV2 instead */
  label: Scalars['String']['output'];
  labelV2: Scalars['String']['output'];
  lengthInSeconds: Scalars['Int']['output'];
};

export type DurationlabelV2Args = {
  locale: Scalars['Locale']['input'];
};

export type DurationContext = 'PUBLIC_PROFILE';

export type DurationLeft = {
  __typename?: 'DurationLeft';
  label: Scalars['String']['output'];
};

export type DurationLeftlabelArgs = {
  locale: Scalars['Locale']['input'];
};

export type EmployeeRecommendation = {
  __typename?: 'EmployeeRecommendation';
  description: Scalars['String']['output'];
  rating: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type EmployeeRecommendationdescriptionArgs = {
  locale?: Scalars['Locale']['input'];
};

export type Enrichment = {
  __typename?: 'Enrichment';
  summary?: Maybe<Array<Scalars['String']['output']>>;
};

export type ExactCommentSocialData = {
  __typename?: 'ExactCommentSocialData';
  likeCount: SocialMetric;
  replyCount: SocialMetric;
};

export type ExactModuleSocialData = {
  __typename?: 'ExactModuleSocialData';
  commentCount: SocialMetric;
  likeCount: SocialMetric;
  viewCount?: Maybe<SocialMetric>;
};

export type ExactThreadSocialData = {
  __typename?: 'ExactThreadSocialData';
  commentAndReplyCount: SocialMetric;
  commentCount: SocialMetric;
  likeCount: SocialMetric;
};

export type ExperienceContextInput = {
  brand?: InputMaybe<Scalars['Brand']['input']>;
  country?: InputMaybe<Scalars['CountryCodeIso2']['input']>;
  /** client generated */
  key: Scalars['UUID']['input'];
  /** IETF BCP 47 Language Tag */
  language?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
};

export type ExperimentDeviceOSInput = {
  name: Scalars['String']['input'];
  version: Scalars['String']['input'];
};

export type ExperimentDeviceType = 'PHONE' | 'TABLET';

export type FeatureFlag = {
  __typename?: 'FeatureFlag';
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['JSON']['output']>;
};

/** contract purely controlled by convention in LD. */
export type FeatureFlagEvaluation = {
  __typename?: 'FeatureFlagEvaluation';
  bigSegmentsStatus?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  reason: Scalars['String']['output'];
  value?: Maybe<Scalars['JSON']['output']>;
  variation?: Maybe<Scalars['String']['output']>;
};

export type FeatureFlagInput = {
  advertiserId?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['String']['input']>;
};

export type Featured = {
  __typename?: 'Featured';
  description?: Maybe<Description>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  videoUrl?: Maybe<Scalars['String']['output']>;
};

export type FeedbackError = {
  message: Scalars['String']['output'];
};

export type FeedbackErrormessageArgs = {
  locale?: InputMaybe<Scalars['Locale']['input']>;
};

export type FeedbackFailure = {
  __typename?: 'FeedbackFailure';
  errors: Array<FeedbackError>;
};

export type FeedbackInput = {
  device?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['Email']['input'];
  message: Scalars['String']['input'];
  zone: Scalars['Zone']['input'];
};

export type FeedbackLoggedInInput = {
  device?: InputMaybe<Scalars['String']['input']>;
  message: Scalars['String']['input'];
  zone: Scalars['Zone']['input'];
};

export type FeedbackMessageMaxLengthError = FeedbackError & {
  __typename?: 'FeedbackMessageMaxLengthError';
  message: Scalars['String']['output'];
};

export type FeedbackMessageMaxLengthErrormessageArgs = {
  locale?: InputMaybe<Scalars['Locale']['input']>;
};

export type FeedbackPayload = FeedbackFailure | FeedbackSuccess;

export type FeedbackSuccess = {
  __typename?: 'FeedbackSuccess';
  ref: Scalars['UUID']['output'];
};

export type FileMetadata = {
  __typename?: 'FileMetadata';
  name: Scalars['String']['output'];
  sensitiveDataInfo?: Maybe<SensitiveDataInfo>;
  size: Scalars['String']['output'];
  /** @deprecated Use virusScanStatus. */
  status: FileMetadataStatus;
  uri: Scalars['String']['output'];
  virusScanStatus: VirusScanStatus;
};

export type FileMetadataStatus = 'HasVirus' | 'OK' | 'Pending' | 'Unknown';

export type FormField = {
  __typename?: 'FormField';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type FreeTextQuestion = Question & {
  __typename?: 'FreeTextQuestion';
  id: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type GFJCompany = {
  __typename?: 'GFJCompany';
  url?: Maybe<Scalars['String']['output']>;
};

export type GFJCompanyurlArgs = {
  locale: Scalars['Locale']['input'];
  zone: Scalars['Zone']['input'];
};

export type GFJInfo = {
  __typename?: 'GFJInfo';
  company?: Maybe<GFJCompany>;
  location?: Maybe<GFJLocation>;
  workTypes?: Maybe<GFJWorkTypes>;
};

export type GFJLocation = {
  __typename?: 'GFJLocation';
  country?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  suburb?: Maybe<Scalars['String']['output']>;
};

export type GFJLocationcountryArgs = {
  locale?: Scalars['Locale']['input'];
};

export type GFJLocationregionArgs = {
  locale?: Scalars['Locale']['input'];
};

export type GFJLocationstateArgs = {
  locale?: Scalars['Locale']['input'];
};

export type GFJLocationsuburbArgs = {
  locale?: Scalars['Locale']['input'];
};

export type GFJWorkTypes = {
  __typename?: 'GFJWorkTypes';
  label?: Maybe<Array<Scalars['String']['output']>>;
};

export type GenerateCoverLetterError = {
  message: Scalars['String']['output'];
};

export type GenerateCoverLetterErrormessageArgs = {
  locale?: InputMaybe<Scalars['Locale']['input']>;
};

export type GenerateCoverLetterFailure = {
  __typename?: 'GenerateCoverLetterFailure';
  errors: Array<GenerateCoverLetterError>;
};

export type GenerateCoverLetterInput = {
  writtenText: Scalars['String']['input'];
};

export type GenerateCoverLetterPayload =
  | GenerateCoverLetterFailure
  | GenerateCoverLetterSuccess;

export type GenerateCoverLetterSuccess = {
  __typename?: 'GenerateCoverLetterSuccess';
  uri: Scalars['String']['output'];
};

export type GenerateResumeFromProfileInput = {
  languageCode: Scalars['LanguageCodeIso']['input'];
  zone: Scalars['Zone']['input'];
};

export type GenerateResumeFromProfilePayload = {
  __typename?: 'GenerateResumeFromProfilePayload';
  resume?: Maybe<Resume>;
  viewer?: Maybe<Candidate>;
};

export type GenerateSelectionCriteriaError = {
  message: Scalars['String']['output'];
};

export type GenerateSelectionCriteriaErrormessageArgs = {
  locale?: InputMaybe<Scalars['Locale']['input']>;
};

export type GenerateSelectionCriteriaFailure = {
  __typename?: 'GenerateSelectionCriteriaFailure';
  errors: Array<GenerateSelectionCriteriaError>;
};

export type GenerateSelectionCriteriaInput = {
  writtenText: Scalars['String']['input'];
};

export type GenerateSelectionCriteriaPayload =
  | GenerateSelectionCriteriaFailure
  | GenerateSelectionCriteriaSuccess;

export type GenerateSelectionCriteriaSuccess = {
  __typename?: 'GenerateSelectionCriteriaSuccess';
  uri: Scalars['String']['output'];
};

/** Other Supporting Types */
export type GptTargetingStringArrayValue = {
  __typename?: 'GptTargetingStringArrayValue';
  key: Scalars['String']['output'];
  values: Array<Scalars['String']['output']>;
};

export type GptTargetingStringValue = {
  __typename?: 'GptTargetingStringValue';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type GroupedCompanies = {
  __typename?: 'GroupedCompanies';
  companies: Array<GroupedCompany>;
  groupName: Scalars['String']['output'];
};

export type GroupedCompany = {
  __typename?: 'GroupedCompany';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export type HiddenVisibilityOption = ProfileVisibilityOption & {
  __typename?: 'HiddenVisibilityOption';
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type HiddenVisibilityOptiondescriptionArgs = {
  locale: Scalars['Locale']['input'];
  zone: Scalars['Zone']['input'];
};

export type HiddenVisibilityOptionnameArgs = {
  locale: Scalars['Locale']['input'];
};

export type HideJobFeedbackReason = {
  __typename?: 'HideJobFeedbackReason';
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type HideJobFeedbackReasonlabelArgs = {
  locale: Scalars['Locale']['input'];
};

export type I18nAccountError = {
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  reason: Scalars['String']['output'];
};

export type I18nAccountErrormessageArgs = {
  locale?: InputMaybe<Scalars['Locale']['input']>;
};

export type I18nAccountFieldError = I18nAccountError & {
  __typename?: 'I18nAccountFieldError';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  path?: Maybe<I18nErrorPath>;
  reason: Scalars['String']['output'];
};

export type I18nAccountFieldErrormessageArgs = {
  locale?: InputMaybe<Scalars['Locale']['input']>;
};

export type I18nErrorPath = {
  __typename?: 'I18nErrorPath';
  field?: Maybe<Scalars['String']['output']>;
  path?: Maybe<Scalars['String']['output']>;
};

export type IJobProfileSalaryMatch = {
  label: Scalars['String']['output'];
};

export type IJobProfileSalaryMatchlabelArgs = {
  locale: Scalars['Locale']['input'];
};

export type IOntologyCountry = {
  __typename?: 'IOntologyCountry';
  id: Scalars['String']['output'];
  isoCode: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type IOntologyEducationProvider = {
  __typename?: 'IOntologyEducationProvider';
  countries: Array<IOntologyCountry>;
  highlights: Array<SuggestionHighlight>;
  id: Scalars['String']['output'];
  matchedVariant: Scalars['String']['output'];
  normalisedText: Scalars['String']['output'];
};

export type IOntologyOrganisation = {
  __typename?: 'IOntologyOrganisation';
  countries: Array<IOntologyCountry>;
  highlights: Array<SuggestionHighlight>;
  id: Scalars['String']['output'];
  matchedVariant: Scalars['String']['output'];
  normalisedText: Scalars['String']['output'];
};

export type IOntologyQualification = {
  __typename?: 'IOntologyQualification';
  highlights: Array<SuggestionHighlight>;
  id: Scalars['String']['output'];
  matchedVariant: Scalars['String']['output'];
  normalisedText: Scalars['String']['output'];
  /** @deprecated Phasing out of UI */
  type: Array<QualificationLevel>;
};

export type IOntologyRoleTitle = {
  __typename?: 'IOntologyRoleTitle';
  highlights: Array<SuggestionHighlight>;
  id: Scalars['String']['output'];
  matchedVariant: Scalars['String']['output'];
  normalisedText: Scalars['String']['output'];
};

export type IOntologyRoleTitleSeniority = {
  __typename?: 'IOntologyRoleTitleSeniority';
  highlights: Array<SuggestionHighlight>;
  id: Scalars['String']['output'];
  matchedRoleTitleVariant: Scalars['String']['output'];
  matchedSeniorityVariant?: Maybe<Scalars['String']['output']>;
  matchedVariant: Scalars['String']['output'];
  normalisedText: Scalars['String']['output'];
  seniorityId?: Maybe<Scalars['String']['output']>;
};

export type ISeekMaxAttachmentStatus = {
  id: Scalars['ID']['output'];
};

export type ISeekMaxCategoryGroup = {
  groupId: Scalars['ID']['output'];
};

export type ISeekMaxCertificateAttachmentStatus = {
  id: Scalars['ID']['output'];
};

export type ISeekMaxCertificateSeekPassStatus = {
  id: Scalars['ID']['output'];
};

export type ISeekMaxComment = {
  id: Scalars['ID']['output'];
};

export type ISeekMaxKOLGroup = {
  description: Scalars['String']['output'];
};

export type ISeekMaxModerationStatus = {
  id: Scalars['ID']['output'];
};

export type ISeekMaxNotification = {
  id: Scalars['ID']['output'];
};

export type ISeekMaxSearchContent = {
  id: Scalars['ID']['output'];
};

export type ISeekMaxThread = {
  id: Scalars['ID']['output'];
};

export type ITrackSelected = {
  __typename?: 'ITrackSelected';
  id: Scalars['String']['output'];
  index: Scalars['Int']['output'];
  session: Scalars['String']['output'];
};

export type Identity = {
  __typename?: 'Identity';
  /** Operator making requests on behalf of user. */
  actor?: Maybe<Actor>;
  /**
   * Indicates that the user is CS operator, regardless of whether they're actively impersonating.
   * Either true or undefined.
   */
  allowImpersonation?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates that the CS operator has enabled administrator mode. Either true or undefined. */
  showCustomerServiceView?: Maybe<Scalars['Boolean']['output']>;
  /** User requesting access to a resource. */
  subject: Subject;
};

export type IdentityVerifiableCredential = BaseVerifiableCredential & {
  __typename?: 'IdentityVerifiableCredential';
  label: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type Job = {
  __typename?: 'Job';
  abstract: Scalars['String']['output'];
  advertiser: Advertiser;
  /** @deprecated Use classifications instead */
  categories?: Maybe<CategoryInfo>;
  classifications: Array<ClassificationInfo>;
  contactMatches?: Maybe<Array<ContactMatches>>;
  content: Scalars['String']['output'];
  createdAt: SeekDateTime;
  expiredAt?: Maybe<SeekDateTime>;
  expiresAt: SeekDateTime;
  id: Scalars['ID']['output'];
  /** @deprecated Use job-details.isChatEligible instead. Will always return null. */
  isChatEligible: Scalars['Boolean']['output'];
  isExpired: Scalars['Boolean']['output'];
  /**
   * Used together with the Link-out system (Close the Loop system)
   * https://indie-jobapply-linkout-service.cloud.seek.com.au/job/<JOBID>
   * to retrieve the external link and record Candidate's action
   */
  isLinkOut: Scalars['Boolean']['output'];
  isProfileApply: Scalars['Boolean']['output'];
  isVerified: Scalars['Boolean']['output'];
  listedAt?: Maybe<SeekDateTime>;
  location: LocationInfo;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  products?: Maybe<JobProducts>;
  salary?: Maybe<JobSalary>;
  shareLink?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  sourceZone?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  title: Scalars['String']['output'];
  tracking?: Maybe<JobTracking>;
  updatedAt: SeekDateTime;
  /** Job URL built with brand based on candidate's zone and selected locale */
  url: Scalars['String']['output'];
  workTypes: JobWorkTypes;
};

export type JobcontentArgs = {
  platform?: InputMaybe<Platform>;
};

export type JobshareLinkArgs = {
  locale?: InputMaybe<Scalars['Locale']['input']>;
  platform: Platform;
  zone: Scalars['Zone']['input'];
};

export type JoburlArgs = {
  locale: Scalars['Locale']['input'];
  zone: Scalars['Zone']['input'];
};

export type JobApplicantsBadge = {
  __typename?: 'JobApplicantsBadge';
  label?: Maybe<Scalars['String']['output']>;
};

export type JobApplicationArea = {
  __typename?: 'JobApplicationArea';
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type JobApplicationClassification = {
  __typename?: 'JobApplicationClassification';
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  subClassification?: Maybe<JobApplicationSubClassification>;
};

export type JobApplicationInsights = {
  __typename?: 'JobApplicationInsights';
  applicationTipsType: JobApplicationInsightsEnum;
  date: SeekDateTime;
  description: Scalars['String']['output'];
  stats: Array<JobApplicationInsightsStat>;
  title: Scalars['String']['output'];
};

export type JobApplicationInsightsdescriptionArgs = {
  locale?: Scalars['Locale']['input'];
};

export type JobApplicationInsightstitleArgs = {
  locale?: Scalars['Locale']['input'];
};

export type JobApplicationInsightsEnum =
  | 'ACTIVITY_STATUS_NOT_SUITABLE'
  | 'ACTIVITY_STATUS_VIEWED';

export type JobApplicationInsightsStat = {
  __typename?: 'JobApplicationInsightsStat';
  stat: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type JobApplicationInsightsStattextArgs = {
  locale?: Scalars['Locale']['input'];
};

export type JobApplicationLocation = {
  __typename?: 'JobApplicationLocation';
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type JobApplicationProcess = {
  __typename?: 'JobApplicationProcess';
  area?: Maybe<JobApplicationArea>;
  classification?: Maybe<JobApplicationClassification>;
  documents: ApplicationDocuments;
  extractedRoleTitles?: Maybe<Array<Scalars['String']['output']>>;
  /** Web apply url used by app legacy clients that may not be able to render the application requirements */
  fallbackUrl?: Maybe<Scalars['String']['output']>;
  job?: Maybe<Job>;
  linkOut?: Maybe<Scalars['Boolean']['output']>;
  location?: Maybe<JobApplicationLocation>;
  profile?: Maybe<ApplicationProfile>;
  /** If job has questionnaire return this object with proper data, else return null */
  questionnaire?: Maybe<Questionnaire>;
  state?: Maybe<JobApplicationState>;
};

export type JobApplicationProcessfallbackUrlArgs = {
  zone: Scalars['Zone']['input'];
};

export type JobApplicationState = {
  __typename?: 'JobApplicationState';
  id?: Maybe<Scalars['ID']['output']>;
};

export type JobApplicationSubClassification = {
  __typename?: 'JobApplicationSubClassification';
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type JobBadges = {
  __typename?: 'JobBadges';
  badgeDetails?: Maybe<Array<Maybe<BadgeDetails>>>;
  badges?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  jobId: Scalars['ID']['output'];
};

export type JobDetails = {
  __typename?: 'JobDetails';
  /** Defines the type of application channel available to the candidate */
  applicationChannel?: Maybe<ApplicationChannel>;
  /**
   * Returns badges for the job details view (e.g. Responsive Hirer).
   * Includes badge display information and tracking events for analytics.
   */
  badges?: Maybe<JobDetailsBadges>;
  /** @deprecated This is the legacy company profile schema, a new resolver will need to be added */
  companyProfile?: Maybe<CompanyProfile>;
  companyReviews?: Maybe<CompanyReviews>;
  companySearchUrl?: Maybe<Scalars['String']['output']>;
  companyTags: Array<CompanyTag>;
  /**
   * GFJInfo is used to provide information needed to show job postings on Google for Jobs.
   * This is strictly used for the above and should not be used for any other purpose.
   */
  gfjInfo?: Maybe<GFJInfo>;
  /** The insights of job details */
  insights?: Maybe<Array<Maybe<JobInsight>>>;
  /**
   * isChatEligible is experimental and will be deprecated after the APEX chat POC is completed
   * @deprecated Feature retired
   */
  isChatEligible?: Maybe<Scalars['Boolean']['output']>;
  job: Job;
  learningInsights?: Maybe<LearningInsights>;
  personalised?: Maybe<PersonalisedJobDetails>;
  recommendedJobs?: Maybe<Array<JobDetailsRecommendedJob>>;
  /** Provides a message concerning whether a candidate may apply */
  restrictedApplication: JobDetailsRestrictedApplication;
  /**
   * SEOInfo is used to provide information for SEO initiatives within the JDV.
   * This is strictly used for the above and should not be used for any other purpose.
   */
  seoInfo?: Maybe<SEOInfo>;
  /**
   * Sourcr is a Product used by Seek for matching recruiters email addresses and phone numbers
   * Note: it is not a misspelling
   * @deprecated Use sourcrRecruiter
   */
  sourcr?: Maybe<JobDetailsSourcr>;
  sourcrRecruiter?: Maybe<SourcrRecruiter>;
  workArrangements?: Maybe<JobDetailsWorkArrangements>;
};

export type JobDetailsapplicationChannelArgs = {
  zone: Scalars['Zone']['input'];
};

export type JobDetailsbadgesArgs = {
  locale: Scalars['Locale']['input'];
  platform: Platform;
  visitorId: Scalars['UUID']['input'];
};

export type JobDetailscompanyProfileArgs = {
  zone: Scalars['Zone']['input'];
};

export type JobDetailscompanyReviewsArgs = {
  zone: Scalars['Zone']['input'];
};

export type JobDetailscompanySearchUrlArgs = {
  languageCode?: InputMaybe<Scalars['LanguageCodeIso']['input']>;
  zone?: InputMaybe<Scalars['Zone']['input']>;
};

export type JobDetailslearningInsightsArgs = {
  locale?: Scalars['Locale']['input'];
  platform: Platform;
  zone: Scalars['Zone']['input'];
};

export type JobDetailsrecommendedJobsArgs = {
  platform: Platform;
  visitorId: Scalars['UUID']['input'];
  zone: Scalars['Zone']['input'];
};

export type JobDetailsrestrictedApplicationArgs = {
  countryCode: Scalars['CountryCodeIso2']['input'];
};

export type JobDetailsworkArrangementsArgs = {
  channel: Scalars['String']['input'];
  platform: Platform;
  visitorId: Scalars['UUID']['input'];
};

export type JobDetailsBadge = JobDetailsBaseBadge & {
  __typename?: 'JobDetailsBadge';
  badge: Scalars['String']['output'];
  displayText: Scalars['String']['output'];
};

export type JobDetailsBadgedisplayTextArgs = {
  locale: Scalars['Locale']['input'];
};

export type JobDetailsBadges = {
  __typename?: 'JobDetailsBadges';
  badges?: Maybe<Array<Maybe<JobDetailsBaseBadge>>>;
};

export type JobDetailsBaseBadge = {
  badge: Scalars['String']['output'];
  displayText: Scalars['String']['output'];
};

export type JobDetailsBaseBadgedisplayTextArgs = {
  locale: Scalars['Locale']['input'];
};

export type JobDetailsInteractiveBadge = JobDetailsBaseBadge &
  JobDetailsInteractiveBaseBadge & {
    __typename?: 'JobDetailsInteractiveBadge';
    badge: Scalars['String']['output'];
    displayText: Scalars['String']['output'];
    message: Scalars['String']['output'];
  };

export type JobDetailsInteractiveBadgedisplayTextArgs = {
  locale: Scalars['Locale']['input'];
};

export type JobDetailsInteractiveBadgemessageArgs = {
  locale: Scalars['Locale']['input'];
  zone: Scalars['Zone']['input'];
};

export type JobDetailsInteractiveBaseBadge = {
  badge: Scalars['String']['output'];
  displayText: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type JobDetailsInteractiveBaseBadgedisplayTextArgs = {
  locale: Scalars['Locale']['input'];
};

export type JobDetailsInteractiveBaseBadgemessageArgs = {
  locale: Scalars['Locale']['input'];
  zone: Scalars['Zone']['input'];
};

export type JobDetailsRecommendedJob = {
  __typename?: 'JobDetailsRecommendedJob';
  job?: Maybe<Job>;
  solMetadata?: Maybe<Scalars['JSON']['output']>;
};

export type JobDetailsResponsiveHirerBadge = JobDetailsBaseBadge &
  JobDetailsInteractiveBaseBadge & {
    __typename?: 'JobDetailsResponsiveHirerBadge';
    badge: Scalars['String']['output'];
    /** EXPERIMENTAL! */
    badgeScore?: Maybe<Scalars['Int']['output']>;
    displayText: Scalars['String']['output'];
    message: Scalars['String']['output'];
  };

export type JobDetailsResponsiveHirerBadgedisplayTextArgs = {
  locale: Scalars['Locale']['input'];
};

export type JobDetailsResponsiveHirerBadgemessageArgs = {
  locale: Scalars['Locale']['input'];
  zone: Scalars['Zone']['input'];
};

export type JobDetailsRestrictedApplication = {
  __typename?: 'JobDetailsRestrictedApplication';
  label?: Maybe<Scalars['String']['output']>;
};

export type JobDetailsRestrictedApplicationlabelArgs = {
  locale: Scalars['Locale']['input'];
};

/**
 * Sourcr is a Product used by Seek for matching recruiters email addresses and phone numbers
 * Note: it is not a misspelling
 */
export type JobDetailsSourcr = {
  __typename?: 'JobDetailsSourcr';
  image: Scalars['String']['output'];
  imageMobile: Scalars['String']['output'];
  link: Scalars['String']['output'];
};

export type JobDetailsTrackingInput = {
  channel: Scalars['String']['input'];
  jobDetailsViewedCorrelationId: Scalars['String']['input'];
  sessionId: Scalars['String']['input'];
};

export type JobDetailsWorkArrangement = {
  __typename?: 'JobDetailsWorkArrangement';
  label?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type JobDetailsWorkArrangementlabelArgs = {
  locale: Scalars['Locale']['input'];
};

export type JobDetailsWorkArrangements = {
  __typename?: 'JobDetailsWorkArrangements';
  arrangements?: Maybe<Array<Maybe<JobDetailsWorkArrangement>>>;
  label?: Maybe<Scalars['String']['output']>;
};

export type JobDetailsWorkArrangementslabelArgs = {
  locale: Scalars['Locale']['input'];
};

export type JobDisplayTag = {
  label: Scalars['String']['output'];
};

export type JobDisplayTaglabelArgs = {
  locale: Scalars['Locale']['input'];
};

export type JobHistoryDateInput = {
  month: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};

export type JobHistoryInput = {
  from: JobHistoryDateInput;
  to?: InputMaybe<JobHistoryDateInput>;
};

export type JobInput = {
  history?: InputMaybe<JobHistoryInput>;
  isJobTitleAnonymised?: InputMaybe<Scalars['Boolean']['input']>;
  location: JobLocationEntityInput;
  roleTitleId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  workType?: InputMaybe<Scalars['String']['input']>;
};

export type JobInsight = {
  message: Scalars['String']['output'];
};

export type JobInsightmessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type JobLocationEntityInput = {
  fullLocation?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['Int']['input']>;
};

export type JobPreferencesCompanyFeedbackReason =
  JobPreferencesFeedbackReason & {
    __typename?: 'JobPreferencesCompanyFeedbackReason';
    displayText?: Maybe<Scalars['String']['output']>;
    label: Scalars['String']['output'];
    reason: Scalars['String']['output'];
    saveJobPreferencesArgs?: Maybe<SaveJobPreferencesArgs>;
  };

export type JobPreferencesCompanyFeedbackReasondisplayTextArgs = {
  locale: Scalars['Locale']['input'];
};

export type JobPreferencesCompanyFeedbackReasonlabelArgs = {
  locale: Scalars['Locale']['input'];
};

export type JobPreferencesEmploymentTypeFeedbackReason =
  JobPreferencesFeedbackReason & {
    __typename?: 'JobPreferencesEmploymentTypeFeedbackReason';
    displayText?: Maybe<Scalars['String']['output']>;
    label: Scalars['String']['output'];
    reason: Scalars['String']['output'];
    saveJobPreferencesArgs?: Maybe<SaveJobPreferencesArgs>;
  };

export type JobPreferencesEmploymentTypeFeedbackReasondisplayTextArgs = {
  locale: Scalars['Locale']['input'];
};

export type JobPreferencesEmploymentTypeFeedbackReasonlabelArgs = {
  locale: Scalars['Locale']['input'];
};

export type JobPreferencesFeedbackReason = {
  displayText?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  reason: Scalars['String']['output'];
  saveJobPreferencesArgs?: Maybe<SaveJobPreferencesArgs>;
};

export type JobPreferencesFeedbackReasondisplayTextArgs = {
  locale: Scalars['Locale']['input'];
};

export type JobPreferencesFeedbackReasonlabelArgs = {
  locale: Scalars['Locale']['input'];
};

export type JobPreferencesFeedbackReasons = {
  __typename?: 'JobPreferencesFeedbackReasons';
  reasons?: Maybe<Array<Maybe<JobPreferencesFeedbackReason>>>;
};

export type JobPreferencesLocationFeedbackReason =
  JobPreferencesFeedbackReason & {
    __typename?: 'JobPreferencesLocationFeedbackReason';
    displayText?: Maybe<Scalars['String']['output']>;
    label: Scalars['String']['output'];
    reason: Scalars['String']['output'];
    saveJobPreferencesArgs?: Maybe<SaveJobPreferencesArgs>;
  };

export type JobPreferencesLocationFeedbackReasondisplayTextArgs = {
  locale: Scalars['Locale']['input'];
};

export type JobPreferencesLocationFeedbackReasonlabelArgs = {
  locale: Scalars['Locale']['input'];
};

export type JobPreferencesRoleTitleFeedbackReason =
  JobPreferencesFeedbackReason & {
    __typename?: 'JobPreferencesRoleTitleFeedbackReason';
    displayText?: Maybe<Scalars['String']['output']>;
    label: Scalars['String']['output'];
    reason: Scalars['String']['output'];
    saveJobPreferencesArgs?: Maybe<SaveJobPreferencesArgs>;
  };

export type JobPreferencesRoleTitleFeedbackReasondisplayTextArgs = {
  locale: Scalars['Locale']['input'];
};

export type JobPreferencesRoleTitleFeedbackReasonlabelArgs = {
  locale: Scalars['Locale']['input'];
};

export type JobProductBranding = {
  __typename?: 'JobProductBranding';
  cover?: Maybe<JobProductBrandingImage>;
  id: Scalars['ID']['output'];
  logo: JobProductBrandingImage;
};

export type JobProductBrandingcoverArgs = {
  isThumbnail?: InputMaybe<Scalars['Boolean']['input']>;
};

export type JobProductBrandingImage = {
  __typename?: 'JobProductBrandingImage';
  aspectRatio?: Maybe<Scalars['Float']['output']>;
  url: Scalars['String']['output'];
};

export type JobProducts = {
  __typename?: 'JobProducts';
  branding?: Maybe<JobProductBranding>;
  bullets?: Maybe<Array<Scalars['String']['output']>>;
  displayTags: Array<JobDisplayTag>;
  questionnaire?: Maybe<JobQuestionnaire>;
  video?: Maybe<VideoProduct>;
};

export type JobProfileMissingSalaryPreference = IJobProfileSalaryMatch & {
  __typename?: 'JobProfileMissingSalaryPreference';
  label: Scalars['String']['output'];
};

export type JobProfileMissingSalaryPreferencelabelArgs = {
  locale: Scalars['Locale']['input'];
};

export type JobProfileSalaryMatch = IJobProfileSalaryMatch & {
  __typename?: 'JobProfileSalaryMatch';
  label: Scalars['String']['output'];
  salaryPreference: SalaryPreference2;
};

export type JobProfileSalaryMatchlabelArgs = {
  locale: Scalars['Locale']['input'];
};

export type JobProfileSalaryMatchsalaryPreferenceArgs = {
  languageCode: Scalars['LanguageCodeIso']['input'];
  locale: Scalars['Locale']['input'];
};

export type JobProfileSalaryNoMatch = IJobProfileSalaryMatch & {
  __typename?: 'JobProfileSalaryNoMatch';
  label: Scalars['String']['output'];
};

export type JobProfileSalaryNoMatchlabelArgs = {
  locale: Scalars['Locale']['input'];
};

/**
 * This is a simplified read-only questionnaire
 * which informs Candidates the questions they will
 * likely need to answer as part of the Application process
 */
export type JobQuestionnaire = {
  __typename?: 'JobQuestionnaire';
  id: Scalars['ID']['output'];
  questions: Array<Scalars['String']['output']>;
};

export type JobSalary = {
  __typename?: 'JobSalary';
  currencyLabel?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
};

export type JobSalarycurrencyLabelArgs = {
  zone: Scalars['Zone']['input'];
};

export type JobSearchAssist = {
  __typename?: 'JobSearchAssist';
  pills?: Maybe<JobSearchAssistPills>;
};

export type JobSearchAssistPill = {
  __typename?: 'JobSearchAssistPill';
  isActive: Scalars['Boolean']['output'];
  keywords: Scalars['String']['output'];
  label: Scalars['String']['output'];
  stateToken: Scalars['Base64Url']['output'];
};

export type JobSearchAssistPills = {
  __typename?: 'JobSearchAssistPills';
  data?: Maybe<Array<JobSearchAssistPill>>;
  token: Scalars['Base64Url']['output'];
};

export type JobSearchQueryMeter = {
  __typename?: 'JobSearchQueryMeter';
  entities?: Maybe<Array<JobSearchQueryMeterEntity>>;
  searchStrength: JobSearchQueryMeterSearchStrength;
};

export type JobSearchQueryMeterEntity = {
  __typename?: 'JobSearchQueryMeterEntity';
  description?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
};

export type JobSearchQueryMeterSearchStrength = {
  __typename?: 'JobSearchQueryMeterSearchStrength';
  label?: Maybe<Scalars['String']['output']>;
  rating: Scalars['Int']['output'];
};

/** Parameters for job search v5 API query recommendations. */
export type JobSearchV5ApiParameters = {
  __typename?: 'JobSearchV5ApiParameters';
  type: Scalars['String']['output'];
  value: Array<Scalars['String']['output']>;
};

/** Job Data Types */
export type JobSearchV6Advertiser = {
  __typename?: 'JobSearchV6Advertiser';
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
};

export type JobSearchV6Branding = {
  __typename?: 'JobSearchV6Branding';
  serpLogoUrl?: Maybe<Scalars['String']['output']>;
};

export type JobSearchV6CanonicalCompany = {
  __typename?: 'JobSearchV6CanonicalCompany';
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
};

export type JobSearchV6Classification = {
  __typename?: 'JobSearchV6Classification';
  classification?: Maybe<JobSearchV6ClassificationDetail>;
  subclassification?: Maybe<JobSearchV6ClassificationDetail>;
};

export type JobSearchV6ClassificationDetail = {
  __typename?: 'JobSearchV6ClassificationDetail';
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
};

/** Suggestion Types */
export type JobSearchV6CompanySearch = {
  __typename?: 'JobSearchV6CompanySearch';
  companyName?: Maybe<Scalars['String']['output']>;
  keywords?: Maybe<Scalars['String']['output']>;
};

export type JobSearchV6CompanySuggestion = {
  __typename?: 'JobSearchV6CompanySuggestion';
  count: Scalars['Int']['output'];
  search: JobSearchV6CompanySearch;
};

export type JobSearchV6Data = {
  __typename?: 'JobSearchV6Data';
  advertiser?: Maybe<JobSearchV6Advertiser>;
  branding?: Maybe<JobSearchV6Branding>;
  bulletPoints: Array<Scalars['String']['output']>;
  classifications: Array<JobSearchV6Classification>;
  companyName?: Maybe<Scalars['String']['output']>;
  companyProfileStructuredDataId?: Maybe<Scalars['ID']['output']>;
  currencyLabel?: Maybe<Scalars['String']['output']>;
  /** @deprecated External reference only */
  displayStyle?: Maybe<Scalars['JSON']['output']>;
  displayType: Scalars['String']['output'];
  employer?: Maybe<JobSearchV6Employer>;
  externalReferences?: Maybe<Array<JobSearchV6ExternalReference>>;
  id: Scalars['ID']['output'];
  isFeatured: Scalars['Boolean']['output'];
  listingDate: SeekDateTime;
  locations: Array<JobSearchV6DataLocation>;
  roleId?: Maybe<Scalars['String']['output']>;
  salaryLabel: Scalars['String']['output'];
  solMetadata?: Maybe<Scalars['JSON']['output']>;
  tags?: Maybe<Array<JobSearchV6DataTag>>;
  teaser: Scalars['String']['output'];
  title: Scalars['String']['output'];
  tracking: Scalars['String']['output'];
  workArrangements?: Maybe<JobSearchV6WorkArrangements>;
  workTypes: Array<Scalars['String']['output']>;
};

export type JobSearchV6DataLocation = {
  __typename?: 'JobSearchV6DataLocation';
  countryCode: Scalars['String']['output'];
  label: Scalars['String']['output'];
  seoHierarchy: Array<JobSearchV6SeoHierarchy>;
};

export type JobSearchV6DataTag = {
  __typename?: 'JobSearchV6DataTag';
  label: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type JobSearchV6Employer = {
  __typename?: 'JobSearchV6Employer';
  companyId?: Maybe<Scalars['String']['output']>;
  companyUrl?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type JobSearchV6ExternalReference = {
  __typename?: 'JobSearchV6ExternalReference';
  id: Scalars['String']['output'];
  metadata?: Maybe<JobSearchV6ExternalReferenceMetadata>;
  sourceSystem: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type JobSearchV6ExternalReferenceAssets = {
  __typename?: 'JobSearchV6ExternalReferenceAssets';
  profilePhotoUrl?: Maybe<Scalars['String']['output']>;
};

export type JobSearchV6ExternalReferenceMetadata = {
  __typename?: 'JobSearchV6ExternalReferenceMetadata';
  assets?: Maybe<JobSearchV6ExternalReferenceAssets>;
  name?: Maybe<Scalars['String']['output']>;
};

/** Facet Types */
export type JobSearchV6FacetCount = {
  __typename?: 'JobSearchV6FacetCount';
  count: Scalars['Int']['output'];
  facet: Scalars['String']['output'];
};

export type JobSearchV6FacetItem = {
  __typename?: 'JobSearchV6FacetItem';
  count: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  label?: Maybe<Scalars['String']['output']>;
};

export type JobSearchV6FacetItemLocalised = {
  __typename?: 'JobSearchV6FacetItemLocalised';
  count: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  label?: Maybe<JobSearchV6LocalisedDescriptionLocalised>;
};

export type JobSearchV6Facets = {
  __typename?: 'JobSearchV6Facets';
  advertiser?: Maybe<Array<JobSearchV6FacetItem>>;
  category?: Maybe<Array<JobSearchV6FacetItemLocalised>>;
  createdAt?: Maybe<Array<JobSearchV6FacetItem>>;
  distinctTitle?: Maybe<Array<JobSearchV6FacetItem>>;
  employer?: Maybe<Array<JobSearchV6FacetItem>>;
  location?: Maybe<Array<JobSearchV6FacetItemLocalised>>;
  salaryMax?: Maybe<Array<JobSearchV6FacetItem>>;
  salaryMin?: Maybe<Array<JobSearchV6FacetItem>>;
  title?: Maybe<Array<JobSearchV6FacetItem>>;
  workArrangement?: Maybe<Array<JobSearchV6FacetItemLocalised>>;
  workType?: Maybe<Array<JobSearchV6FacetItemLocalised>>;
};

export type JobSearchV6GptTargeting =
  | GptTargetingStringArrayValue
  | GptTargetingStringValue;

/** Search Metadata Types */
export type JobSearchV6Info = {
  __typename?: 'JobSearchV6Info';
  experiment: Scalars['String']['output'];
  newSince?: Maybe<Scalars['Int']['output']>;
  source: Scalars['String']['output'];
  timeTaken: Scalars['Int']['output'];
};

export type JobSearchV6IntentSuggestion = {
  __typename?: 'JobSearchV6IntentSuggestion';
  count: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  label: JobSearchV6IntentSuggestionLabel;
  params: JobSearchV6IntentSuggestionParams;
  type: Scalars['String']['output'];
};

export type JobSearchV6IntentSuggestionLabel = {
  __typename?: 'JobSearchV6IntentSuggestionLabel';
  defaultText: Scalars['String']['output'];
  lang: Scalars['String']['output'];
};

export type JobSearchV6IntentSuggestionParams = {
  __typename?: 'JobSearchV6IntentSuggestionParams';
  classification?: Maybe<Array<Scalars['Int']['output']>>;
  companyName?: Maybe<Scalars['String']['output']>;
  dateRange?: Maybe<Scalars['Int']['output']>;
  distance?: Maybe<Scalars['Float']['output']>;
  keywords?: Maybe<Scalars['String']['output']>;
  maxSalary?: Maybe<Scalars['Int']['output']>;
  minSalary?: Maybe<Scalars['Int']['output']>;
  salaryType?: Maybe<Scalars['JobSearchV6SalaryType']['output']>;
  siteKey?: Maybe<Scalars['String']['output']>;
  sortMode?: Maybe<Scalars['JobSearchV6SortMode']['output']>;
  subclassification?: Maybe<Array<Scalars['Int']['output']>>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  where?: Maybe<Scalars['String']['output']>;
  workArrangement?: Maybe<Array<Scalars['Int']['output']>>;
  workTypes?: Maybe<Array<Scalars['Int']['output']>>;
};

export type JobSearchV6LocalisedDescription = {
  __typename?: 'JobSearchV6LocalisedDescription';
  contextualName: Scalars['String']['output'];
  lang: Scalars['String']['output'];
};

export type JobSearchV6LocalisedDescriptionLocalised = {
  __typename?: 'JobSearchV6LocalisedDescriptionLocalised';
  lang: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type JobSearchV6Location = {
  __typename?: 'JobSearchV6Location';
  defaultDistanceKms?: Maybe<Scalars['Float']['output']>;
  description: Scalars['String']['output'];
  isGranular?: Maybe<Scalars['Boolean']['output']>;
  localisedDescriptions: Array<JobSearchV6LocalisedDescription>;
  locationDescription: Scalars['String']['output'];
  type: Scalars['String']['output'];
  whereId: Scalars['String']['output'];
};

export type JobSearchV6LocationSuggestion = {
  __typename?: 'JobSearchV6LocationSuggestion';
  description: Scalars['String']['output'];
  whereId: Scalars['String']['output'];
};

export type JobSearchV6Pill = {
  __typename?: 'JobSearchV6Pill';
  isActive: Scalars['Boolean']['output'];
  keywords: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

/** Input Types */
export type JobSearchV6QueryInput = {
  advertiserGroup?: InputMaybe<Array<Scalars['String']['input']>>;
  advertiserId?: InputMaybe<Array<Scalars['Int']['input']>>;
  baseKeywords?: InputMaybe<Scalars['String']['input']>;
  channel?: InputMaybe<Scalars['JobSearchV6Channel']['input']>;
  classification?: InputMaybe<Array<Scalars['Int']['input']>>;
  companyId?: InputMaybe<Array<Scalars['Int']['input']>>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  companyProfileStructuredDataId?: InputMaybe<Array<Scalars['Int']['input']>>;
  companySearch?: InputMaybe<Scalars['Boolean']['input']>;
  dateRange?: InputMaybe<Scalars['Int']['input']>;
  distance?: InputMaybe<Scalars['Float']['input']>;
  duplicates?: InputMaybe<Scalars['JobSearchV6DuplicateHandling']['input']>;
  encodedUrl?: InputMaybe<Scalars['String']['input']>;
  engineConfig?: InputMaybe<Scalars['String']['input']>;
  eventCaptureSessionId?: InputMaybe<Scalars['String']['input']>;
  eventCaptureUserId?: InputMaybe<Scalars['String']['input']>;
  facets?: InputMaybe<Array<Scalars['JobSearchV6Facet']['input']>>;
  include?: InputMaybe<Array<Scalars['JobSearchV6Include']['input']>>;
  jobId?: InputMaybe<Array<Scalars['Int']['input']>>;
  keywords?: InputMaybe<Scalars['String']['input']>;
  locale: Scalars['Locale']['input'];
  maxListingDate?: InputMaybe<Scalars['String']['input']>;
  minListingDate?: InputMaybe<Scalars['String']['input']>;
  newSince?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['PositiveInt']['input']>;
  pageSize?: InputMaybe<Scalars['PositiveInt']['input']>;
  queryHints?: InputMaybe<Array<Scalars['JobSearchV6QueryHint']['input']>>;
  relatedSearchesCount?: InputMaybe<Scalars['PositiveInt']['input']>;
  salaryRange?: InputMaybe<Scalars['String']['input']>;
  salaryType?: InputMaybe<Scalars['JobSearchV6SalaryType']['input']>;
  savedSearchId?: InputMaybe<Scalars['String']['input']>;
  siteKey: Scalars['JobSearchV6SiteKey']['input'];
  solId?: InputMaybe<Scalars['UUID']['input']>;
  sortMode?: InputMaybe<Scalars['JobSearchV6SortMode']['input']>;
  source?: InputMaybe<Scalars['JobSearchV6Source']['input']>;
  stateToken?: InputMaybe<Scalars['String']['input']>;
  subclassification?: InputMaybe<Array<Scalars['Int']['input']>>;
  tags?: InputMaybe<Array<Scalars['JobSearchV6Tag']['input']>>;
  userId?: InputMaybe<Scalars['String']['input']>;
  userQueryId?: InputMaybe<Scalars['String']['input']>;
  userSessionId?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['String']['input']>;
  whereId?: InputMaybe<Scalars['Int']['input']>;
  whereIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  workArrangement?: InputMaybe<
    Array<Scalars['JobSearchV6WorkArrangement']['input']>
  >;
  workType?: InputMaybe<Array<Scalars['JobSearchV6WorkType']['input']>>;
};

export type JobSearchV6RelatedSearches = {
  __typename?: 'JobSearchV6RelatedSearches';
  keywords: Scalars['String']['output'];
  totalJobs: Scalars['Int']['output'];
};

/** Sort Mode Types */
export type JobSearchV6ResultSortMode = {
  __typename?: 'JobSearchV6ResultSortMode';
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type JobSearchV6SearchExecuted = {
  __typename?: 'JobSearchV6SearchExecuted';
  classification?: Maybe<Array<Scalars['Int']['output']>>;
  companyName?: Maybe<Scalars['String']['output']>;
  dateRange?: Maybe<Scalars['Int']['output']>;
  distance?: Maybe<Scalars['Float']['output']>;
  keywords?: Maybe<Scalars['String']['output']>;
  maxSalary?: Maybe<Scalars['Int']['output']>;
  minSalary?: Maybe<Scalars['Int']['output']>;
  salaryType?: Maybe<Scalars['JobSearchV6SalaryType']['output']>;
  siteKey?: Maybe<Scalars['String']['output']>;
  sortMode?: Maybe<Scalars['JobSearchV6SortMode']['output']>;
  subclassification?: Maybe<Array<Scalars['Int']['output']>>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  where?: Maybe<Scalars['String']['output']>;
  workArrangement?: Maybe<Array<Scalars['Int']['output']>>;
  workTypes?: Maybe<Array<Scalars['Int']['output']>>;
};

export type JobSearchV6SearchParams = {
  __typename?: 'JobSearchV6SearchParams';
  advertisergroup?: Maybe<Scalars['String']['output']>;
  advertiserid?: Maybe<Scalars['String']['output']>;
  basekeywords?: Maybe<Scalars['String']['output']>;
  classification?: Maybe<Scalars['String']['output']>;
  cluster?: Maybe<Scalars['String']['output']>;
  companyid?: Maybe<Scalars['String']['output']>;
  companyname?: Maybe<Scalars['String']['output']>;
  companyprofilestructureddataid?: Maybe<Scalars['String']['output']>;
  companysearch?: Maybe<Scalars['String']['output']>;
  daterange?: Maybe<Scalars['String']['output']>;
  distance?: Maybe<Scalars['String']['output']>;
  duplicates?: Maybe<Scalars['String']['output']>;
  encodedurl?: Maybe<Scalars['String']['output']>;
  engineconfig?: Maybe<Scalars['String']['output']>;
  eventcapturesessionid?: Maybe<Scalars['String']['output']>;
  eventcaptureuserid?: Maybe<Scalars['String']['output']>;
  facets?: Maybe<Scalars['String']['output']>;
  graduatesearch?: Maybe<Scalars['String']['output']>;
  include?: Maybe<Scalars['String']['output']>;
  jobid?: Maybe<Scalars['String']['output']>;
  keywords?: Maybe<Scalars['String']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  maxlistingdate?: Maybe<Scalars['String']['output']>;
  minlistingdate?: Maybe<Scalars['String']['output']>;
  newsince?: Maybe<Scalars['String']['output']>;
  page?: Maybe<Scalars['String']['output']>;
  pagesize?: Maybe<Scalars['String']['output']>;
  queryhints?: Maybe<Scalars['String']['output']>;
  ref?: Maybe<Scalars['String']['output']>;
  relatedsearchescount?: Maybe<Scalars['String']['output']>;
  salaryrange?: Maybe<Scalars['String']['output']>;
  salarytype?: Maybe<Scalars['String']['output']>;
  savedsearchid?: Maybe<Scalars['String']['output']>;
  sitekey?: Maybe<Scalars['String']['output']>;
  solid?: Maybe<Scalars['String']['output']>;
  sortmode?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  statetoken?: Maybe<Scalars['String']['output']>;
  subclassification?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Scalars['String']['output']>;
  userid?: Maybe<Scalars['String']['output']>;
  userqueryid?: Maybe<Scalars['String']['output']>;
  usersessionid?: Maybe<Scalars['String']['output']>;
  where?: Maybe<Scalars['String']['output']>;
  whereid?: Maybe<Scalars['String']['output']>;
  whereids?: Maybe<Scalars['String']['output']>;
  workarrangement?: Maybe<Scalars['String']['output']>;
  worktype?: Maybe<Scalars['String']['output']>;
};

export type JobSearchV6SeoHierarchy = {
  __typename?: 'JobSearchV6SeoHierarchy';
  contextualName: Scalars['String']['output'];
};

export type JobSearchV6ShowMordorQueryType = 'COUNT' | 'COUNTS' | 'SEARCH';

export type JobSearchV6Suggestions = {
  __typename?: 'JobSearchV6Suggestions';
  asyncPillsToken?: Maybe<Scalars['String']['output']>;
  company?: Maybe<JobSearchV6CompanySuggestion>;
  location?: Maybe<Array<JobSearchV6LocationSuggestion>>;
  pills?: Maybe<Array<JobSearchV6Pill>>;
  relatedSearches?: Maybe<Array<JobSearchV6RelatedSearches>>;
  showSABFilter?: Maybe<Scalars['Boolean']['output']>;
};

export type JobSearchV6WorkArrangementData = {
  __typename?: 'JobSearchV6WorkArrangementData';
  id?: Maybe<Scalars['String']['output']>;
  label?: Maybe<JobSearchV6WorkArrangementLabel>;
};

export type JobSearchV6WorkArrangementLabel = {
  __typename?: 'JobSearchV6WorkArrangementLabel';
  text?: Maybe<Scalars['String']['output']>;
};

export type JobSearchV6WorkArrangements = {
  __typename?: 'JobSearchV6WorkArrangements';
  data?: Maybe<Array<JobSearchV6WorkArrangementData>>;
  displayText?: Maybe<Scalars['String']['output']>;
};

export type JobTag = {
  __typename?: 'JobTag';
  label?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type JobTaglabelArgs = {
  locale?: InputMaybe<Scalars['Locale']['input']>;
};

export type JobTracking = {
  __typename?: 'JobTracking';
  adProductType?: Maybe<Scalars['String']['output']>;
  classificationInfo?: Maybe<JobTrackingClassificationInfo>;
  hasRoleRequirements?: Maybe<Scalars['Boolean']['output']>;
  isPrivateAdvertiser?: Maybe<Scalars['Boolean']['output']>;
  isRightToWorkRequired?: Maybe<Scalars['Boolean']['output']>;
  isScreenAssigned?: Maybe<Scalars['Boolean']['output']>;
  locationInfo?: Maybe<JobTrackingLocationInfo>;
  postedTime?: Maybe<Scalars['String']['output']>;
  workTypeIds?: Maybe<Scalars['String']['output']>;
};

export type JobTrackingClassificationInfo = {
  __typename?: 'JobTrackingClassificationInfo';
  classification?: Maybe<Scalars['String']['output']>;
  classificationId?: Maybe<Scalars['String']['output']>;
  subClassification?: Maybe<Scalars['String']['output']>;
  subClassificationId?: Maybe<Scalars['String']['output']>;
};

export type JobTrackingLocationInfo = {
  __typename?: 'JobTrackingLocationInfo';
  area?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  locationIds?: Maybe<Array<Scalars['String']['output']>>;
};

export type JobWorkTypes = {
  __typename?: 'JobWorkTypes';
  label: Scalars['String']['output'];
};

export type JobWorkTypeslabelArgs = {
  locale?: Scalars['Locale']['input'];
};

export type KeyValue = {
  __typename?: 'KeyValue';
  key: Scalars['String']['output'];
  value: Scalars['JSON']['output'];
};

export type KeyValueInput = {
  key: Scalars['String']['input'];
  value: Scalars['JSON']['input'];
};

export type KeywordSuggestion = {
  __typename?: 'KeywordSuggestion';
  /** A array of SuggestionHighlight which tells you the text index 'start' and 'end' to highlight. This supports multi highlight on a single string of text */
  highlights: Array<SuggestionHighlight>;
  text: Scalars['String']['output'];
};

/** KeywordSuggestionGroup is a collection of pre-defined suggestions e.g. Recent */
export type KeywordSuggestionGroup = {
  __typename?: 'KeywordSuggestionGroup';
  label: Scalars['String']['output'];
  suggestions: Array<KeywordSuggestion>;
  type: SuggestionGroupType;
};

export type KeywordSuggestionType = KeywordSuggestion | KeywordSuggestionGroup;

export type LanguageCode = 'en' | 'id' | 'ms' | 'th' | 'tl' | 'vi';

export type LanguageProficiency = {
  __typename?: 'LanguageProficiency';
  id: Scalars['UUID']['output'];
  name: OntologyStructuredData;
};

export type LastAnswer = {
  __typename?: 'LastAnswer';
  id: Scalars['String']['output'];
  text: Scalars['String']['output'];
  uri?: Maybe<Scalars['String']['output']>;
};

export type LastWrittenCoverLetter = {
  __typename?: 'LastWrittenCoverLetter';
  content: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type LearningInsights = {
  __typename?: 'LearningInsights';
  action?: Maybe<LearningInsightsAction>;
  analytics?: Maybe<Scalars['JSON']['output']>;
  content: Scalars['String']['output'];
};

export type LearningInsightsAction = {
  __typename?: 'LearningInsightsAction';
  label: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type Licence = {
  __typename?: 'Licence';
  credential?: Maybe<BaseCredential>;
  credentialType?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** @deprecated No longer shown in UI. Use expiryStatus instead */
  expiryDate?: Maybe<MonthYear>;
  formattedDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  isVerified: Scalars['Boolean']['output'];
  issueDate?: Maybe<MonthYear>;
  issuingOrganisation?: Maybe<Scalars['String']['output']>;
  name: OntologyStructuredData;
  noExpiryDate: Scalars['Boolean']['output'];
  status?: Maybe<LicenceStatus>;
  verificationMessage?: Maybe<Scalars['String']['output']>;
  verificationUrl?: Maybe<Scalars['String']['output']>;
};

export type LicenceStatus = 'Expired' | 'ExpiresSoon' | 'New';

export type LicenceVerifiableCredential = BaseVerifiableCredential & {
  __typename?: 'LicenceVerifiableCredential';
  expiryStatus?: Maybe<CredentialExpiryStatus>;
  label: Scalars['String']['output'];
  /** String representing the entity type provided by Ontology for tracking purposes, e.g. 'Drivers Licence' */
  trackingEntityName?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
  /** Translated string used to prompt verification of a licence, e.g. "Verify your Driver's Licence" */
  verificationMessage?: Maybe<Scalars['String']['output']>;
};

export type LimitedVisibilityOption = ProfileVisibilityOption & {
  __typename?: 'LimitedVisibilityOption';
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type LimitedVisibilityOptiondescriptionArgs = {
  locale: Scalars['Locale']['input'];
  zone: Scalars['Zone']['input'];
};

export type LimitedVisibilityOptionnameArgs = {
  locale: Scalars['Locale']['input'];
};

export type LinkoutChannel = ApplicationChannel & {
  __typename?: 'LinkoutChannel';
  label?: Maybe<Scalars['String']['output']>;
};

export type LinkoutChannellabelArgs = {
  locale: Scalars['Locale']['input'];
};

export type LiteProfileUpdateInput = {
  aboutYouEmail: Scalars['String']['input'];
  aboutYouName: Scalars['String']['input'];
  accountPrimaryContact: Scalars['String']['input'];
  brandId?: InputMaybe<Scalars['String']['input']>;
  organisationName: Scalars['String']['input'];
};

export type LiteProfileUpdateNotificationPayload = {
  __typename?: 'LiteProfileUpdateNotificationPayload';
  success: Scalars['Boolean']['output'];
};

export type Location2 = {
  __typename?: 'Location2';
  countryCode: Scalars['CountryCodeIso2']['output'];
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isDeprecated?: Maybe<Scalars['Boolean']['output']>;
  kind: Scalars['String']['output'];
  shortDescription: Scalars['String']['output'];
};

export type LocationInfo = {
  __typename?: 'LocationInfo';
  label: Scalars['String']['output'];
};

export type LocationInfolabelArgs = {
  language?: InputMaybe<Scalars['LanguageCodeIso']['input']>;
  locale?: InputMaybe<Scalars['Locale']['input']>;
  type?: InputMaybe<LocationLabelType>;
};

export type LocationLabelType = 'LONG' | 'SHORT';

export type LocationRadiusOption = {
  __typename?: 'LocationRadiusOption';
  longLabel: Scalars['String']['output'];
  shortLabel: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type LocationRadiusOptionlongLabelArgs = {
  locale: Scalars['Locale']['input'];
};

export type LocationRadiusOptionshortLabelArgs = {
  locale: Scalars['Locale']['input'];
};

export type LocationSuggestion = {
  __typename?: 'LocationSuggestion';
  defaultDistanceKms?: Maybe<Scalars['Float']['output']>;
  /** A array of SuggestionHighlight which tells you the text index 'start' and 'end' to highlight. This supports multi highlight on a single string of text */
  highlights: Array<SuggestionHighlight>;
  id: Scalars['String']['output'];
  isGranular: Scalars['Boolean']['output'];
  partnerId?: Maybe<Scalars['String']['output']>;
  text: Scalars['String']['output'];
};

/** LocationSuggestionGroup is a collection of pre-defined suggestions e.g. Recent or Suggested Area */
export type LocationSuggestionGroup = {
  __typename?: 'LocationSuggestionGroup';
  label: Scalars['String']['output'];
  suggestions: Array<LocationSuggestion>;
  type: SuggestionGroupType;
};

export type LocationSuggestionType =
  | LocationSuggestion
  | LocationSuggestionGroup;

export type LoggedOutRecommendedGlobalJob = {
  __typename?: 'LoggedOutRecommendedGlobalJob';
  job?: Maybe<Job>;
  solMetadata: Scalars['JSON']['output'];
};

export type LoggedOutRecommendedGlobalJobs = {
  __typename?: 'LoggedOutRecommendedGlobalJobs';
  globalJobs?: Maybe<Array<Maybe<LoggedOutRecommendedGlobalJob>>>;
  solMetadata?: Maybe<Scalars['JSON']['output']>;
};

export type MKLocationSuggestion = {
  __typename?: 'MKLocationSuggestion';
  countryCode: Scalars['CountryCodeIso2']['output'];
  id: Scalars['Int']['output'];
  text: Scalars['String']['output'];
};

export type MKLocationTrackSelectedResponse = {
  __typename?: 'MKLocationTrackSelectedResponse';
  id: Scalars['Int']['output'];
};

export type MarkAsPreferredApplicationDuplicateError =
  MarkAsPreferredApplicationError & {
    __typename?: 'MarkAsPreferredApplicationDuplicateError';
    message: Scalars['String']['output'];
  };

export type MarkAsPreferredApplicationDuplicateErrormessageArgs = {
  locale?: InputMaybe<Scalars['Locale']['input']>;
};

export type MarkAsPreferredApplicationError = {
  message: Scalars['String']['output'];
};

export type MarkAsPreferredApplicationErrormessageArgs = {
  locale?: InputMaybe<Scalars['Locale']['input']>;
};

export type MarkAsPreferredApplicationFailure = {
  __typename?: 'MarkAsPreferredApplicationFailure';
  errors: Array<MarkAsPreferredApplicationError>;
};

export type MarkAsPreferredApplicationInput = {
  applicationRequestId: Scalars['ID']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
};

export type MarkAsPreferredApplicationNotEligibleJobError =
  MarkAsPreferredApplicationError & {
    __typename?: 'MarkAsPreferredApplicationNotEligibleJobError';
    message: Scalars['String']['output'];
  };

export type MarkAsPreferredApplicationNotEligibleJobErrormessageArgs = {
  locale?: InputMaybe<Scalars['Locale']['input']>;
};

export type MarkAsPreferredApplicationNotEnoughCreditError =
  MarkAsPreferredApplicationError & {
    __typename?: 'MarkAsPreferredApplicationNotEnoughCreditError';
    message: Scalars['String']['output'];
  };

export type MarkAsPreferredApplicationNotEnoughCreditErrormessageArgs = {
  locale?: InputMaybe<Scalars['Locale']['input']>;
};

export type MarkAsPreferredApplicationPayload =
  | MarkAsPreferredApplicationFailure
  | MarkAsPreferredApplicationSuccess;

export type MarkAsPreferredApplicationSuccess = {
  __typename?: 'MarkAsPreferredApplicationSuccess';
  /** @deprecated Deprecated and to be removed by 31/10/2026. Use credit2 instead */
  credit: PriorityApplyCandidateCredit;
  credit2: PriorityApplyCandidateCredit2;
};

export type MarqueeCompanyProfile = {
  __typename?: 'MarqueeCompanyProfile';
  companyNameSlug?: Maybe<Scalars['String']['output']>;
  /** primary key: Company ID */
  id: Scalars['ID']['output'];
  jobCount?: Maybe<Scalars['Int']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  /** foreign key: Ontology Organisation ID */
  organizationId?: Maybe<Scalars['ID']['output']>;
  reviews?: Maybe<CompanyProfileReviewsSummary>;
  serviceToken: Scalars['UUID']['output'];
  title: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type MatchedQualities = {
  __typename?: 'MatchedQualities';
  inferred?: Maybe<Array<Maybe<Skill>>>;
  matched?: Maybe<Array<Maybe<Skill>>>;
  unmatched?: Maybe<Array<Maybe<Skill>>>;
};

export type MatchedSkills = {
  __typename?: 'MatchedSkills';
  inferred?: Maybe<Array<Maybe<Quality>>>;
  matched?: Maybe<Array<Maybe<Quality>>>;
  matchedQualitiesRequestToken?: Maybe<Scalars['String']['output']>;
  unmatched?: Maybe<Array<Maybe<Quality>>>;
};

export type MissionStatement = {
  __typename?: 'MissionStatement';
  description: Description;
};

export type MobileNotiError = {
  message: Scalars['String']['output'];
};

export type MobileNotiErrormessageArgs = {
  locale?: InputMaybe<Scalars['Locale']['input']>;
};

export type MobileNotiFailure = {
  __typename?: 'MobileNotiFailure';
  errors: Array<MobileNotiError>;
};

export type MobileNotiServiceUnavailableError = MobileNotiError & {
  __typename?: 'MobileNotiServiceUnavailableError';
  message: Scalars['String']['output'];
};

export type MobileNotiServiceUnavailableErrormessageArgs = {
  locale?: InputMaybe<Scalars['Locale']['input']>;
};

export type MobileNotiUnknownError = MobileNotiError & {
  __typename?: 'MobileNotiUnknownError';
  message: Scalars['String']['output'];
};

export type MobileNotiUnknownErrormessageArgs = {
  locale?: InputMaybe<Scalars['Locale']['input']>;
};

export type MobilePlatformNoti = {
  client: Scalars['String']['input'];
  name: Scalars['String']['input'];
  service: Scalars['String']['input'];
};

export type MonthYear = {
  __typename?: 'MonthYear';
  month: Scalars['Int']['output'];
  year: Scalars['Int']['output'];
};

export type MonthYearInput = {
  month: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};

export type MostRecentRoleInput = {
  company: Scalars['String']['input'];
  finished?: InputMaybe<MonthYearInput>;
  started: MonthYearInput;
  title: Scalars['String']['input'];
};

export type MultipleChoiceQuestion = Question & {
  __typename?: 'MultipleChoiceQuestion';
  id: Scalars['String']['output'];
  lastAnswers?: Maybe<Array<LastAnswer>>;
  options: Array<QuestionOption>;
  text: Scalars['String']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  _empty?: Maybe<Scalars['String']['output']>;
  /** Add feedback for a salary nudge */
  addSalaryNudgeFeedback: CandidateSalaryNudgeFeedbackPayload;
  addSeekMaxCertificateToSeekPass: AddSeekMaxCertificateToSeekPassPayload;
  changeEmailAddress?: Maybe<ChangeEmailAddressPayload>;
  changeEmailStart?: Maybe<ChangeEmailStartPayload>;
  changeEmailVerify?: Maybe<ChangeEmailVerifyPayload>;
  changePassword?: Maybe<ChangePasswordPayload>;
  confirmQualification: ConfirmQualificationPayload;
  confirmRole?: Maybe<ConfirmRolePayload>;
  createApacSavedSearch: CreateApacSavedSearchPayload;
  /** UNSTABLE! */
  createCandidateJobMatchRequest?: Maybe<CreateCandidateJobMatchResponse>;
  /** Create a consent for a given transactionId */
  createConsent: CreateConsentPayload;
  createLinkoutApplication?: Maybe<CreateLinkoutApplicationPayload>;
  /** Create avatar record and URL for uploading an image */
  createProfileAvatar?: Maybe<CreateProfileAvatarPayload>;
  createSavedJob2: CreateSavedJobPayload;
  /** @deprecated Use createSeekMaxCommentModeration instead */
  createSeekMaxComment: CreateSeekMaxCommentPayload;
  createSeekMaxCommentModeration?: Maybe<CreateSeekMaxCommentPayload>;
  createSeekMaxModuleBookmark: CreateSeekMaxModuleBookmarkPayload;
  /** @deprecated Use createSeekMaxReplyModeration instead */
  createSeekMaxReply: CreateSeekMaxReplyPayload;
  createSeekMaxReplyModeration?: Maybe<CreateSeekMaxReplyPayload>;
  createSeekMaxThread: CreateSeekMaxThreadPayload;
  createSeekMaxThreadModeration?: Maybe<CreateSeekMaxThreadPayload>;
  /** @deprecated Use createSeekMaxThreadModeration instead */
  createSeekMaxThreadV2: CreateSeekMaxThreadPayload;
  /** @deprecated This functionality is retired */
  createShareableProfileSettings: CreateShareableProfileSettingsPayload;
  createUnregisteredApacSavedSearchWithChecksum: CreateUnregisteredApacSavedSearchWithChecksumPayload;
  deleteAccount?: Maybe<DeleteAccountPayload>;
  deleteApacSavedSearch: DeleteApacSavedSearchPayload;
  deleteAppliedJob: DeleteAppliedJobPayload;
  /** EXPERIMENTAL! */
  deleteJobPreferences?: Maybe<DeleteJobPreferencesPayload>;
  deleteLanguageProficiency: DeleteLanguageProficiencyPayload;
  deleteLicence: DeleteLicencePayload;
  /** Delete the candidate's avatar image */
  deleteProfileAvatar?: Maybe<DeleteProfileAvatarPayload>;
  deleteQualification?: Maybe<DeleteQualificationPayload>;
  /** Delete the specified from a candidates profile */
  deleteResume?: Maybe<DeleteResumePayload>;
  deleteRole?: Maybe<DeleteRolePayload>;
  deleteSavedJob2: DeleteSavedJobPayload;
  deleteSeekMaxComment: DeleteSeekMaxCommentPayload;
  deleteSeekMaxModuleBookmark: DeleteSeekMaxModuleBookmarkPayload;
  deleteSeekMaxReply: DeleteSeekMaxReplyPayload;
  deleteSeekMaxThread: DeleteSeekMaxThreadPayload;
  feedback?: Maybe<FeedbackPayload>;
  feedbackLoggedIn?: Maybe<FeedbackPayload>;
  generateCoverLetter: GenerateCoverLetterPayload;
  /**
   * This mutation will generate a resume from the candidates profile. The generated
   * resume will be stored in the profile.
   */
  generateResumeFromProfile?: Maybe<GenerateResumeFromProfilePayload>;
  generateSelectionCriteria: GenerateSelectionCriteriaPayload;
  /** @deprecated This does nothing. This will be removed in the future. */
  liteProfileUpdateNotification?: Maybe<LiteProfileUpdateNotificationPayload>;
  markAsPreferredApplication?: Maybe<MarkAsPreferredApplicationPayload>;
  mkTrackLocationSuggestionSelection: MKLocationTrackSelectedResponse;
  postCompanyProfileReviewFlag?: Maybe<PostCompanyProfileReviewFlagPayload>;
  postCompanyProfileReviewUpvotes?: Maybe<PostCompanyProfileReviewUpvotesPayload>;
  postCompanyReview: PostCompanyReviewPayload;
  postCompanyReviewExperiment2?: Maybe<PostCompanyReviewExperiment2Payload>;
  /** This mutation is utilised to complete the uploading process. */
  processUploadedAttachment?: Maybe<ProcessUploadedAttachmentPayload>;
  /**
   * This mutation is utilised to complete the uploading process. Plus, it also triggers the parsing for this resume
   * via the contextId passed by clients, and it is only used for uploading parsing.
   */
  processUploadedResume?: Maybe<ProcessUploadedResumeResult>;
  provisionAccount?: Maybe<ProvisionAccountPayload>;
  /** Reject consent for a given transactionId */
  rejectConsent: RejectConsentPayload;
  /** @deprecated Use rejectUnconfirmedData instead */
  rejectRole?: Maybe<RejectRolePayload>;
  rejectUnconfirmedData: RejectUnconfirmedDataPayload;
  reportJob: ReportJobPayload;
  reportProfile?: Maybe<ReportProfileSuccessPayload>;
  reportSeekMaxComment: ReportSeekMaxCommentPayload;
  reportSeekMaxReply: ReportSeekMaxReplyPayload;
  reportSeekMaxThread: ReportSeekMaxThreadPayload;
  /**
   * This mutation is only used for selected|scheduled resume parsing (selecting one of the previously uploaded resumes during
   * job apply process) and default resume parsing (making an uploaded resume the primary|default one on profile page),
   * the contextId set by clients is the key to this parsing.
   */
  requestResumeParsing?: Maybe<MutationResult>;
  resubscribeApacSavedSearchByCode: ResubscribeApacSavedSearchByCodePayload;
  /** EXPERIMENTAL! */
  saveJobPreferences?: Maybe<SaveJobPreferencesPayload>;
  saveSeekMaxKeywordSearch: SaveSeekMaxKeywordSearchPayload;
  sendLoginCallbackEvent?: Maybe<SendLoginCallbackEventPayload>;
  sendSeekMaxModuleClickedEvent: SendSeekMaxModuleClickedEventPayload;
  sendSeekMaxModuleClickedPersonalisationEvent: SeekMaxModuleClickedPersonalisationEventPayload;
  sendSeekMaxModuleProgress: SeekMaxModuleProgressPayload;
  /** UNSTABLE! */
  sendSeekMaxThreadViewedPersonalisationEvent: SeekMaxThreadViewedPersonalisationEventPayload;
  sendSeekMaxVideoViewedEvent: SeekMaxVideoViewedEventPayload;
  sendSeekMaxVideoViewedPersonalisationEvent: SeekMaxVideoViewedPersonalisationEventPayload;
  setAppliedJobNotes: SetAppliedJobNotesPayload;
  /** Set the default resume for a candidate. */
  setDefaultResume?: Maybe<SetDefaultResumePayload>;
  setSavedJobNotes: SetSavedJobNotesPayload;
  setSeekMaxCategoryGroupFollowedStatus: SetSeekMaxCategoryGroupFollowedStatusPayload;
  setSeekMaxCommentLikedStatus: SetSeekMaxCommentLikedStatusPayload;
  setSeekMaxModuleLikedStatus: SetSeekMaxModuleLikedStatusPayload;
  setSeekMaxNotificationAsReadStatus?: Maybe<SetSeekMaxNotificationAsReadStatusPayload>;
  setSeekMaxThreadLikedStatus: SetSeekMaxThreadLikedStatusPayload;
  setSeekMaxThreadPollStatus: SetSeekMaxThreadPollStatusPayload;
  submitApplication: SubmitApplicationPayload;
  /** UNSTABLE! EXPERIMENTAL! */
  submitCareerFeedJobsRefinement?: Maybe<SubmitCareerFeedJobsRefinementPayload>;
  /** EXPERIMENTAL! Rec Refinement Fake Door Contact the team at https://seek.enterprise.slack.com/archives/CEBGFFBSP */
  submitFakeDoorRecommendationsRefinementFeedback?: Maybe<SubmitFakeDoorRecommendationsRefinementFeedbackPayload>;
  submitMessage?: Maybe<SubmitSourcrMessagePayload>;
  submitSourcrPageAnalyticsEvent?: Maybe<SubmitSourcrPageAnalyticsEventPayload>;
  subscribeApacSavedEmailAlert: SubscribeApacSavedEmailAlertPayload;
  subscribeMobileNotifications: SubscribeMobileNotiPayload;
  trackJobApplicationStarted: TrackJobApplicationStartedPayload;
  trackJobDetailsViewed: TrackJobDetailsViewedPayload;
  trackSearchResultSelected: TrackSearchResultSelectedPayload;
  unsubscribeApacSavedSearchByCode: UnsubscribeApacSavedSearchByCodePayload;
  unsubscribeMobileNotifications: UnsubscribeMobileNotiPayload;
  updateApproachability: UpdateApproachabilityPayload;
  updateAvailability?: Maybe<UpdateNoticePeriodPayload>;
  updateCareerObjectives?: Maybe<UpdateCareerObjectivesPayload>;
  updateCurrentLocation2: UpdateCurrentLocation2Payload;
  updateLanguageProficiency: UpdateLanguageProficiencyPayload;
  updateLicence: UpdateLicencePayload;
  updateMarketInsightsPreferences?: Maybe<UpdateMarketInsightsPreferencesPayload>;
  /** @deprecated Use updateAvailability instead */
  updateNoticePeriod?: Maybe<UpdateNoticePeriodPayload>;
  updateNotificationCtpPreferences?: Maybe<UpdateNotificationCtpPreferencesPayload>;
  updateNotificationCtpSubscriptionWithToken?: Maybe<UpdateNotificationCtpSubscriptionWithTokenPayload>;
  updatePersonalDetails?: Maybe<UpdatePersonalDetailsPayload>;
  updatePreferredClassification: UpdatePreferredClassificationPayload;
  updatePreferredLocations2: UpdatePreferredLocations2Payload;
  /** EXPERIMENTAL! */
  updatePreferredRoleTitles?: Maybe<UpdatePreferredRoleTitlesPayload>;
  updatePreferredWorkTypes?: Maybe<UpdateWorkTypesPayload>;
  updateProfileVisibility: UpdateProfileVisibilityPayload;
  updateProfileVisibility2: UpdateProfileVisibility2Payload;
  updateQualification?: Maybe<UpdateQualificationPayload>;
  updateRightsToWork: UpdateRightsToWorkPayload;
  updateRole?: Maybe<UpdateRolePayload>;
  updateSalaryPreferences: UpdateSalaryPreferencesPayload;
  updateSeekMaxMyThreadsLastViewed?: Maybe<UpdateSeekMaxMyThreadsLastViewedPayload>;
  /** @deprecated This functionality is retired */
  updateShareableProfileSettings: UpdateShareableProfileSettingsPayload;
  /** @deprecated This functionality is retired */
  updateShareableProfileViews: UpdateShareableProfileViewsPayload;
  updateSkills?: Maybe<UpdateSkillsPayload>;
  updateVerifiedLicence: UpdateVerifiedLicencePayload;
  updateVerifiedQualification: UpdateVerifiedQualificationPayload;
  /** @deprecated Its no longer being used in production after unification. Will be removed in future releases. */
  updateYearsOfExperience: UpdateYearsOfExperiencePayload;
};

export type MutationaddSalaryNudgeFeedbackArgs = {
  nudgeId: Scalars['ID']['input'];
  nudgeOption: Scalars['String']['input'];
  zone: Scalars['String']['input'];
};

export type MutationaddSeekMaxCertificateToSeekPassArgs = {
  input: AddSeekMaxCertificateToSeekPassInput;
};

export type MutationchangeEmailAddressArgs = {
  input: ChangeEmailAddressInput;
};

export type MutationchangeEmailStartArgs = {
  input: ChangeEmailStartInput;
};

export type MutationchangeEmailVerifyArgs = {
  input: ChangeEmailVerifyInput;
};

export type MutationchangePasswordArgs = {
  input: ChangePasswordInput;
};

export type MutationconfirmQualificationArgs = {
  input: ConfirmQualificationInput;
};

export type MutationconfirmRoleArgs = {
  input: ConfirmRoleInput;
};

export type MutationcreateApacSavedSearchArgs = {
  input: CreateApacSavedSearchInput;
};

export type MutationcreateCandidateJobMatchRequestArgs = {
  input: CreateCandidateJobMatchRequestInput;
};

export type MutationcreateConsentArgs = {
  input: CreateConsentInput;
};

export type MutationcreateLinkoutApplicationArgs = {
  input: CreateLinkoutApplicationInput;
};

export type MutationcreateSavedJob2Args = {
  input: CreateSavedJobInput;
};

export type MutationcreateSeekMaxCommentArgs = {
  input: CreateSeekMaxCommentInput;
};

export type MutationcreateSeekMaxCommentModerationArgs = {
  input: CreateSeekMaxCommentV2Input;
};

export type MutationcreateSeekMaxModuleBookmarkArgs = {
  input: SeekMaxModuleBookmarkInput;
};

export type MutationcreateSeekMaxReplyArgs = {
  input: CreateSeekMaxReplyInput;
};

export type MutationcreateSeekMaxReplyModerationArgs = {
  input: CreateSeekMaxReplyV2Input;
};

export type MutationcreateSeekMaxThreadArgs = {
  input: CreateSeekMaxThreadInput;
};

export type MutationcreateSeekMaxThreadModerationArgs = {
  input: CreateSeekMaxThreadV2Input;
};

export type MutationcreateSeekMaxThreadV2Args = {
  input: CreateSeekMaxThreadV2Input;
};

export type MutationcreateUnregisteredApacSavedSearchWithChecksumArgs = {
  input: CreateUnregisteredApacSavedSearchWithChecksumInput;
};

export type MutationdeleteAccountArgs = {
  input: DeleteAccountInput;
};

export type MutationdeleteApacSavedSearchArgs = {
  input: DeleteApacSavedSearchInput;
};

export type MutationdeleteAppliedJobArgs = {
  input: DeleteAppliedJobInput;
};

export type MutationdeleteJobPreferencesArgs = {
  input: Array<DeleteJobPreferencesInput>;
};

export type MutationdeleteLanguageProficiencyArgs = {
  input: DeleteLanguageProficiencyInput;
};

export type MutationdeleteLicenceArgs = {
  input: DeleteLicenceInput;
};

export type MutationdeleteQualificationArgs = {
  input: DeleteQualificationInput;
};

export type MutationdeleteResumeArgs = {
  input: DeleteResumeInput;
};

export type MutationdeleteRoleArgs = {
  input: DeleteRoleInput;
};

export type MutationdeleteSavedJob2Args = {
  input: DeleteSavedJobInput;
};

export type MutationdeleteSeekMaxCommentArgs = {
  input: DeleteSeekMaxCommentInput;
};

export type MutationdeleteSeekMaxModuleBookmarkArgs = {
  input: SeekMaxModuleBookmarkInput;
};

export type MutationdeleteSeekMaxReplyArgs = {
  input: DeleteSeekMaxReplyInput;
};

export type MutationdeleteSeekMaxThreadArgs = {
  input: DeleteSeekMaxThreadInput;
};

export type MutationfeedbackArgs = {
  input: FeedbackInput;
};

export type MutationfeedbackLoggedInArgs = {
  input: FeedbackLoggedInInput;
};

export type MutationgenerateCoverLetterArgs = {
  input: GenerateCoverLetterInput;
};

export type MutationgenerateResumeFromProfileArgs = {
  input?: InputMaybe<GenerateResumeFromProfileInput>;
};

export type MutationgenerateSelectionCriteriaArgs = {
  input: GenerateSelectionCriteriaInput;
};

export type MutationliteProfileUpdateNotificationArgs = {
  input: LiteProfileUpdateInput;
};

export type MutationmarkAsPreferredApplicationArgs = {
  input: MarkAsPreferredApplicationInput;
};

export type MutationmkTrackLocationSuggestionSelectionArgs = {
  id: Scalars['Int']['input'];
  session: Scalars['String']['input'];
};

export type MutationpostCompanyProfileReviewFlagArgs = {
  input: PostCompanyProfileReviewFlagInput;
};

export type MutationpostCompanyProfileReviewUpvotesArgs = {
  input: PostCompanyProfileReviewUpvotesInput;
};

export type MutationpostCompanyReviewArgs = {
  input: PostCompanyReviewInput;
};

export type MutationpostCompanyReviewExperiment2Args = {
  input: PostCompanyReviewExperiment2Input;
};

export type MutationprocessUploadedAttachmentArgs = {
  input: ProcessUploadedAttachmentInput;
};

export type MutationprocessUploadedResumeArgs = {
  input: ProcessUploadedResumeInput;
};

export type MutationprovisionAccountArgs = {
  zone?: InputMaybe<Scalars['Zone']['input']>;
};

export type MutationrejectConsentArgs = {
  input: RejectConsentInput;
};

export type MutationrejectRoleArgs = {
  input: RejectRoleInput;
};

export type MutationrejectUnconfirmedDataArgs = {
  input: RejectUnconfirmedDataInput;
};

export type MutationreportJobArgs = {
  input: ReportJobInput;
};

export type MutationreportProfileArgs = {
  input: ReportProfileInput;
};

export type MutationreportSeekMaxCommentArgs = {
  input: ReportSeekMaxCommentInput;
};

export type MutationreportSeekMaxReplyArgs = {
  input: ReportSeekMaxReplyInput;
};

export type MutationreportSeekMaxThreadArgs = {
  input: ReportSeekMaxThreadInput;
};

export type MutationrequestResumeParsingArgs = {
  input: RequestResumeParsingInput;
};

export type MutationresubscribeApacSavedSearchByCodeArgs = {
  input: ResubscribeApacSavedSearchByCodeInput;
};

export type MutationsaveJobPreferencesArgs = {
  input: Array<SaveJobPreferencesInput>;
};

export type MutationsaveSeekMaxKeywordSearchArgs = {
  input: SaveSeekMaxKeywordSearchInput;
};

export type MutationsendSeekMaxModuleClickedEventArgs = {
  input: SendSeekMaxModuleClickedEventInput;
};

export type MutationsendSeekMaxModuleClickedPersonalisationEventArgs = {
  input: SeekMaxModuleClickedPersonalisationEventInput;
};

export type MutationsendSeekMaxModuleProgressArgs = {
  input: SeekMaxModuleProgressInput;
};

export type MutationsendSeekMaxThreadViewedPersonalisationEventArgs = {
  input: SeekMaxThreadViewedPersonalisationEventInput;
};

export type MutationsendSeekMaxVideoViewedEventArgs = {
  input: SeekMaxVideoViewedEventInput;
};

export type MutationsendSeekMaxVideoViewedPersonalisationEventArgs = {
  input: SeekMaxVideoViewedPersonalisationEventInput;
};

export type MutationsetAppliedJobNotesArgs = {
  input: SetAppliedJobNotesInput;
};

export type MutationsetDefaultResumeArgs = {
  input: SetDefaultResumeInput;
};

export type MutationsetSavedJobNotesArgs = {
  input: SetSavedJobNotesInput;
};

export type MutationsetSeekMaxCategoryGroupFollowedStatusArgs = {
  input: SeekMaxCategoryGroupFollowInput;
};

export type MutationsetSeekMaxCommentLikedStatusArgs = {
  input: SeekMaxLikeInput;
};

export type MutationsetSeekMaxModuleLikedStatusArgs = {
  input: SeekMaxModuleLikeInput;
};

export type MutationsetSeekMaxNotificationAsReadStatusArgs = {
  input: SeekMaxNotificationAsReadInput;
};

export type MutationsetSeekMaxThreadLikedStatusArgs = {
  input: SeekMaxLikeInput;
};

export type MutationsetSeekMaxThreadPollStatusArgs = {
  input: SeekMaxThreadPollInput;
};

export type MutationsubmitApplicationArgs = {
  input: SubmitApplicationInput;
};

export type MutationsubmitCareerFeedJobsRefinementArgs = {
  input: SubmitCareerFeedJobsRefinementInput;
};

export type MutationsubmitFakeDoorRecommendationsRefinementFeedbackArgs = {
  input: SubmitFakeDoorRecommendationsRefinementFeedbackInput;
};

export type MutationsubmitMessageArgs = {
  input: SourcrMessageInput;
};

export type MutationsubmitSourcrPageAnalyticsEventArgs = {
  input: SourcrPageAnalyticsEventInput;
};

export type MutationsubscribeApacSavedEmailAlertArgs = {
  input: SubscribeApacSavedEmailAlertInput;
};

export type MutationsubscribeMobileNotificationsArgs = {
  input: SubscribeMobileNoti;
};

export type MutationtrackJobApplicationStartedArgs = {
  input: TrackJobApplicationStartedInput;
};

export type MutationtrackJobDetailsViewedArgs = {
  input: TrackJobDetailsViewedInput;
};

export type MutationtrackSearchResultSelectedArgs = {
  input: TrackSearchResultSelectedInput;
};

export type MutationunsubscribeApacSavedSearchByCodeArgs = {
  input: UnsubscribeApacSavedSearchByCodeInput;
};

export type MutationunsubscribeMobileNotificationsArgs = {
  input: UnsubscribeMobileNoti;
};

export type MutationupdateApproachabilityArgs = {
  input: UpdateApproachabilityInput;
};

export type MutationupdateAvailabilityArgs = {
  input: UpdateAvailabilityInput;
};

export type MutationupdateCareerObjectivesArgs = {
  input: UpdateCareerObjectivesInput;
};

export type MutationupdateCurrentLocation2Args = {
  input: UpdateCurrentLocation2Input;
};

export type MutationupdateLanguageProficiencyArgs = {
  input: UpdateLanguageProficiencyInput;
};

export type MutationupdateLicenceArgs = {
  input: UpdateLicenceInput;
};

export type MutationupdateMarketInsightsPreferencesArgs = {
  input: UpdateMarketInsightsPreferencesInput;
};

export type MutationupdateNoticePeriodArgs = {
  input: UpdateNoticePeriodInput;
};

export type MutationupdateNotificationCtpPreferencesArgs = {
  input: UpdateNotificationCtpPreferenceInput;
};

export type MutationupdateNotificationCtpSubscriptionWithTokenArgs = {
  input: NotificationCtpSubscriptionWithTokenInput;
};

export type MutationupdatePersonalDetailsArgs = {
  input: UpdatePersonalDetailsInput;
};

export type MutationupdatePreferredClassificationArgs = {
  input: UpdateClassificationInput;
};

export type MutationupdatePreferredLocations2Args = {
  input: UpdatePreferredLocations2Input;
};

export type MutationupdatePreferredRoleTitlesArgs = {
  input: UpdatePreferredRoleTitlesInput;
};

export type MutationupdatePreferredWorkTypesArgs = {
  input: UpdatePreferredWorkTypesInput;
};

export type MutationupdateProfileVisibilityArgs = {
  input: UpdateProfileVisibilityInput;
};

export type MutationupdateProfileVisibility2Args = {
  input: UpdateProfileVisibility2Input;
};

export type MutationupdateQualificationArgs = {
  input: UpdateQualificationInput;
};

export type MutationupdateRightsToWorkArgs = {
  input: UpdateRightsToWorkInput;
};

export type MutationupdateRoleArgs = {
  input: UpdateRoleInput;
};

export type MutationupdateSalaryPreferencesArgs = {
  input: UpdateSalaryPreferencesInput;
};

export type MutationupdateSeekMaxMyThreadsLastViewedArgs = {
  input: UpdateSeekMaxMyThreadsLastViewedInput;
};

export type MutationupdateShareableProfileSettingsArgs = {
  input: UpdateShareableProfileSettingsInput;
};

export type MutationupdateShareableProfileViewsArgs = {
  input: UpdateShareableProfileViewsInput;
};

export type MutationupdateSkillsArgs = {
  input: UpdateSkillsInput;
};

export type MutationupdateVerifiedLicenceArgs = {
  input: UpdateVerifiedLicenceInput;
};

export type MutationupdateVerifiedQualificationArgs = {
  input: UpdateVerifiedQualificationInput;
};

export type MutationupdateYearsOfExperienceArgs = {
  input: UpdateYearsOfExperienceInput;
};

export type MutationResult = {
  __typename?: 'MutationResult';
  ref?: Maybe<Scalars['UUID']['output']>;
};

export type Nationality = {
  __typename?: 'Nationality';
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type NationalityInput = {
  id: Scalars['ID']['input'];
};

export type NoticePeriod = {
  __typename?: 'NoticePeriod';
  weeks: Scalars['Int']['output'];
};

export type NotificationCTPCategory = {
  __typename?: 'NotificationCTPCategory';
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type NotificationCTPCategorydescriptionArgs = {
  locale: Scalars['Locale']['input'];
};

export type NotificationCTPCategorylabelArgs = {
  locale: Scalars['Locale']['input'];
  zone: Scalars['Zone']['input'];
};

export type NotificationCTPChannel = {
  __typename?: 'NotificationCTPChannel';
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type NotificationCTPChannellabelArgs = {
  locale: Scalars['Locale']['input'];
};

export type NotificationCTPFrequency = {
  __typename?: 'NotificationCTPFrequency';
  options: Array<NotificationCTPFrequencyOptions>;
  value: Scalars['String']['output'];
};

export type NotificationCTPFrequencyOptions = {
  __typename?: 'NotificationCTPFrequencyOptions';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type NotificationCTPFrequencyOptionsdescriptionArgs = {
  locale: Scalars['Locale']['input'];
};

export type NotificationCTPFrequencyOptionslabelArgs = {
  locale: Scalars['Locale']['input'];
};

export type NotificationCTPPreference = {
  __typename?: 'NotificationCTPPreference';
  product: NotificationCTPProduct;
  subscriptions: Array<NotificationCTPSubscription>;
};

export type NotificationCTPPreferenceGroup = {
  __typename?: 'NotificationCTPPreferenceGroup';
  category: NotificationCTPCategory;
  preferences: Array<NotificationCTPPreference>;
};

export type NotificationCTPProduct = {
  __typename?: 'NotificationCTPProduct';
  action?: Maybe<NotificationCTPProductAction>;
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type NotificationCTPProductdescriptionArgs = {
  locale: Scalars['Locale']['input'];
  zone: Scalars['Zone']['input'];
};

export type NotificationCTPProductlabelArgs = {
  locale: Scalars['Locale']['input'];
};

export type NotificationCTPProductAction = {
  __typename?: 'NotificationCTPProductAction';
  label: Scalars['String']['output'];
  path: Scalars['String']['output'];
};

export type NotificationCTPProductActionlabelArgs = {
  locale: Scalars['Locale']['input'];
  zone: Scalars['Zone']['input'];
};

export type NotificationCTPSubscription = {
  __typename?: 'NotificationCTPSubscription';
  channel: NotificationCTPChannel;
  frequency?: Maybe<NotificationCTPFrequency>;
  id: Scalars['ID']['output'];
  subscribed: Scalars['Boolean']['output'];
  token?: Maybe<Scalars['String']['output']>;
};

export type NotificationChannelInput = {
  channel: NotificationCtpChannelType;
  frequency?: InputMaybe<NotificationCtpFrequencyType>;
  reason: NotificationCtpUpdateReasonType;
  subscribe: Scalars['Boolean']['input'];
};

export type NotificationCtpChannelType = 'email' | 'push';

export type NotificationCtpFrequencyType = 'daily' | 'dynamic' | 'weekly';

export type NotificationCtpPreferenceError = {
  errorCode?: Maybe<Scalars['Int']['output']>;
  message: Scalars['String']['output'];
};

export type NotificationCtpPreferenceErrormessageArgs = {
  locale?: InputMaybe<Scalars['Locale']['input']>;
};

export type NotificationCtpPreferenceProductType =
  | 'AppAdExpired'
  | 'AppConfirmed'
  | 'AppNotSuitable'
  | 'AppViewed'
  | 'AppliedJobsActivity'
  | 'CareerHubReengageExplore'
  | 'CareerHubThreadReply'
  | 'ImproveJobSearch'
  | 'MarketingAdviceTips'
  | 'MarketingNewsletter'
  | 'MarketingPartnerUpdates'
  | 'MarketingProductUpdates'
  | 'MarketingProfileUpdate'
  | 'MarketingSurveyResearch'
  | 'NewJob'
  | 'ProfileActivity'
  | 'ReOnboarding'
  | 'ReminderToApply'
  | 'SavedSearch'
  | 'SearchesToSave'
  | 'TopApplicant'
  | 'VerificationRequests'
  | 'WRU';

export type NotificationCtpPreferencesInput = {
  id: NotificationCtpPreferenceProductType;
  notificationsChannel: Array<NotificationChannelInput>;
};

export type NotificationCtpSubscriptionWithTokenInput = {
  locale?: InputMaybe<Scalars['Locale']['input']>;
  subscribe: Scalars['Boolean']['input'];
  token: Scalars['String']['input'];
};

export type NotificationCtpUpdateReasonType =
  | 'clickOps'
  | 'customer'
  | 'importOld'
  | 'legalRequirement'
  | 'preferenceUI'
  | 'sunrise'
  | 'sunset'
  | 'tcpd'
  | 'unificationHistorical'
  | 'unificationLiveSync'
  | 'unknown'
  | 'updateWithToken';

export type NumberOfReviews = {
  __typename?: 'NumberOfReviews';
  description: Scalars['String']['output'];
  value: Scalars['Int']['output'];
};

export type NumberOfReviewsdescriptionArgs = {
  locale: Scalars['Locale']['input'];
};

export type OntologyRole = {
  __typename?: 'OntologyRole';
  id: Scalars['String']['output'];
  roleTitle: Scalars['String']['output'];
  uri: Scalars['String']['output'];
};

export type OntologyRoleroleTitleArgs = {
  locale: Scalars['Locale']['input'];
};

export type OntologySpecReq = {
  __typename?: 'OntologySpecReq';
  collectExpiry: Scalars['Boolean']['output'];
  highlights: Array<SuggestionHighlight>;
  id: Scalars['String']['output'];
  matchedVariant: Scalars['String']['output'];
  normalisedText: Scalars['String']['output'];
  verificationUrl?: Maybe<Scalars['String']['output']>;
};

export type OntologySpecReqverificationUrlArgs = {
  languageCode?: InputMaybe<Scalars['LanguageCodeIso']['input']>;
  platform?: InputMaybe<Platform>;
  source?: InputMaybe<SourceExperience>;
  zone?: InputMaybe<Scalars['Zone']['input']>;
};

export type OntologyStructuredData = {
  __typename?: 'OntologyStructuredData';
  ontologyId?: Maybe<Scalars['ID']['output']>;
  text: Scalars['String']['output'];
};

export type OntologyStructuredDataInput = {
  ontologyId?: InputMaybe<Scalars['ID']['input']>;
  text: Scalars['String']['input'];
};

export type OntologyType =
  | 'EDUCATION_PROVIDERS'
  | 'ORGANISATIONS'
  | 'QUALIFICATIONS'
  | 'ROLETITLES'
  | 'ROLETITLES_SENIORITY'
  | 'SPECREQS';

export type Option = 'all' | 'common';

export type OverallRating = {
  __typename?: 'OverallRating';
  numberOfReviews: NumberOfReviews;
  value: Scalars['Float']['output'];
};

export type Overview = {
  __typename?: 'Overview';
  description?: Maybe<Description>;
  industry?: Maybe<Scalars['String']['output']>;
  primaryLocation?: Maybe<Scalars['String']['output']>;
  size?: Maybe<CompanySize>;
  specialities?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Website>;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPrevPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type ParentClassification = {
  __typename?: 'ParentClassification';
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  subClassifications: Array<ChildClassification>;
};

export type ParentClassificationdescriptionArgs = {
  languageCode?: InputMaybe<Scalars['LanguageCodeIso']['input']>;
};

export type PendingCredentialGroup = {
  __typename?: 'PendingCredentialGroup';
  count: Scalars['Int']['output'];
  label: Scalars['String']['output'];
};

export type PendingCredit = PriorityApplyCandidateCredit2 & {
  __typename?: 'PendingCredit';
  nextRenewalDate?: Maybe<SeekDateTime>;
  remainingCount: Scalars['Int']['output'];
  totalCredit: Scalars['Int']['output'];
};

export type PerkAndBenefit = {
  __typename?: 'PerkAndBenefit';
  description: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type PersonalDetails = {
  __typename?: 'PersonalDetails';
  /**
   * The candidate's country calling code. The `description` field will be returned in the
   * language specified by the `languageCode` parameter passed to the `personalDetails`
   * field. If this field is `null` then the `defaultCountryCallingCode` value must be
   * used instead. Otherwise, this field must always be used.
   */
  countryCallingCode?: Maybe<CountryCallingCode>;
  /**
   * A default country calling code based on the `countryCode` parameter passed to the
   * `personalDetails` field. The `description` field will be returned in the language
   * specified by the `languageCode` parameter passed to the `personalDetails` field.
   * If the `countryCallingCode` field is `null`, then this  field must always be used.
   * Otherwise, the `countryCallingCode` must be used instead.
   */
  defaultCountryCallingCode: CountryCallingCode;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  /** @deprecated Being phased out as part of unification */
  nationality?: Maybe<Nationality>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

export type PersonalisedJobDetails = {
  __typename?: 'PersonalisedJobDetails';
  /** Job Application Insights provides information and context about an applied job */
  applicationInsights?: Maybe<JobApplicationInsights>;
  /** @deprecated Replaced by PersonalisedJobDetails.appliedJob */
  appliedDateTime?: Maybe<SeekDateTime>;
  appliedJob?: Maybe<AppliedJob>;
  /** UNSTABLE! */
  candidateJobMatch?: Maybe<CandidateJobMatch>;
  /** @deprecated Replaced by PersonalisedJobDetails.savedJob */
  isSaved?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated No longer shown in UI */
  jobApplicantsBadge?: Maybe<JobApplicantsBadge>;
  /**
   * CAUTION!! This field uses a resolver that does not meet the SPREAD requirements
   * for a Seek Resource API.  Please query separately from the other fields in the
   * PersonaliseJobDetails object.
   */
  matchedSkills?: Maybe<MatchedSkills>;
  qualities?: Maybe<MatchedQualities>;
  salaryMatch?: Maybe<IJobProfileSalaryMatch>;
  savedJob?: Maybe<SavedJob>;
  /**
   * Top Applicant Badge uses Brand, Locale/translatable text
   * @deprecated Fetching data from Personalisation API, requiring different data than what was being provided
   */
  topApplicantBadge?: Maybe<TopApplicantBadge>;
  /** Top Applicant Badge 2: replaces Top Applicant Badge to ensure non-breaking change - adds arguments for the fetch */
  topApplicantBadge2?: Maybe<TopApplicantBadge>;
};

export type PersonalisedJobDetailstopApplicantBadge2Args = {
  languageCode: Scalars['LanguageCodeIso']['input'];
  platform: Platform;
  visitorId: Scalars['UUID']['input'];
};

export type PersonalisedSeekMaxCategoryGroup = {
  __typename?: 'PersonalisedSeekMaxCategoryGroup';
  followed?: Maybe<Scalars['Boolean']['output']>;
};

export type PersonalisedSeekMaxComment = {
  __typename?: 'PersonalisedSeekMaxComment';
  isAuthor?: Maybe<Scalars['Boolean']['output']>;
  likedV3?: Maybe<Scalars['Boolean']['output']>;
};

export type PersonalisedSeekMaxCommentisAuthorArgs = {
  zone: Scalars['Zone']['input'];
};

export type PersonalisedSeekMaxCommentlikedV3Args = {
  zone: Scalars['Zone']['input'];
};

export type PersonalisedSeekMaxModule = {
  __typename?: 'PersonalisedSeekMaxModule';
  bookmark?: Maybe<SeekMaxModuleBookmark>;
  likedV3?: Maybe<Scalars['Boolean']['output']>;
};

export type PersonalisedSeekMaxModulebookmarkArgs = {
  zone: Scalars['Zone']['input'];
};

export type PersonalisedSeekMaxModulelikedV3Args = {
  zone: Scalars['Zone']['input'];
};

export type PersonalisedSeekMaxModuleProgress = {
  __typename?: 'PersonalisedSeekMaxModuleProgress';
  completed: Scalars['Boolean']['output'];
  nextVideoProgress?: Maybe<SeekMaxNextVideoProgress>;
};

export type PersonalisedSeekMaxPollOption = {
  __typename?: 'PersonalisedSeekMaxPollOption';
  votedV3?: Maybe<Scalars['Boolean']['output']>;
};

export type PersonalisedSeekMaxPollOptionvotedV3Args = {
  zone: Scalars['Zone']['input'];
};

export type PersonalisedSeekMaxReply = {
  __typename?: 'PersonalisedSeekMaxReply';
  isAuthor?: Maybe<Scalars['Boolean']['output']>;
};

export type PersonalisedSeekMaxReplyisAuthorArgs = {
  zone: Scalars['Zone']['input'];
};

export type PersonalisedSeekMaxThread = {
  __typename?: 'PersonalisedSeekMaxThread';
  isAuthor?: Maybe<Scalars['Boolean']['output']>;
  likedV3?: Maybe<Scalars['Boolean']['output']>;
};

export type PersonalisedSeekMaxThreadisAuthorArgs = {
  zone: Scalars['Zone']['input'];
};

export type PersonalisedSeekMaxThreadlikedV3Args = {
  zone: Scalars['Zone']['input'];
};

export type PersonalisedSeekMaxThreadSearchContent = {
  __typename?: 'PersonalisedSeekMaxThreadSearchContent';
  isAuthor?: Maybe<Scalars['Boolean']['output']>;
  likedV3?: Maybe<Scalars['Boolean']['output']>;
};

export type PersonalisedSeekMaxThreadSearchContentisAuthorArgs = {
  zone: Scalars['Zone']['input'];
};

export type PersonalisedSeekMaxThreadSearchContentlikedV3Args = {
  zone: Scalars['Zone']['input'];
};

export type PersonalisedSeekMaxVideo = {
  __typename?: 'PersonalisedSeekMaxVideo';
  progress: SeekMaxVideoProgress;
};

export type PersonalisedSeekMaxVideoprogressArgs = {
  locale?: InputMaybe<Scalars['Locale']['input']>;
  zone?: InputMaybe<Scalars['Zone']['input']>;
};

export type Platform = 'ANDROID' | 'IOS' | 'WEB';

export type PostCompanyProfileReviewFlagInput = {
  companyId: Scalars['String']['input'];
  details: Scalars['String']['input'];
  reason: Scalars['String']['input'];
  reviewId: Scalars['String']['input'];
};

export type PostCompanyProfileReviewFlagPayload = {
  __typename?: 'PostCompanyProfileReviewFlagPayload';
  success: Scalars['Boolean']['output'];
};

export type PostCompanyProfileReviewUpvotesInput = {
  companyId: Scalars['String']['input'];
  reviewId: Scalars['String']['input'];
};

export type PostCompanyProfileReviewUpvotesPayload = {
  __typename?: 'PostCompanyProfileReviewUpvotesPayload';
  success: Scalars['Boolean']['output'];
};

export type PostCompanyReviewCreationError = PostCompanyReviewError & {
  __typename?: 'PostCompanyReviewCreationError';
  message: Scalars['String']['output'];
};

export type PostCompanyReviewCreationErrormessageArgs = {
  locale?: InputMaybe<Scalars['Locale']['input']>;
};

export type PostCompanyReviewError = {
  message: Scalars['String']['output'];
};

export type PostCompanyReviewErrormessageArgs = {
  locale?: InputMaybe<Scalars['Locale']['input']>;
};

export type PostCompanyReviewExperiment2Failure = {
  __typename?: 'PostCompanyReviewExperiment2Failure';
  errors: Array<PostCompanyReviewError>;
};

export type PostCompanyReviewExperiment2Input = {
  careerOpportunity?: InputMaybe<RatingDescriptionInput>;
  companyId?: InputMaybe<Scalars['String']['input']>;
  companyName: Scalars['String']['input'];
  diversity?: InputMaybe<RatingDescriptionInput>;
  executiveManagement?: InputMaybe<RatingDescriptionInput>;
  organisationId?: InputMaybe<Scalars['String']['input']>;
  overall?: InputMaybe<RatingDescriptionInput>;
  perksAndBenefits?: InputMaybe<RatingDescriptionInput>;
  reviewId?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<RoleInput>;
  salary?: InputMaybe<SalaryInput>;
  workEnvironment?: InputMaybe<RatingDescriptionInput>;
  workLifeBalance?: InputMaybe<RatingDescriptionInput>;
  zone: Scalars['Zone']['input'];
};

export type PostCompanyReviewExperiment2Payload =
  | PostCompanyReviewExperiment2Failure
  | PostCompanyReviewExperiment2Success;

export type PostCompanyReviewExperiment2Success = {
  __typename?: 'PostCompanyReviewExperiment2Success';
  reviewId: Scalars['String']['output'];
};

export type PostCompanyReviewFailure = {
  __typename?: 'PostCompanyReviewFailure';
  errors: Array<PostCompanyReviewError>;
};

export type PostCompanyReviewInput = {
  careerOpportunity?: InputMaybe<RatingInput>;
  companyId: Scalars['String']['input'];
  companyName: Scalars['String']['input'];
  details: ReviewDetailsInput;
  diversity?: InputMaybe<RatingInput>;
  executiveManagement?: InputMaybe<RatingInput>;
  job: JobInput;
  languageISO: Scalars['String']['input'];
  organisationId?: InputMaybe<Scalars['String']['input']>;
  perksAndBenefits?: InputMaybe<RatingInput>;
  salary?: InputMaybe<SalaryInput>;
  workEnvironment?: InputMaybe<RatingInput>;
  workLifeBalance?: InputMaybe<RatingInput>;
};

export type PostCompanyReviewPayload =
  | PostCompanyReviewFailure
  | PostCompanyReviewSuccess;

export type PostCompanyReviewSuccess = {
  __typename?: 'PostCompanyReviewSuccess';
  reviewId: Scalars['String']['output'];
};

export type PreferredLocation2Input = {
  id: Scalars['Int']['input'];
};

export type PrioritizedCredit = PriorityApplyCandidateCredit2 & {
  __typename?: 'PrioritizedCredit';
  nextRenewalDate?: Maybe<SeekDateTime>;
  remainingCount: Scalars['Int']['output'];
  totalCredit: Scalars['Int']['output'];
};

export type PriorityApplyCandidateCredit = {
  __typename?: 'PriorityApplyCandidateCredit';
  nextRenewalDate?: Maybe<SeekDateTime>;
  remainingCount: Scalars['Int']['output'];
  totalCredit: Scalars['Int']['output'];
};

export type PriorityApplyCandidateCredit2 = {
  remainingCount: Scalars['Int']['output'];
  totalCredit: Scalars['Int']['output'];
};

export type PriorityApplyCredit = {
  __typename?: 'PriorityApplyCredit';
  /** @deprecated Deprecated and to be removed by 31/10/2026. Use credit2 instead */
  credit?: Maybe<PriorityApplyCandidateCredit>;
  credit2?: Maybe<PriorityApplyCandidateCredit2>;
  creditConfig?: Maybe<PriorityApplyCreditConfig>;
};

export type PriorityApplyCreditcredit2Args = {
  languageCode: Scalars['LanguageCodeIso']['input'];
  zone: Scalars['Zone']['input'];
};

export type PriorityApplyCreditConfig = {
  __typename?: 'PriorityApplyCreditConfig';
  creditValue: Scalars['Int']['output'];
  renewFrequency?: Maybe<RenewFrequency>;
};

export type PriorityApplyInput = {
  state: Scalars['String']['input'];
};

export type PriorityApplyState = {
  __typename?: 'PriorityApplyState';
  state: Scalars['String']['output'];
  updatedAt?: Maybe<SeekDateTime>;
};

export type Privacy = {
  __typename?: 'Privacy';
  education: Scalars['Boolean']['output'];
  languages: Scalars['Boolean']['output'];
  licences: Scalars['Boolean']['output'];
  personalDetails: Scalars['Boolean']['output'];
  skills: Scalars['Boolean']['output'];
  summary: Scalars['Boolean']['output'];
  workHistory: Scalars['Boolean']['output'];
};

export type PrivacyInput = {
  education: Scalars['Boolean']['input'];
  languages: Scalars['Boolean']['input'];
  licences: Scalars['Boolean']['input'];
  personalDetails: Scalars['Boolean']['input'];
  skills: Scalars['Boolean']['input'];
  summary: Scalars['Boolean']['input'];
  workHistory: Scalars['Boolean']['input'];
};

export type PrivacyPolicyQuestion = Question & {
  __typename?: 'PrivacyPolicyQuestion';
  id: Scalars['String']['output'];
  options: Array<QuestionOption>;
  text: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type ProcessUploadedAttachmentInput = {
  attachmentType: AttachmentType;
  id: Scalars['UUID']['input'];
};

export type ProcessUploadedAttachmentPayload = {
  __typename?: 'ProcessUploadedAttachmentPayload';
  uri: Scalars['String']['output'];
};

export type ProcessUploadedResumeInput = {
  /** @deprecated Only the zone parameter should be passed after all unification releases */
  countryCode?: InputMaybe<Scalars['CountryCodeIso2']['input']>;
  id: Scalars['UUID']['input'];
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  origin?: InputMaybe<ResumeOriginType>;
  parsingContext?: InputMaybe<RequestResumeParsingContext>;
  zone?: InputMaybe<Scalars['Zone']['input']>;
};

export type ProcessUploadedResumeResult = {
  __typename?: 'ProcessUploadedResumeResult';
  /** @deprecated Please use the resume type with more resume metadata */
  id: Scalars['UUID']['output'];
  resume: Resume;
  viewer?: Maybe<Candidate>;
};

export type ProfileAvatar = {
  __typename?: 'ProfileAvatar';
  /** Avatar ID */
  id: Scalars['ID']['output'];
  /** Image 128x128 URL */
  image128Url?: Maybe<Scalars['String']['output']>;
  /** Image 256x256 URL */
  image256Url?: Maybe<Scalars['String']['output']>;
  /** Image 512x512 URL */
  image512Url?: Maybe<Scalars['String']['output']>;
};

export type ProfileAvatarStatusError = {
  message: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type ProfileAvatarStatusErrormessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type ProfileAvatarStatusErrortitleArgs = {
  locale: Scalars['Locale']['input'];
};

export type ProfileAvatarStatusFailure = {
  __typename?: 'ProfileAvatarStatusFailure';
  error: ProfileAvatarStatusError;
};

export type ProfileAvatarStatusGenericError = ProfileAvatarStatusError & {
  __typename?: 'ProfileAvatarStatusGenericError';
  message: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type ProfileAvatarStatusGenericErrormessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type ProfileAvatarStatusGenericErrortitleArgs = {
  locale: Scalars['Locale']['input'];
};

export type ProfileAvatarStatusHasVirusError = ProfileAvatarStatusError & {
  __typename?: 'ProfileAvatarStatusHasVirusError';
  message: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type ProfileAvatarStatusHasVirusErrormessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type ProfileAvatarStatusHasVirusErrortitleArgs = {
  locale: Scalars['Locale']['input'];
};

export type ProfileAvatarStatusModerationFailedError =
  ProfileAvatarStatusError & {
    __typename?: 'ProfileAvatarStatusModerationFailedError';
    message: Scalars['String']['output'];
    title: Scalars['String']['output'];
  };

export type ProfileAvatarStatusModerationFailedErrormessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type ProfileAvatarStatusModerationFailedErrortitleArgs = {
  locale: Scalars['Locale']['input'];
};

export type ProfileAvatarStatusPending = {
  __typename?: 'ProfileAvatarStatusPending';
  /** Avatar ID */
  avatarId: Scalars['ID']['output'];
};

export type ProfileAvatarStatusResult =
  | ProfileAvatarStatusFailure
  | ProfileAvatarStatusPending
  | ProfileAvatarStatusSuccess;

export type ProfileAvatarStatusSuccess = {
  __typename?: 'ProfileAvatarStatusSuccess';
  /** Candidate with updated Profile Avatar. Use this to refetch the `profileAvatar` field. */
  viewer?: Maybe<Candidate>;
};

export type ProfileInsights = {
  __typename?: 'ProfileInsights';
  activities: Array<ProfileInsightsActivity>;
  searchImpressionCount: Scalars['Int']['output'];
  viewCount: Scalars['Int']['output'];
};

export type ProfileInsights2 = {
  __typename?: 'ProfileInsights2';
  activities: Array<ProfileInsightsActivity2>;
  searchImpressionCount: Scalars['Int']['output'];
  viewCount: Scalars['Int']['output'];
};

export type ProfileInsightsActivity = {
  /** The relative day(s) since the activity, or date of the activity if more than 29 days ago */
  date: Scalars['String']['output'];
  /** Display label for the source of the activity e.g. Found from an employer search */
  sourceLabel: Scalars['String']['output'];
};

export type ProfileInsightsActivitydateArgs = {
  languageCode: Scalars['LanguageCodeIso']['input'];
  timezone?: InputMaybe<Scalars['Timezone']['input']>;
  zone: Scalars['Zone']['input'];
};

export type ProfileInsightsActivitysourceLabelArgs = {
  languageCode: Scalars['LanguageCodeIso']['input'];
};

export type ProfileInsightsActivity2 = {
  /** The relative day(s) since the activity, or date of the activity if more than 29 days ago */
  date: SeekDateTime;
  /** Display label for the source of the activity e.g. Found from an employer search */
  sourceLabel: Scalars['String']['output'];
};

export type ProfileInsightsActivity2dateArgs = {
  locale: Scalars['Locale']['input'];
  timezone?: InputMaybe<Scalars['Timezone']['input']>;
};

export type ProfileInsightsActivity2sourceLabelArgs = {
  locale: Scalars['Locale']['input'];
};

export type ProfileInsightsAdvertiser = {
  __typename?: 'ProfileInsightsAdvertiser';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type ProfileInsightsAdvertiser2 = {
  __typename?: 'ProfileInsightsAdvertiser2';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** region Deprecated */
export type ProfileInsightsJob = {
  __typename?: 'ProfileInsightsJob';
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
  /** Job URL built with brand based on candidate's zone and selected language */
  url: Scalars['String']['output'];
};

/** region Deprecated */
export type ProfileInsightsJoburlArgs = {
  languageCode: Scalars['LanguageCodeIso']['input'];
  zone: Scalars['Zone']['input'];
};

export type ProfileInsightsJobSentActivity = ProfileInsightsActivity & {
  __typename?: 'ProfileInsightsJobSentActivity';
  /** The advertiser who interacted with the candidate's profile */
  advertiser: ProfileInsightsAdvertiser;
  date: Scalars['String']['output'];
  /** Job sent from the advertiser to the candidate */
  job: ProfileInsightsJob;
  sourceLabel: Scalars['String']['output'];
};

export type ProfileInsightsJobSentActivitydateArgs = {
  languageCode: Scalars['LanguageCodeIso']['input'];
  timezone?: InputMaybe<Scalars['Timezone']['input']>;
  zone: Scalars['Zone']['input'];
};

export type ProfileInsightsJobSentActivitysourceLabelArgs = {
  languageCode: Scalars['LanguageCodeIso']['input'];
};

export type ProfileInsightsJobSentActivity2 = ProfileInsightsActivity2 & {
  __typename?: 'ProfileInsightsJobSentActivity2';
  /** The advertiser who interacted with the candidate's profile */
  advertiser?: Maybe<ProfileInsightsAdvertiser2>;
  date: SeekDateTime;
  /** Job sent from the advertiser to the candidate */
  job?: Maybe<Job>;
  sourceLabel: Scalars['String']['output'];
};

export type ProfileInsightsJobSentActivity2dateArgs = {
  locale: Scalars['Locale']['input'];
  timezone?: InputMaybe<Scalars['Timezone']['input']>;
};

export type ProfileInsightsJobSentActivity2sourceLabelArgs = {
  locale: Scalars['Locale']['input'];
};

export type ProfileInsightsMessageSentActivity = ProfileInsightsActivity & {
  __typename?: 'ProfileInsightsMessageSentActivity';
  /** The advertiser who interacted with the candidate's profile */
  advertiser: ProfileInsightsAdvertiser;
  date: Scalars['String']['output'];
  sourceLabel: Scalars['String']['output'];
};

export type ProfileInsightsMessageSentActivitydateArgs = {
  languageCode: Scalars['LanguageCodeIso']['input'];
  timezone?: InputMaybe<Scalars['Timezone']['input']>;
  zone: Scalars['Zone']['input'];
};

export type ProfileInsightsMessageSentActivitysourceLabelArgs = {
  languageCode: Scalars['LanguageCodeIso']['input'];
};

export type ProfileInsightsMessageSentActivity2 = ProfileInsightsActivity2 & {
  __typename?: 'ProfileInsightsMessageSentActivity2';
  /** The advertiser who interacted with the candidate's profile */
  advertiser?: Maybe<ProfileInsightsAdvertiser2>;
  date: SeekDateTime;
  sourceLabel: Scalars['String']['output'];
};

export type ProfileInsightsMessageSentActivity2dateArgs = {
  locale: Scalars['Locale']['input'];
  timezone?: InputMaybe<Scalars['Timezone']['input']>;
};

export type ProfileInsightsMessageSentActivity2sourceLabelArgs = {
  locale: Scalars['Locale']['input'];
};

export type ProfileInsightsResumeDownloadedActivity =
  ProfileInsightsActivity & {
    __typename?: 'ProfileInsightsResumeDownloadedActivity';
    /** The advertiser who interacted with the candidate's profile */
    advertiser: ProfileInsightsAdvertiser;
    date: Scalars['String']['output'];
    sourceLabel: Scalars['String']['output'];
  };

export type ProfileInsightsResumeDownloadedActivitydateArgs = {
  languageCode: Scalars['LanguageCodeIso']['input'];
  timezone?: InputMaybe<Scalars['Timezone']['input']>;
  zone: Scalars['Zone']['input'];
};

export type ProfileInsightsResumeDownloadedActivitysourceLabelArgs = {
  languageCode: Scalars['LanguageCodeIso']['input'];
};

export type ProfileInsightsResumeDownloadedActivity2 =
  ProfileInsightsActivity2 & {
    __typename?: 'ProfileInsightsResumeDownloadedActivity2';
    /** The advertiser who interacted with the candidate's profile */
    advertiser?: Maybe<ProfileInsightsAdvertiser2>;
    date: SeekDateTime;
    sourceLabel: Scalars['String']['output'];
  };

export type ProfileInsightsResumeDownloadedActivity2dateArgs = {
  locale: Scalars['Locale']['input'];
  timezone?: InputMaybe<Scalars['Timezone']['input']>;
};

export type ProfileInsightsResumeDownloadedActivity2sourceLabelArgs = {
  locale: Scalars['Locale']['input'];
};

export type ProfileLocationKind =
  | 'COUNTRY'
  | 'REGION'
  | 'SEEK_AREA'
  | 'SEEK_LOCATION'
  | 'STATE'
  | 'SUBURB';

export type ProfileLocationTrackSelectedResponse = {
  __typename?: 'ProfileLocationTrackSelectedResponse';
  id: Scalars['Int']['output'];
};

export type ProfileLocationType = 'Home' | 'Preferred';

export type ProfileScore = {
  __typename?: 'ProfileScore';
  /** Overall progress/completeness, value from 0 to 1. */
  progress: Scalars['Float']['output'];
  /** The sum of all score values from each individual scorer. */
  score: Scalars['Float']['output'];
  /** A list of all tips the candidate can action on their profile. */
  tips: Array<ProfileScoreTip>;
};

export type ProfileScoreTip = {
  __typename?: 'ProfileScoreTip';
  /** Parameters used by the profile app to customise the tip action. */
  action: ProfileScoreTipAction;
  /** A description of the value the candidate could get by actioning this tip. */
  description: Scalars['String']['output'];
  /** The action button label for this tip. */
  label: Scalars['String']['output'];
  /** The score amount that can be gained from actioning this tip. */
  score: Scalars['Float']['output'];
};

export type ProfileScoreTipAction = {
  __typename?: 'ProfileScoreTipAction';
  /**
   * The specific card to scroll to when the tip is actioned. Valid values are
   * strings from [this array](https://github.com/SEEK-Jobs/ca-myprofile-ui/blob/master/src/components/Router/index.ts#L29).
   */
  card: Scalars['String']['output'];
  /**
   * A specific field to focus on within the `card` specified. The field must
   * have a focus ref attached it. Reference the `field-name` associated with
   * the ref. [Example](https://github.com/SEEK-Jobs/ca-myprofile-ui/blob/494f567314685156cc3c40bfa212746d14845efa/src/components/Profile/PersonalDetails/EditPersonalDetails/EditPersonalDetails.tsx#L144).
   */
  field?: Maybe<Scalars['String']['output']>;
  /**
   * The id of a specific profile item. Can be used if you want an action to
   * target a specific item, e.g. a candidate's most recent career history.
   */
  item?: Maybe<Scalars['String']['output']>;
  /**
   * The mode to set the card to when the tip is actioned. Valid values are
   * `read` or `edit`.
   */
  mode?: Maybe<Scalars['String']['output']>;
};

export type ProfileSuggestLocation = {
  __typename?: 'ProfileSuggestLocation';
  contextualName: Scalars['String']['output'];
  countryCode: Scalars['CountryCodeIso2']['output'];
  highlights: Array<SuggestionHighlight>;
  id: Scalars['Int']['output'];
  kind: Scalars['String']['output'];
  shortName: Scalars['String']['output'];
};

export type ProfileSuggestLocationGroup = {
  __typename?: 'ProfileSuggestLocationGroup';
  label: Scalars['String']['output'];
  suggestions: Array<ProfileSuggestLocation>;
};

export type ProfileSuggestLocationType =
  | ProfileSuggestLocation
  | ProfileSuggestLocationGroup;

export type ProfileSuggestion = {
  __typename?: 'ProfileSuggestion';
  /** Action that candidate could take on for this particular suggestion. */
  action?: Maybe<ProfileSuggestionAction>;
  /** A suggestion message the candidate can improve or action on their profile. */
  message: Scalars['String']['output'];
  /** Event name passed to the tracking system when the suggestion is displayed. */
  trackingNudgeType: Scalars['String']['output'];
};

export type ProfileSuggestionAction = {
  __typename?: 'ProfileSuggestionAction';
  /** The context of the action on what is the next step to take after button click. */
  context?: Maybe<ProfileSuggestionActionContext>;
  /** The action button label for this suggestion action. */
  label: Scalars['String']['output'];
  /** Event name passed to the tracking system when the action is clicked. */
  trackingCallToAction: Scalars['String']['output'];
};

export type ProfileSuggestionActionContext = {
  /**
   * The specific card to scroll to when the tip is actioned. Valid values are
   * strings from [this array](https://github.com/SEEK-Jobs/ca-myprofile-ui/blob/master/src/components/Router/index.ts#L29).
   */
  card?: Maybe<Scalars['String']['output']>;
  /**
   * A specific field to focus on within the `section` specified. The field must have a focus ref attached it. Reference the `field-name` associated with
   * the ref. [Example](https://github.com/SEEK-Jobs/ca-myprofile-ui/blob/494f567314685156cc3c40bfa212746d14845efa/src/components/Profile/PersonalDetails/EditPersonalDetails/EditPersonalDetails.tsx#L144).
   * (Mainly used by web)
   */
  field?: Maybe<Scalars['String']['output']>;
  /** The mode to set the section/card to when the suggestion is actioned. Valid values are `read` or `edit`. (Mainly used by web) */
  mode?: Maybe<Scalars['String']['output']>;
};

export type ProfileSuggestionAvailabilityActionContext =
  ProfileSuggestionActionContext & {
    __typename?: 'ProfileSuggestionAvailabilityActionContext';
    card?: Maybe<Scalars['String']['output']>;
    field?: Maybe<Scalars['String']['output']>;
    mode?: Maybe<Scalars['String']['output']>;
  };

export type ProfileSuggestionCareerHistoryActionContext =
  ProfileSuggestionActionContext & {
    __typename?: 'ProfileSuggestionCareerHistoryActionContext';
    card?: Maybe<Scalars['String']['output']>;
    field?: Maybe<Scalars['String']['output']>;
    /**
     * The id of a specific profile item. Can be used if you want an action to
     * target a specific item, e.g. a candidate's most recent career history.
     */
    itemId?: Maybe<Scalars['String']['output']>;
    mode?: Maybe<Scalars['String']['output']>;
  };

export type ProfileSuggestionClassificationActionContext =
  ProfileSuggestionActionContext & {
    __typename?: 'ProfileSuggestionClassificationActionContext';
    card?: Maybe<Scalars['String']['output']>;
    field?: Maybe<Scalars['String']['output']>;
    mode?: Maybe<Scalars['String']['output']>;
  };

export type ProfileSuggestionEducationActionContext =
  ProfileSuggestionActionContext & {
    __typename?: 'ProfileSuggestionEducationActionContext';
    card?: Maybe<Scalars['String']['output']>;
    field?: Maybe<Scalars['String']['output']>;
    mode?: Maybe<Scalars['String']['output']>;
  };

export type ProfileSuggestionLanguagesActionContext =
  ProfileSuggestionActionContext & {
    __typename?: 'ProfileSuggestionLanguagesActionContext';
    card?: Maybe<Scalars['String']['output']>;
    field?: Maybe<Scalars['String']['output']>;
    mode?: Maybe<Scalars['String']['output']>;
  };

export type ProfileSuggestionLicencesActionContext =
  ProfileSuggestionActionContext & {
    __typename?: 'ProfileSuggestionLicencesActionContext';
    card?: Maybe<Scalars['String']['output']>;
    field?: Maybe<Scalars['String']['output']>;
    mode?: Maybe<Scalars['String']['output']>;
  };

export type ProfileSuggestionPersonalDetailsActionContext =
  ProfileSuggestionActionContext & {
    __typename?: 'ProfileSuggestionPersonalDetailsActionContext';
    card?: Maybe<Scalars['String']['output']>;
    field?: Maybe<Scalars['String']['output']>;
    mode?: Maybe<Scalars['String']['output']>;
  };

export type ProfileSuggestionPersonalSummaryActionContext =
  ProfileSuggestionActionContext & {
    __typename?: 'ProfileSuggestionPersonalSummaryActionContext';
    card?: Maybe<Scalars['String']['output']>;
    field?: Maybe<Scalars['String']['output']>;
    mode?: Maybe<Scalars['String']['output']>;
  };

export type ProfileSuggestionProfileVisibilityActionContext =
  ProfileSuggestionActionContext & {
    __typename?: 'ProfileSuggestionProfileVisibilityActionContext';
    card?: Maybe<Scalars['String']['output']>;
    field?: Maybe<Scalars['String']['output']>;
    mode?: Maybe<Scalars['String']['output']>;
  };

export type ProfileSuggestionResumeActionContext =
  ProfileSuggestionActionContext & {
    __typename?: 'ProfileSuggestionResumeActionContext';
    card?: Maybe<Scalars['String']['output']>;
    field?: Maybe<Scalars['String']['output']>;
    mode?: Maybe<Scalars['String']['output']>;
  };

export type ProfileSuggestionRightToWorkActionContext =
  ProfileSuggestionActionContext & {
    __typename?: 'ProfileSuggestionRightToWorkActionContext';
    card?: Maybe<Scalars['String']['output']>;
    field?: Maybe<Scalars['String']['output']>;
    mode?: Maybe<Scalars['String']['output']>;
  };

export type ProfileSuggestionSalaryActionContext =
  ProfileSuggestionActionContext & {
    __typename?: 'ProfileSuggestionSalaryActionContext';
    card?: Maybe<Scalars['String']['output']>;
    field?: Maybe<Scalars['String']['output']>;
    mode?: Maybe<Scalars['String']['output']>;
  };

export type ProfileSuggestionSkillsActionContext =
  ProfileSuggestionActionContext & {
    __typename?: 'ProfileSuggestionSkillsActionContext';
    card?: Maybe<Scalars['String']['output']>;
    field?: Maybe<Scalars['String']['output']>;
    mode?: Maybe<Scalars['String']['output']>;
  };

export type ProfileSuggestionWorkTypeActionContext =
  ProfileSuggestionActionContext & {
    __typename?: 'ProfileSuggestionWorkTypeActionContext';
    card?: Maybe<Scalars['String']['output']>;
    field?: Maybe<Scalars['String']['output']>;
    mode?: Maybe<Scalars['String']['output']>;
  };

export type ProfileVerifications = {
  __typename?: 'ProfileVerifications';
  nudge?: Maybe<VerificationsNudge2>;
  verifiable?: Maybe<Array<VerifiableCredentialCategory>>;
  verified?: Maybe<Array<VerifiedCredentialCategory>>;
};

export type ProfileVerificationsnudgeArgs = {
  platform: Platform;
  source: SourceExperience;
  testGroup?: InputMaybe<VerificationsTestVariant>;
};

export type ProfileVerificationsverifiableArgs = {
  platform: Platform;
  source: SourceExperience;
};

export type ProfileVisibility = {
  __typename?: 'ProfileVisibility';
  /** Human readable string used when showing the candidate's profile visibility in a read-only context */
  description: Scalars['String']['output'];
  /** Visibility level of the candidate's profile */
  level: VisibilityLevel;
};

export type ProfileVisibilityOption = {
  /** Detailed description of what this visibility level means, localised based on provided locale */
  description: Scalars['String']['output'];
  /** Unique identifier for the visibility level */
  id: Scalars['String']['output'];
  /** Display name for the visibility level, localised based on provided locale */
  name: Scalars['String']['output'];
};

export type ProfileVisibilityOptiondescriptionArgs = {
  locale: Scalars['Locale']['input'];
  zone: Scalars['Zone']['input'];
};

export type ProfileVisibilityOptionnameArgs = {
  locale: Scalars['Locale']['input'];
};

export type ProvisionAccountError = {
  message: Scalars['String']['output'];
};

export type ProvisionAccountErrormessageArgs = {
  locale?: InputMaybe<Scalars['Locale']['input']>;
};

export type ProvisionAccountErrorAlreadyProvisioned = ProvisionAccountError & {
  __typename?: 'ProvisionAccountErrorAlreadyProvisioned';
  message: Scalars['String']['output'];
};

export type ProvisionAccountErrorAlreadyProvisionedmessageArgs = {
  locale?: InputMaybe<Scalars['Locale']['input']>;
};

export type ProvisionAccountErrorAlreadyProvisionedDuplicateGuid =
  ProvisionAccountError & {
    __typename?: 'ProvisionAccountErrorAlreadyProvisionedDuplicateGuid';
    message: Scalars['String']['output'];
  };

export type ProvisionAccountErrorAlreadyProvisionedDuplicateGuidmessageArgs = {
  locale?: InputMaybe<Scalars['Locale']['input']>;
};

export type ProvisionAccountFailure = {
  __typename?: 'ProvisionAccountFailure';
  error: ProvisionAccountError;
};

export type ProvisionAccountPayload =
  | ProvisionAccountFailure
  | ProvisionAccountSuccess;

export type ProvisionAccountSuccess = {
  __typename?: 'ProvisionAccountSuccess';
  id: Scalars['ID']['output'];
  isTokenRefreshRequired: Scalars['Boolean']['output'];
};

export type PublicProfile = {
  __typename?: 'PublicProfile';
  displayUrl: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type PublicProfiledisplayUrlArgs = {
  zone: Scalars['Zone']['input'];
};

export type PublicProfileurlArgs = {
  locale: Scalars['Locale']['input'];
  platform: Platform;
  zone: Scalars['Zone']['input'];
};

export type PublicProfileAvatarUrls = {
  __typename?: 'PublicProfileAvatarUrls';
  /** Image 128x128 URL */
  image128Url?: Maybe<Scalars['String']['output']>;
  /** Image 256x256 URL */
  image256Url?: Maybe<Scalars['String']['output']>;
  /** Image 512x512 URL */
  image512Url?: Maybe<Scalars['String']['output']>;
};

export type PublicProfileCompaniesInput = {
  /** Whether to match the latest companies only */
  matchLatestOnly: Scalars['Boolean']['input'];
  /** The value is a free text */
  values: Array<Scalars['String']['input']>;
};

export type PublicProfileEducation = {
  /** The name of the educational qualification */
  name: Scalars['String']['output'];
};

export type PublicProfileEducationCompletion = {
  __typename?: 'PublicProfileEducationCompletion';
  label?: Maybe<Scalars['String']['output']>;
};

export type PublicProfileEducationCompletionlabelArgs = {
  locale: Scalars['Locale']['input'];
};

export type PublicProfileInclusiveWorkDuration = {
  __typename?: 'PublicProfileInclusiveWorkDuration';
  label?: Maybe<Scalars['String']['output']>;
};

export type PublicProfileInclusiveWorkDurationlabelArgs = {
  locale: Scalars['Locale']['input'];
};

export type PublicProfileLicence = {
  /** The name of the licence */
  name: Scalars['String']['output'];
};

/** Shared types */
export type PublicProfileLocation = {
  __typename?: 'PublicProfileLocation';
  /** The candidate's location label */
  label?: Maybe<Scalars['String']['output']>;
};

/** Shared types */
export type PublicProfileLocationlabelArgs = {
  locale: Scalars['Locale']['input'];
};

export type PublicProfileLocationsInput = {
  /** The value can be location ids or free text */
  values: Array<Scalars['String']['input']>;
};

export type PublicProfileRightToWork = {
  __typename?: 'PublicProfileRightToWork';
  /** A localized label describing the country to which the candidate's right to work status applies. */
  countryLabel: Scalars['String']['output'];
  /** True if the candidate's right to work status for this country has been verified by SEEK Pass. */
  isVerified: Scalars['Boolean']['output'];
  /** A localized label describing the candidate's right to work status for this country. */
  statusLabel: Scalars['String']['output'];
};

export type PublicProfileRightToWorkcountryLabelArgs = {
  locale: Scalars['Locale']['input'];
};

export type PublicProfileRightToWorkstatusLabelArgs = {
  locale: Scalars['Locale']['input'];
};

/** Search types */
export type PublicProfileRoleTitlesInput = {
  /** Whether to match the latest role titles only */
  matchLatestOnly: Scalars['Boolean']['input'];
  /** The value is a free text search */
  values: Array<Scalars['String']['input']>;
};

export type PublicProfileSearchInput = {
  /** The companies used to filter candidate profile search results */
  companies?: InputMaybe<PublicProfileCompaniesInput>;
  /** The locations used to filter candidate profile search results */
  locations: PublicProfileLocationsInput;
  /** The market used to search for candidate profiles */
  market: Scalars['String']['input'];
  /** The page number requested for search results */
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  /** Number of profile search results per page */
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  /** The role titles used to filter candidate profile search results */
  roleTitles?: InputMaybe<PublicProfileRoleTitlesInput>;
  /** The search query used to search for candidate profiles */
  searchQuery: Scalars['String']['input'];
  /** Unique identifier for the visitor, used by the backend to log public profile search events for analytics. */
  visitorId?: InputMaybe<Scalars['UUID']['input']>;
};

export type PublicProfileSearchResult = {
  /** The candidate profile id */
  slug: Scalars['ID']['output'];
};

export type PublicProfileSearchResultEdge = {
  __typename?: 'PublicProfileSearchResultEdge';
  /** The candidate profile node */
  node: PublicProfileSearchResult;
};

/**
 * Developer Note:
 * Although we're currently using offset-based pagination, the results structure follows the Relay connection pattern.
 * This design choice ensures future compatibility and prevents breaking changes if we decide to switch to cursor-based pagination in the future.
 */
export type PublicProfileSearchResults = {
  __typename?: 'PublicProfileSearchResults';
  /** The exact matching profiles with pagination information */
  exactMatches: Array<PublicProfileSearchResultEdge>;
  /** The pagination information for the search results */
  pageInfo: PublicProfileSearchResultsPageInfo;
  /** The partial matching profiles with pagination information */
  partialMatches: Array<PublicProfileSearchResultEdge>;
  /** Used for tracking to correlate search actions with profile views. */
  serviceToken: Scalars['UUID']['output'];
};

export type PublicProfileSearchResultsPageInfo = {
  __typename?: 'PublicProfileSearchResultsPageInfo';
  /** The total number of exact matching profiles for the search query */
  totalExactMatches: Scalars['Int']['output'];
  /** The total number of profiles matching the search query */
  totalMatches: Scalars['Int']['output'];
  /** The total number of partial matching profiles for the search query */
  totalPartialMatches: Scalars['Int']['output'];
};

export type PublicProfileView = {
  /** The candidate profile id */
  slug: Scalars['ID']['output'];
};

export type PublicProfileViewInput = {
  /** The slug for the candidate profile */
  slug: Scalars['ID']['input'];
};

export type PublicVisibilityOption = ProfileVisibilityOption & {
  __typename?: 'PublicVisibilityOption';
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type PublicVisibilityOptiondescriptionArgs = {
  locale: Scalars['Locale']['input'];
  zone: Scalars['Zone']['input'];
};

export type PublicVisibilityOptionnameArgs = {
  locale: Scalars['Locale']['input'];
};

export type Qualification = {
  __typename?: 'Qualification';
  completed: Scalars['Boolean']['output'];
  completionDate?: Maybe<CompletionDate>;
  credential?: Maybe<BaseCredential>;
  /** This field returns a description of the completion for the qualification eg. "In progress", "Finished 2018" */
  formattedCompletion: Scalars['String']['output'];
  highlights?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  institute: OntologyStructuredData;
  isVerified: Scalars['Boolean']['output'];
  /**
   * Required for JobsDB only
   * @deprecated Legacy field
   */
  level2?: Maybe<Scalars['String']['output']>;
  name: OntologyStructuredData;
  status?: Maybe<QualificationStatus>;
  tracking?: Maybe<TrackingInfo>;
  verificationUrl?: Maybe<Scalars['String']['output']>;
};

export type QualificationLevel =
  | 'AdvancedDiploma'
  | 'AssociateDegree'
  | 'BachelorDegree'
  | 'BachelorDegreeHonours'
  | 'CertificateI'
  | 'CertificateII'
  | 'CertificateIII'
  | 'CertificateIV'
  | 'CompletedHighSchool'
  | 'CompletedYear9To11'
  | 'Diploma'
  | 'DoctoralDegree'
  | 'GraduateCertificate'
  | 'GraduateDiploma'
  | 'IosLongtailFallback'
  | 'MastersDegree';

export type QualificationStatus = 'New';

export type QualificationVerifiableCredential = BaseVerifiableCredential & {
  __typename?: 'QualificationVerifiableCredential';
  label: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type Quality = {
  __typename?: 'Quality';
  displayLabel: Scalars['String']['output'];
  ontologyId: Scalars['ID']['output'];
  shortId: Scalars['UUID']['output'];
};

export type QualitydisplayLabelArgs = {
  locale: Scalars['Locale']['input'];
};

export type Query = {
  __typename?: 'Query';
  _empty?: Maybe<Scalars['String']['output']>;
  accountExists: AccountStatus;
  availabilityOptions: Array<AvailabilityOption>;
  banner?: Maybe<Banner>;
  bookmarkedSeekMaxModules: SeekMaxModuleBookmarkResults;
  careerFeed?: Maybe<CareerFeed>;
  /** EXPERIMENTAL! */
  careerFeedInsights?: Maybe<CareerFeedInsights>;
  /** UNSTABLE! EXPERIMENTAL! */
  careerFeedJobsRefinementStatus?: Maybe<CareerFeedJobsRefinementStatus>;
  categorySeekMaxModules?: Maybe<SeekMaxModuleConnectionResults>;
  /** @deprecated Use seekMaxThreads instead */
  categorySeekMaxThreads?: Maybe<SeekMaxThreadConnectionResults>;
  classifications: Array<ParentClassification>;
  /** @deprecated Testing purpose only */
  cloudsmithTest?: Maybe<Scalars['String']['output']>;
  companyDetails?: Maybe<CompanyDetails>;
  companyNameSlug: CompanyNameSlug;
  /** @deprecated Please move to companyDetails.companyProfile this is the new home for this data. This will be removed in the future. */
  companyProfile: CompanyProfile;
  companyProfileReviewUpvotes?: Maybe<ReviewUpvotes>;
  /** @deprecated Use Launch Darkly instead. This will be removed in the future. */
  companyProfilesFeatureFlags: Array<FeatureFlag>;
  companyReviews?: Maybe<Reviews>;
  /** The details of a consent transaction for a given transactionId */
  consentTransactionDetails?: Maybe<ConsentTransactionDetails>;
  /**
   * A list of country codes filtered based on the `option` parameter. The `description`
   * of each list item will be returned in the language specified via the `languageCode`
   * parameter. *Note*: The default value for the `languageCode` parameter is `en`, *not*
   * `false` as it appears in the playground.
   */
  countryCallingCodeOptions: Array<CountryCallingCode>;
  defaultCurrency: DefaultCurrency;
  dummy?: Maybe<Scalars['String']['output']>;
  /**
   * Dummy field to keep SeekDuration and DurationContext types reachable
   * @deprecated Dummy field to satisfy no-unreachable-types lint rule
   */
  dummySeekDuration?: Maybe<SeekDuration>;
  /** @deprecated Field used for testing purposes only */
  echoBase64Url?: Maybe<Scalars['Base64Url']['output']>;
  featureFlags?: Maybe<Array<FeatureFlagEvaluation>>;
  featuredSeekMaxCollection?: Maybe<SeekMaxCollection>;
  featuredSeekMaxThreadsV2?: Maybe<Array<Maybe<SeekMaxThread>>>;
  featuredSeekMaxThreadsV3?: Maybe<SeekMaxThreadConnectionResults>;
  groupedCompanies?: Maybe<Array<Maybe<GroupedCompanies>>>;
  hideJobFeedbackReasons?: Maybe<Array<HideJobFeedbackReason>>;
  jobApplicationProcess?: Maybe<JobApplicationProcess>;
  /** UNSTABLE! */
  jobCountV6?: Maybe<CountV6Result>;
  /** UNSTABLE! */
  jobCountsV6?: Maybe<CountsV6Result>;
  jobDetails?: Maybe<JobDetails>;
  /** UNSTABLE! */
  jobSearchAssist?: Maybe<JobSearchAssist>;
  /** UNSTABLE! */
  jobSearchQueryMeter?: Maybe<JobSearchQueryMeter>;
  /** UNSTABLE! */
  jobSearchV6?: Maybe<SearchV6Result>;
  /** UNSTABLE! */
  locationRadiusOptions?: Maybe<Array<LocationRadiusOption>>;
  loggedOutRecommendedJobs?: Maybe<LoggedOutRecommendedGlobalJobs>;
  marqueeCompanies: Array<MarqueeCompanyProfile>;
  mkLocationSuggestions: Array<MKLocationSuggestion>;
  moreSeekMaxThreadsV2?: Maybe<SeekMaxThreadConnectionResults>;
  ontologyEducationProviders: Array<IOntologyEducationProvider>;
  ontologyOrganisations: Array<IOntologyOrganisation>;
  ontologyQualifications: Array<IOntologyQualification>;
  ontologyRoleTitles: Array<IOntologyRoleTitle>;
  ontologyRoleTitlesSeniority: Array<IOntologyRoleTitleSeniority>;
  ontologySpecReqs: Array<OntologySpecReq>;
  ontologyTrackSelected?: Maybe<ITrackSelected>;
  pinnedSeekMaxThreadsV2?: Maybe<Array<Maybe<SeekMaxThread>>>;
  preferredClassificationOptions: Array<ClassificationOptions>;
  priorityApplyCredit?: Maybe<PriorityApplyCredit>;
  profileLocationSuggest: Array<ProfileSuggestLocationType>;
  profileLocationTrackSelected: ProfileLocationTrackSelectedResponse;
  /** Profile Visibility options */
  profileVisibilityOptions: Array<ProfileVisibilityOption>;
  publicProfileSearch?: Maybe<PublicProfileSearchResults>;
  publicProfileView?: Maybe<PublicProfileView>;
  /**
   * UNSTABLE! Returns up to three query recommendations for the candidate.
   * Nullable array to allow degraded responses if the upstream service fails.
   */
  queryRecommendations?: Maybe<QueryRecommendationResult>;
  /** @deprecated Use recentlyAddedSeekMaxModulesV2 instead */
  recentlyAddedSeekMaxModules: Array<SeekMaxModule>;
  recentlyAddedSeekMaxModulesV2?: Maybe<Array<SeekMaxModule>>;
  recommendedSeekMaxModules: Array<SeekMaxModule>;
  relatedSeekMaxModules: Array<SeekMaxModule>;
  resumePrivacyDisclaimers: ResumePrivacyDisclaimers;
  review?: Maybe<Review>;
  /** @deprecated Please move to companyDetails.companyProfile.companyReviewRating this is the new home for this data. This will be removed in the future. */
  reviewsRatingSummary?: Maybe<ReviewsRatingSummary>;
  /** A list of right to work options for all countries we collect right to work information in */
  rightToWorkOptions: Array<RightToWorkCountryOptions>;
  roleFunctionOptions: Array<RoleFunctionOption>;
  salaryOptions: Array<SalaryOption>;
  searchCompanyDetails?: Maybe<SearchCompanyDetails>;
  searchCompanyProfilesByName: Array<SearchCompanyProfileResultItem>;
  searchFilterData: SearchFilterData;
  searchKeywordsSuggest: SearchKeywordSuggestions;
  searchLocationsSuggest: SearchLocationSuggestions;
  searchSalaryRanges?: Maybe<Array<SearchSalaryRange>>;
  searchSeekMaxContentsV2?: Maybe<SeekMaxContentSearchResults>;
  seekMaxCategoryGroup?: Maybe<ISeekMaxCategoryGroup>;
  seekMaxCategoryGroups?: Maybe<SeekMaxCategoryGroupConnectionResults>;
  seekMaxCertificateAttachmentStatus?: Maybe<ISeekMaxCertificateAttachmentStatus>;
  seekMaxCertificateSeekPassStatus?: Maybe<ISeekMaxCertificateSeekPassStatus>;
  seekMaxCertificates?: Maybe<SeekMaxCertificateConnectionResults>;
  seekMaxCollections: Array<SeekMaxCollection>;
  seekMaxComment?: Maybe<ISeekMaxComment>;
  seekMaxCommentModerationStatus?: Maybe<ISeekMaxModerationStatus>;
  seekMaxCommentsV2?: Maybe<SeekMaxCommentConnectionResults>;
  seekMaxFeedModules?: Maybe<SeekMaxModuleFeedResults>;
  seekMaxFeedThreads?: Maybe<SeekMaxThreadFeedResults>;
  seekMaxLandingInfo: SeekMaxLandingInfo;
  seekMaxModule?: Maybe<SeekMaxModule>;
  seekMaxModulesInProgress: SeekMaxModulesInProgressResults;
  seekMaxMyThreadsV2?: Maybe<SeekMaxThreadConnectionResults>;
  seekMaxMyUnreadThreadsCount?: Maybe<SeekMaxUnreadThreadsCountResponse>;
  seekMaxNotifications?: Maybe<SeekMaxNotificationConnectionResults>;
  seekMaxProfileV2?: Maybe<SeekMaxProfile>;
  seekMaxReplies: SeekMaxReplyResults;
  seekMaxReplyModerationStatus?: Maybe<ISeekMaxModerationStatus>;
  /** @deprecated Use seekMaxThreadModerationStatus instead */
  seekMaxThreadAttachmentStatus?: Maybe<ISeekMaxAttachmentStatus>;
  seekMaxThreadModerationStatus?: Maybe<ISeekMaxModerationStatus>;
  seekMaxThreadV2?: Maybe<ISeekMaxThread>;
  seekMaxThreads?: Maybe<SeekMaxThreadConnectionResults>;
  seekMaxUnreadNotificationsCount?: Maybe<SeekMaxUnreadNotificationsCountResponse>;
  /**
   * Displays data that a candidate has chosen to share via a public url
   * @deprecated This functionality is retired
   */
  shareableProfile: ShareableProfile;
  /** UNSTABLE! */
  showMordorQueryV6?: Maybe<ShowMordorQueryV6Result>;
  sourcr?: Maybe<Sourcr>;
  supportedCountries: Array<CountryInformation>;
  trendingSeekMaxModulesV2?: Maybe<SeekMaxTrendingModuleConnectionResults>;
  /** The version of the schema */
  version: Scalars['String']['output'];
  viewer?: Maybe<Candidate>;
  workTypeOptions: Array<WorkTypeTaxonomyOption>;
};

export type QueryaccountExistsArgs = {
  email: Scalars['String']['input'];
};

export type QueryavailabilityOptionsArgs = {
  languageCode: Scalars['LanguageCodeIso']['input'];
};

export type QuerybannerArgs = {
  candidateId?: InputMaybe<Scalars['String']['input']>;
  classification?: InputMaybe<Scalars['String']['input']>;
  country: Scalars['String']['input'];
  keywords?: InputMaybe<Scalars['String']['input']>;
  locale?: Scalars['Locale']['input'];
  loggedIn?: InputMaybe<Scalars['String']['input']>;
  placement: BannerPlacement;
  roleId?: InputMaybe<Scalars['String']['input']>;
  salaryRange?: InputMaybe<Scalars['String']['input']>;
  salaryType?: InputMaybe<Scalars['String']['input']>;
  subclassification?: InputMaybe<Scalars['String']['input']>;
  visitorId?: InputMaybe<Scalars['UUID']['input']>;
  where?: InputMaybe<Scalars['String']['input']>;
  workType?: InputMaybe<Scalars['String']['input']>;
  zone?: InputMaybe<Scalars['Zone']['input']>;
};

export type QuerybookmarkedSeekMaxModulesArgs = {
  countryCode?: InputMaybe<Scalars['CountryCodeIso2']['input']>;
  pageSize: Scalars['Int']['input'];
  pageToken?: InputMaybe<Scalars['String']['input']>;
  zone?: InputMaybe<Scalars['Zone']['input']>;
};

export type QuerycareerFeedArgs = {
  candidateChatContext?: InputMaybe<RecommendedJobsChatContextInput>;
  channel: CareerFeedChannel;
  components: Array<CareerFeedComponent>;
  context?: InputMaybe<CareerFeedContextInput>;
  experiments?: InputMaybe<Array<InputMaybe<CareerFeedExperimentInput>>>;
  platform: Platform;
  visitorId: Scalars['UUID']['input'];
  zone: Scalars['Zone']['input'];
};

export type QuerycareerFeedInsightsArgs = {
  locationId: Scalars['String']['input'];
  roleTitleId: Scalars['String']['input'];
  visitorId: Scalars['UUID']['input'];
  zone: Scalars['Zone']['input'];
};

export type QuerycareerFeedJobsRefinementStatusArgs = {
  refinementToken: Scalars['UUID']['input'];
};

export type QuerycategorySeekMaxModulesArgs = {
  categoryCode: Scalars['String']['input'];
  cursor: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  zone: Scalars['Zone']['input'];
};

export type QuerycategorySeekMaxThreadsArgs = {
  categoryId: Scalars['ID']['input'];
  cursor: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  zone: Scalars['Zone']['input'];
};

export type QueryclassificationsArgs = {
  zone: Scalars['Zone']['input'];
};

export type QuerycompanyDetailsArgs = {
  id: Scalars['CompanyId']['input'];
};

export type QuerycompanyNameSlugArgs = {
  companySlug: Scalars['String']['input'];
  isLegacyUrl?: Scalars['Boolean']['input'];
  zone?: Scalars['Zone']['input'];
};

export type QuerycompanyProfileArgs = {
  id: Scalars['ID']['input'];
  useCachedProfile?: Scalars['Boolean']['input'];
  zone: Scalars['Zone']['input'];
};

export type QuerycompanyProfileReviewUpvotesArgs = {
  id: Scalars['ID']['input'];
  zone: Scalars['Zone']['input'];
};

export type QuerycompanyProfilesFeatureFlagsArgs = {
  input?: InputMaybe<FeatureFlagInput>;
};

export type QuerycompanyReviewsArgs = {
  companyId: Scalars['ID']['input'];
  locationId?: InputMaybe<Scalars['ID']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  zone: Scalars['Zone']['input'];
};

export type QueryconsentTransactionDetailsArgs = {
  input: ConsentTransactionDetailsInput;
};

export type QuerycountryCallingCodeOptionsArgs = {
  languageCode?: InputMaybe<Scalars['LanguageCodeIso']['input']>;
  option?: InputMaybe<Option>;
};

export type QuerydefaultCurrencyArgs = {
  zone: Scalars['Zone']['input'];
};

export type QueryechoBase64UrlArgs = {
  input?: InputMaybe<Scalars['Base64Url']['input']>;
};

export type QueryfeatureFlagsArgs = {
  applicationContext?: InputMaybe<ApplicationContextInput>;
  deviceContext?: InputMaybe<DeviceContextInput>;
  experienceContext?: InputMaybe<ExperienceContextInput>;
  flags: Array<Scalars['String']['input']>;
  visitorContext?: InputMaybe<VisitorContextInput>;
};

export type QueryfeaturedSeekMaxCollectionArgs = {
  maxCollectionSize: Scalars['Int']['input'];
  zone: Scalars['Zone']['input'];
};

export type QueryfeaturedSeekMaxThreadsV2Args = {
  maxSize: Scalars['PositiveInt']['input'];
  zone: Scalars['Zone']['input'];
};

export type QueryfeaturedSeekMaxThreadsV3Args = {
  cursor: Scalars['Int']['input'];
  pageSize: Scalars['PositiveInt']['input'];
  zone: Scalars['Zone']['input'];
};

export type QuerygroupedCompaniesArgs = {
  excludedCompanyIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  groupBy: CompanyGroupByInput;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  randomSeed?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<COMPANY_SORT_BY>;
  zone: Scalars['Zone']['input'];
};

export type QueryjobApplicationProcessArgs = {
  jobId: Scalars['ID']['input'];
};

export type QueryjobCountV6Args = {
  params: JobSearchV6QueryInput;
};

export type QueryjobCountsV6Args = {
  params: JobSearchV6QueryInput;
};

export type QueryjobDetailsArgs = {
  id: Scalars['ID']['input'];
  tracking?: InputMaybe<JobDetailsTrackingInput>;
};

export type QueryjobSearchAssistArgs = {
  tokens: Array<Scalars['Base64Url']['input']>;
  visitorId: Scalars['UUID']['input'];
};

export type QueryjobSearchQueryMeterArgs = {
  locale: Scalars['Locale']['input'];
  query: Scalars['String']['input'];
};

export type QueryjobSearchV6Args = {
  params: JobSearchV6QueryInput;
};

export type QueryloggedOutRecommendedJobsArgs = {
  cluster?: InputMaybe<Scalars['SmarterSearchCluster']['input']>;
  jobId: Scalars['ID']['input'];
  limit?: Scalars['Int']['input'];
  platform: Platform;
  source: AttributionSource;
  visitorId: Scalars['UUID']['input'];
  zone: Scalars['Zone']['input'];
};

export type QuerymarqueeCompaniesArgs = {
  hideJobs?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  zone?: Scalars['Zone']['input'];
};

export type QuerymkLocationSuggestionsArgs = {
  count?: InputMaybe<Scalars['Int']['input']>;
  countries?: InputMaybe<Array<Scalars['CountryCodeIso2']['input']>>;
  kind: Array<Scalars['String']['input']>;
  languageCode?: InputMaybe<Scalars['LanguageCodeIso']['input']>;
  searchText: Scalars['String']['input'];
  session: Scalars['String']['input'];
  zone: Scalars['Zone']['input'];
};

export type QuerymoreSeekMaxThreadsV2Args = {
  cursor: Scalars['Int']['input'];
  pageSize: Scalars['PositiveInt']['input'];
  zone: Scalars['Zone']['input'];
};

export type QueryontologyEducationProvidersArgs = {
  count: Scalars['Int']['input'];
  countryCode?: InputMaybe<CountryCode>;
  countryCode2?: InputMaybe<Scalars['CountryCodeIso2']['input']>;
  languageCode?: InputMaybe<Scalars['LanguageCodeIso']['input']>;
  query: Scalars['String']['input'];
  session: Scalars['String']['input'];
};

export type QueryontologyOrganisationsArgs = {
  count: Scalars['Int']['input'];
  countryCode?: InputMaybe<CountryCode>;
  countryCode2?: InputMaybe<Scalars['CountryCodeIso2']['input']>;
  languageCode?: InputMaybe<Scalars['LanguageCodeIso']['input']>;
  query: Scalars['String']['input'];
  session: Scalars['String']['input'];
};

export type QueryontologyQualificationsArgs = {
  count: Scalars['Int']['input'];
  countryCode?: InputMaybe<CountryCode>;
  countryCode2?: InputMaybe<Scalars['CountryCodeIso2']['input']>;
  languageCode?: InputMaybe<Scalars['LanguageCodeIso']['input']>;
  query: Scalars['String']['input'];
  session: Scalars['String']['input'];
};

export type QueryontologyRoleTitlesArgs = {
  count: Scalars['Int']['input'];
  countryCode2?: InputMaybe<Scalars['CountryCodeIso2']['input']>;
  languageCode?: InputMaybe<Scalars['LanguageCodeIso']['input']>;
  query: Scalars['String']['input'];
  session: Scalars['String']['input'];
};

export type QueryontologyRoleTitlesSeniorityArgs = {
  count: Scalars['Int']['input'];
  countryCode?: InputMaybe<CountryCode>;
  countryCode2?: InputMaybe<Scalars['CountryCodeIso2']['input']>;
  languageCode?: InputMaybe<Scalars['LanguageCodeIso']['input']>;
  query: Scalars['String']['input'];
  session: Scalars['String']['input'];
};

export type QueryontologySpecReqsArgs = {
  count: Scalars['Int']['input'];
  countryCode?: InputMaybe<Scalars['CountryCodeIso2']['input']>;
  languageCode?: InputMaybe<Scalars['LanguageCodeIso']['input']>;
  profileField?: InputMaybe<SpecReqProfileField>;
  query: Scalars['String']['input'];
  session: Scalars['String']['input'];
};

export type QueryontologyTrackSelectedArgs = {
  id: Scalars['String']['input'];
  index: Scalars['Int']['input'];
  ontologyType: OntologyType;
  session: Scalars['String']['input'];
};

export type QuerypinnedSeekMaxThreadsV2Args = {
  maxSize: Scalars['PositiveInt']['input'];
  zone: Scalars['Zone']['input'];
};

export type QuerypreferredClassificationOptionsArgs = {
  languageCode: Scalars['LanguageCodeIso']['input'];
  zone: Scalars['Zone']['input'];
};

export type QueryprofileLocationSuggestArgs = {
  count: Scalars['Int']['input'];
  languageCode?: InputMaybe<Scalars['LanguageCodeIso']['input']>;
  locationKinds?: InputMaybe<Array<ProfileLocationKind>>;
  locationType: ProfileLocationType;
  query: Scalars['String']['input'];
  session: Scalars['String']['input'];
  zone: Scalars['Zone']['input'];
};

export type QueryprofileLocationTrackSelectedArgs = {
  id: Scalars['Int']['input'];
  session: Scalars['String']['input'];
};

export type QuerypublicProfileSearchArgs = {
  input: PublicProfileSearchInput;
};

export type QuerypublicProfileViewArgs = {
  input: PublicProfileViewInput;
};

export type QueryqueryRecommendationsArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
  locale: Scalars['Locale']['input'];
  siteKey: Scalars['String']['input'];
  solVisitorId?: InputMaybe<Scalars['String']['input']>;
};

export type QueryrecentlyAddedSeekMaxModulesArgs = {
  locale: Scalars['Locale']['input'];
};

export type QueryrecentlyAddedSeekMaxModulesV2Args = {
  zone: Scalars['Zone']['input'];
};

export type QueryrecommendedSeekMaxModulesArgs = {
  countryCode?: InputMaybe<Scalars['CountryCodeIso2']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  zone?: InputMaybe<Scalars['Zone']['input']>;
};

export type QueryrelatedSeekMaxModulesArgs = {
  moduleId: Scalars['ID']['input'];
  zone: Scalars['Zone']['input'];
};

export type QueryresumePrivacyDisclaimersArgs = {
  isUnifiedSite?: InputMaybe<Scalars['Boolean']['input']>;
  languageCode: Scalars['LanguageCodeIso']['input'];
  zone: Scalars['Zone']['input'];
};

export type QueryreviewArgs = {
  reviewId: Scalars['ID']['input'];
  zone: Scalars['Zone']['input'];
};

export type QueryreviewsRatingSummaryArgs = {
  companyId: Scalars['ID']['input'];
};

export type QueryrightToWorkOptionsArgs = {
  filter?: InputMaybe<RightToWorkFilterInput>;
  isUnified?: InputMaybe<Scalars['Boolean']['input']>;
  languageCode?: InputMaybe<Scalars['LanguageCodeIso']['input']>;
  locale?: InputMaybe<Scalars['Locale']['input']>;
  platform?: InputMaybe<Platform>;
  source?: InputMaybe<SourceExperience>;
  zone?: InputMaybe<Scalars['Zone']['input']>;
};

export type QueryroleFunctionOptionsArgs = {
  countryCode: Scalars['CountryCodeIso2']['input'];
  languageCode: LanguageCode;
};

export type QuerysearchCompanyDetailsArgs = {
  filter?: InputMaybe<SearchCompanyDetailsFilterInput>;
  paging?: InputMaybe<SearchCompanyDetailsPagingInput>;
};

export type QuerysearchCompanyProfilesByNameArgs = {
  includeBranding?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  published?: InputMaybe<Scalars['Boolean']['input']>;
  zone?: InputMaybe<Scalars['Zone']['input']>;
};

export type QuerysearchKeywordsSuggestArgs = {
  count: Scalars['Int']['input'];
  countryCode2?: InputMaybe<Scalars['CountryCodeIso2']['input']>;
  query: Scalars['String']['input'];
  visitorId?: InputMaybe<Scalars['UUID']['input']>;
};

export type QuerysearchLocationsSuggestArgs = {
  count: Scalars['Int']['input'];
  country?: InputMaybe<Scalars['CountryCodeIso2']['input']>;
  countryCode?: InputMaybe<CountryCode>;
  isRemoteEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isUnified?: InputMaybe<Scalars['Boolean']['input']>;
  locale?: InputMaybe<Scalars['Locale']['input']>;
  query: Scalars['String']['input'];
  recentLocation?: InputMaybe<Scalars['String']['input']>;
  visitorId?: InputMaybe<Scalars['UUID']['input']>;
};

export type QuerysearchSalaryRangesArgs = {
  zone: Scalars['Zone']['input'];
};

export type QuerysearchSeekMaxContentsV2Args = {
  contentType?: InputMaybe<Scalars['String']['input']>;
  cursor: Scalars['Int']['input'];
  pageSize: Scalars['PositiveInt']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
  zone: Scalars['Zone']['input'];
};

export type QueryseekMaxCategoryGroupArgs = {
  groupId: Scalars['UUID']['input'];
  locale?: InputMaybe<Scalars['Locale']['input']>;
  zone: Scalars['Zone']['input'];
};

export type QueryseekMaxCategoryGroupsArgs = {
  cursor: Scalars['Int']['input'];
  locale?: InputMaybe<Scalars['Locale']['input']>;
  pageSize: Scalars['Int']['input'];
  zone: Scalars['Zone']['input'];
};

export type QueryseekMaxCertificateAttachmentStatusArgs = {
  id: Scalars['ID']['input'];
};

export type QueryseekMaxCertificateSeekPassStatusArgs = {
  id: Scalars['ID']['input'];
};

export type QueryseekMaxCertificatesArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  pageSize: Scalars['PositiveInt']['input'];
};

export type QueryseekMaxCollectionsArgs = {
  maxCollectionSize: Scalars['Int']['input'];
  zone: Scalars['Zone']['input'];
};

export type QueryseekMaxCommentArgs = {
  id: Scalars['ID']['input'];
  zone: Scalars['Zone']['input'];
};

export type QueryseekMaxCommentModerationStatusArgs = {
  commentId: Scalars['ID']['input'];
  zone: Scalars['Zone']['input'];
};

export type QueryseekMaxCommentsV2Args = {
  cursor: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  threadId: Scalars['ID']['input'];
  zone: Scalars['Zone']['input'];
};

export type QueryseekMaxFeedModulesArgs = {
  cursor: Scalars['Int']['input'];
  pageSize: Scalars['PositiveInt']['input'];
  zone: Scalars['Zone']['input'];
};

export type QueryseekMaxFeedThreadsArgs = {
  cursor: Scalars['Int']['input'];
  pageSize: Scalars['PositiveInt']['input'];
  zone: Scalars['Zone']['input'];
};

export type QueryseekMaxModuleArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  zone: Scalars['Zone']['input'];
};

export type QueryseekMaxModulesInProgressArgs = {
  locale: Scalars['Locale']['input'];
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pageToken?: InputMaybe<Scalars['String']['input']>;
};

export type QueryseekMaxMyThreadsV2Args = {
  cursor: Scalars['Int']['input'];
  pageSize: Scalars['PositiveInt']['input'];
  zone: Scalars['Zone']['input'];
};

export type QueryseekMaxMyUnreadThreadsCountArgs = {
  zone: Scalars['Zone']['input'];
};

export type QueryseekMaxNotificationsArgs = {
  cursor: Scalars['Int']['input'];
  locale: Scalars['Locale']['input'];
  pageSize: Scalars['PositiveInt']['input'];
  zone: Scalars['Zone']['input'];
};

export type QueryseekMaxRepliesArgs = {
  commentId: Scalars['ID']['input'];
  cursor?: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  zone?: InputMaybe<Scalars['Zone']['input']>;
};

export type QueryseekMaxReplyModerationStatusArgs = {
  replyId: Scalars['ID']['input'];
  zone: Scalars['Zone']['input'];
};

export type QueryseekMaxThreadAttachmentStatusArgs = {
  id: Scalars['ID']['input'];
  zone?: InputMaybe<Scalars['Zone']['input']>;
};

export type QueryseekMaxThreadModerationStatusArgs = {
  threadId: Scalars['ID']['input'];
  zone: Scalars['Zone']['input'];
};

export type QueryseekMaxThreadV2Args = {
  id: Scalars['ID']['input'];
  zone: Scalars['Zone']['input'];
};

export type QueryseekMaxThreadsArgs = {
  cursor: Scalars['Int']['input'];
  groupNanoId: Scalars['ID']['input'];
  pageSize: Scalars['PositiveInt']['input'];
  zone: Scalars['Zone']['input'];
};

export type QueryseekMaxUnreadNotificationsCountArgs = {
  zone: Scalars['Zone']['input'];
};

export type QueryshareableProfileArgs = {
  languageCode: Scalars['LanguageCodeIso']['input'];
  profileSlug: Scalars['String']['input'];
  zone: Scalars['Zone']['input'];
};

export type QueryshowMordorQueryV6Args = {
  params: JobSearchV6QueryInput;
  type: JobSearchV6ShowMordorQueryType;
};

export type QuerysupportedCountriesArgs = {
  languageCode: Scalars['LanguageCodeIso']['input'];
};

export type QuerytrendingSeekMaxModulesV2Args = {
  pageSize: Scalars['Int']['input'];
  pageToken?: InputMaybe<Scalars['String']['input']>;
  zone: Scalars['Zone']['input'];
};

export type QueryworkTypeOptionsArgs = {
  languageCode: Scalars['LanguageCodeIso']['input'];
};

/** One recommended query with search parameters and human-readable filters. */
export type QueryRecommendation = {
  __typename?: 'QueryRecommendation';
  parameters: Array<JobSearchV5ApiParameters>;
  searchQueryString?: Maybe<Scalars['JobSearchQueryString']['output']>;
};

/** One recommended query with search parameters and human-readable filters. */
export type QueryRecommendationparametersArgs = {
  locale: Scalars['Locale']['input'];
  siteKey: Scalars['String']['input'];
};

/** One recommended query with search parameters and human-readable filters. */
export type QueryRecommendationsearchQueryStringArgs = {
  locale: Scalars['Locale']['input'];
  siteKey: Scalars['String']['input'];
};

/** The result wrapper for query recommendations including upstream requestId. */
export type QueryRecommendationResult = {
  __typename?: 'QueryRecommendationResult';
  items: Array<QueryRecommendation>;
  requestId: Scalars['String']['output'];
};

export type Question = {
  id: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type QuestionOption = {
  __typename?: 'QuestionOption';
  id: Scalars['String']['output'];
  text: Scalars['String']['output'];
  uri?: Maybe<Scalars['String']['output']>;
};

export type Questionnaire = {
  __typename?: 'Questionnaire';
  questions: Array<Question>;
};

export type QuestionnaireAnswerInput = {
  answers: Array<AnswerForQuestionInput>;
  questionId: Scalars['String']['input'];
};

export type RatingDescriptionInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  rating?: InputMaybe<Scalars['Int']['input']>;
};

export type RatingInput = {
  rating?: InputMaybe<Scalars['Int']['input']>;
};

export type RatingItem = {
  __typename?: 'RatingItem';
  description: Scalars['String']['output'];
  /** @deprecated Use value instead */
  rating: Scalars['Float']['output'];
  value: Scalars['Float']['output'];
};

export type RatingItemdescriptionArgs = {
  locale?: Scalars['Locale']['input'];
};

export type Recommendations = {
  __typename?: 'Recommendations';
  recommendedGlobalJobs?: Maybe<RecommendedGlobalJobs>;
  similarJobsGlobal?: Maybe<RecommendedGlobalJobs>;
};

export type RecommendationsrecommendedGlobalJobsArgs = {
  candidateChatContext?: InputMaybe<RecommendedJobsChatContextInput>;
  cluster?: InputMaybe<Scalars['SmarterSearchCluster']['input']>;
  includeSavedJobs?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  platform: Platform;
  source: AttributionSource;
  visitorId: Scalars['UUID']['input'];
  zone: Scalars['Zone']['input'];
};

export type RecommendationssimilarJobsGlobalArgs = {
  cluster?: InputMaybe<Scalars['SmarterSearchCluster']['input']>;
  includeSavedJobs?: InputMaybe<Scalars['Boolean']['input']>;
  jobId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  platform: Platform;
  source: AttributionSource;
  visitorId: Scalars['UUID']['input'];
  zone: Scalars['Zone']['input'];
};

export type RecommendedGlobalJob = {
  __typename?: 'RecommendedGlobalJob';
  id: Scalars['ID']['output'];
  isNew: Scalars['Boolean']['output'];
  isSaved: Scalars['Boolean']['output'];
  job: Job;
  solMetadata: Scalars['JSON']['output'];
  tags?: Maybe<Array<JobTag>>;
};

export type RecommendedGlobalJobs = {
  __typename?: 'RecommendedGlobalJobs';
  globalJobs: Array<RecommendedGlobalJob>;
  solMetadata?: Maybe<Scalars['JSON']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type RecommendedJobsChatContextConfidenceInput = {
  classifications?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  companies?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  keywords?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  locationText?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  salaryFrom?: InputMaybe<Scalars['String']['input']>;
  salaryFromAnnualized?: InputMaybe<
    Array<InputMaybe<Scalars['String']['input']>>
  >;
  salaryTo?: InputMaybe<Scalars['String']['input']>;
  salaryToAnnualized?: InputMaybe<
    Array<InputMaybe<Scalars['String']['input']>>
  >;
  skills?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  workArrangement?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  workType?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type RecommendedJobsChatContextInput = {
  classifications?: InputMaybe<Array<Scalars['String']['input']>>;
  companies?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  confidence?: InputMaybe<RecommendedJobsChatContextConfidenceInput>;
  keywords?: InputMaybe<Scalars['String']['input']>;
  locationText?: InputMaybe<Array<Scalars['String']['input']>>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  salaryFrom?: InputMaybe<Scalars['String']['input']>;
  salaryFromAnnualized?: InputMaybe<Scalars['Int']['input']>;
  salaryTo?: InputMaybe<Scalars['String']['input']>;
  salaryToAnnualized?: InputMaybe<Scalars['Int']['input']>;
  skills?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  timestamp?: InputMaybe<Scalars['String']['input']>;
  titles?: InputMaybe<Array<Scalars['String']['input']>>;
  workArrangement?: InputMaybe<
    Array<Scalars['RecommendedJobsWorkArrangementOption']['input']>
  >;
  workType?: InputMaybe<
    Array<Scalars['RecommendedJobsWorkTypeOption']['input']>
  >;
};

export type Reference = {
  __typename?: 'Reference';
  /** The candidate's job title or position during the referenced period */
  candidateRoleTitle: Scalars['String']['output'];
  /** The date when the candidate started working with the referee */
  fromDate: SeekDateTime;
  /** The name of the organisation where the candidate and the person providing the reference worked together */
  organisationName: Scalars['String']['output'];
  /** The full name of the person providing the reference */
  refereeFullName: Scalars['String']['output'];
  /** The referee's job title or position during the referenced period */
  refereeRoleTitle: Scalars['String']['output'];
  /** The date when the reference was provided */
  referenceDate: SeekDateTime;
  /** A localized description of the working relationship between the candidate and the person providing the reference (referee). It expects locale as argument to give translated text */
  relationshipText: Scalars['String']['output'];
  /** The date when the candidate stopped working with the referee (if applicable) */
  toDate?: Maybe<SeekDateTime>;
};

export type ReferencerelationshipTextArgs = {
  locale: Scalars['Locale']['input'];
};

export type ReferenceCheck = {
  __typename?: 'ReferenceCheck';
  /** Identifier of the reference check */
  id: Scalars['String']['output'];
  /** The list of references included in this reference check */
  references: Array<Reference>;
};

export type ReferenceCheckInput = {
  id: Scalars['String']['input'];
};

export type RejectConsentError = {
  message: Scalars['String']['output'];
};

export type RejectConsentErrormessageArgs = {
  locale?: InputMaybe<Scalars['Locale']['input']>;
};

export type RejectConsentFailure = {
  __typename?: 'RejectConsentFailure';
  errors: Array<RejectConsentError>;
};

export type RejectConsentInput = {
  transactionId: Scalars['UUID']['input'];
};

export type RejectConsentPayload = RejectConsentFailure | RejectConsentSuccess;

export type RejectConsentSuccess = {
  __typename?: 'RejectConsentSuccess';
  redirectUri: Scalars['String']['output'];
};

export type RejectConsentTransactionInvalidError = RejectConsentError & {
  __typename?: 'RejectConsentTransactionInvalidError';
  message: Scalars['String']['output'];
};

export type RejectConsentTransactionInvalidErrormessageArgs = {
  locale?: InputMaybe<Scalars['Locale']['input']>;
};

export type RejectRoleInput = {
  achievements?: InputMaybe<Scalars['String']['input']>;
  company: OntologyStructuredDataInput;
  from: MonthYearInput;
  id: Scalars['UUID']['input'];
  seniority?: InputMaybe<OntologyStructuredDataInput>;
  title: OntologyStructuredDataInput;
  to?: InputMaybe<MonthYearInput>;
  tracking?: InputMaybe<TrackingInfoInput>;
};

export type RejectRolePayload = {
  __typename?: 'RejectRolePayload';
  /** @deprecated Use viewer.roles */
  id: Scalars['UUID']['output'];
  viewer?: Maybe<Candidate>;
};

export type RejectUnconfirmedDataInput = {
  dataType: UnconfirmedDataType;
  id: Scalars['UUID']['input'];
  tracking?: InputMaybe<TrackingInfoInput>;
};

export type RejectUnconfirmedDataPayload = {
  __typename?: 'RejectUnconfirmedDataPayload';
  /** @deprecated Use viewer.qualifications or viewer.roles */
  ref?: Maybe<Scalars['UUID']['output']>;
  viewer?: Maybe<Candidate>;
};

export type RenewFrequency = {
  __typename?: 'RenewFrequency';
  unit: RenewalUnit;
  value: Scalars['Int']['output'];
};

export type RenewalUnit = 'days' | 'months';

export type ReportJobCountryCode = 'AU' | 'NZ';

export type ReportJobInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['CountryCodeIso2']['input']>;
  /** @deprecated Use country */
  countryCode?: InputMaybe<ReportJobCountryCode>;
  email: Scalars['Email']['input'];
  jobId: Scalars['Int']['input'];
  reason: Scalars['String']['input'];
};

export type ReportJobPayload = {
  __typename?: 'ReportJobPayload';
  success: Scalars['Boolean']['output'];
};

export type ReportProfileInput = {
  comment: Scalars['String']['input'];
  profileSlug: Scalars['String']['input'];
  reason: ReportProfileReason;
};

export type ReportProfileReason =
  | 'FAKE_PROFILE'
  | 'FRAUD_OR_SCAM'
  | 'INAPPROPRIATE_CONTENT'
  | 'SELLING_BUSINESS_SERVICES';

export type ReportProfileSuccessPayload = {
  __typename?: 'ReportProfileSuccessPayload';
  profileSlug: Scalars['String']['output'];
};

export type ReportSeekMaxCommentAlreadyReportedError =
  ReportSeekMaxCommentError & {
    __typename?: 'ReportSeekMaxCommentAlreadyReportedError';
    message: Scalars['String']['output'];
    title: Scalars['String']['output'];
  };

export type ReportSeekMaxCommentAlreadyReportedErrormessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type ReportSeekMaxCommentAlreadyReportedErrortitleArgs = {
  locale: Scalars['Locale']['input'];
};

export type ReportSeekMaxCommentError = {
  message: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type ReportSeekMaxCommentErrormessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type ReportSeekMaxCommentErrortitleArgs = {
  locale: Scalars['Locale']['input'];
};

export type ReportSeekMaxCommentFailure = {
  __typename?: 'ReportSeekMaxCommentFailure';
  errors: Array<ReportSeekMaxCommentError>;
};

export type ReportSeekMaxCommentInput = {
  id: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
  zone?: InputMaybe<Scalars['Zone']['input']>;
};

export type ReportSeekMaxCommentPayload =
  | ReportSeekMaxCommentFailure
  | ReportSeekMaxCommentSuccess;

export type ReportSeekMaxCommentPrivilegeError = ReportSeekMaxCommentError & {
  __typename?: 'ReportSeekMaxCommentPrivilegeError';
  message: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type ReportSeekMaxCommentPrivilegeErrormessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type ReportSeekMaxCommentPrivilegeErrortitleArgs = {
  locale: Scalars['Locale']['input'];
};

export type ReportSeekMaxCommentSuccess = {
  __typename?: 'ReportSeekMaxCommentSuccess';
  id: Scalars['ID']['output'];
};

export type ReportSeekMaxCommentUserIsBannedError =
  ReportSeekMaxCommentError & {
    __typename?: 'ReportSeekMaxCommentUserIsBannedError';
    message: Scalars['String']['output'];
    title: Scalars['String']['output'];
  };

export type ReportSeekMaxCommentUserIsBannedErrormessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type ReportSeekMaxCommentUserIsBannedErrortitleArgs = {
  locale: Scalars['Locale']['input'];
};

export type ReportSeekMaxReplyAlreadyReportedError = ReportSeekMaxReplyError & {
  __typename?: 'ReportSeekMaxReplyAlreadyReportedError';
  message: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type ReportSeekMaxReplyAlreadyReportedErrormessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type ReportSeekMaxReplyAlreadyReportedErrortitleArgs = {
  locale: Scalars['Locale']['input'];
};

export type ReportSeekMaxReplyError = {
  message: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type ReportSeekMaxReplyErrormessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type ReportSeekMaxReplyErrortitleArgs = {
  locale: Scalars['Locale']['input'];
};

export type ReportSeekMaxReplyFailure = {
  __typename?: 'ReportSeekMaxReplyFailure';
  errors: Array<ReportSeekMaxReplyError>;
};

export type ReportSeekMaxReplyInput = {
  id: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
  zone?: InputMaybe<Scalars['Zone']['input']>;
};

export type ReportSeekMaxReplyPayload =
  | ReportSeekMaxReplyFailure
  | ReportSeekMaxReplySuccess;

export type ReportSeekMaxReplyPrivilegeError = ReportSeekMaxReplyError & {
  __typename?: 'ReportSeekMaxReplyPrivilegeError';
  message: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type ReportSeekMaxReplyPrivilegeErrormessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type ReportSeekMaxReplyPrivilegeErrortitleArgs = {
  locale: Scalars['Locale']['input'];
};

export type ReportSeekMaxReplySuccess = {
  __typename?: 'ReportSeekMaxReplySuccess';
  id: Scalars['ID']['output'];
};

export type ReportSeekMaxReplyUserIsBannedError = ReportSeekMaxReplyError & {
  __typename?: 'ReportSeekMaxReplyUserIsBannedError';
  message: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type ReportSeekMaxReplyUserIsBannedErrormessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type ReportSeekMaxReplyUserIsBannedErrortitleArgs = {
  locale: Scalars['Locale']['input'];
};

export type ReportSeekMaxThreadAlreadyReportedError =
  ReportSeekMaxThreadError & {
    __typename?: 'ReportSeekMaxThreadAlreadyReportedError';
    message: Scalars['String']['output'];
    title: Scalars['String']['output'];
  };

export type ReportSeekMaxThreadAlreadyReportedErrormessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type ReportSeekMaxThreadAlreadyReportedErrortitleArgs = {
  locale: Scalars['Locale']['input'];
};

export type ReportSeekMaxThreadError = {
  message: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type ReportSeekMaxThreadErrormessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type ReportSeekMaxThreadErrortitleArgs = {
  locale: Scalars['Locale']['input'];
};

export type ReportSeekMaxThreadFailure = {
  __typename?: 'ReportSeekMaxThreadFailure';
  errors: Array<ReportSeekMaxThreadError>;
};

export type ReportSeekMaxThreadInput = {
  id: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
  zone?: InputMaybe<Scalars['Zone']['input']>;
};

export type ReportSeekMaxThreadPayload =
  | ReportSeekMaxThreadFailure
  | ReportSeekMaxThreadSuccess;

export type ReportSeekMaxThreadPrivilegeError = ReportSeekMaxThreadError & {
  __typename?: 'ReportSeekMaxThreadPrivilegeError';
  message: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type ReportSeekMaxThreadPrivilegeErrormessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type ReportSeekMaxThreadPrivilegeErrortitleArgs = {
  locale: Scalars['Locale']['input'];
};

export type ReportSeekMaxThreadSuccess = {
  __typename?: 'ReportSeekMaxThreadSuccess';
  id: Scalars['ID']['output'];
};

export type ReportSeekMaxThreadUserIsBannedError = ReportSeekMaxThreadError & {
  __typename?: 'ReportSeekMaxThreadUserIsBannedError';
  message: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type ReportSeekMaxThreadUserIsBannedErrormessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type ReportSeekMaxThreadUserIsBannedErrortitleArgs = {
  locale: Scalars['Locale']['input'];
};

export type RequestResumeParsingContext = {
  id: Scalars['UUID']['input'];
};

export type RequestResumeParsingInput = {
  id: Scalars['UUID']['input'];
  parsingContext: RequestResumeParsingContext;
  zone?: InputMaybe<Scalars['Zone']['input']>;
};

export type RestrictedPublicProfileDigitalIdentity = {
  __typename?: 'RestrictedPublicProfileDigitalIdentity';
  /** Whether the candidate has verified identity */
  isVerified: Scalars['Boolean']['output'];
};

export type RestrictedPublicProfileSearchResult = PublicProfileSearchResult & {
  __typename?: 'RestrictedPublicProfileSearchResult';
  /** The candidate's verified identity details */
  digitalIdentity?: Maybe<RestrictedPublicProfileDigitalIdentity>;
  /** The candidate profile first name */
  firstName: Scalars['String']['output'];
  /** Whether the candidate has verified credentials */
  hasVerifiedCredentials: Scalars['Boolean']['output'];
  /** The candidate profile home location */
  homeLocation: PublicProfileLocation;
  /** The candidate profile last name */
  lastName: Scalars['String']['output'];
  /** The candidate's profile avatar URLs in different sizes */
  profileAvatarUrls?: Maybe<PublicProfileAvatarUrls>;
  /** The candidate profile id */
  slug: Scalars['ID']['output'];
  /** The candidate's work history, */
  workHistories: Array<RestrictedPublicProfileWorkHistory>;
};

export type RestrictedPublicProfileView = PublicProfileView & {
  __typename?: 'RestrictedPublicProfileView';
  /** The candidate's verified identity details */
  digitalIdentity?: Maybe<RestrictedPublicProfileDigitalIdentity>;
  /** The candidate profile first name */
  firstName: Scalars['String']['output'];
  /** Whether the candidate has verified credentials */
  hasVerifiedCredentials: Scalars['Boolean']['output'];
  /** The candidate profile home location */
  homeLocation: PublicProfileLocation;
  /** The candidate profile last name */
  lastName: Scalars['String']['output'];
  /** The candidate's profile avatar URLs in different sizes */
  profileAvatarUrls?: Maybe<PublicProfileAvatarUrls>;
  /** The candidate's profile GUID, used for tracking and analytics. */
  profileGuid: Scalars['UUID']['output'];
  /** The candidate profile id */
  slug: Scalars['ID']['output'];
  /** The candidate's work history, */
  workHistories: Array<RestrictedPublicProfileWorkHistory>;
};

export type RestrictedPublicProfileWorkHistory = {
  __typename?: 'RestrictedPublicProfileWorkHistory';
  /** The candidate profile company name */
  companyName: Scalars['String']['output'];
  /** The candidate profile job title */
  roleTitle: Scalars['String']['output'];
};

export type ResubscribeApacSavedSearchByCodeError = {
  __typename?: 'ResubscribeApacSavedSearchByCodeError';
  message: Scalars['String']['output'];
};

export type ResubscribeApacSavedSearchByCodeErrormessageArgs = {
  locale?: InputMaybe<Scalars['Locale']['input']>;
};

export type ResubscribeApacSavedSearchByCodeFailure = {
  __typename?: 'ResubscribeApacSavedSearchByCodeFailure';
  error: ResubscribeApacSavedSearchByCodeError;
};

export type ResubscribeApacSavedSearchByCodeInput = {
  code: Scalars['String']['input'];
};

export type ResubscribeApacSavedSearchByCodePayload =
  | ResubscribeApacSavedSearchByCodeFailure
  | ResubscribeApacSavedSearchByCodeSuccess;

export type ResubscribeApacSavedSearchByCodeSuccess = {
  __typename?: 'ResubscribeApacSavedSearchByCodeSuccess';
  id: Scalars['ID']['output'];
  type: Scalars['String']['output'];
};

export type Resume = {
  __typename?: 'Resume';
  createdDateRelative: Scalars['String']['output'];
  createdDateUtc: Scalars['DateTime']['output'];
  fileMetadata: FileMetadata;
  id: Scalars['UUID']['output'];
  isDefault: Scalars['Boolean']['output'];
  origin: ResumeOrigin;
};

export type ResumeAppliedJobDocument = {
  __typename?: 'ResumeAppliedJobDocument';
  attachmentMetadata: AttachmentMetadata;
  blobUrl: Scalars['String']['output'];
  downloadLink?: Maybe<Scalars['String']['output']>;
};

export type ResumeInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  idFromResumeResource?: InputMaybe<Scalars['Int']['input']>;
  uri: Scalars['String']['input'];
};

export type ResumeOrigin = {
  __typename?: 'ResumeOrigin';
  type?: Maybe<ResumeOriginType>;
};

export type ResumeOriginType = 'Generated' | 'Uploaded';

export type ResumePrivacyDisclaimer = {
  __typename?: 'ResumePrivacyDisclaimer';
  isEmphasized: Scalars['Boolean']['output'];
  value: Scalars['String']['output'];
};

export type ResumePrivacyDisclaimers = {
  __typename?: 'ResumePrivacyDisclaimers';
  longParagraphs: Array<ResumePrivacyDisclaimer>;
  shortParagraphs: Array<ResumePrivacyDisclaimer>;
};

export type Review = {
  __typename?: 'Review';
  companyId: Scalars['String']['output'];
  cons: Scalars['String']['output'];
  createdAt: SeekDateTime;
  employmentStatus?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  jobTitle?: Maybe<Scalars['String']['output']>;
  overallRating: Scalars['Float']['output'];
  pros: Scalars['String']['output'];
  ratings: Array<RatingItem>;
  recommended: ReviewRecommended;
  reply?: Maybe<CompanyReviewReply>;
  salarySummary: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
  upvotes?: Maybe<Upvotes>;
  workLocation?: Maybe<Scalars['String']['output']>;
};

export type ReviewemploymentStatusArgs = {
  locale?: Scalars['Locale']['input'];
};

export type ReviewsalarySummaryArgs = {
  locale?: Scalars['Locale']['input'];
};

export type ReviewDetailsInput = {
  cons?: InputMaybe<Scalars['String']['input']>;
  isCompanyRecommended?: InputMaybe<Scalars['Boolean']['input']>;
  overallExperience?: InputMaybe<Scalars['String']['input']>;
  overallExperienceDetails?: InputMaybe<Scalars['String']['input']>;
  overallRating: Scalars['Int']['input'];
  pros?: InputMaybe<Scalars['String']['input']>;
};

export type ReviewRecommended = {
  __typename?: 'ReviewRecommended';
  description: Scalars['String']['output'];
  value: Scalars['Boolean']['output'];
};

export type ReviewRecommendeddescriptionArgs = {
  locale?: Scalars['Locale']['input'];
};

export type ReviewUpvotes = {
  __typename?: 'ReviewUpvotes';
  upvotes: Array<Scalars['String']['output']>;
};

export type Reviews = {
  __typename?: 'Reviews';
  data: Array<Review>;
  paging: ReviewsPaging;
};

export type ReviewsPaging = {
  __typename?: 'ReviewsPaging';
  page: Scalars['Int']['output'];
  perPage: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type ReviewsRatingSummary = {
  __typename?: 'ReviewsRatingSummary';
  careerOpportunity?: Maybe<ReviewsRatingSummaryFull>;
  company?: Maybe<ReviewsRatingSummaryFull>;
  companyId: Scalars['ID']['output'];
  companyRating1Star?: Maybe<ReviewsRatingSummaryCountOnly>;
  companyRating2Star?: Maybe<ReviewsRatingSummaryCountOnly>;
  companyRating3Star?: Maybe<ReviewsRatingSummaryCountOnly>;
  companyRating4Star?: Maybe<ReviewsRatingSummaryCountOnly>;
  companyRating5Star?: Maybe<ReviewsRatingSummaryCountOnly>;
  companyRecommended?: Maybe<ReviewsRatingSummaryWithoutRating>;
  diversity?: Maybe<ReviewsRatingSummaryFull>;
  executiveManagement?: Maybe<ReviewsRatingSummaryFull>;
  perksAndBenefits?: Maybe<ReviewsRatingSummaryFull>;
  salaryFair?: Maybe<ReviewsRatingSummaryWithoutRating>;
  salaryGenerous?: Maybe<ReviewsRatingSummaryWithoutRating>;
  salaryPoor?: Maybe<ReviewsRatingSummaryWithoutRating>;
  workEnvironment?: Maybe<ReviewsRatingSummaryFull>;
  workLifeBalance?: Maybe<ReviewsRatingSummaryFull>;
};

export type ReviewsRatingSummaryCountOnly = {
  __typename?: 'ReviewsRatingSummaryCountOnly';
  count?: Maybe<Scalars['Int']['output']>;
};

export type ReviewsRatingSummaryFull = {
  __typename?: 'ReviewsRatingSummaryFull';
  count?: Maybe<Scalars['Int']['output']>;
  percentage?: Maybe<Scalars['Int']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
};

export type ReviewsRatingSummaryWithoutRating = {
  __typename?: 'ReviewsRatingSummaryWithoutRating';
  count?: Maybe<Scalars['Int']['output']>;
  percentage?: Maybe<Scalars['Int']['output']>;
};

export type ReviewsSummary = {
  __typename?: 'ReviewsSummary';
  communityGuideline: CommunityGuideline;
  employeeRecommendation: EmployeeRecommendation;
  overallRating: OverallRating;
  ratings: Array<RatingItem>;
  salaryRating: SalaryRating;
};

export type RightToWork = {
  __typename?: 'RightToWork';
  /** Information about the country associated with the right to work */
  country: CountryInformation;
  credential?: Maybe<RightToWorkCredential>;
  /** Unique ID that identifies a specific right to work */
  id: Scalars['UUID']['output'];
  /** Will be true if it doesn't have ontology data */
  isDeprecated?: Maybe<Scalars['Boolean']['output']>;
  /** Will be `null` if the user has not selected a right to work option. */
  type2?: Maybe<RightToWorkType2>;
  /** Will only hold a value if the verification URL should be shown, will be `null` otherwise. */
  verificationUrl?: Maybe<Scalars['String']['output']>;
};

export type RightToWorkCountryOptions = {
  __typename?: 'RightToWorkCountryOptions';
  /** Information about the country associated with the right to work options */
  country: CountryInformation;
  /** A array of SuggestionHighlight which tells you the text index 'start' and 'end' to highlight. This supports multi highlight on a single string of text */
  highlights?: Maybe<Array<SuggestionHighlight>>;
  /** A list of right to work options for the associated country code */
  options: Array<RightToWorkOption>;
};

export type RightToWorkCredential = {
  __typename?: 'RightToWorkCredential';
  expiryFormatted: Scalars['String']['output'];
  fullName?: Maybe<Scalars['String']['output']>;
  manageVerificationUrl: Scalars['String']['output'];
  status?: Maybe<CredentialStatus>;
  verification: CredentialVerification;
  visa?: Maybe<RightToWorkVisa>;
};

export type RightToWorkFilterInput = {
  /** A partial country name to be searched */
  countryNameQuery?: InputMaybe<Scalars['String']['input']>;
};

export type RightToWorkOption = {
  __typename?: 'RightToWorkOption';
  /** Human readable string used when the user is selecting a right to work option. E.g. `Yes`. */
  description: Scalars['String']['output'];
  /** Human readable string used when showing a right to work option in a read-only context. E.g. `Yes, I have the right to work in Australia`. */
  formattedDescription: Scalars['String']['output'];
  /** Unique ID used to identify a specific right to work option */
  id: Scalars['ID']['output'];
  /** Certsy verification URL for this right to work option. Will be `null` if selecting this option indicates that you do not have the right to work */
  verificationUrl?: Maybe<Scalars['String']['output']>;
};

export type RightToWorkType2 = {
  __typename?: 'RightToWorkType2';
  /** Human readable string used when the user is selecting a right to work option. E.g. `Yes`. */
  description: Scalars['String']['output'];
  /** Human readable string used when showing a right to work option in a read-only context. E.g. `Yes, I have the right to work in Australia`. */
  formattedDescription: Scalars['String']['output'];
  /** Unique ID associated with a  `RightToWorkOption` */
  id: Scalars['String']['output'];
};

export type RightToWorkType2Input = {
  /** ID corresponding to a `RightToWorkOption` */
  id: Scalars['ID']['input'];
};

export type RightToWorkVerifiableCredential = BaseVerifiableCredential & {
  __typename?: 'RightToWorkVerifiableCredential';
  label: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type RightToWorkVisa = {
  __typename?: 'RightToWorkVisa';
  detailUrl?: Maybe<Scalars['String']['output']>;
  holderType?: Maybe<Scalars['String']['output']>;
  subclass?: Maybe<Scalars['String']['output']>;
};

export type RightsToWorkAlert = {
  __typename?: 'RightsToWorkAlert';
  alert?: Maybe<AlertType>;
};

export type Role = {
  __typename?: 'Role';
  achievements?: Maybe<Scalars['String']['output']>;
  company: OntologyStructuredData;
  from: MonthYear;
  /** Required for JobsDB only */
  function?: Maybe<RoleFunction>;
  id: Scalars['UUID']['output'];
  /** Required for JobsDB only */
  industry?: Maybe<RoleIndustry>;
  seniority?: Maybe<OntologyStructuredData>;
  title: OntologyStructuredData;
  to?: Maybe<MonthYear>;
  tracking?: Maybe<TrackingInfo>;
};

export type RoleFunction = {
  __typename?: 'RoleFunction';
  id: Scalars['ID']['output'];
  subFunction: RoleSubFunction;
};

export type RoleFunctionInput = {
  id: Scalars['ID']['input'];
  subFunction: RoleSubFunctionInput;
};

export type RoleFunctionOption = {
  __typename?: 'RoleFunctionOption';
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  roleSubFunctions: Array<RoleSubFunctionOption>;
};

export type RoleIndustry = {
  __typename?: 'RoleIndustry';
  id: Scalars['ID']['output'];
};

export type RoleIndustryInput = {
  id: Scalars['ID']['input'];
};

export type RoleInput = {
  genericTitle?: InputMaybe<Scalars['String']['input']>;
  isCurrentEmployee?: InputMaybe<Scalars['Boolean']['input']>;
  jobTitleId: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
  workHistory?: InputMaybe<JobHistoryInput>;
  workType: Scalars['String']['input'];
};

export type RoleSubFunction = {
  __typename?: 'RoleSubFunction';
  id: Scalars['ID']['output'];
};

export type RoleSubFunctionInput = {
  id: Scalars['ID']['input'];
};

export type RoleSubFunctionOption = {
  __typename?: 'RoleSubFunctionOption';
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type SEOInfo = {
  __typename?: 'SEOInfo';
  broaderLocationName?: Maybe<Scalars['String']['output']>;
  classification?: Maybe<Array<Scalars['String']['output']>>;
  normalisedOrganisationName?: Maybe<Scalars['String']['output']>;
  normalisedRoleTitle?: Maybe<Scalars['String']['output']>;
  subClassification?: Maybe<Array<Scalars['String']['output']>>;
  where?: Maybe<Scalars['String']['output']>;
  workType?: Maybe<Scalars['String']['output']>;
};

export type SEOInfobroaderLocationNameArgs = {
  locale?: Scalars['Locale']['input'];
};

export type SEOInfowhereArgs = {
  locale?: Scalars['Locale']['input'];
  zone: Scalars['Zone']['input'];
};

export type SalaryFrequency = {
  __typename?: 'SalaryFrequency';
  isDefault: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type SalaryFrequencylabelArgs = {
  languageCode?: InputMaybe<Scalars['LanguageCodeIso']['input']>;
};

export type SalaryInput = {
  currency?: InputMaybe<Scalars['String']['input']>;
  includeBonus?: InputMaybe<Scalars['Boolean']['input']>;
  maximum?: InputMaybe<Scalars['Int']['input']>;
  minimum?: InputMaybe<Scalars['Int']['input']>;
  rating?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type SalaryOption = {
  __typename?: 'SalaryOption';
  annually: Array<SalaryRangeOption>;
  country: Scalars['String']['output'];
  hourly: Array<SalaryRangeOption>;
};

export type SalaryPreference2 = {
  __typename?: 'SalaryPreference2';
  /** Candidate's preferred minimum salary amount for a specific country and salary type */
  amount?: Maybe<Scalars['SafeInt']['output']>;
  /** Information about the country associated with the salary preference */
  country: CountryInformation;
  /** Currency associated with the minimum salary amount */
  currencyCode: Scalars['CurrencyCodeIso']['output'];
  /**
   * Formatted string to be shown to the user in read-mode. Formatted as:
   * {currency code} {amount} {salary type}. Will be `null` if the
   * preference has no `amount` value.
   */
  description?: Maybe<Scalars['String']['output']>;
  /** Unique ID that identifies a specific salary preference */
  id: Scalars['UUID']['output'];
  /** Salary type corresponding to the minimum salary amount */
  salaryType: SalaryType2;
};

export type SalaryPreference2Input = {
  /** Candidate's preferred minimum salary amount for a specific country and salary type */
  amount?: InputMaybe<Scalars['SafeInt']['input']>;
  /** Country associated with the minimum salary amount */
  countryCode: Scalars['CountryCodeIso2']['input'];
  /** Unique ID that identifies a specific salary preference */
  id: Scalars['UUID']['input'];
  /** Salary type corresponding to the minimum salary amount */
  salaryType: SalaryType2;
};

export type SalaryRangeByIndustryDetails = {
  __typename?: 'SalaryRangeByIndustryDetails';
  industryAverageDescription: Scalars['String']['output'];
  jobsCount: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  salaryType: Scalars['String']['output'];
};

export type SalaryRangeByIndustryDetailsindustryAverageDescriptionArgs = {
  locale: Scalars['Locale']['input'];
};

export type SalaryRangeByIndustryDetailslabelArgs = {
  locale: Scalars['Locale']['input'];
};

export type SalaryRangeByRoles = {
  __typename?: 'SalaryRangeByRoles';
  roleId: Scalars['ID']['output'];
  roleTitle: Scalars['String']['output'];
  salaryRangeByCompany?: Maybe<SalaryRangeDetails>;
  salaryRangeByIndustry?: Maybe<SalaryRangeByIndustryDetails>;
};

export type SalaryRangeByRolesroleTitleArgs = {
  locale: Scalars['Locale']['input'];
};

export type SalaryRangeDetails = {
  __typename?: 'SalaryRangeDetails';
  jobsCount: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  salaryType: Scalars['String']['output'];
};

export type SalaryRangeDetailslabelArgs = {
  locale: Scalars['Locale']['input'];
};

export type SalaryRangeOption = {
  __typename?: 'SalaryRangeOption';
  label: Scalars['String']['output'];
  value: Scalars['SafeInt']['output'];
};

export type SalaryRating = {
  __typename?: 'SalaryRating';
  description: Scalars['String']['output'];
  rating: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type SalaryRatingdescriptionArgs = {
  locale?: Scalars['Locale']['input'];
};

export type SalaryType2 = 'Annual' | 'Hourly' | 'Monthly';

export type SaveJobPreferencesArgs = {
  __typename?: 'SaveJobPreferencesArgs';
  reason: Scalars['String']['output'];
  typeId: Scalars['String']['output'];
};

export type SaveJobPreferencesError = {
  message: Scalars['String']['output'];
};

export type SaveJobPreferencesErrormessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type SaveJobPreferencesFailure = {
  __typename?: 'SaveJobPreferencesFailure';
  error: SaveJobPreferencesError;
};

export type SaveJobPreferencesInput = {
  reason: Scalars['String']['input'];
  typeId: Scalars['String']['input'];
};

export type SaveJobPreferencesPayload =
  | SaveJobPreferencesFailure
  | SaveJobPreferencesSuccess;

export type SaveJobPreferencesSuccess = {
  __typename?: 'SaveJobPreferencesSuccess';
  preferences: Array<Maybe<CandidateJobPreferencesGroup>>;
};

export type SaveSeekMaxKeywordSearchError = {
  message: Scalars['String']['output'];
};

export type SaveSeekMaxKeywordSearchErrormessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type SaveSeekMaxKeywordSearchFailure = {
  __typename?: 'SaveSeekMaxKeywordSearchFailure';
  errors: Array<SaveSeekMaxKeywordSearchError>;
};

export type SaveSeekMaxKeywordSearchInput = {
  searchedKeyword: Scalars['String']['input'];
};

export type SaveSeekMaxKeywordSearchPayload =
  | SaveSeekMaxKeywordSearchFailure
  | SaveSeekMaxKeywordSearchSuccess;

export type SaveSeekMaxKeywordSearchSuccess = {
  __typename?: 'SaveSeekMaxKeywordSearchSuccess';
  searchedKeyword: Scalars['String']['output'];
};

export type SavedJob = {
  __typename?: 'SavedJob';
  createdAt: SeekDateTime;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  isExternal: Scalars['Boolean']['output'];
  job: Job;
  notes?: Maybe<Scalars['String']['output']>;
  zone?: Maybe<Scalars['Zone']['output']>;
};

export type SavedJobConnection = {
  __typename?: 'SavedJobConnection';
  edges: Array<SavedJobEdge>;
  pageInfo: PageInfo;
  total: Scalars['Int']['output'];
};

export type SavedJobEdge = {
  __typename?: 'SavedJobEdge';
  cursor: Scalars['String']['output'];
  node: SavedJob;
};

export type SavedJobEventCaptureDataInput = {
  channel: Scalars['String']['input'];
  eventCaptureSessionId: Scalars['String']['input'];
  serpTracking?: InputMaybe<Scalars['String']['input']>;
  view: Scalars['String']['input'];
};

export type SavedSearchApacQuery = {
  __typename?: 'SavedSearchApacQuery';
  parameters: Array<SavedSearchParameters>;
  searchQueryString?: Maybe<Scalars['JobSearchQueryString']['output']>;
};

export type SavedSearchParameters = {
  __typename?: 'SavedSearchParameters';
  type: Scalars['String']['output'];
  value: Array<Scalars['String']['output']>;
};

export type SearchAppliedJobPartial = {
  __typename?: 'SearchAppliedJobPartial';
  jobId: Scalars['String']['output'];
};

export type SearchCompanyDetails = {
  __typename?: 'SearchCompanyDetails';
  data?: Maybe<Array<Maybe<SearchCompanyProfileItem>>>;
  paging: ReviewsPaging;
};

export type SearchCompanyDetailsFilterInput = {
  countryId?: InputMaybe<Scalars['Int']['input']>;
  industry?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  seekAreaId?: InputMaybe<Scalars['Int']['input']>;
  seekLocationId?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<SearchCompanyProfileSortBy>;
  stateId?: InputMaybe<Scalars['Int']['input']>;
  suburbId?: InputMaybe<Scalars['Int']['input']>;
  zone?: InputMaybe<Scalars['Zone']['input']>;
};

export type SearchCompanyDetailsPagingInput = {
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export type SearchCompanyProfileData = {
  __typename?: 'SearchCompanyProfileData';
  branding?: Maybe<BasicBranding>;
  name: Scalars['String']['output'];
  /** @deprecated Not required anymore */
  overview?: Maybe<CompanyProfileOverview>;
  published?: Maybe<Scalars['Boolean']['output']>;
  reviewCount?: Maybe<Scalars['Int']['output']>;
  reviewRating?: Maybe<Scalars['Float']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
};

export type SearchCompanyProfileItem = {
  __typename?: 'SearchCompanyProfileItem';
  companyId: Scalars['ID']['output'];
  companyOverview?: Maybe<Scalars['String']['output']>;
  companySlug?: Maybe<Scalars['String']['output']>;
  coverUrl?: Maybe<Scalars['String']['output']>;
  industry?: Maybe<Scalars['String']['output']>;
  jobCount?: Maybe<Scalars['Int']['output']>;
  location?: Maybe<SearchCompanyProfileLocation>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  organisationId?: Maybe<Scalars['String']['output']>;
  overallRating?: Maybe<CompanyProfileOverallRating>;
  size?: Maybe<Scalars['String']['output']>;
  sortRating?: Maybe<CompanyProfileSortRating>;
};

export type SearchCompanyProfileLocation = {
  __typename?: 'SearchCompanyProfileLocation';
  area?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  suburb?: Maybe<Scalars['String']['output']>;
};

export type SearchCompanyProfileResultItem = {
  __typename?: 'SearchCompanyProfileResultItem';
  companyId: Scalars['String']['output'];
  data: SearchCompanyProfileData;
  organisationId: Scalars['String']['output'];
  zone: Scalars['String']['output'];
};

export type SearchCompanyProfileSortBy =
  | 'CAREER_OPPORTUNITY'
  | 'DIVERSITY'
  | 'EXECUTIVE_MANAGEMENT'
  | 'FIRST_NATION'
  | 'OVERALL_RATING'
  | 'PERKS_AND_BENEFITS'
  | 'WORK_ENVIRONMENT'
  | 'WORK_LIFE_BALANCE';

export type SearchFilterData = {
  __typename?: 'SearchFilterData';
  workArrangementOptions: Array<WorkArrangementOption>;
};

export type SearchKeywordSuggestions = {
  __typename?: 'SearchKeywordSuggestions';
  metadata?: Maybe<SearchSuggestionsMetadata>;
  suggestions: Array<KeywordSuggestionType>;
};

export type SearchLocationSuggestions = {
  __typename?: 'SearchLocationSuggestions';
  suggestions: Array<LocationSuggestionType>;
};

export type SearchPageInfo = {
  __typename?: 'SearchPageInfo';
  endCursor?: Maybe<Scalars['Int']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPrevPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['Int']['output']>;
};

export type SearchSalaryRange = {
  __typename?: 'SearchSalaryRange';
  frequency: SalaryFrequency;
  range: Array<SearchSalaryRangeItem>;
};

export type SearchSalaryRangeItem = {
  __typename?: 'SearchSalaryRangeItem';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type SearchSalaryRangeItemlabelArgs = {
  languageCode?: InputMaybe<Scalars['LanguageCodeIso']['input']>;
  type?: InputMaybe<SearchSalaryRangeLabelType>;
};

export type SearchSalaryRangeLabelType = 'LONG' | 'SHORT';

export type SearchSavedJobPartial = {
  __typename?: 'SearchSavedJobPartial';
  jobId: Scalars['String']['output'];
  zone?: Maybe<Scalars['Zone']['output']>;
};

export type SearchSuggestionsMetadata = {
  __typename?: 'SearchSuggestionsMetadata';
  flightId?: Maybe<Scalars['String']['output']>;
  requestToken?: Maybe<Scalars['UUID']['output']>;
};

export type SearchV6Result = {
  __typename?: 'SearchV6Result';
  canonicalCompany?: Maybe<JobSearchV6CanonicalCompany>;
  data: Array<JobSearchV6Data>;
  facets?: Maybe<JobSearchV6Facets>;
  gptTargeting?: Maybe<Array<Maybe<JobSearchV6GptTargeting>>>;
  info: JobSearchV6Info;
  intentSuggestions?: Maybe<Array<Maybe<JobSearchV6IntentSuggestion>>>;
  isQueryModified?: Maybe<Scalars['Boolean']['output']>;
  location?: Maybe<JobSearchV6Location>;
  searchExecuted?: Maybe<JobSearchV6SearchExecuted>;
  searchParams?: Maybe<JobSearchV6SearchParams>;
  solMetadata?: Maybe<Scalars['JSON']['output']>;
  sortModes: Array<Maybe<JobSearchV6ResultSortMode>>;
  suggestions?: Maybe<JobSearchV6Suggestions>;
  totalCount: Scalars['Int']['output'];
  userQueryId: Scalars['String']['output'];
};

export type SeekDateTime = {
  __typename?: 'SeekDateTime';
  dateTime: Scalars['String']['output'];
  dateTimeUtc: Scalars['DateTime']['output'];
  /** Contextual label for the date. E.g. for job posted, 15 mins ago, but for seekmax poll, 15 mins left */
  label: Scalars['String']['output'];
  longAbsoluteLabel: Scalars['String']['output'];
  longLabel: Scalars['String']['output'];
  /** @deprecated Use label with context SEEKMAX_POLL_DURATION_LEFT */
  seekMaxPollLabel: Scalars['String']['output'];
  /** Generic string representation of the absolute date. E.g. 9 Nov 2021 */
  shortAbsoluteLabel: Scalars['String']['output'];
  /** Generic string representation of the date relative to now. E.g. 6 hours ago */
  shortLabel: Scalars['String']['output'];
  shortMonthYearAbsoluteLabel: Scalars['String']['output'];
};

export type SeekDateTimedateTimeArgs = {
  locale?: InputMaybe<Scalars['Locale']['input']>;
  timezone?: InputMaybe<Scalars['Timezone']['input']>;
};

export type SeekDateTimelabelArgs = {
  context: DateTimeContext;
  length: DateTimeLength;
  locale: Scalars['Locale']['input'];
  timezone: Scalars['Timezone']['input'];
};

export type SeekDateTimelongAbsoluteLabelArgs = {
  locale?: InputMaybe<Scalars['Locale']['input']>;
  timezone?: InputMaybe<Scalars['Timezone']['input']>;
};

export type SeekDateTimelongLabelArgs = {
  locale?: InputMaybe<Scalars['Locale']['input']>;
  timezone?: InputMaybe<Scalars['Timezone']['input']>;
};

export type SeekDateTimeseekMaxPollLabelArgs = {
  locale: Scalars['Locale']['input'];
  timezone: Scalars['Timezone']['input'];
};

export type SeekDateTimeshortAbsoluteLabelArgs = {
  locale?: InputMaybe<Scalars['Locale']['input']>;
  timezone?: InputMaybe<Scalars['Timezone']['input']>;
};

export type SeekDateTimeshortLabelArgs = {
  locale?: InputMaybe<Scalars['Locale']['input']>;
  timezone?: InputMaybe<Scalars['Timezone']['input']>;
};

export type SeekDateTimeshortMonthYearAbsoluteLabelArgs = {
  locale?: InputMaybe<Scalars['Locale']['input']>;
  timezone?: InputMaybe<Scalars['Timezone']['input']>;
};

export type SeekDuration = {
  __typename?: 'SeekDuration';
  label?: Maybe<Scalars['String']['output']>;
};

export type SeekDurationlabelArgs = {
  context: DurationContext;
  locale: Scalars['Locale']['input'];
};

export type SeekLocation = {
  __typename?: 'SeekLocation';
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
};

export type SeekLocationlabelArgs = {
  context: SeekLocationContext;
  labelType?: InputMaybe<SeekLocationLabelType>;
  locale: Scalars['Locale']['input'];
  zone: Scalars['Zone']['input'];
};

/**
 * SeekLocationContext
 * ContextualName: example usage, location autocomplete when searching for jobs
 * DisplayName: example usage, location as display on job details.
 */
export type SeekLocationContext = 'CONTEXTUAL_NAME' | 'DISPLAY_NAME';

/**
 * SeekLocationLabelType
 * Short: typically used for mobile, or other places where screen space is constrained
 * Long: typically used for web (not on mobile), where screen space is less constrained
 */
export type SeekLocationLabelType = 'LONG' | 'SHORT';

export type SeekMaxAttachment = {
  id: Scalars['ID']['output'];
  url: Scalars['String']['output'];
};

export type SeekMaxAttachmentFailed = ISeekMaxAttachmentStatus & {
  __typename?: 'SeekMaxAttachmentFailed';
  failureReason: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type SeekMaxAttachmentPending = ISeekMaxAttachmentStatus & {
  __typename?: 'SeekMaxAttachmentPending';
  id: Scalars['ID']['output'];
};

export type SeekMaxAttachmentPublished = ISeekMaxAttachmentStatus & {
  __typename?: 'SeekMaxAttachmentPublished';
  id: Scalars['ID']['output'];
  url: Scalars['String']['output'];
};

export type SeekMaxAttachmentType = 'IMAGE';

export type SeekMaxAttachmentUploadReady = ISeekMaxAttachmentStatus & {
  __typename?: 'SeekMaxAttachmentUploadReady';
  id: Scalars['ID']['output'];
  uploadUrl: Scalars['String']['output'];
};

/** @deprecated(reason: 'To be removed SeekMaxCategory enum') */
export type SeekMaxCategory =
  | 'BUSINESS_AND_FINANCE'
  | 'CAREER_ADVICE'
  | 'INDUSTRY_TRENDS'
  | 'JOB_SEARCH_ADVICE'
  | 'LANGUAGE_LEARNING'
  | 'LEADERSHIP_AND_MANAGEMENT'
  | 'SALARY_ADVICE'
  | 'SALES_AND_MARKETING'
  | 'SELF_DEVELOPMENT'
  | 'TECHNOLOGY_AND_DESIGN';

export type SeekMaxCategoryGroupConnectionResults = {
  __typename?: 'SeekMaxCategoryGroupConnectionResults';
  edges?: Maybe<Array<Maybe<SeekMaxCategoryGroupEdge>>>;
  pageInfo: SeekMaxPageInfo;
};

export type SeekMaxCategoryGroupEdge = {
  __typename?: 'SeekMaxCategoryGroupEdge';
  cursor: Scalars['Int']['output'];
  node: ISeekMaxCategoryGroup;
};

export type SeekMaxCategoryGroupFollowInput = {
  followed: Scalars['Boolean']['input'];
  groupId: Scalars['ID']['input'];
};

export type SeekMaxCategoryGroupLocal = ISeekMaxCategoryGroup & {
  __typename?: 'SeekMaxCategoryGroupLocal';
  categoryId: Scalars['ID']['output'];
  description: Scalars['String']['output'];
  groupId: Scalars['ID']['output'];
  memberCount: SocialMetric;
  name: Scalars['String']['output'];
  personalisedDetails?: Maybe<PersonalisedSeekMaxCategoryGroup>;
};

export type SeekMaxCategoryGroupTopic = ISeekMaxCategoryGroup & {
  __typename?: 'SeekMaxCategoryGroupTopic';
  categoryCode: Scalars['String']['output'];
  categoryId: Scalars['ID']['output'];
  groupId: Scalars['ID']['output'];
  memberCount: SocialMetric;
  name: Scalars['String']['output'];
  personalisedDetails?: Maybe<PersonalisedSeekMaxCategoryGroup>;
};

export type SeekMaxCertType = 'CERTIFICATE' | 'NONE' | 'QUIZZED_CERTIFICATE';

export type SeekMaxCertificate = {
  __typename?: 'SeekMaxCertificate';
  achievedAt: SeekDateTime;
  author: Scalars['String']['output'];
  badgeUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  seekPassStatus?: Maybe<ISeekMaxCertificateSeekPassStatus>;
  title: Scalars['String']['output'];
};

export type SeekMaxCertificateAttachmentFailed =
  ISeekMaxCertificateAttachmentStatus & {
    __typename?: 'SeekMaxCertificateAttachmentFailed';
    failureReason: Scalars['String']['output'];
    id: Scalars['ID']['output'];
  };

export type SeekMaxCertificateAttachmentPending =
  ISeekMaxCertificateAttachmentStatus & {
    __typename?: 'SeekMaxCertificateAttachmentPending';
    id: Scalars['ID']['output'];
  };

export type SeekMaxCertificateAttachmentPublished =
  ISeekMaxCertificateAttachmentStatus & {
    __typename?: 'SeekMaxCertificateAttachmentPublished';
    id: Scalars['ID']['output'];
    url: Scalars['String']['output'];
  };

export type SeekMaxCertificateConnectionResults = {
  __typename?: 'SeekMaxCertificateConnectionResults';
  edges?: Maybe<Array<Maybe<SeekMaxCertificateEdge>>>;
  pageInfo: PageInfo;
};

export type SeekMaxCertificateEdge = {
  __typename?: 'SeekMaxCertificateEdge';
  node: SeekMaxCertificate;
};

export type SeekMaxCertificateSeekPassFail =
  ISeekMaxCertificateSeekPassStatus & {
    __typename?: 'SeekMaxCertificateSeekPassFail';
    id: Scalars['ID']['output'];
  };

export type SeekMaxCertificateSeekPassPending =
  ISeekMaxCertificateSeekPassStatus & {
    __typename?: 'SeekMaxCertificateSeekPassPending';
    id: Scalars['ID']['output'];
  };

export type SeekMaxCertificateSeekPassSuccess =
  ISeekMaxCertificateSeekPassStatus & {
    __typename?: 'SeekMaxCertificateSeekPassSuccess';
    id: Scalars['ID']['output'];
  };

export type SeekMaxCollection = {
  __typename?: 'SeekMaxCollection';
  modules: Array<SeekMaxModule>;
  title: Scalars['String']['output'];
};

export type SeekMaxComment = {
  __typename?: 'SeekMaxComment';
  author: SeekMaxPublicUser;
  content: Scalars['String']['output'];
  creationDate: SeekDateTime;
  exactSocialData: ExactCommentSocialData;
  id: Scalars['ID']['output'];
  personalisedDetails?: Maybe<PersonalisedSeekMaxComment>;
};

export type SeekMaxCommentConnectionResults = {
  __typename?: 'SeekMaxCommentConnectionResults';
  edges?: Maybe<Array<Maybe<SeekMaxCommentEdge>>>;
  pageInfo: SeekMaxPageInfo;
  /** @deprecated Use pageSize instead */
  totalCount: Scalars['Int']['output'];
};

export type SeekMaxCommentEdge = {
  __typename?: 'SeekMaxCommentEdge';
  cursor: Scalars['Int']['output'];
  node?: Maybe<ISeekMaxComment>;
};

export type SeekMaxCommentLikedStatusFailure = {
  __typename?: 'SeekMaxCommentLikedStatusFailure';
  errors: Array<SeekMaxLikedStatusError>;
};

export type SeekMaxCommentLikedStatusSuccess = {
  __typename?: 'SeekMaxCommentLikedStatusSuccess';
  id: Scalars['ID']['output'];
  likeCount: SocialMetric;
  liked: Scalars['Boolean']['output'];
};

export type SeekMaxCommentV2 = ISeekMaxComment & {
  __typename?: 'SeekMaxCommentV2';
  author: SeekMaxPublicUser;
  content: Scalars['String']['output'];
  creationDate: SeekDateTime;
  exactSocialData: ExactCommentSocialData;
  id: Scalars['ID']['output'];
  personalisedDetails?: Maybe<PersonalisedSeekMaxComment>;
};

export type SeekMaxContentSearchResults = {
  __typename?: 'SeekMaxContentSearchResults';
  edges: Array<SeekMaxSearchContentEdge>;
  pageInfo: SearchPageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SeekMaxImageAttachment = SeekMaxAttachment & {
  __typename?: 'SeekMaxImageAttachment';
  id: Scalars['ID']['output'];
  url: Scalars['String']['output'];
};

export type SeekMaxKOLExpert = ISeekMaxKOLGroup & {
  __typename?: 'SeekMaxKOLExpert';
  description: Scalars['String']['output'];
};

export type SeekMaxLandingInfo = {
  __typename?: 'SeekMaxLandingInfo';
  learningProfileId: Scalars['String']['output'];
};

export type SeekMaxLikeInput = {
  id: Scalars['ID']['input'];
  liked: Scalars['Boolean']['input'];
  zone?: InputMaybe<Scalars['Zone']['input']>;
};

export type SeekMaxLikedStatusError = {
  message: Scalars['String']['output'];
};

export type SeekMaxLikedStatusErrormessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type SeekMaxModerationFlagImage = {
  __typename?: 'SeekMaxModerationFlagImage';
  attachmentId: Scalars['ID']['output'];
  flagCategory: Scalars['String']['output'];
  flagReason: Scalars['String']['output'];
};

export type SeekMaxModerationFlagText = {
  __typename?: 'SeekMaxModerationFlagText';
  flagCategory: Scalars['String']['output'];
  flagReason: Scalars['String']['output'];
};

export type SeekMaxModerationFlags = {
  __typename?: 'SeekMaxModerationFlags';
  image?: Maybe<Array<SeekMaxModerationFlagImage>>;
  text?: Maybe<Array<SeekMaxModerationFlagText>>;
};

export type SeekMaxModerationStatusFail = ISeekMaxModerationStatus & {
  __typename?: 'SeekMaxModerationStatusFail';
  flags: SeekMaxModerationFlags;
  id: Scalars['ID']['output'];
};

export type SeekMaxModerationStatusPending = ISeekMaxModerationStatus & {
  __typename?: 'SeekMaxModerationStatusPending';
  id: Scalars['ID']['output'];
};

export type SeekMaxModerationStatusSuccess = ISeekMaxModerationStatus & {
  __typename?: 'SeekMaxModerationStatusSuccess';
  attachments?: Maybe<Array<SeekMaxImageAttachment>>;
  id: Scalars['ID']['output'];
};

export type SeekMaxModule = {
  __typename?: 'SeekMaxModule';
  /** UNSTABLE! */
  approxSocialData: ApproxModuleSocialData;
  author: Scalars['String']['output'];
  /** @deprecated To be removed SeekMaxCategory enum */
  categories?: Maybe<Array<SeekMaxCategory>>;
  certData?: Maybe<SeekMaxModuleCertificateData>;
  description?: Maybe<Scalars['String']['output']>;
  exactSocialData: ExactModuleSocialData;
  id: Scalars['ID']['output'];
  keywordTags?: Maybe<Array<Scalars['String']['output']>>;
  metaData?: Maybe<SeekMaxModuleMetaData>;
  personalisedDetails?: Maybe<PersonalisedSeekMaxModule>;
  personalisedProgress?: Maybe<PersonalisedSeekMaxModuleProgress>;
  previewImageSrc?: Maybe<Scalars['String']['output']>;
  shareLink: Scalars['String']['output'];
  skillLevel: SeekMaxSkillLevel;
  tags?: Maybe<Array<SeekMaxTags>>;
  threadId?: Maybe<Scalars['ID']['output']>;
  thumbnailImageSrc?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  totalDuration: Duration;
  videos?: Maybe<Array<SeekMaxVideo>>;
};

export type SeekMaxModulepersonalisedProgressArgs = {
  countryCode?: InputMaybe<Scalars['CountryCodeIso2']['input']>;
  zone?: InputMaybe<Scalars['Zone']['input']>;
};

export type SeekMaxModuleshareLinkArgs = {
  languageCode: Scalars['LanguageCodeIso']['input'];
  platform: Platform;
  zone: Scalars['Zone']['input'];
};

export type SeekMaxModuleBookmark = {
  __typename?: 'SeekMaxModuleBookmark';
  bookmarkDate: SeekDateTime;
};

export type SeekMaxModuleBookmarkInput = {
  /** @deprecated Not in use */
  countryCode?: InputMaybe<Scalars['CountryCodeIso2']['input']>;
  id: Scalars['ID']['input'];
};

export type SeekMaxModuleBookmarkResults = {
  __typename?: 'SeekMaxModuleBookmarkResults';
  modules: Array<SeekMaxModule>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
  resultCount: Scalars['Int']['output'];
};

export type SeekMaxModuleCertificateData = {
  __typename?: 'SeekMaxModuleCertificateData';
  certType?: Maybe<SeekMaxCertType>;
  url?: Maybe<Scalars['String']['output']>;
};

export type SeekMaxModuleClickedPersonalisationEventError = {
  message: Scalars['String']['output'];
};

export type SeekMaxModuleClickedPersonalisationEventErrormessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type SeekMaxModuleClickedPersonalisationEventFailure = {
  __typename?: 'SeekMaxModuleClickedPersonalisationEventFailure';
  errors: Array<SeekMaxModuleClickedPersonalisationEventError>;
};

export type SeekMaxModuleClickedPersonalisationEventInput = {
  moduleId: Scalars['ID']['input'];
  session: Scalars['UUID']['input'];
  zone: Scalars['Zone']['input'];
};

export type SeekMaxModuleClickedPersonalisationEventPayload =
  | SeekMaxModuleClickedPersonalisationEventFailure
  | SeekMaxModuleClickedPersonalisationEventSuccess;

export type SeekMaxModuleClickedPersonalisationEventSuccess = {
  __typename?: 'SeekMaxModuleClickedPersonalisationEventSuccess';
  moduleId: Scalars['ID']['output'];
};

export type SeekMaxModuleConnectionResults = {
  __typename?: 'SeekMaxModuleConnectionResults';
  edges: Array<SeekMaxModuleEdge>;
  pageInfo: SeekMaxPageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SeekMaxModuleEdge = {
  __typename?: 'SeekMaxModuleEdge';
  cursor: Scalars['Int']['output'];
  node: SeekMaxModule;
};

export type SeekMaxModuleFeed = {
  __typename?: 'SeekMaxModuleFeed';
  content: SeekMaxModule;
  metaData?: Maybe<SeekMaxModuleMetaData>;
};

export type SeekMaxModuleFeedEdge = {
  __typename?: 'SeekMaxModuleFeedEdge';
  node: SeekMaxModuleFeed;
};

export type SeekMaxModuleFeedResults = {
  __typename?: 'SeekMaxModuleFeedResults';
  edges?: Maybe<Array<Maybe<SeekMaxModuleFeedEdge>>>;
};

export type SeekMaxModuleLikeInput = {
  liked: Scalars['Boolean']['input'];
  moduleThreadId: Scalars['ID']['input'];
  zone?: InputMaybe<Scalars['Zone']['input']>;
};

export type SeekMaxModuleLikedStatusFailure = {
  __typename?: 'SeekMaxModuleLikedStatusFailure';
  errors: Array<SeekMaxLikedStatusError>;
};

export type SeekMaxModuleLikedStatusSuccess = {
  __typename?: 'SeekMaxModuleLikedStatusSuccess';
  likeCount: SocialMetric;
  liked: Scalars['Boolean']['output'];
  moduleThreadId: Scalars['ID']['output'];
};

export type SeekMaxModuleMetaData = {
  __typename?: 'SeekMaxModuleMetaData';
  source?: Maybe<Scalars['String']['output']>;
};

export type SeekMaxModuleProgressError = {
  message: Scalars['String']['output'];
};

export type SeekMaxModuleProgressErrormessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type SeekMaxModuleProgressFailure = {
  __typename?: 'SeekMaxModuleProgressFailure';
  errors: Array<SeekMaxModuleProgressError>;
};

export type SeekMaxModuleProgressInput = {
  /** @deprecated Use zone instead */
  countryCode?: InputMaybe<Scalars['CountryCodeIso2']['input']>;
  id: Scalars['ID']['input'];
  resumeFromSeconds: Scalars['Float']['input'];
  videoId: Scalars['ID']['input'];
  zone?: InputMaybe<Scalars['Zone']['input']>;
};

export type SeekMaxModuleProgressPayload =
  | SeekMaxModuleProgressFailure
  | SeekMaxModuleProgressSuccess;

export type SeekMaxModuleProgressSuccess = {
  __typename?: 'SeekMaxModuleProgressSuccess';
  id: Scalars['ID']['output'];
  videoId: Scalars['ID']['output'];
};

export type SeekMaxModuleSearchContent = ISeekMaxSearchContent & {
  __typename?: 'SeekMaxModuleSearchContent';
  author: Scalars['String']['output'];
  exactSocialData: ExactModuleSocialData;
  id: Scalars['ID']['output'];
  previewImageSrc?: Maybe<Scalars['String']['output']>;
  thumbnailImageSrc?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  totalDuration: Duration;
  videoCount: Scalars['Int']['output'];
};

export type SeekMaxModulesInProgressResults = {
  __typename?: 'SeekMaxModulesInProgressResults';
  modules: Array<SeekMaxModule>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
  resultCount: Scalars['Int']['output'];
};

export type SeekMaxNextVideoProgress = {
  __typename?: 'SeekMaxNextVideoProgress';
  durationLeft?: Maybe<DurationLeft>;
  id: Scalars['ID']['output'];
  percentageCompleted: Scalars['Float']['output'];
  previewImageSrc?: Maybe<Scalars['String']['output']>;
  resumeFromSeconds: Scalars['Float']['output'];
  state: SeekMaxVideoState;
  thumbnailImageSrc?: Maybe<Scalars['String']['output']>;
};

export type SeekMaxNotificationActorDetails = {
  __typename?: 'SeekMaxNotificationActorDetails';
  firstName?: Maybe<Scalars['String']['output']>;
  learningProfileHashCode?: Maybe<Scalars['Int']['output']>;
  learningProfileId?: Maybe<Scalars['ID']['output']>;
};

export type SeekMaxNotificationAsReadInput = {
  notificationId: Scalars['ID']['input'];
  zone: Scalars['Zone']['input'];
};

export type SeekMaxNotificationConnectionResults = {
  __typename?: 'SeekMaxNotificationConnectionResults';
  edges?: Maybe<Array<Maybe<SeekMaxNotificationEdge>>>;
  pageInfo: SeekMaxPageInfo;
  totalCount: Scalars['Int']['output'];
  totalUnreadCount: Scalars['Int']['output'];
};

export type SeekMaxNotificationConnectionResultsedgesArgs = {
  cursor: Scalars['Int']['input'];
};

export type SeekMaxNotificationConnectionResultspageInfoArgs = {
  cursor: Scalars['Int']['input'];
  pageSize: Scalars['PositiveInt']['input'];
};

export type SeekMaxNotificationEdge = {
  __typename?: 'SeekMaxNotificationEdge';
  cursor: Scalars['Int']['output'];
  node: ISeekMaxNotification;
};

export type SeekMaxPageInfo = {
  __typename?: 'SeekMaxPageInfo';
  endCursor?: Maybe<Scalars['Int']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPrevPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['Int']['output']>;
};

export type SeekMaxPoll = {
  __typename?: 'SeekMaxPoll';
  endDate: SeekDateTime;
  ended: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  maxVotes: Scalars['Int']['output'];
  options: Array<SeekMaxPollOption>;
  voteCount: SocialMetric;
};

export type SeekMaxPollOption = {
  __typename?: 'SeekMaxPollOption';
  count: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  percentage: Scalars['Int']['output'];
  personalisedDetails?: Maybe<PersonalisedSeekMaxPollOption>;
  title: Scalars['String']['output'];
};

export type SeekMaxProfile = {
  __typename?: 'SeekMaxProfile';
  groups: Array<ISeekMaxKOLGroup>;
  learningProfileHashCode: Scalars['Int']['output'];
  learningProfileId: Scalars['ID']['output'];
};

export type SeekMaxPublicLearningProfile = {
  __typename?: 'SeekMaxPublicLearningProfile';
  firstName?: Maybe<Scalars['String']['output']>;
  jobTitle?: Maybe<Scalars['String']['output']>;
};

export type SeekMaxPublicUser = {
  __typename?: 'SeekMaxPublicUser';
  groups: Array<ISeekMaxKOLGroup>;
  id: Scalars['ID']['output'];
  learningProfile?: Maybe<SeekMaxPublicLearningProfile>;
  learningProfileHashCode: Scalars['Int']['output'];
};

export type SeekMaxReply = {
  __typename?: 'SeekMaxReply';
  author: SeekMaxPublicUser;
  content: Scalars['String']['output'];
  creationDate: SeekDateTime;
  id: Scalars['ID']['output'];
  personalisedDetails?: Maybe<PersonalisedSeekMaxReply>;
};

export type SeekMaxReplyResults = {
  __typename?: 'SeekMaxReplyResults';
  lastCursor: Scalars['Int']['output'];
  replies: Array<SeekMaxReply>;
  resultCount: Scalars['Int']['output'];
};

export type SeekMaxSearchContentEdge = {
  __typename?: 'SeekMaxSearchContentEdge';
  cursor: Scalars['Int']['output'];
  node: ISeekMaxSearchContent;
};

export type SeekMaxSkillLevel = 'BASIC' | 'EXPERT' | 'INTERMEDIATE' | 'UNKNOWN';

export type SeekMaxTags = {
  __typename?: 'SeekMaxTags';
  color: Scalars['String']['output'];
  tag: Scalars['String']['output'];
};

export type SeekMaxThread = {
  __typename?: 'SeekMaxThread';
  attachments?: Maybe<Array<SeekMaxImageAttachment>>;
  author: SeekMaxPublicUser;
  categoryGroup?: Maybe<ISeekMaxCategoryGroup>;
  commentsV3?: Maybe<Array<Maybe<SeekMaxComment>>>;
  creationDate: SeekDateTime;
  description: Scalars['String']['output'];
  exactSocialData: ExactThreadSocialData;
  hasUnreadPosts?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  isPinned: Scalars['Boolean']['output'];
  keywordTags?: Maybe<Array<Scalars['String']['output']>>;
  personalisedDetails?: Maybe<PersonalisedSeekMaxThread>;
  pollV3?: Maybe<SeekMaxPoll>;
  shareLink: Scalars['String']['output'];
  slug?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type SeekMaxThreadcategoryGroupArgs = {
  locale?: InputMaybe<Scalars['Locale']['input']>;
  zone: Scalars['Zone']['input'];
};

export type SeekMaxThreadcommentsV3Args = {
  zone: Scalars['Zone']['input'];
};

export type SeekMaxThreadpollV3Args = {
  zone: Scalars['Zone']['input'];
};

export type SeekMaxThreadshareLinkArgs = {
  languageCode: Scalars['LanguageCodeIso']['input'];
  platform: Platform;
  zone: Scalars['Zone']['input'];
};

export type SeekMaxThreadConnectionResults = {
  __typename?: 'SeekMaxThreadConnectionResults';
  edges: Array<SeekMaxThreadEdge>;
  pageInfo: SeekMaxPageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SeekMaxThreadEdge = {
  __typename?: 'SeekMaxThreadEdge';
  cursor: Scalars['Int']['output'];
  node: SeekMaxThread;
};

export type SeekMaxThreadFeed = {
  __typename?: 'SeekMaxThreadFeed';
  content: SeekMaxThread;
  metaData?: Maybe<SeekMaxThreadMetaData>;
};

export type SeekMaxThreadFeedEdge = {
  __typename?: 'SeekMaxThreadFeedEdge';
  node: SeekMaxThreadFeed;
};

export type SeekMaxThreadFeedResults = {
  __typename?: 'SeekMaxThreadFeedResults';
  edges?: Maybe<Array<Maybe<SeekMaxThreadFeedEdge>>>;
};

export type SeekMaxThreadLikedStatusFailure = {
  __typename?: 'SeekMaxThreadLikedStatusFailure';
  errors: Array<SeekMaxLikedStatusError>;
};

export type SeekMaxThreadLikedStatusSuccess = {
  __typename?: 'SeekMaxThreadLikedStatusSuccess';
  id: Scalars['ID']['output'];
  likeCount: SocialMetric;
  liked: Scalars['Boolean']['output'];
};

export type SeekMaxThreadMetaData = {
  __typename?: 'SeekMaxThreadMetaData';
  source?: Maybe<Scalars['String']['output']>;
};

export type SeekMaxThreadPollInput = {
  optionId: Scalars['ID']['input'];
  pollId: Scalars['ID']['input'];
  voted: Scalars['Boolean']['input'];
  zone?: InputMaybe<Scalars['Zone']['input']>;
};

export type SeekMaxThreadPollStatusError = {
  message: Scalars['String']['output'];
};

export type SeekMaxThreadPollStatusErrormessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type SeekMaxThreadPollStatusFailure = {
  __typename?: 'SeekMaxThreadPollStatusFailure';
  errors: Array<SeekMaxThreadPollStatusError>;
};

export type SeekMaxThreadPollStatusSuccess = {
  __typename?: 'SeekMaxThreadPollStatusSuccess';
  optionId: Scalars['ID']['output'];
  pollId: Scalars['ID']['output'];
  voted: Scalars['Boolean']['output'];
};

export type SeekMaxThreadSearchContent = ISeekMaxSearchContent & {
  __typename?: 'SeekMaxThreadSearchContent';
  attachments?: Maybe<Array<SeekMaxImageAttachment>>;
  author: SeekMaxPublicUser;
  categoryGroup?: Maybe<ISeekMaxCategoryGroup>;
  commentsV3?: Maybe<Array<Maybe<SeekMaxComment>>>;
  creationDate: SeekDateTime;
  description: Scalars['String']['output'];
  exactSocialData: ExactThreadSocialData;
  id: Scalars['ID']['output'];
  isPinned: Scalars['Boolean']['output'];
  keywordTags?: Maybe<Array<Scalars['String']['output']>>;
  personalisedDetails?: Maybe<PersonalisedSeekMaxThreadSearchContent>;
  slug?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type SeekMaxThreadSearchContentcategoryGroupArgs = {
  locale?: InputMaybe<Scalars['Locale']['input']>;
  zone: Scalars['Zone']['input'];
};

export type SeekMaxThreadSearchContentcommentsV3Args = {
  zone: Scalars['Zone']['input'];
};

export type SeekMaxThreadV2 = ISeekMaxThread & {
  __typename?: 'SeekMaxThreadV2';
  attachments?: Maybe<Array<SeekMaxImageAttachment>>;
  author: SeekMaxPublicUser;
  categoryGroup?: Maybe<ISeekMaxCategoryGroup>;
  commentsV3?: Maybe<Array<Maybe<SeekMaxComment>>>;
  creationDate: SeekDateTime;
  description: Scalars['String']['output'];
  exactSocialData: ExactThreadSocialData;
  id: Scalars['ID']['output'];
  isPinned: Scalars['Boolean']['output'];
  keywordTags?: Maybe<Array<Scalars['String']['output']>>;
  personalisedDetails?: Maybe<PersonalisedSeekMaxThread>;
  pollV3?: Maybe<SeekMaxPoll>;
  shareLink: Scalars['String']['output'];
  slug?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type SeekMaxThreadV2categoryGroupArgs = {
  locale?: InputMaybe<Scalars['Locale']['input']>;
  zone: Scalars['Zone']['input'];
};

export type SeekMaxThreadV2commentsV3Args = {
  zone: Scalars['Zone']['input'];
};

export type SeekMaxThreadV2pollV3Args = {
  zone: Scalars['Zone']['input'];
};

export type SeekMaxThreadV2shareLinkArgs = {
  languageCode: Scalars['LanguageCodeIso']['input'];
  platform: Platform;
  zone: Scalars['Zone']['input'];
};

export type SeekMaxThreadViewedPersonalisationEventError = {
  /** UNSTABLE! */
  message: Scalars['String']['output'];
};

export type SeekMaxThreadViewedPersonalisationEventErrormessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type SeekMaxThreadViewedPersonalisationEventFailure = {
  __typename?: 'SeekMaxThreadViewedPersonalisationEventFailure';
  /** UNSTABLE! */
  errors: Array<SeekMaxThreadViewedPersonalisationEventError>;
};

export type SeekMaxThreadViewedPersonalisationEventInput = {
  /** UNSTABLE! */
  threadId: Scalars['ID']['input'];
  /** UNSTABLE! */
  zone: Scalars['Zone']['input'];
};

export type SeekMaxThreadViewedPersonalisationEventPayload =
  | SeekMaxThreadViewedPersonalisationEventFailure
  | SeekMaxThreadViewedPersonalisationEventSuccess;

export type SeekMaxThreadViewedPersonalisationEventSuccess = {
  __typename?: 'SeekMaxThreadViewedPersonalisationEventSuccess';
  /** UNSTABLE! */
  threadId: Scalars['ID']['output'];
  /** UNSTABLE! */
  zone: Scalars['Zone']['output'];
};

export type SeekMaxTransactionalNotification = ISeekMaxNotification & {
  __typename?: 'SeekMaxTransactionalNotification';
  actorDetails: SeekMaxNotificationActorDetails;
  contentType: Scalars['String']['output'];
  deeplink: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isRead: Scalars['Boolean']['output'];
  subtitle: Scalars['String']['output'];
  timestamp: SeekDateTime;
  title: Scalars['String']['output'];
};

export type SeekMaxTrendingModuleConnectionResults = {
  __typename?: 'SeekMaxTrendingModuleConnectionResults';
  edges?: Maybe<Array<Maybe<SeekMaxTrendingModuleEdge>>>;
  pageInfo: PageInfo;
};

export type SeekMaxTrendingModuleEdge = {
  __typename?: 'SeekMaxTrendingModuleEdge';
  node: SeekMaxModule;
};

export type SeekMaxUnreadNotificationsCountResponse = {
  __typename?: 'SeekMaxUnreadNotificationsCountResponse';
  count: Scalars['Int']['output'];
  label: Scalars['String']['output'];
};

export type SeekMaxUnreadNotificationsCountResponselabelArgs = {
  locale: Scalars['Locale']['input'];
};

export type SeekMaxUnreadThreadsCountResponse = {
  __typename?: 'SeekMaxUnreadThreadsCountResponse';
  count: Scalars['Int']['output'];
};

export type SeekMaxVideo = {
  __typename?: 'SeekMaxVideo';
  description?: Maybe<Scalars['String']['output']>;
  drmEnabled: Scalars['Boolean']['output'];
  duration: Duration;
  id: Scalars['ID']['output'];
  personalisedDetails?: Maybe<PersonalisedSeekMaxVideo>;
  previewImageSrc: Scalars['String']['output'];
  thumbnailImageSrc: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type SeekMaxVideoProgress = {
  __typename?: 'SeekMaxVideoProgress';
  durationLeft?: Maybe<DurationLeft>;
  percentageCompleted: Scalars['Float']['output'];
  resumeFromSeconds: Scalars['Float']['output'];
  state: SeekMaxVideoState;
};

export type SeekMaxVideoState = 'COMPLETED' | 'IN_PROGRESS' | 'NOT_STARTED';

export type SeekMaxVideoViewedEventError = {
  message: Scalars['String']['output'];
};

export type SeekMaxVideoViewedEventErrormessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type SeekMaxVideoViewedEventFailure = {
  __typename?: 'SeekMaxVideoViewedEventFailure';
  errors: Array<SeekMaxVideoViewedEventError>;
};

export type SeekMaxVideoViewedEventInput = {
  /** @deprecated Use zone instead */
  locale?: InputMaybe<Scalars['Locale']['input']>;
  moduleId: Scalars['ID']['input'];
  session: Scalars['UUID']['input'];
  videoId: Scalars['ID']['input'];
  zone?: InputMaybe<Scalars['Zone']['input']>;
};

export type SeekMaxVideoViewedEventPayload =
  | SeekMaxVideoViewedEventFailure
  | SeekMaxVideoViewedEventSuccess;

export type SeekMaxVideoViewedEventSuccess = {
  __typename?: 'SeekMaxVideoViewedEventSuccess';
  moduleId: Scalars['ID']['output'];
  videoId: Scalars['ID']['output'];
};

export type SeekMaxVideoViewedPersonalisationEventError = {
  message: Scalars['String']['output'];
};

export type SeekMaxVideoViewedPersonalisationEventErrormessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type SeekMaxVideoViewedPersonalisationEventFailure = {
  __typename?: 'SeekMaxVideoViewedPersonalisationEventFailure';
  errors: Array<SeekMaxVideoViewedPersonalisationEventError>;
};

export type SeekMaxVideoViewedPersonalisationEventInput = {
  moduleId: Scalars['ID']['input'];
  session: Scalars['UUID']['input'];
  videoId: Scalars['ID']['input'];
  zone: Scalars['Zone']['input'];
};

export type SeekMaxVideoViewedPersonalisationEventPayload =
  | SeekMaxVideoViewedPersonalisationEventFailure
  | SeekMaxVideoViewedPersonalisationEventSuccess;

export type SeekMaxVideoViewedPersonalisationEventSuccess = {
  __typename?: 'SeekMaxVideoViewedPersonalisationEventSuccess';
  moduleId: Scalars['ID']['output'];
  videoId: Scalars['ID']['output'];
};

export type SelectionCriteriaInput = {
  uri: Scalars['String']['input'];
  writtenText?: InputMaybe<Scalars['String']['input']>;
};

export type SendLoginCallbackEventFailure = {
  __typename?: 'SendLoginCallbackEventFailure';
  error: I18nAccountError;
};

export type SendLoginCallbackEventPayload =
  | SendLoginCallbackEventFailure
  | SendLoginCallbackEventSuccess;

export type SendLoginCallbackEventSuccess = {
  __typename?: 'SendLoginCallbackEventSuccess';
  loginType: Scalars['String']['output'];
};

export type SendSeekMaxModuleClickedEventError = {
  message: Scalars['String']['output'];
};

export type SendSeekMaxModuleClickedEventErrormessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type SendSeekMaxModuleClickedEventFailure = {
  __typename?: 'SendSeekMaxModuleClickedEventFailure';
  errors: Array<SendSeekMaxModuleClickedEventError>;
};

export type SendSeekMaxModuleClickedEventInput = {
  /** @deprecated Use zone instead */
  countryCode?: InputMaybe<Scalars['CountryCodeIso2']['input']>;
  moduleId: Scalars['ID']['input'];
  session: Scalars['UUID']['input'];
  zone?: InputMaybe<Scalars['Zone']['input']>;
};

export type SendSeekMaxModuleClickedEventPayload =
  | SendSeekMaxModuleClickedEventFailure
  | SendSeekMaxModuleClickedEventSuccess;

export type SendSeekMaxModuleClickedEventSuccess = {
  __typename?: 'SendSeekMaxModuleClickedEventSuccess';
  moduleId: Scalars['ID']['output'];
};

export type SensitiveDataInfo = {
  __typename?: 'SensitiveDataInfo';
  isDetected: Scalars['Boolean']['output'];
};

export type SetAppliedJobNotesError = {
  message: Scalars['String']['output'];
};

export type SetAppliedJobNotesErrormessageArgs = {
  locale?: InputMaybe<Scalars['Locale']['input']>;
};

export type SetAppliedJobNotesFailure = {
  __typename?: 'SetAppliedJobNotesFailure';
  errors: Array<SetAppliedJobNotesError>;
};

export type SetAppliedJobNotesInput = {
  id: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
};

export type SetAppliedJobNotesPayload =
  | SetAppliedJobNotesFailure
  | SetAppliedJobNotesSuccess;

export type SetAppliedJobNotesSuccess = {
  __typename?: 'SetAppliedJobNotesSuccess';
  id?: Maybe<Scalars['String']['output']>;
};

export type SetAppliedJobNotesValidationError = SetAppliedJobNotesError & {
  __typename?: 'SetAppliedJobNotesValidationError';
  message: Scalars['String']['output'];
};

export type SetAppliedJobNotesValidationErrormessageArgs = {
  locale?: InputMaybe<Scalars['Locale']['input']>;
};

export type SetDefaultResumeInput = {
  id: Scalars['UUID']['input'];
};

export type SetDefaultResumePayload = {
  __typename?: 'SetDefaultResumePayload';
  ref?: Maybe<Scalars['UUID']['output']>;
  viewer?: Maybe<Candidate>;
};

export type SetSavedJobNotesError = {
  message: Scalars['String']['output'];
};

export type SetSavedJobNotesErrormessageArgs = {
  locale?: InputMaybe<Scalars['Locale']['input']>;
};

export type SetSavedJobNotesFailure = {
  __typename?: 'SetSavedJobNotesFailure';
  errors: Array<SetSavedJobNotesError>;
};

export type SetSavedJobNotesInput = {
  id: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
};

export type SetSavedJobNotesPayload =
  | SetSavedJobNotesFailure
  | SetSavedJobNotesSuccess;

export type SetSavedJobNotesSuccess = {
  __typename?: 'SetSavedJobNotesSuccess';
  id: Scalars['ID']['output'];
};

export type SetSavedJobNotesValidationError = SetSavedJobNotesError & {
  __typename?: 'SetSavedJobNotesValidationError';
  message: Scalars['String']['output'];
};

export type SetSavedJobNotesValidationErrormessageArgs = {
  locale?: InputMaybe<Scalars['Locale']['input']>;
};

export type SetSeekMaxCategoryGroupFollowedStatusError = {
  message: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type SetSeekMaxCategoryGroupFollowedStatusErrormessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type SetSeekMaxCategoryGroupFollowedStatusErrortitleArgs = {
  locale: Scalars['Locale']['input'];
};

export type SetSeekMaxCategoryGroupFollowedStatusFailure = {
  __typename?: 'SetSeekMaxCategoryGroupFollowedStatusFailure';
  errors: Array<SetSeekMaxCategoryGroupFollowedStatusError>;
};

export type SetSeekMaxCategoryGroupFollowedStatusPayload =
  | SetSeekMaxCategoryGroupFollowedStatusFailure
  | SetSeekMaxCategoryGroupFollowedStatusSuccess;

export type SetSeekMaxCategoryGroupFollowedStatusSuccess = {
  __typename?: 'SetSeekMaxCategoryGroupFollowedStatusSuccess';
  categoryId: Scalars['ID']['output'];
  followed: Scalars['Boolean']['output'];
  groupId: Scalars['ID']['output'];
};

export type SetSeekMaxCommentLikedStatusPayload =
  | SeekMaxCommentLikedStatusFailure
  | SeekMaxCommentLikedStatusSuccess;

export type SetSeekMaxModuleLikedStatusPayload =
  | SeekMaxModuleLikedStatusFailure
  | SeekMaxModuleLikedStatusSuccess;

export type SetSeekMaxNotificationAsReadStatusError = {
  message: Scalars['String']['output'];
};

export type SetSeekMaxNotificationAsReadStatusErrormessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type SetSeekMaxNotificationAsReadStatusPayload =
  | SetSeekMaxNotificationAsReadStatusPayloadFailure
  | SetSeekMaxNotificationAsReadStatusPayloadSuccess;

export type SetSeekMaxNotificationAsReadStatusPayloadFailure = {
  __typename?: 'SetSeekMaxNotificationAsReadStatusPayloadFailure';
  errors: Array<SetSeekMaxNotificationAsReadStatusError>;
};

export type SetSeekMaxNotificationAsReadStatusPayloadSuccess = {
  __typename?: 'SetSeekMaxNotificationAsReadStatusPayloadSuccess';
  notificationId: Scalars['ID']['output'];
};

export type SetSeekMaxThreadLikedStatusPayload =
  | SeekMaxThreadLikedStatusFailure
  | SeekMaxThreadLikedStatusSuccess;

export type SetSeekMaxThreadPollStatusPayload =
  | SeekMaxThreadPollStatusFailure
  | SeekMaxThreadPollStatusSuccess;

export type ShareableProfile = {
  __typename?: 'ShareableProfile';
  active: Scalars['Boolean']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  languageProficiencies: Array<LanguageProficiency>;
  licences: Array<Licence>;
  personalDetails: PersonalDetails;
  qualifications: Array<Qualification>;
  roles: Array<Role>;
  skills: Array<Skill>;
  summary?: Maybe<Scalars['String']['output']>;
  verifiedIdentity?: Maybe<VerifiedIdentity>;
};

export type ShareableProfileSettings = {
  __typename?: 'ShareableProfileSettings';
  active?: Maybe<Scalars['Boolean']['output']>;
  displayUrl?: Maybe<Scalars['String']['output']>;
  privacy?: Maybe<Privacy>;
  profileSlug?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  views?: Maybe<Scalars['Int']['output']>;
};

export type ShowMordorQueryV6Result = {
  __typename?: 'ShowMordorQueryV6Result';
  searchParams: Scalars['String']['output'];
};

export type SingleChoiceQuestion = Question & {
  __typename?: 'SingleChoiceQuestion';
  id: Scalars['String']['output'];
  lastAnswer?: Maybe<LastAnswer>;
  options: Array<QuestionOption>;
  text: Scalars['String']['output'];
};

export type Skill = {
  __typename?: 'Skill';
  keyword: OntologyStructuredData;
};

export type SkillInput = {
  keyword: OntologyStructuredDataInput;
};

export type SocialMetric = {
  __typename?: 'SocialMetric';
  count: Scalars['Int']['output'];
  label: Scalars['String']['output'];
};

export type Sort = 'ASC' | 'DESC';

export type SourceExperience = 'APPLY' | 'JAS' | 'PROFILE';

export type Sourcr = {
  __typename?: 'Sourcr';
  agencyPaginatedReviews?: Maybe<SourcrRecruiterDirectoryPaginatedReview>;
  agencyProfileDetails?: Maybe<SourcrRecruiterDirectoryAgencyDetails>;
  awards?: Maybe<SourcrRecruiterDirectoryAwards>;
  featuredAgencies?: Maybe<SourcrRecruiterDirectorySearchAgencyResult>;
  featuredRecruiters?: Maybe<SourcrRecruiterDirectorySearchRecruiterResult>;
  paginatedJobs?: Maybe<SourcrRecruiterDirectoryPaginatedJob>;
  paginatedPlacements?: Maybe<SourcrRecruiterDirectoryPaginatedPlacement>;
  paginatedRecruiters?: Maybe<SourcrRecruiterDirectoryPaginatedRecruiter>;
  recruiterPaginatedReviews?: Maybe<SourcrRecruiterDirectoryPaginatedReview>;
  recruiterProfileDetails?: Maybe<SourcrRecruiterDirectoryRecruiterDetails>;
  searchAgency?: Maybe<SourcrRecruiterDirectorySearchAgencyResult>;
  searchFilters?: Maybe<SourcrRecruiterDirectorySearchFilters>;
  searchRecruiter?: Maybe<SourcrRecruiterDirectorySearchRecruiterResult>;
};

export type SourcragencyPaginatedReviewsArgs = {
  pagination: SourcrRecruiterDirectoryPaginationInput;
  slug: Scalars['String']['input'];
};

export type SourcragencyProfileDetailsArgs = {
  slug: Scalars['String']['input'];
  visitorId?: InputMaybe<Scalars['String']['input']>;
};

export type SourcrawardsArgs = {
  limit: Scalars['Int']['input'];
  slug: Scalars['String']['input'];
  type: SourcrRecruiterDirectoryProfileTypeEnum;
};

export type SourcrfeaturedAgenciesArgs = {
  country: Scalars['String']['input'];
};

export type SourcrfeaturedRecruitersArgs = {
  country: Scalars['String']['input'];
};

export type SourcrpaginatedJobsArgs = {
  pagination: SourcrRecruiterDirectoryPaginationInput;
  slug: Scalars['String']['input'];
  type: SourcrRecruiterDirectoryProfileTypeEnum;
};

export type SourcrpaginatedPlacementsArgs = {
  pagination: SourcrRecruiterDirectoryPaginationInput;
  slug: Scalars['String']['input'];
  type: SourcrRecruiterDirectoryProfileTypeEnum;
};

export type SourcrpaginatedRecruitersArgs = {
  pagination: SourcrRecruiterDirectoryPaginationInput;
  slug: Scalars['String']['input'];
};

export type SourcrrecruiterPaginatedReviewsArgs = {
  pagination: SourcrRecruiterDirectoryPaginationInput;
  slug: Scalars['String']['input'];
};

export type SourcrrecruiterProfileDetailsArgs = {
  slug: Scalars['String']['input'];
  visitorId?: InputMaybe<Scalars['String']['input']>;
};

export type SourcrsearchAgencyArgs = {
  input?: InputMaybe<SourcrRecruiterDirectorySearchInput>;
};

export type SourcrsearchRecruiterArgs = {
  input?: InputMaybe<SourcrRecruiterDirectorySearchInput>;
};

export type SourcrMessageInput = {
  country: Scalars['String']['input'];
  email: Scalars['Email']['input'];
  message: Scalars['String']['input'];
  name: Scalars['String']['input'];
  number?: InputMaybe<Scalars['String']['input']>;
  serviceToken?: InputMaybe<Scalars['String']['input']>;
  slug: Scalars['String']['input'];
  type: SourcrRecruiterDirectoryProfileTypeEnum;
};

export type SourcrPageAnalyticsEventInput = {
  browser?: InputMaybe<Scalars['String']['input']>;
  device?: InputMaybe<Scalars['String']['input']>;
  ipAddress?: InputMaybe<Scalars['String']['input']>;
  operatingSystem?: InputMaybe<Scalars['String']['input']>;
  page: Scalars['String']['input'];
  pageType: SourcrRecruiterDirectoryProfileTypeEnum;
  referrer?: InputMaybe<Scalars['String']['input']>;
  slug: Scalars['String']['input'];
  timeSpent?: InputMaybe<Scalars['Float']['input']>;
};

export type SourcrRecruiter = {
  __typename?: 'SourcrRecruiter';
  agencyImageUrl?: Maybe<Scalars['String']['output']>;
  agencyName?: Maybe<Scalars['String']['output']>;
  avatarImageUrl?: Maybe<Scalars['String']['output']>;
  contactUrl: Scalars['String']['output'];
  jobTitle?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  overallRating: Scalars['Float']['output'];
  reviewCount: Scalars['Int']['output'];
};

export type SourcrRecruiterAward = {
  __typename?: 'SourcrRecruiterAward';
  name?: Maybe<Scalars['String']['output']>;
  result?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  years?: Maybe<Scalars['String']['output']>;
};

export type SourcrRecruiterDirectoryAddress = {
  __typename?: 'SourcrRecruiterDirectoryAddress';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export type SourcrRecruiterDirectoryAgency = {
  __typename?: 'SourcrRecruiterDirectoryAgency';
  address?: Maybe<SourcrRecruiterDirectoryAddress>;
  avatarImageUrl?: Maybe<Scalars['String']['output']>;
  bannerImageUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  rating?: Maybe<Scalars['Float']['output']>;
  reviewCount: Scalars['Int']['output'];
  slug: Scalars['String']['output'];
};

export type SourcrRecruiterDirectoryAgencyDetails = {
  __typename?: 'SourcrRecruiterDirectoryAgencyDetails';
  about?: Maybe<Scalars['String']['output']>;
  address?: Maybe<SourcrRecruiterDirectoryAddress>;
  avatarImageUrl?: Maybe<Scalars['String']['output']>;
  bannerImageUrl?: Maybe<Scalars['String']['output']>;
  contactNumber?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  metadata?: Maybe<SourcrRecruiterDirectoryMetadata>;
  name: Scalars['String']['output'];
  rating?: Maybe<Scalars['Float']['output']>;
  reviewCount: Scalars['Int']['output'];
  reviewsInsight?: Maybe<SourcrRecruiterDirectoryReviewsInsight>;
  showSeekDirectoryEmail?: Maybe<Scalars['Boolean']['output']>;
  slug: Scalars['String']['output'];
  specialisations?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  website?: Maybe<Scalars['String']['output']>;
};

export type SourcrRecruiterDirectoryAwards = {
  __typename?: 'SourcrRecruiterDirectoryAwards';
  items?: Maybe<Array<Maybe<SourcrRecruiterAward>>>;
  totalItems?: Maybe<Scalars['Int']['output']>;
};

export type SourcrRecruiterDirectoryFilterInput = {
  name?: InputMaybe<SourcrRecruiterDirectoryFilterNameEnum>;
  values?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type SourcrRecruiterDirectoryFilterNameEnum =
  | 'CLAIMED'
  | 'COUNTRY'
  | 'LAST_REVIEW_DATE'
  | 'PLACEMENT_TITLES'
  | 'POSTCODE'
  | 'ROLE_TYPES'
  | 'SPECIALISATIONS';

export type SourcrRecruiterDirectoryJob = {
  __typename?: 'SourcrRecruiterDirectoryJob';
  createdAt?: Maybe<SeekDateTime>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  jobId?: Maybe<Scalars['Int']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type SourcrRecruiterDirectoryJobCategory = {
  __typename?: 'SourcrRecruiterDirectoryJobCategory';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type SourcrRecruiterDirectoryLocationFilter = {
  __typename?: 'SourcrRecruiterDirectoryLocationFilter';
  country?: Maybe<Scalars['String']['output']>;
  postcodes?: Maybe<
    Array<Maybe<SourcrRecruiterDirectoryLocationFilterPostcodes>>
  >;
};

export type SourcrRecruiterDirectoryLocationFilterPostcodes = {
  __typename?: 'SourcrRecruiterDirectoryLocationFilterPostcodes';
  name?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type SourcrRecruiterDirectoryMetadata = {
  __typename?: 'SourcrRecruiterDirectoryMetadata';
  serviceToken?: Maybe<Scalars['String']['output']>;
};

export type SourcrRecruiterDirectoryPaginatedJob = {
  __typename?: 'SourcrRecruiterDirectoryPaginatedJob';
  items: Array<Maybe<SourcrRecruiterDirectoryJob>>;
  pagination?: Maybe<SourcrRecruiterDirectorySearchResultPagination>;
};

export type SourcrRecruiterDirectoryPaginatedPlacement = {
  __typename?: 'SourcrRecruiterDirectoryPaginatedPlacement';
  items?: Maybe<Array<Maybe<SourcrRecruiterDirectoryPlacement>>>;
  pagination?: Maybe<SourcrRecruiterDirectorySearchResultPagination>;
};

export type SourcrRecruiterDirectoryPaginatedRecruiter = {
  __typename?: 'SourcrRecruiterDirectoryPaginatedRecruiter';
  items?: Maybe<Array<Maybe<SourcrRecruiterDirectoryRecruiter>>>;
  pagination?: Maybe<SourcrRecruiterDirectorySearchResultPagination>;
};

export type SourcrRecruiterDirectoryPaginatedReview = {
  __typename?: 'SourcrRecruiterDirectoryPaginatedReview';
  items?: Maybe<Array<Maybe<SourcrRecruiterDirectoryReview>>>;
  pagination?: Maybe<SourcrRecruiterDirectorySearchResultPagination>;
};

export type SourcrRecruiterDirectoryPaginationInput = {
  cursor: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
};

export type SourcrRecruiterDirectoryPlacement = {
  __typename?: 'SourcrRecruiterDirectoryPlacement';
  address?: Maybe<SourcrRecruiterDirectoryAddress>;
  category?: Maybe<SourcrRecruiterDirectoryJobCategory>;
  id: Scalars['ID']['output'];
  industry?: Maybe<Scalars['String']['output']>;
  jobTitle?: Maybe<Scalars['String']['output']>;
  jobType?: Maybe<Scalars['String']['output']>;
  salaryRange?: Maybe<Scalars['String']['output']>;
};

export type SourcrRecruiterDirectoryProfileTypeEnum = 'AGENCY' | 'RECRUITER';

export type SourcrRecruiterDirectoryRecruiter = {
  __typename?: 'SourcrRecruiterDirectoryRecruiter';
  address?: Maybe<SourcrRecruiterDirectoryAddress>;
  agencyName?: Maybe<Scalars['String']['output']>;
  avatarImageUrl?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  placementCount: Scalars['Int']['output'];
  rating?: Maybe<Scalars['Float']['output']>;
  reviewCount: Scalars['Int']['output'];
  slug: Scalars['String']['output'];
  specialisations?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type SourcrRecruiterDirectoryRecruiterDetails = {
  __typename?: 'SourcrRecruiterDirectoryRecruiterDetails';
  about?: Maybe<Scalars['String']['output']>;
  address?: Maybe<SourcrRecruiterDirectoryAddress>;
  agency?: Maybe<SourcrRecruiterDirectoryAgency>;
  agencyName?: Maybe<Scalars['String']['output']>;
  avatarImageUrl?: Maybe<Scalars['String']['output']>;
  bannerImageUrl?: Maybe<Scalars['String']['output']>;
  contactNumber?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isRecommended?: Maybe<Scalars['Boolean']['output']>;
  jobTitle?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<SourcrRecruiterDirectoryMetadata>;
  name: Scalars['String']['output'];
  rating?: Maybe<Scalars['Float']['output']>;
  reviewCount: Scalars['Int']['output'];
  reviewsInsight?: Maybe<SourcrRecruiterDirectoryReviewsInsight>;
  showSeekDirectoryEmail?: Maybe<Scalars['Boolean']['output']>;
  slug: Scalars['String']['output'];
  specialisations?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  website?: Maybe<Scalars['String']['output']>;
};

export type SourcrRecruiterDirectoryReview = {
  __typename?: 'SourcrRecruiterDirectoryReview';
  agency?: Maybe<SourcrRecruiterDirectoryAgency>;
  candidateQuality?: Maybe<Scalars['Float']['output']>;
  candidateRating?: Maybe<Scalars['Float']['output']>;
  communication?: Maybe<Scalars['Float']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<SeekDateTime>;
  firstName?: Maybe<Scalars['String']['output']>;
  googleRating?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  industryKnowledge?: Maybe<Scalars['Float']['output']>;
  isExternal?: Maybe<Scalars['Boolean']['output']>;
  isRepliedBy?: Maybe<Scalars['String']['output']>;
  isRepliedByAgencyAdmin?: Maybe<Scalars['Boolean']['output']>;
  isThirdParty?: Maybe<Scalars['Boolean']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
  recruiter?: Maybe<SourcrRecruiterDirectoryRecruiter>;
  repliedAgency?: Maybe<SourcrRecruiterDirectoryAgency>;
  replyMessage?: Maybe<Scalars['String']['output']>;
  responsiveness?: Maybe<Scalars['Float']['output']>;
  review?: Maybe<Scalars['String']['output']>;
  secondaryRecruiter?: Maybe<SourcrRecruiterDirectoryRecruiter>;
  sourceType?: Maybe<Scalars['String']['output']>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type SourcrRecruiterDirectoryReviewsInsight = {
  __typename?: 'SourcrRecruiterDirectoryReviewsInsight';
  last12MonthsReviewCount?: Maybe<Scalars['Int']['output']>;
  placementCount?: Maybe<Scalars['Int']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
};

export type SourcrRecruiterDirectorySearchAgencyResult = {
  __typename?: 'SourcrRecruiterDirectorySearchAgencyResult';
  items?: Maybe<Array<Maybe<SourcrRecruiterDirectoryAgency>>>;
  metadata?: Maybe<SourcrRecruiterDirectoryMetadata>;
  pagination?: Maybe<SourcrRecruiterDirectorySearchResultPagination>;
  placementTitleMatchAccuracy?: Maybe<Scalars['String']['output']>;
};

export type SourcrRecruiterDirectorySearchFilters = {
  __typename?: 'SourcrRecruiterDirectorySearchFilters';
  locations?: Maybe<Array<Maybe<SourcrRecruiterDirectoryLocationFilter>>>;
  roles?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  specialities?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type SourcrRecruiterDirectorySearchInput = {
  filters?: InputMaybe<Array<InputMaybe<SourcrRecruiterDirectoryFilterInput>>>;
  pagination?: InputMaybe<SourcrRecruiterDirectoryPaginationInput>;
  query?: InputMaybe<Scalars['String']['input']>;
  visitorId?: InputMaybe<Scalars['String']['input']>;
  withBoost?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SourcrRecruiterDirectorySearchRecruiterResult = {
  __typename?: 'SourcrRecruiterDirectorySearchRecruiterResult';
  items?: Maybe<Array<Maybe<SourcrRecruiterDirectoryRecruiter>>>;
  metadata?: Maybe<SourcrRecruiterDirectoryMetadata>;
  pagination?: Maybe<SourcrRecruiterDirectorySearchResultPagination>;
  placementTitleMatchAccuracy?: Maybe<Scalars['String']['output']>;
};

export type SourcrRecruiterDirectorySearchResultPagination = {
  __typename?: 'SourcrRecruiterDirectorySearchResultPagination';
  cursor?: Maybe<Scalars['Int']['output']>;
  pageSize?: Maybe<Scalars['Int']['output']>;
  totalItems?: Maybe<Scalars['Int']['output']>;
};

export type SpecReqProfileField =
  | 'LanguageProficiency'
  | 'LicencesCertifications'
  | 'PreferredLocation'
  | 'PreferredWorkTypes'
  | 'RightToWork'
  | 'Skills';

export type StandardChannel = ApplicationChannel & {
  __typename?: 'StandardChannel';
  label?: Maybe<Scalars['String']['output']>;
};

export type StandardChannellabelArgs = {
  locale: Scalars['Locale']['input'];
};

export type StandardVisibilityOption = ProfileVisibilityOption & {
  __typename?: 'StandardVisibilityOption';
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type StandardVisibilityOptiondescriptionArgs = {
  locale: Scalars['Locale']['input'];
  zone: Scalars['Zone']['input'];
};

export type StandardVisibilityOptionnameArgs = {
  locale: Scalars['Locale']['input'];
};

export type SubClassification = {
  __typename?: 'SubClassification';
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
};

export type SubClassificationInput = {
  id: Scalars['Int']['input'];
};

export type Subject = {
  __typename?: 'Subject';
  /** The Auth0 user id of the subject, eg 'auth0|12eb841a02c489d1'. */
  id: Scalars['String']['output'];
  /**
   * The associated jobseeker id, derived from the "http://seek/claims/user_id" claim.
   * This is optional, as the user in Auth0 may not be associated with a jobseeker record.
   */
  userId?: Maybe<Scalars['String']['output']>;
};

export type SubmitApplicationError = {
  message: Scalars['String']['output'];
};

export type SubmitApplicationErrormessageArgs = {
  locale?: InputMaybe<Scalars['Locale']['input']>;
};

export type SubmitApplicationFailure = {
  __typename?: 'SubmitApplicationFailure';
  errors: Array<SubmitApplicationError>;
};

export type SubmitApplicationInput = {
  correlationId: Scalars['ID']['input'];
  coverLetter?: InputMaybe<CoverLetterInput>;
  jobId: Scalars['ID']['input'];
  mostRecentRole?: InputMaybe<MostRecentRoleInput>;
  personalDetails?: InputMaybe<SubmitApplicationPersonalDetailsInput>;
  priorityApply?: InputMaybe<PriorityApplyInput>;
  profilePrivacyLevel?: InputMaybe<Scalars['String']['input']>;
  questionnaireAnswers?: InputMaybe<Array<QuestionnaireAnswerInput>>;
  referenceCheck?: InputMaybe<ReferenceCheckInput>;
  resume?: InputMaybe<ResumeInput>;
  selectionCriteria?: InputMaybe<SelectionCriteriaInput>;
  zone?: InputMaybe<Scalars['Zone']['input']>;
};

export type SubmitApplicationPayload =
  | SubmitApplicationFailure
  | SubmitApplicationSuccess;

export type SubmitApplicationPersonalDetailsInput = {
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};

export type SubmitApplicationSuccess = {
  __typename?: 'SubmitApplicationSuccess';
  applicationId: Scalars['String']['output'];
  /** @deprecated Use applicationId instead */
  viewer?: Maybe<Candidate>;
};

export type SubmitApplicationValidationError = SubmitApplicationError & {
  __typename?: 'SubmitApplicationValidationError';
  message: Scalars['String']['output'];
};

export type SubmitApplicationValidationErrormessageArgs = {
  locale?: InputMaybe<Scalars['Locale']['input']>;
};

export type SubmitCareerFeedJobsRefinementError = {
  message: Scalars['String']['output'];
};

export type SubmitCareerFeedJobsRefinementFailure = {
  __typename?: 'SubmitCareerFeedJobsRefinementFailure';
  error: SubmitCareerFeedJobsRefinementError;
};

export type SubmitCareerFeedJobsRefinementInput = {
  items: Array<CareerFeedJobsRefinementItemInput>;
  recsServiceToken: Scalars['UUID']['input'];
};

export type SubmitCareerFeedJobsRefinementPayload =
  | SubmitCareerFeedJobsRefinementFailure
  | SubmitCareerFeedJobsRefinementSuccess;

export type SubmitCareerFeedJobsRefinementSuccess = {
  __typename?: 'SubmitCareerFeedJobsRefinementSuccess';
  status: CareerFeedJobsRefinementStatus;
};

export type SubmitFakeDoorRecommendationsRefinementFeedbackError = {
  message: Scalars['String']['output'];
};

export type SubmitFakeDoorRecommendationsRefinementFeedbackErrormessageArgs = {
  locale?: InputMaybe<Scalars['Locale']['input']>;
};

export type SubmitFakeDoorRecommendationsRefinementFeedbackFailure = {
  __typename?: 'SubmitFakeDoorRecommendationsRefinementFeedbackFailure';
  error: SubmitFakeDoorRecommendationsRefinementFeedbackError;
};

export type SubmitFakeDoorRecommendationsRefinementFeedbackInput = {
  country: Scalars['CountryCodeIso2']['input'];
  feedback: Scalars['String']['input'];
};

export type SubmitFakeDoorRecommendationsRefinementFeedbackPayload =
  | SubmitFakeDoorRecommendationsRefinementFeedbackFailure
  | SubmitFakeDoorRecommendationsRefinementFeedbackSuccess;

export type SubmitFakeDoorRecommendationsRefinementFeedbackSuccess = {
  __typename?: 'SubmitFakeDoorRecommendationsRefinementFeedbackSuccess';
  message: Scalars['String']['output'];
};

export type SubmitFakeDoorRecommendationsRefinementFeedbackValidationError =
  SubmitFakeDoorRecommendationsRefinementFeedbackError & {
    __typename?: 'SubmitFakeDoorRecommendationsRefinementFeedbackValidationError';
    message: Scalars['String']['output'];
  };

export type SubmitFakeDoorRecommendationsRefinementFeedbackValidationErrormessageArgs =
  {
    locale?: InputMaybe<Scalars['Locale']['input']>;
  };

export type SubmitSourcrMessagePayload = {
  __typename?: 'SubmitSourcrMessagePayload';
  message?: Maybe<Scalars['String']['output']>;
};

export type SubmitSourcrPageAnalyticsEventPayload = {
  __typename?: 'SubmitSourcrPageAnalyticsEventPayload';
  message?: Maybe<Scalars['String']['output']>;
};

export type SubscribeApacSavedEmailAlertError = {
  message: Scalars['String']['output'];
};

export type SubscribeApacSavedEmailAlertErrormessageArgs = {
  locale?: InputMaybe<Scalars['Locale']['input']>;
};

export type SubscribeApacSavedEmailAlertFailedError =
  SubscribeApacSavedEmailAlertError & {
    __typename?: 'SubscribeApacSavedEmailAlertFailedError';
    message: Scalars['String']['output'];
  };

export type SubscribeApacSavedEmailAlertFailedErrormessageArgs = {
  locale?: InputMaybe<Scalars['Locale']['input']>;
};

export type SubscribeApacSavedEmailAlertFailure = {
  __typename?: 'SubscribeApacSavedEmailAlertFailure';
  errors?: Maybe<Array<SubscribeApacSavedEmailAlertError>>;
};

export type SubscribeApacSavedEmailAlertInput = {
  id: Scalars['ID']['input'];
  subscribe: Scalars['Boolean']['input'];
};

export type SubscribeApacSavedEmailAlertPayload =
  | SubscribeApacSavedEmailAlertFailure
  | SubscribeApacSavedEmailAlertSuccess;

export type SubscribeApacSavedEmailAlertSuccess = {
  __typename?: 'SubscribeApacSavedEmailAlertSuccess';
  savedSearch: ApacSavedSearch;
  subscribed: Scalars['Boolean']['output'];
};

export type SubscribeMobileNoti = {
  appVersion: Scalars['String']['input'];
  deviceToken: Scalars['String']['input'];
  platform: MobilePlatformNoti;
  zone: Scalars['Zone']['input'];
};

export type SubscribeMobileNotiPayload =
  | MobileNotiFailure
  | SubscribeMobileNotiSuccess;

export type SubscribeMobileNotiSuccess = {
  __typename?: 'SubscribeMobileNotiSuccess';
  deviceToken: Scalars['String']['output'];
  platformName: Scalars['String']['output'];
};

export type SuggestionGroupType =
  | 'International'
  | 'Recent'
  | 'Remote'
  | 'Suggestions';

export type SuggestionHighlight = {
  __typename?: 'SuggestionHighlight';
  end: Scalars['Int']['output'];
  start: Scalars['Int']['output'];
};

export type TestTagsInput = {
  testRecord?: InputMaybe<Scalars['Boolean']['input']>;
  testScope?: InputMaybe<Scalars['String']['input']>;
};

export type TopApplicantBadge = {
  __typename?: 'TopApplicantBadge';
  description: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type TopApplicantBadgedescriptionArgs = {
  locale?: Scalars['Locale']['input'];
  zone?: InputMaybe<Scalars['Zone']['input']>;
};

export type TopApplicantBadgelabelArgs = {
  locale?: Scalars['Locale']['input'];
};

export type TrackJobApplicationStartedInput = {
  applicationCorrelationId: Scalars['ID']['input'];
  isProfileApply?: InputMaybe<Scalars['Boolean']['input']>;
  jobId: Scalars['ID']['input'];
  sessionId: Scalars['ID']['input'];
};

export type TrackJobApplicationStartedPayload = {
  __typename?: 'TrackJobApplicationStartedPayload';
  eventId?: Maybe<Scalars['ID']['output']>;
};

export type TrackJobDetailsViewedError = {
  message: Scalars['String']['output'];
};

export type TrackJobDetailsViewedErrormessageArgs = {
  locale?: InputMaybe<Scalars['Locale']['input']>;
};

export type TrackJobDetailsViewedFailure = {
  __typename?: 'TrackJobDetailsViewedFailure';
  error: TrackJobDetailsViewedError;
};

export type TrackJobDetailsViewedInput = {
  candidateId?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Deprecated in favour of a more descriptive field name. Use testTags instead. */
  jobDetailsViewedCorrelationId?: InputMaybe<Scalars['String']['input']>;
  jobId: Scalars['Int']['input'];
  jobseekerSessionId: Scalars['String']['input'];
  omnitureTracking?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<TestTagsInput>;
  testTags?: InputMaybe<TestTagsInput>;
};

export type TrackJobDetailsViewedPayload =
  | TrackJobDetailsViewedFailure
  | TrackJobDetailsViewedSuccess;

export type TrackJobDetailsViewedSuccess = {
  __typename?: 'TrackJobDetailsViewedSuccess';
  eventId?: Maybe<Scalars['String']['output']>;
};

export type TrackSearchResultSelectedError = {
  message: Scalars['String']['output'];
};

export type TrackSearchResultSelectedErrormessageArgs = {
  locale?: InputMaybe<Scalars['Locale']['input']>;
};

export type TrackSearchResultSelectedFailure = {
  __typename?: 'TrackSearchResultSelectedFailure';
  error: TrackSearchResultSelectedError;
};

export type TrackSearchResultSelectedInput = {
  adDisplayType: Scalars['String']['input'];
  isFeatured?: InputMaybe<Scalars['Boolean']['input']>;
  jobId: Scalars['Int']['input'];
  jobseekerSessionId: Scalars['String']['input'];
  tags?: InputMaybe<TestTagsInput>;
  testTags?: InputMaybe<TestTagsInput>;
  /** @deprecated Deprecated in favour of a more descriptive field name. Use testTags instead. */
  userQueryId?: InputMaybe<Scalars['String']['input']>;
};

export type TrackSearchResultSelectedPayload =
  | TrackSearchResultSelectedFailure
  | TrackSearchResultSelectedSuccess;

export type TrackSearchResultSelectedSuccess = {
  __typename?: 'TrackSearchResultSelectedSuccess';
  eventId?: Maybe<Scalars['String']['output']>;
};

export type TrackingInfo = {
  __typename?: 'TrackingInfo';
  events?: Maybe<Array<KeyValue>>;
};

export type TrackingInfoInput = {
  events?: InputMaybe<Array<KeyValueInput>>;
};

export type UnconfirmedContextType = 'Application' | 'PrimaryResume';

export type UnconfirmedData = UnconfirmedDataCompleted | UnconfirmedDataPending;

export type UnconfirmedDataCompleted = {
  __typename?: 'UnconfirmedDataCompleted';
  completed: Scalars['Boolean']['output'];
  qualifications: Array<Qualification>;
  roles: Array<Role>;
};

export type UnconfirmedDataPending = {
  __typename?: 'UnconfirmedDataPending';
  completed: Scalars['Boolean']['output'];
};

export type UnconfirmedDataType = 'CareerHistory' | 'Education';

export type UnknownCreateShareableProfileSettingsError =
  CreateShareableProfileSettingsError & {
    __typename?: 'UnknownCreateShareableProfileSettingsError';
    message: Scalars['String']['output'];
  };

export type UnknownCreateShareableProfileSettingsErrormessageArgs = {
  locale?: InputMaybe<Scalars['Locale']['input']>;
};

export type UnknownDeleteJobPreferencesError = DeleteJobPreferencesError & {
  __typename?: 'UnknownDeleteJobPreferencesError';
  message: Scalars['String']['output'];
};

export type UnknownDeleteJobPreferencesErrormessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type UnknownSaveJobPreferencesError = SaveJobPreferencesError & {
  __typename?: 'UnknownSaveJobPreferencesError';
  message: Scalars['String']['output'];
};

export type UnknownSaveJobPreferencesErrormessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type UnknownUpdateCurrentLocation2Error = UpdateCurrentLocation2Error & {
  __typename?: 'UnknownUpdateCurrentLocation2Error';
  message: Scalars['String']['output'];
};

export type UnknownUpdateCurrentLocation2ErrormessageArgs = {
  locale?: InputMaybe<Scalars['Locale']['input']>;
};

export type UnknownUpdatePreferredLocations2Error =
  UpdatePreferredLocations2Error & {
    __typename?: 'UnknownUpdatePreferredLocations2Error';
    message: Scalars['String']['output'];
  };

export type UnknownUpdatePreferredLocations2ErrormessageArgs = {
  locale?: InputMaybe<Scalars['Locale']['input']>;
};

export type UnknownUpdateShareableProfileSettingsError =
  UpdateShareableProfileSettingsError & {
    __typename?: 'UnknownUpdateShareableProfileSettingsError';
    message: Scalars['String']['output'];
  };

export type UnknownUpdateShareableProfileSettingsErrormessageArgs = {
  locale?: InputMaybe<Scalars['Locale']['input']>;
};

export type UnknownUpdateShareableProfileViewsError =
  UpdateShareableProfileViewsError & {
    __typename?: 'UnknownUpdateShareableProfileViewsError';
    message: Scalars['String']['output'];
  };

export type UnknownUpdateShareableProfileViewsErrormessageArgs = {
  locale?: InputMaybe<Scalars['Locale']['input']>;
};

export type UnrestrictedPublicProfileDigitalIdentity = {
  __typename?: 'UnrestrictedPublicProfileDigitalIdentity';
  /** Whether the candidate has verified identity */
  isVerified: Scalars['Boolean']['output'];
  /** Verified Name */
  verifiedName?: Maybe<Scalars['String']['output']>;
};

export type UnrestrictedPublicProfileSearchResult =
  PublicProfileSearchResult & {
    __typename?: 'UnrestrictedPublicProfileSearchResult';
    /** The candidate's verified identity details */
    digitalIdentity?: Maybe<UnrestrictedPublicProfileDigitalIdentity>;
    /** The candidate profile first name */
    firstName: Scalars['String']['output'];
    /** Whether the candidate has verified credentials */
    hasVerifiedCredentials: Scalars['Boolean']['output'];
    /** The candidate profile home location */
    homeLocation: PublicProfileLocation;
    /** True if the profile is owned by the logged in user */
    isOwnedByLoggedInUser: Scalars['Boolean']['output'];
    /** The candidate profile last name */
    lastName: Scalars['String']['output'];
    /** The candidate's profile avatar URLs in different sizes */
    profileAvatarUrls?: Maybe<PublicProfileAvatarUrls>;
    /** The candidate profile id */
    slug: Scalars['ID']['output'];
    /** The candidate's work history, */
    workHistories: Array<UnrestrictedPublicProfileWorkHistory>;
  };

export type UnrestrictedPublicProfileView = PublicProfileView & {
  __typename?: 'UnrestrictedPublicProfileView';
  /** The candidate's verified identity details */
  digitalIdentity?: Maybe<UnrestrictedPublicProfileDigitalIdentity>;
  /** The candidate's educational qualifications */
  education: Array<PublicProfileEducation>;
  /** The candidate profile first name */
  firstName: Scalars['String']['output'];
  /** Whether the candidate has verified credentials */
  hasVerifiedCredentials: Scalars['Boolean']['output'];
  /** The candidate profile home location */
  homeLocation: PublicProfileLocation;
  /** True if the profile is owned by the logged in user */
  isOwnedByLoggedInUser: Scalars['Boolean']['output'];
  /** The candidate's languages */
  languages: Array<Scalars['String']['output']>;
  /** The candidate profile last name */
  lastName: Scalars['String']['output'];
  /** The candidate's licences */
  licences: Array<PublicProfileLicence>;
  /** The candidate's personal summary */
  personalSummary?: Maybe<Scalars['String']['output']>;
  /** The candidate's profile avatar URLs in different sizes */
  profileAvatarUrls?: Maybe<PublicProfileAvatarUrls>;
  /** The candidate's profile GUID, used for tracking and analytics. */
  profileGuid: Scalars['UUID']['output'];
  /** The candidate's rights to work information */
  rightsToWork: Array<PublicProfileRightToWork>;
  /** The candidate's skills */
  skills: Array<Scalars['String']['output']>;
  /** The candidate profile id */
  slug: Scalars['ID']['output'];
  /** The candidate's work history, */
  workHistories: Array<UnrestrictedPublicProfileWorkHistory>;
};

export type UnrestrictedPublicProfileWorkHistory = {
  __typename?: 'UnrestrictedPublicProfileWorkHistory';
  /** The candidate profile achievements */
  achievements?: Maybe<Scalars['String']['output']>;
  /** The candidate profile company name */
  companyName: Scalars['String']['output'];
  /** The candidate's work duration counted in months and years using inclusive calculation where both start and end months are included (e.g., Jan 2025 to Mar 2025 = 3 months). */
  duration: PublicProfileInclusiveWorkDuration;
  /** The candidate profile job title */
  roleTitle: Scalars['String']['output'];
};

export type UnsubscribeApacSavedSearchByCodeError = {
  __typename?: 'UnsubscribeApacSavedSearchByCodeError';
  message: Scalars['String']['output'];
};

export type UnsubscribeApacSavedSearchByCodeErrormessageArgs = {
  locale?: InputMaybe<Scalars['Locale']['input']>;
};

export type UnsubscribeApacSavedSearchByCodeFailure = {
  __typename?: 'UnsubscribeApacSavedSearchByCodeFailure';
  error: UnsubscribeApacSavedSearchByCodeError;
};

/** Unsubscribe By Code */
export type UnsubscribeApacSavedSearchByCodeInput = {
  code: Scalars['String']['input'];
};

export type UnsubscribeApacSavedSearchByCodePayload =
  | UnsubscribeApacSavedSearchByCodeFailure
  | UnsubscribeApacSavedSearchByCodeSuccess;

export type UnsubscribeApacSavedSearchByCodeSuccess = {
  __typename?: 'UnsubscribeApacSavedSearchByCodeSuccess';
  id: Scalars['ID']['output'];
  type: Scalars['String']['output'];
};

export type UnsubscribeMobileNoti = {
  deviceToken: Scalars['String']['input'];
  zone: Scalars['Zone']['input'];
};

export type UnsubscribeMobileNotiPayload =
  | MobileNotiFailure
  | UnsubscribeMobileNotiSuccess;

export type UnsubscribeMobileNotiSuccess = {
  __typename?: 'UnsubscribeMobileNotiSuccess';
  deviceToken: Scalars['String']['output'];
};

export type UnverifiedPublicProfileEducation = PublicProfileEducation & {
  __typename?: 'UnverifiedPublicProfileEducation';
  /** The completion status of the education. */
  completion: PublicProfileEducationCompletion;
  /** The highlights of the educational qualification */
  highlights?: Maybe<Scalars['String']['output']>;
  /** The name of the educational institution */
  institute: Scalars['String']['output'];
  /** The name of the educational qualification */
  name: Scalars['String']['output'];
};

export type UnverifiedPublicProfileLicence = PublicProfileLicence & {
  __typename?: 'UnverifiedPublicProfileLicence';
  /** The user defined description of the licence */
  description?: Maybe<Scalars['String']['output']>;
  /** The name of the organization that issued the licence */
  issuingOrganisation?: Maybe<Scalars['String']['output']>;
  /** The name of the licence */
  name: Scalars['String']['output'];
};

export type UpdateApproachabilityInput = {
  approachable: Scalars['Boolean']['input'];
};

export type UpdateApproachabilityPayload = {
  __typename?: 'UpdateApproachabilityPayload';
  /** @deprecated Please use viewer.approachability */
  ref?: Maybe<Scalars['UUID']['output']>;
  viewer?: Maybe<Candidate>;
};

export type UpdateAvailabilityInput = {
  id: Scalars['Int']['input'];
};

export type UpdateCareerObjectivesInput = {
  personalStatement: Scalars['String']['input'];
};

export type UpdateCareerObjectivesPayload = {
  __typename?: 'UpdateCareerObjectivesPayload';
  /** @deprecated Please use `viewer.careerObjectives.personalStatement` instead */
  personalStatement: Scalars['String']['output'];
  viewer?: Maybe<Candidate>;
};

export type UpdateClassificationInput = {
  classification: ClassificationInput;
};

export type UpdateCurrentLocation2Error = {
  message: Scalars['String']['output'];
};

export type UpdateCurrentLocation2ErrormessageArgs = {
  locale?: InputMaybe<Scalars['Locale']['input']>;
};

export type UpdateCurrentLocation2Failure = {
  __typename?: 'UpdateCurrentLocation2Failure';
  error: UpdateCurrentLocation2Error;
};

export type UpdateCurrentLocation2Input = {
  currentLocation: CurrentLocation2Input;
};

export type UpdateCurrentLocation2Payload =
  | UpdateCurrentLocation2Failure
  | UpdateCurrentLocation2Success;

export type UpdateCurrentLocation2Success = {
  __typename?: 'UpdateCurrentLocation2Success';
  viewer?: Maybe<Candidate>;
};

export type UpdateLanguageProficiencyInput = {
  id: Scalars['UUID']['input'];
  name: OntologyStructuredDataInput;
};

export type UpdateLanguageProficiencyPayload = {
  __typename?: 'UpdateLanguageProficiencyPayload';
  viewer?: Maybe<Candidate>;
};

export type UpdateLicenceInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  expiryDate?: InputMaybe<MonthYearInput>;
  id: Scalars['UUID']['input'];
  issueDate?: InputMaybe<MonthYearInput>;
  issuingOrganisation?: InputMaybe<Scalars['String']['input']>;
  name: OntologyStructuredDataInput;
  noExpiryDate: Scalars['Boolean']['input'];
};

export type UpdateLicencePayload = {
  __typename?: 'UpdateLicencePayload';
  viewer?: Maybe<Candidate>;
};

export type UpdateMarketInsightsPreferencesConflictError =
  UpdateMarketInsightsPreferencesError & {
    __typename?: 'UpdateMarketInsightsPreferencesConflictError';
    message: Scalars['String']['output'];
  };

export type UpdateMarketInsightsPreferencesConflictErrormessageArgs = {
  locale?: InputMaybe<Scalars['Locale']['input']>;
};

export type UpdateMarketInsightsPreferencesError = {
  message: Scalars['String']['output'];
};

export type UpdateMarketInsightsPreferencesErrormessageArgs = {
  locale?: InputMaybe<Scalars['Locale']['input']>;
};

export type UpdateMarketInsightsPreferencesFailure = {
  __typename?: 'UpdateMarketInsightsPreferencesFailure';
  error: UpdateMarketInsightsPreferencesError;
};

export type UpdateMarketInsightsPreferencesInput = {
  location: CareerFeedInsightsLocationInput;
  role: CareerFeedInsightsRoleInput;
};

export type UpdateMarketInsightsPreferencesPayload =
  | UpdateMarketInsightsPreferencesFailure
  | UpdateMarketInsightsPreferencesSuccess;

export type UpdateMarketInsightsPreferencesSuccess = {
  __typename?: 'UpdateMarketInsightsPreferencesSuccess';
  message: Scalars['String']['output'];
};

export type UpdateMarketInsightsPreferencesValidationError =
  UpdateMarketInsightsPreferencesError & {
    __typename?: 'UpdateMarketInsightsPreferencesValidationError';
    message: Scalars['String']['output'];
  };

export type UpdateMarketInsightsPreferencesValidationErrormessageArgs = {
  locale?: InputMaybe<Scalars['Locale']['input']>;
};

export type UpdateNoticePeriodInput = {
  weeks: Scalars['Int']['input'];
};

export type UpdateNoticePeriodPayload = {
  __typename?: 'UpdateNoticePeriodPayload';
  /** @deprecated Use viewer.noticePeriod */
  ref?: Maybe<Scalars['UUID']['output']>;
  viewer?: Maybe<Candidate>;
};

export type UpdateNotificationCtpPreferenceError =
  NotificationCtpPreferenceError & {
    __typename?: 'UpdateNotificationCtpPreferenceError';
    errorCode?: Maybe<Scalars['Int']['output']>;
    message: Scalars['String']['output'];
  };

export type UpdateNotificationCtpPreferenceErrormessageArgs = {
  locale?: InputMaybe<Scalars['Locale']['input']>;
};

export type UpdateNotificationCtpPreferenceFailure = {
  __typename?: 'UpdateNotificationCtpPreferenceFailure';
  error: NotificationCtpPreferenceError;
};

export type UpdateNotificationCtpPreferenceInput = {
  onlyProductionOption?: Scalars['Boolean']['input'];
  preferences: Array<NotificationCtpPreferencesInput>;
  zone: Scalars['Zone']['input'];
};

export type UpdateNotificationCtpPreferencesPayload =
  | UpdateNotificationCtpPreferenceFailure
  | UpdateNotificationCtpPreferencesSuccess;

export type UpdateNotificationCtpPreferencesSuccess = {
  __typename?: 'UpdateNotificationCtpPreferencesSuccess';
  success: Array<NotificationCTPPreferenceGroup>;
};

export type UpdateNotificationCtpSubscriptionWithTokenPayload =
  | UpdateNotificationCtpPreferenceFailure
  | UpdateNotificationCtpSubscriptionWithTokenSuccess;

export type UpdateNotificationCtpSubscriptionWithTokenSuccess = {
  __typename?: 'UpdateNotificationCtpSubscriptionWithTokenSuccess';
  product: NotificationCTPProduct;
  subscribed: Scalars['Boolean']['output'];
  subscriptionChannel: NotificationCTPChannel;
};

export type UpdatePersonalDetailsInput = {
  countryCallingCode?: InputMaybe<CountryCallingCodeInput>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  /** *Note*: Nationality will be phased out as part of unification. Currently kept to support functionalies in SEEK Asia platforms. */
  nationality?: InputMaybe<NationalityInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePersonalDetailsPayload = {
  __typename?: 'UpdatePersonalDetailsPayload';
  /** @deprecated use viewer.personalDetails instead */
  personalDetails: PersonalDetails;
  viewer?: Maybe<Candidate>;
};

export type UpdatePreferredClassificationPayload = {
  __typename?: 'UpdatePreferredClassificationPayload';
  /** @deprecated Use viewer.preferredClassification */
  ref?: Maybe<Scalars['UUID']['output']>;
  viewer?: Maybe<Candidate>;
};

export type UpdatePreferredLocations2Error = {
  message: Scalars['String']['output'];
};

export type UpdatePreferredLocations2ErrormessageArgs = {
  locale?: InputMaybe<Scalars['Locale']['input']>;
};

export type UpdatePreferredLocations2Failure = {
  __typename?: 'UpdatePreferredLocations2Failure';
  error: UpdatePreferredLocations2Error;
};

export type UpdatePreferredLocations2Input = {
  preferredLocations: Array<PreferredLocation2Input>;
};

export type UpdatePreferredLocations2Payload =
  | UpdatePreferredLocations2Failure
  | UpdatePreferredLocations2Success;

export type UpdatePreferredLocations2Success = {
  __typename?: 'UpdatePreferredLocations2Success';
  viewer?: Maybe<Candidate>;
};

export type UpdatePreferredRoleTitlesError = {
  message: Scalars['String']['output'];
};

export type UpdatePreferredRoleTitlesErrormessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type UpdatePreferredRoleTitlesFailure = {
  __typename?: 'UpdatePreferredRoleTitlesFailure';
  errors: Array<UpdatePreferredRoleTitlesError>;
};

export type UpdatePreferredRoleTitlesInput = {
  preferredRoleTitles: Array<OntologyStructuredDataInput>;
};

export type UpdatePreferredRoleTitlesPayload =
  | UpdatePreferredRoleTitlesFailure
  | UpdatePreferredRoleTitlesSuccess;

export type UpdatePreferredRoleTitlesSuccess = {
  __typename?: 'UpdatePreferredRoleTitlesSuccess';
  viewer?: Maybe<Candidate>;
};

export type UpdatePreferredWorkTypesInput = {
  ids: Array<Scalars['Int']['input']>;
};

export type UpdateProfileVisibility2Failure = {
  __typename?: 'UpdateProfileVisibility2Failure';
  error: UpdateProfileVisibilityError;
};

export type UpdateProfileVisibility2Input = {
  id: Scalars['ProfileVisibilityLevel']['input'];
};

export type UpdateProfileVisibility2Payload =
  | UpdateProfileVisibility2Failure
  | UpdateProfileVisibility2Success;

export type UpdateProfileVisibility2Success = {
  __typename?: 'UpdateProfileVisibility2Success';
  viewer?: Maybe<Candidate>;
};

export type UpdateProfileVisibilityError = {
  message: Scalars['String']['output'];
};

export type UpdateProfileVisibilityErrormessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type UpdateProfileVisibilityInput = {
  level: VisibilityLevel;
};

export type UpdateProfileVisibilityPayload = {
  __typename?: 'UpdateProfileVisibilityPayload';
  /** @deprecated Use viewer.profileVisibility */
  ref?: Maybe<Scalars['String']['output']>;
  viewer?: Maybe<Candidate>;
};

export type UpdateQualificationInput = {
  completed: Scalars['Boolean']['input'];
  completionYear?: InputMaybe<Scalars['Int']['input']>;
  expectedCompletionDate?: InputMaybe<MonthYearInput>;
  highlights?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  institute: OntologyStructuredDataInput;
  name: OntologyStructuredDataInput;
};

export type UpdateQualificationPayload = {
  __typename?: 'UpdateQualificationPayload';
  /**
   * qualification does not have translation support due to it being deprecated
   * @deprecated Use `viewer.qualification`
   */
  qualification?: Maybe<Qualification>;
  viewer?: Maybe<Candidate>;
};

export type UpdateRightToWorkInput = {
  /** Country associated with the right to work */
  countryCode: Scalars['CountryCodeIso2']['input'];
  /** Unique ID that identifies a specific right to work */
  id: Scalars['UUID']['input'];
  /** Candidate's right to work for a specific country */
  type2?: InputMaybe<RightToWorkType2Input>;
};

export type UpdateRightsToWorkInput = {
  /** List of rights to work to update */
  rightsToWork: Array<UpdateRightToWorkInput>;
};

export type UpdateRightsToWorkPayload = {
  __typename?: 'UpdateRightsToWorkPayload';
  viewer?: Maybe<Candidate>;
};

export type UpdateRoleInput = {
  achievements?: InputMaybe<Scalars['String']['input']>;
  company: OntologyStructuredDataInput;
  from: MonthYearInput;
  /** Required for JobsDB only */
  function?: InputMaybe<RoleFunctionInput>;
  id: Scalars['UUID']['input'];
  /** Required for JobsDB only */
  industry?: InputMaybe<RoleIndustryInput>;
  seniority?: InputMaybe<OntologyStructuredDataInput>;
  title: OntologyStructuredDataInput;
  to?: InputMaybe<MonthYearInput>;
};

export type UpdateRolePayload = {
  __typename?: 'UpdateRolePayload';
  /** @deprecated Use viewer.roles */
  role?: Maybe<Role>;
  viewer?: Maybe<Candidate>;
};

export type UpdateSalaryPreferencesInput = {
  /** List of salary preferences to update */
  salaryPreferences: Array<SalaryPreference2Input>;
};

export type UpdateSalaryPreferencesPayload = {
  __typename?: 'UpdateSalaryPreferencesPayload';
  viewer?: Maybe<Candidate>;
};

export type UpdateSeekMaxMyThreadsLastViewedError = {
  message: Scalars['String']['output'];
};

export type UpdateSeekMaxMyThreadsLastViewedErrormessageArgs = {
  locale: Scalars['Locale']['input'];
};

export type UpdateSeekMaxMyThreadsLastViewedFailure = {
  __typename?: 'UpdateSeekMaxMyThreadsLastViewedFailure';
  errors: Array<UpdateSeekMaxMyThreadsLastViewedError>;
};

export type UpdateSeekMaxMyThreadsLastViewedInput = {
  zone: Scalars['Zone']['input'];
};

export type UpdateSeekMaxMyThreadsLastViewedPayload =
  | UpdateSeekMaxMyThreadsLastViewedFailure
  | UpdateSeekMaxMyThreadsLastViewedSuccess;

export type UpdateSeekMaxMyThreadsLastViewedSuccess = {
  __typename?: 'UpdateSeekMaxMyThreadsLastViewedSuccess';
  success: Scalars['Boolean']['output'];
};

export type UpdateShareableProfileSettingsError = {
  message: Scalars['String']['output'];
};

export type UpdateShareableProfileSettingsErrormessageArgs = {
  locale?: InputMaybe<Scalars['Locale']['input']>;
};

export type UpdateShareableProfileSettingsFailure = {
  __typename?: 'UpdateShareableProfileSettingsFailure';
  error: UpdateShareableProfileSettingsError;
};

export type UpdateShareableProfileSettingsInput = {
  active: Scalars['Boolean']['input'];
  privacy?: InputMaybe<PrivacyInput>;
};

export type UpdateShareableProfileSettingsPayload =
  | UpdateShareableProfileSettingsFailure
  | UpdateShareableProfileSettingsSuccess;

export type UpdateShareableProfileSettingsSuccess = {
  __typename?: 'UpdateShareableProfileSettingsSuccess';
  viewer?: Maybe<Candidate>;
};

export type UpdateShareableProfileViewsError = {
  message: Scalars['String']['output'];
};

export type UpdateShareableProfileViewsErrormessageArgs = {
  locale?: InputMaybe<Scalars['Locale']['input']>;
};

export type UpdateShareableProfileViewsFailure = {
  __typename?: 'UpdateShareableProfileViewsFailure';
  error: UpdateShareableProfileViewsError;
};

export type UpdateShareableProfileViewsInput = {
  profileSlug: Scalars['String']['input'];
};

export type UpdateShareableProfileViewsPayload =
  | UpdateShareableProfileViewsFailure
  | UpdateShareableProfileViewsSuccess;

export type UpdateShareableProfileViewsSuccess = {
  __typename?: 'UpdateShareableProfileViewsSuccess';
  ref: Scalars['UUID']['output'];
};

export type UpdateSkillsInput = {
  skills: Array<SkillInput>;
};

export type UpdateSkillsPayload = {
  __typename?: 'UpdateSkillsPayload';
  /** @deprecated Use `viewer.skills` instead */
  skills?: Maybe<Array<Skill>>;
  viewer?: Maybe<Candidate>;
};

export type UpdateVerifiedLicenceInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
};

export type UpdateVerifiedLicencePayload = {
  __typename?: 'UpdateVerifiedLicencePayload';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
};

export type UpdateVerifiedQualificationInput = {
  highlights?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
};

export type UpdateVerifiedQualificationPayload = {
  __typename?: 'UpdateVerifiedQualificationPayload';
  viewer?: Maybe<Candidate>;
};

export type UpdateWorkTypesPayload = {
  __typename?: 'UpdateWorkTypesPayload';
  /** @deprecated Use viewer.workTypes */
  ref?: Maybe<Scalars['UUID']['output']>;
  viewer?: Maybe<Candidate>;
};

export type UpdateYearsOfExperienceInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  newToWorkforce: Scalars['Boolean']['input'];
};

export type UpdateYearsOfExperiencePayload = {
  __typename?: 'UpdateYearsOfExperiencePayload';
  viewer?: Maybe<Candidate>;
};

export type Upvotes = {
  __typename?: 'Upvotes';
  count: Scalars['Int']['output'];
  description: Scalars['String']['output'];
  userIds?: Maybe<Array<Scalars['String']['output']>>;
};

export type UpvotesdescriptionArgs = {
  locale?: Scalars['Locale']['input'];
};

export type UrgentJobDisplayTag = JobDisplayTag & {
  __typename?: 'UrgentJobDisplayTag';
  label: Scalars['String']['output'];
};

export type UrgentJobDisplayTaglabelArgs = {
  locale: Scalars['Locale']['input'];
};

export type UserCookie = {
  __typename?: 'UserCookie';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type VerifiableCredential = {
  __typename?: 'VerifiableCredential';
  label: Scalars['String']['output'];
  type: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type VerifiableCredentialCategory = {
  __typename?: 'VerifiableCredentialCategory';
  credentials?: Maybe<Array<BaseVerifiableCredential>>;
  label: Scalars['String']['output'];
  pendingCount?: Maybe<Scalars['Int']['output']>;
};

export type VerifiableCredentialGroup = {
  __typename?: 'VerifiableCredentialGroup';
  credentials: Array<VerifiableCredential>;
  label: Scalars['String']['output'];
};

export type VerifiableCredentialNudge = {
  __typename?: 'VerifiableCredentialNudge';
  credential: VerifiableCredential;
};

export type VerifiableCredentialNudge2 = {
  __typename?: 'VerifiableCredentialNudge2';
  credential: BaseVerifiableCredential;
};

export type VerificationNudge = {
  __typename?: 'VerificationNudge';
  ctaLabel: Scalars['String']['output'];
  ctaUrl: Scalars['String']['output'];
  description: Scalars['String']['output'];
  rank: Scalars['Int']['output'];
  /** uri may be an empty string as Digital ID nudges do not have a uri. */
  uri: Scalars['String']['output'];
  verificationType: Array<Scalars['String']['output']>;
};

export type Verifications = {
  __typename?: 'Verifications';
  nudge?: Maybe<VerificationsNudge>;
  pending?: Maybe<Array<PendingCredentialGroup>>;
  verifiable: Array<VerifiableCredentialGroup>;
  verified: Array<VerifiedCredentialGroup>;
};

export type VerificationsNudge =
  | VerifiableCredentialNudge
  | VerificationsOpenDetailsNudge;

export type VerificationsNudge2 =
  | VerifiableCredentialNudge2
  | VerificationsOpenDetailsNudge;

export type VerificationsOpenDetailsNudge = {
  __typename?: 'VerificationsOpenDetailsNudge';
  ref: Scalars['UUID']['output'];
};

export type VerificationsTestVariant =
  | 'IDENTITY'
  | 'OPENDETAILS'
  | 'VERIFIEDWORKEMAIL';

export type VerifiedCredential = {
  __typename?: 'VerifiedCredential';
  credentialInfo: Array<CredentialInfo>;
  label: Scalars['String']['output'];
};

export type VerifiedCredential2 = {
  __typename?: 'VerifiedCredential2';
  credentialInfo: Array<CredentialInfo>;
  /** String to indicate the type of credential used for frontend tracking, e.g. identity, workplace */
  credentialType: Scalars['String']['output'];
  expiryStatus?: Maybe<CredentialExpiryStatus>;
  label: Scalars['String']['output'];
};

export type VerifiedCredentialCategory = {
  __typename?: 'VerifiedCredentialCategory';
  credentials?: Maybe<Array<VerifiedCredential2>>;
  label: Scalars['String']['output'];
};

export type VerifiedCredentialGroup = {
  __typename?: 'VerifiedCredentialGroup';
  credentials: Array<VerifiedCredential>;
  label: Scalars['String']['output'];
};

export type VerifiedIdentity = {
  __typename?: 'VerifiedIdentity';
  isMatchingProfileName?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated use name */
  label?: Maybe<Scalars['String']['output']>;
  manageVerificationUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  verificationUrl?: Maybe<Scalars['String']['output']>;
};

export type VerifiedPublicProfileEducation = PublicProfileEducation & {
  __typename?: 'VerifiedPublicProfileEducation';
  /** The name of the educational qualification */
  name: Scalars['String']['output'];
};

export type VerifiedPublicProfileLicence = PublicProfileLicence & {
  __typename?: 'VerifiedPublicProfileLicence';
  /** The name of the licence */
  name: Scalars['String']['output'];
};

export type VideoProduct = {
  __typename?: 'VideoProduct';
  position: VideoProductPosition;
  url: Scalars['String']['output'];
};

export type VideoProductPosition = 'BOTTOM' | 'TOP';

export type VirusScanStatus = 'HasVirus' | 'OK' | 'Pending' | 'Unknown';

export type VisibilityLevel = 'Hidden' | 'Limited' | 'Standard';

export type VisitorContextInput = {
  /** visitorId from client */
  key: Scalars['UUID']['input'];
};

export type Website = {
  __typename?: 'Website';
  displayName: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type WorkArrangementOption = {
  __typename?: 'WorkArrangementOption';
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type WorkArrangementOptionlabelArgs = {
  locale: Scalars['Locale']['input'];
};

export type WorkType = {
  __typename?: 'WorkType';
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
};

export type WorkTypeTaxonomyOption = {
  __typename?: 'WorkTypeTaxonomyOption';
  /** Human readable string used when the user is selecting a work type option. */
  description: Scalars['String']['output'];
  /** Unique ID used to identify a specific work type option */
  id: Scalars['Int']['output'];
};

export type WorkplaceVerifiableCredential = BaseVerifiableCredential & {
  __typename?: 'WorkplaceVerifiableCredential';
  label: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type WrongPasswordError = I18nAccountError & {
  __typename?: 'WrongPasswordError';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  reason: Scalars['String']['output'];
};

export type WrongPasswordErrormessageArgs = {
  locale?: InputMaybe<Scalars['Locale']['input']>;
};

export type Year = {
  __typename?: 'Year';
  year: Scalars['Int']['output'];
};

/**
 * DEPRECATED: This entire years-of-experience module is deprecated and will be removed in future releases.
 * It is no longer used in production after unification.
 */
export type YearsOfExperience = {
  __typename?: 'YearsOfExperience';
  /**
   * Whether or not the candidate is new to the workforce
   * @deprecated No longer used in production after unification.
   */
  newToWorkforce: Scalars['Boolean']['output'];
  /**
   * The years of experience option chosen by the candidate
   * @deprecated No longer used in production after unification.
   */
  option?: Maybe<YearsOfExperienceOption>;
};

export type YearsOfExperienceOption = {
  __typename?: 'YearsOfExperienceOption';
  /** @deprecated No longer used in production after unification. */
  description: Scalars['String']['output'];
  /** @deprecated No longer used in production after unification. */
  id: Scalars['ID']['output'];
};

export type PostProfileReportMutationVariables = Exact<{
  input: ReportProfileInput;
}>;

export type PostProfileReportMutation = {
  __typename?: 'Mutation';
  reportProfile?: {
    __typename?: 'ReportProfileSuccessPayload';
    profileSlug: string;
  } | null;
};

export type GetCandidateDetailsQueryVariables = Exact<{ [key: string]: never }>;

export type GetCandidateDetailsQuery = {
  __typename?: 'Query';
  viewer?: {
    __typename?: 'Candidate';
    id: number;
    emailAddress: any;
    trackingId: string;
    personalDetails: {
      __typename?: 'PersonalDetails';
      firstName?: string | null;
    };
    identity: {
      __typename?: 'Identity';
      actor?: { __typename?: 'Actor'; id: string } | null;
    };
    profileVisibility2?:
      | { __typename?: 'HiddenVisibilityOption'; id: string }
      | { __typename?: 'LimitedVisibilityOption'; id: string }
      | { __typename?: 'PublicVisibilityOption'; id: string }
      | { __typename?: 'StandardVisibilityOption'; id: string }
      | null;
    profileAvatar?: {
      __typename?: 'ProfileAvatar';
      id: string;
      image128Url?: string | null;
    } | null;
  } | null;
};

export type PublicProfileSearchQueryVariables = Exact<{
  input: PublicProfileSearchInput;
  locale: Scalars['Locale']['input'];
}>;

export type PublicProfileSearchQuery = {
  __typename?: 'Query';
  publicProfileSearch?: {
    __typename?: 'PublicProfileSearchResults';
    serviceToken: any;
    exactMatches: Array<{
      __typename?: 'PublicProfileSearchResultEdge';
      node:
        | {
            __typename?: 'RestrictedPublicProfileSearchResult';
            firstName: string;
            lastName: string;
            hasVerifiedCredentials: boolean;
            slug: string;
            homeLocation: {
              __typename?: 'PublicProfileLocation';
              label?: string | null;
            };
            workHistories: Array<{
              __typename?: 'RestrictedPublicProfileWorkHistory';
              companyName: string;
              roleTitle: string;
            }>;
            digitalIdentity?: {
              __typename?: 'RestrictedPublicProfileDigitalIdentity';
              isVerified: boolean;
            } | null;
            profileAvatarUrls?: {
              __typename?: 'PublicProfileAvatarUrls';
              image128Url?: string | null;
              image256Url?: string | null;
              image512Url?: string | null;
            } | null;
          }
        | {
            __typename?: 'UnrestrictedPublicProfileSearchResult';
            firstName: string;
            lastName: string;
            hasVerifiedCredentials: boolean;
            isOwnedByLoggedInUser: boolean;
            slug: string;
            homeLocation: {
              __typename?: 'PublicProfileLocation';
              label?: string | null;
            };
            workHistories: Array<{
              __typename?: 'UnrestrictedPublicProfileWorkHistory';
              companyName: string;
              roleTitle: string;
              achievements?: string | null;
              duration: {
                __typename?: 'PublicProfileInclusiveWorkDuration';
                label?: string | null;
              };
            }>;
            digitalIdentity?: {
              __typename?: 'UnrestrictedPublicProfileDigitalIdentity';
              verifiedName?: string | null;
              isVerified: boolean;
            } | null;
            profileAvatarUrls?: {
              __typename?: 'PublicProfileAvatarUrls';
              image128Url?: string | null;
              image256Url?: string | null;
              image512Url?: string | null;
            } | null;
          };
    }>;
    partialMatches: Array<{
      __typename?: 'PublicProfileSearchResultEdge';
      node:
        | {
            __typename?: 'RestrictedPublicProfileSearchResult';
            firstName: string;
            lastName: string;
            hasVerifiedCredentials: boolean;
            slug: string;
            homeLocation: {
              __typename?: 'PublicProfileLocation';
              label?: string | null;
            };
            workHistories: Array<{
              __typename?: 'RestrictedPublicProfileWorkHistory';
              companyName: string;
              roleTitle: string;
            }>;
            digitalIdentity?: {
              __typename?: 'RestrictedPublicProfileDigitalIdentity';
              isVerified: boolean;
            } | null;
            profileAvatarUrls?: {
              __typename?: 'PublicProfileAvatarUrls';
              image128Url?: string | null;
              image256Url?: string | null;
              image512Url?: string | null;
            } | null;
          }
        | {
            __typename?: 'UnrestrictedPublicProfileSearchResult';
            firstName: string;
            lastName: string;
            hasVerifiedCredentials: boolean;
            isOwnedByLoggedInUser: boolean;
            slug: string;
            homeLocation: {
              __typename?: 'PublicProfileLocation';
              label?: string | null;
            };
            workHistories: Array<{
              __typename?: 'UnrestrictedPublicProfileWorkHistory';
              companyName: string;
              roleTitle: string;
              achievements?: string | null;
              duration: {
                __typename?: 'PublicProfileInclusiveWorkDuration';
                label?: string | null;
              };
            }>;
            digitalIdentity?: {
              __typename?: 'UnrestrictedPublicProfileDigitalIdentity';
              verifiedName?: string | null;
              isVerified: boolean;
            } | null;
            profileAvatarUrls?: {
              __typename?: 'PublicProfileAvatarUrls';
              image128Url?: string | null;
              image256Url?: string | null;
              image512Url?: string | null;
            } | null;
          };
    }>;
    pageInfo: {
      __typename?: 'PublicProfileSearchResultsPageInfo';
      totalExactMatches: number;
      totalPartialMatches: number;
      totalMatches: number;
    };
  } | null;
};

export type PublicProfileViewQueryVariables = Exact<{
  input: PublicProfileViewInput;
  locale: Scalars['Locale']['input'];
}>;

export type PublicProfileViewQuery = {
  __typename?: 'Query';
  publicProfileView?:
    | {
        __typename: 'RestrictedPublicProfileView';
        slug: string;
        firstName: string;
        lastName: string;
        hasVerifiedCredentials: boolean;
        profileGuid: any;
        profileAvatarUrls?: {
          __typename?: 'PublicProfileAvatarUrls';
          image128Url?: string | null;
          image256Url?: string | null;
          image512Url?: string | null;
        } | null;
        homeLocation: {
          __typename?: 'PublicProfileLocation';
          label?: string | null;
        };
        workHistories: Array<{
          __typename?: 'RestrictedPublicProfileWorkHistory';
          companyName: string;
          roleTitle: string;
        }>;
        digitalIdentity?: {
          __typename?: 'RestrictedPublicProfileDigitalIdentity';
          isVerified: boolean;
        } | null;
      }
    | {
        __typename: 'UnrestrictedPublicProfileView';
        slug: string;
        firstName: string;
        lastName: string;
        hasVerifiedCredentials: boolean;
        personalSummary?: string | null;
        skills: Array<string>;
        languages: Array<string>;
        isOwnedByLoggedInUser: boolean;
        profileGuid: any;
        profileAvatarUrls?: {
          __typename?: 'PublicProfileAvatarUrls';
          image128Url?: string | null;
          image256Url?: string | null;
          image512Url?: string | null;
        } | null;
        homeLocation: {
          __typename?: 'PublicProfileLocation';
          label?: string | null;
        };
        workHistories: Array<{
          __typename?: 'UnrestrictedPublicProfileWorkHistory';
          companyName: string;
          roleTitle: string;
          achievements?: string | null;
          duration: {
            __typename?: 'PublicProfileInclusiveWorkDuration';
            label?: string | null;
          };
        }>;
        digitalIdentity?: {
          __typename?: 'UnrestrictedPublicProfileDigitalIdentity';
          verifiedName?: string | null;
          isVerified: boolean;
        } | null;
        education: Array<
          | {
              __typename: 'UnverifiedPublicProfileEducation';
              name: string;
              institute: string;
              highlights?: string | null;
              completion: {
                __typename?: 'PublicProfileEducationCompletion';
                label?: string | null;
              };
            }
          | { __typename: 'VerifiedPublicProfileEducation'; name: string }
        >;
        licences: Array<
          | {
              __typename: 'UnverifiedPublicProfileLicence';
              name: string;
              description?: string | null;
              issuingOrganisation?: string | null;
            }
          | { __typename: 'VerifiedPublicProfileLicence'; name: string }
        >;
        rightsToWork: Array<{
          __typename?: 'PublicProfileRightToWork';
          countryLabel: string;
          statusLabel: string;
          isVerified: boolean;
        }>;
      }
    | null;
};

export type GetKeywordSuggestionsQueryVariables = Exact<{
  keyword: Scalars['String']['input'];
  country: Scalars['CountryCodeIso2']['input'];
}>;

export type GetKeywordSuggestionsQuery = {
  __typename?: 'Query';
  searchKeywordsSuggest: {
    __typename?: 'SearchKeywordSuggestions';
    suggestions: Array<
      | {
          __typename?: 'KeywordSuggestion';
          text: string;
          highlights: Array<{
            __typename?: 'SuggestionHighlight';
            start: number;
            end: number;
          }>;
        }
      | { __typename?: 'KeywordSuggestionGroup' }
    >;
  };
};

export type GetSuggestionsForCompanyQueryVariables = Exact<{
  query: Scalars['String']['input'];
  count: Scalars['Int']['input'];
  session: Scalars['String']['input'];
  countryCode2?: InputMaybe<Scalars['CountryCodeIso2']['input']>;
  languageCode?: InputMaybe<Scalars['LanguageCodeIso']['input']>;
}>;

export type GetSuggestionsForCompanyQuery = {
  __typename?: 'Query';
  ontologyOrganisations: Array<{
    __typename?: 'IOntologyOrganisation';
    id: string;
    normalisedText: string;
  }>;
};

export type GetSuggestionsForLocationQueryVariables = Exact<{
  searchText: Scalars['String']['input'];
  session: Scalars['String']['input'];
  kind: Array<Scalars['String']['input']> | Scalars['String']['input'];
  zone: Scalars['Zone']['input'];
  count?: InputMaybe<Scalars['Int']['input']>;
  countries?: InputMaybe<
    | Array<Scalars['CountryCodeIso2']['input']>
    | Scalars['CountryCodeIso2']['input']
  >;
  languageCode?: InputMaybe<Scalars['LanguageCodeIso']['input']>;
}>;

export type GetSuggestionsForLocationQuery = {
  __typename?: 'Query';
  mkLocationSuggestions: Array<{
    __typename?: 'MKLocationSuggestion';
    id: number;
    text: string;
  }>;
};

export type GetSuggestionsForRoleTitleQueryVariables = Exact<{
  query: Scalars['String']['input'];
  count: Scalars['Int']['input'];
  countryCode: Scalars['CountryCodeIso2']['input'];
  languageCode: Scalars['LanguageCodeIso']['input'];
  session: Scalars['String']['input'];
}>;

export type GetSuggestionsForRoleTitleQuery = {
  __typename?: 'Query';
  ontologyRoleTitlesSeniority: Array<{
    __typename: 'IOntologyRoleTitleSeniority';
    id: string;
    normalisedText: string;
  }>;
};

export const PostProfileReportDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'PostProfileReport' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReportProfileInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reportProfile' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'profileSlug' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PostProfileReportMutation,
  PostProfileReportMutationVariables
>;
export const GetCandidateDetailsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetCandidateDetails' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'viewer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'personalDetails' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'firstName' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'emailAddress' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'trackingId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'identity' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'actor' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'profileVisibility2' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'profileAvatar' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'image128Url' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetCandidateDetailsQuery,
  GetCandidateDetailsQueryVariables
>;
export const PublicProfileSearchDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PublicProfileSearch' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'PublicProfileSearchInput' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'locale' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Locale' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'publicProfileSearch' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'exactMatches' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'slug' },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: {
                                  kind: 'Name',
                                  value:
                                    'UnrestrictedPublicProfileSearchResult',
                                },
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'firstName' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'lastName' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'homeLocation',
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'label',
                                          },
                                          arguments: [
                                            {
                                              kind: 'Argument',
                                              name: {
                                                kind: 'Name',
                                                value: 'locale',
                                              },
                                              value: {
                                                kind: 'Variable',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'locale',
                                                },
                                              },
                                            },
                                          ],
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'workHistories',
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'companyName',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'roleTitle',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'duration',
                                          },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'label',
                                                },
                                                arguments: [
                                                  {
                                                    kind: 'Argument',
                                                    name: {
                                                      kind: 'Name',
                                                      value: 'locale',
                                                    },
                                                    value: {
                                                      kind: 'Variable',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'locale',
                                                      },
                                                    },
                                                  },
                                                ],
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'achievements',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'hasVerifiedCredentials',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'digitalIdentity',
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'verifiedName',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'isVerified',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'isOwnedByLoggedInUser',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'profileAvatarUrls',
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'image128Url',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'image256Url',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'image512Url',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: {
                                  kind: 'Name',
                                  value: 'RestrictedPublicProfileSearchResult',
                                },
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'firstName' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'lastName' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'homeLocation',
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'label',
                                          },
                                          arguments: [
                                            {
                                              kind: 'Argument',
                                              name: {
                                                kind: 'Name',
                                                value: 'locale',
                                              },
                                              value: {
                                                kind: 'Variable',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'locale',
                                                },
                                              },
                                            },
                                          ],
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'workHistories',
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'companyName',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'roleTitle',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'hasVerifiedCredentials',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'digitalIdentity',
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'isVerified',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'profileAvatarUrls',
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'image128Url',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'image256Url',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'image512Url',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'partialMatches' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'slug' },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: {
                                  kind: 'Name',
                                  value:
                                    'UnrestrictedPublicProfileSearchResult',
                                },
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'firstName' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'lastName' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'homeLocation',
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'label',
                                          },
                                          arguments: [
                                            {
                                              kind: 'Argument',
                                              name: {
                                                kind: 'Name',
                                                value: 'locale',
                                              },
                                              value: {
                                                kind: 'Variable',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'locale',
                                                },
                                              },
                                            },
                                          ],
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'workHistories',
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'companyName',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'roleTitle',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'duration',
                                          },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'label',
                                                },
                                                arguments: [
                                                  {
                                                    kind: 'Argument',
                                                    name: {
                                                      kind: 'Name',
                                                      value: 'locale',
                                                    },
                                                    value: {
                                                      kind: 'Variable',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'locale',
                                                      },
                                                    },
                                                  },
                                                ],
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'achievements',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'hasVerifiedCredentials',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'digitalIdentity',
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'verifiedName',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'isVerified',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'isOwnedByLoggedInUser',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'profileAvatarUrls',
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'image128Url',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'image256Url',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'image512Url',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: {
                                  kind: 'Name',
                                  value: 'RestrictedPublicProfileSearchResult',
                                },
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'firstName' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'lastName' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'homeLocation',
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'label',
                                          },
                                          arguments: [
                                            {
                                              kind: 'Argument',
                                              name: {
                                                kind: 'Name',
                                                value: 'locale',
                                              },
                                              value: {
                                                kind: 'Variable',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'locale',
                                                },
                                              },
                                            },
                                          ],
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'workHistories',
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'companyName',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'roleTitle',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'hasVerifiedCredentials',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'digitalIdentity',
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'isVerified',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'profileAvatarUrls',
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'image128Url',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'image256Url',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'image512Url',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'totalExactMatches' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'totalPartialMatches' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'totalMatches' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'serviceToken' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PublicProfileSearchQuery,
  PublicProfileSearchQueryVariables
>;
export const PublicProfileViewDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PublicProfileView' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'PublicProfileViewInput' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'locale' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Locale' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'publicProfileView' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'UnrestrictedPublicProfileView',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'firstName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lastName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'profileAvatarUrls' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'image128Url' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'image256Url' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'image512Url' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'homeLocation' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'label' },
                              arguments: [
                                {
                                  kind: 'Argument',
                                  name: { kind: 'Name', value: 'locale' },
                                  value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'locale' },
                                  },
                                },
                              ],
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'workHistories' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'companyName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'roleTitle' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'duration' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'label' },
                                    arguments: [
                                      {
                                        kind: 'Argument',
                                        name: { kind: 'Name', value: 'locale' },
                                        value: {
                                          kind: 'Variable',
                                          name: {
                                            kind: 'Name',
                                            value: 'locale',
                                          },
                                        },
                                      },
                                    ],
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'achievements' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hasVerifiedCredentials' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'digitalIdentity' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'verifiedName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'isVerified' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'personalSummary' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'education' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: '__typename' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: {
                                  kind: 'Name',
                                  value: 'UnverifiedPublicProfileEducation',
                                },
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'name' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'institute' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'completion' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'label',
                                          },
                                          arguments: [
                                            {
                                              kind: 'Argument',
                                              name: {
                                                kind: 'Name',
                                                value: 'locale',
                                              },
                                              value: {
                                                kind: 'Variable',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'locale',
                                                },
                                              },
                                            },
                                          ],
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'highlights' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: {
                                  kind: 'Name',
                                  value: 'VerifiedPublicProfileEducation',
                                },
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'name' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'licences' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: '__typename' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: {
                                  kind: 'Name',
                                  value: 'UnverifiedPublicProfileLicence',
                                },
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'name' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'description',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'issuingOrganisation',
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: {
                                  kind: 'Name',
                                  value: 'VerifiedPublicProfileLicence',
                                },
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'name' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'skills' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'languages' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'rightsToWork' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'countryLabel' },
                              arguments: [
                                {
                                  kind: 'Argument',
                                  name: { kind: 'Name', value: 'locale' },
                                  value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'locale' },
                                  },
                                },
                              ],
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'statusLabel' },
                              arguments: [
                                {
                                  kind: 'Argument',
                                  name: { kind: 'Name', value: 'locale' },
                                  value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'locale' },
                                  },
                                },
                              ],
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'isVerified' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isOwnedByLoggedInUser' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'profileGuid' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'RestrictedPublicProfileView',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'firstName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lastName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'profileAvatarUrls' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'image128Url' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'image256Url' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'image512Url' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'homeLocation' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'label' },
                              arguments: [
                                {
                                  kind: 'Argument',
                                  name: { kind: 'Name', value: 'locale' },
                                  value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'locale' },
                                  },
                                },
                              ],
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'workHistories' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'companyName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'roleTitle' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hasVerifiedCredentials' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'digitalIdentity' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'isVerified' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'profileGuid' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PublicProfileViewQuery,
  PublicProfileViewQueryVariables
>;
export const GetKeywordSuggestionsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetKeywordSuggestions' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'keyword' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'country' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CountryCodeIso2' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'searchKeywordsSuggest' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'query' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'keyword' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'count' },
                value: { kind: 'IntValue', value: '5' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'countryCode2' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'country' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'suggestions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'KeywordSuggestion' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'text' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'highlights' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'start' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'end' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetKeywordSuggestionsQuery,
  GetKeywordSuggestionsQueryVariables
>;
export const GetSuggestionsForCompanyDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetSuggestionsForCompany' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'query' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'count' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'session' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'countryCode2' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'CountryCodeIso2' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'languageCode' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'LanguageCodeIso' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ontologyOrganisations' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'query' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'query' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'count' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'count' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'session' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'session' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'countryCode2' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'countryCode2' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'languageCode' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'languageCode' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'normalisedText' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetSuggestionsForCompanyQuery,
  GetSuggestionsForCompanyQueryVariables
>;
export const GetSuggestionsForLocationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetSuggestionsForLocation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'searchText' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'session' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'kind' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: {
                  kind: 'NamedType',
                  name: { kind: 'Name', value: 'String' },
                },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'zone' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Zone' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'count' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'countries' },
          },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'CountryCodeIso2' },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'languageCode' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'LanguageCodeIso' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mkLocationSuggestions' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'searchText' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'searchText' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'session' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'session' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'kind' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'kind' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'zone' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'zone' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'count' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'count' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'countries' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'countries' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'languageCode' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'languageCode' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'text' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetSuggestionsForLocationQuery,
  GetSuggestionsForLocationQueryVariables
>;
export const GetSuggestionsForRoleTitleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetSuggestionsForRoleTitle' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'query' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'count' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'countryCode' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CountryCodeIso2' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'languageCode' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'LanguageCodeIso' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'session' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ontologyRoleTitlesSeniority' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'query' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'query' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'count' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'count' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'countryCode2' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'countryCode' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'languageCode' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'languageCode' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'session' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'session' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'normalisedText' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetSuggestionsForRoleTitleQuery,
  GetSuggestionsForRoleTitleQueryVariables
>;
